// playground requires you to assign document definition to a variable called dd
// playground requires you to assign document definition to a variable called dd
import { digitsToWords } from './digitsToWords.js'
export const convertToPDFProducts = (items, isGST, invoiceData, metaData) => {
	let productList = [];
	let totalObj = {
		quantity: 0,
		basicPrice: 0,
		totlePrice: 0,
		CGST_val: 0,
		SGST_val: 0,
		IGST_val: 0
	}
	let lastIndex = 0;
	items.map((item, index) => {
		let product = [];
		lastIndex = index;
		product.push({ text: index + 1, style: "product" });
		// product.push({ text: item.productName, style: "product" });
		product.push({ text: item.productName + (item.subDescription ? "\n" + item.subDescription + "\n" : ""), alignment: 'left', style: 'product' });
		if (isGST) {
			product.push({ text: item.HSN_code, style: "product" });
		}
		product.push({ text: item.quantity, style: "productRight" });
		let unit = item.unit;
		if (metaData.terms.isMajorUnitDisplay && metaData.productObj && metaData.productObj[item.productId] && metaData.productObj[item.productId].majorUnit) {
			let text = "(" + (item.quantity / metaData.productObj[item.productId].majorUnitQuantity) + " " + metaData.productObj[item.productId].majorUnit + ")";
			unit = unit + text;
		}
		product.push({ text: unit, style: "product" });
		product.push({ text: item.rate, style: "productRight" });
		// product.push({ text: item.basicPrice, style: "product" });
		if (isGST) {
			product.push({ text: Number.parseFloat(item.basicPrice).toFixed(2), style: "productRight" });
		}
		if (isGST) {
			product.push({ text: item.CGST, style: "product" });
			product.push({ text: Number.parseFloat(item.CGST_val).toFixed(2), style: "productRight" });
			product.push({ text: item.SGST, style: "product" });
			product.push({ text: Number.parseFloat(item.SGST_val).toFixed(2), style: "productRight" });
			product.push({ text: item.IGST, style: "product" });
			product.push({ text: Number.parseFloat(item.IGST_val).toFixed(2), style: "productRight" });
		}
		product.push({ text: Number.parseFloat(item.totlePrice).toFixed(2), style: "productRight" });
		totalObj.quantity += item.quantity;
		totalObj.basicPrice += Number.parseFloat(item.basicPrice);
		totalObj.CGST_val += Number.parseFloat(item.CGST_val);
		totalObj.SGST_val += Number.parseFloat(item.SGST_val);
		totalObj.IGST_val += Number.parseFloat(item.IGST_val);
		totalObj.totlePrice += Number.parseFloat(item.totlePrice);
		productList.push(product);
	})

	if (invoiceData.gstOnExtraChanrges) {
		let isIGST = invoiceData.gstType == 'IGST' ? true : false;
		invoiceData.extraCharges.map((item, index) => {
			lastIndex++;
			let product = [];
			product.push({ text: lastIndex + 1, style: "product" });
			// product.push({ text: item.productName, style: "product" });
			product.push({ text: item.name, alignment: 'left', style: 'product' });
			if (isGST) {
				product.push({ text: "", style: "product" });
			}
			product.push({ text: "", style: "productRight" });
			product.push({ text: "", style: "product" });
			product.push({ text: "", style: "productRight" });
			// product.push({ text: item.basicPrice, style: "product" });
			if (isGST) {
				product.push({ text: " ₹ " + Number.parseFloat(item.amount).toFixed(2), style: "productRight" });
			}
			if (isGST) {
				if (isIGST) {
					product.push({ text: "", style: "product" });
					product.push({ text: "", style: "productRight" });
					product.push({ text: "", style: "product" });
					product.push({ text: "", style: "productRight" });
					product.push({ text: item.gst, style: "product" });
					product.push({ text: Number.parseFloat(item.gstAmount).toFixed(2), style: "productRight" });
					totalObj.IGST_val += Number.parseFloat(item.gstAmount);
				} else {
					product.push({ text: Number.parseFloat(item.gst / 2).toFixed(2), style: "product" });
					product.push({ text: Number.parseFloat(item.gstAmount / 2).toFixed(2), style: "productRight" });
					product.push({ text: Number.parseFloat(item.gst / 2).toFixed(2), style: "product" });
					product.push({ text: Number.parseFloat(item.gstAmount / 2).toFixed(2), style: "productRight" });
					product.push({ text: "", style: "product" });
					product.push({ text: "", style: "productRight" });
					totalObj.CGST_val += Number.parseFloat(item.gstAmount / 2);
					totalObj.SGST_val += Number.parseFloat(item.gstAmount / 2);
				}

			}
			product.push({ text: " ₹ " + Number.parseFloat(Number.parseFloat(item.gstAmount) + Number.parseFloat(item.amount)).toFixed(2), style: "productRight" });
			totalObj.quantity += 1;
			totalObj.basicPrice += Number.parseFloat(item.amount);
			totalObj.totlePrice += Number.parseFloat(item.gstAmount) + Number.parseFloat(item.amount);
			productList.push(product);
		})
	}

	if (isGST) {
		productList.push([
			{ text: '', style: "product" },
			{ text: 'Total', style: "total" },
			{ text: '', style: "product" },
			{ text: totalObj.quantity, style: "total" },
			{ text: '', style: "product" },
			{ text: '', style: "product" },
			{ text: totalObj.basicPrice.toFixed(2), style: "totalRight" },
			{ text: '', style: "totalRight" },
			{ text: totalObj.CGST_val.toFixed(2), style: "totalRight" },
			{ text: '', style: "totalRight" },
			{ text: totalObj.SGST_val.toFixed(2), style: "totalRight" },
			{ text: '', style: "totalright" },
			{ text: totalObj.IGST_val.toFixed(2), style: "totalRight" },
			{ text: totalObj.totlePrice.toFixed(2), style: "totalRight" },]);
		return productList;
	} else {
		productList.push([
			{ text: '', style: "product" },
			{ text: 'Total', style: "total" },
			// { text: '', style: "product" },
			{ text: (totalObj.quantity).toFixed(2), style: "totalRight" },
			{ text: '', style: "product" },
			{ text: '', style: "product" },
			{ text: totalObj.basicPrice.toFixed(2), style: "totalRight" }]);
		//{ text: totalObj.totlePrice.toFixed(2), style: "total" }]);
		return productList;
	}
}

// New Development For Dairy Business
export const convertToDairyPDFProducts = (items, isGST, invoiceData, metaData) => {
	let productList = [];
	let totalObj = {
		quantity: 0,
		fat: 0,
		basicPrice: 0,
		totlePrice: 0,
		CGST_val: 0,
		SGST_val: 0,
		IGST_val: 0
	}
	let lastIndex = 0;
	items.map((item, index) => {
		let product = [];
		lastIndex = index;
		product.push({ text: index + 1, style: "product" });
		// product.push({ text: item.productName, style: "product" });
		product.push({ text: item.productName + (item.subDescription ? "\n" + item.subDescription + "\n" : ""), alignment: 'left', style: 'product' });
		if (isGST) {
			product.push({ text: item.HSN_code, style: "product" });
		}
		product.push({ text: item.quantity, style: "productRight" });
		let unit = item.unit;
		if (metaData.terms.isMajorUnitDisplay && metaData.productObj && metaData.productObj[item.productId] && metaData.productObj[item.productId].majorUnit) {
			let text = "(" + (item.quantity / metaData.productObj[item.productId].majorUnitQuantity) + " " + metaData.productObj[item.productId].majorUnit + ")";
			unit = unit + text;
		}
		product.push({ text: unit, style: "product" });
		product.push({ text: item.fat, style: "productRight" });
		product.push({ text: item.rate, style: "productRight" });
		// product.push({ text: item.basicPrice, style: "product" });
		if (isGST) {
			product.push({ text: Number.parseFloat(item.basicPrice).toFixed(2), style: "productRight" });
		}
		if (isGST) {
			product.push({ text: item.CGST, style: "product" });
			product.push({ text: Number.parseFloat(item.CGST_val).toFixed(2), style: "productRight" });
			product.push({ text: item.SGST, style: "product" });
			product.push({ text: Number.parseFloat(item.SGST_val).toFixed(2), style: "productRight" });
			product.push({ text: item.IGST, style: "product" });
			product.push({ text: Number.parseFloat(item.IGST_val).toFixed(2), style: "productRight" });
		}
		product.push({ text: Number.parseFloat(item.totlePrice).toFixed(2), style: "productRight" });
		totalObj.quantity += item.quantity;
		totalObj.fat += item.fat;
		totalObj.basicPrice += Number.parseFloat(item.basicPrice);
		totalObj.CGST_val += Number.parseFloat(item.CGST_val);
		totalObj.SGST_val += Number.parseFloat(item.SGST_val);
		totalObj.IGST_val += Number.parseFloat(item.IGST_val);
		totalObj.totlePrice += Number.parseFloat(item.totlePrice);
		productList.push(product);
	})

	if (invoiceData.gstOnExtraChanrges) {
		let isIGST = invoiceData.gstType == 'IGST' ? true : false;
		invoiceData.extraCharges.map((item, index) => {
			lastIndex++;
			let product = [];
			product.push({ text: lastIndex + 1, style: "product" });
			// product.push({ text: item.productName, style: "product" });
			product.push({ text: item.name, alignment: 'left', style: 'product' });
			if (isGST) {
				product.push({ text: "", style: "product" });
			}
			product.push({ text: "", style: "productRight" });
			product.push({ text: "", style: "product" });
			product.push({ text: "", style: "productRight" });
			product.push({ text: "", style: "product" });
			if (isGST) {
				product.push({ text: " ₹ " + Number.parseFloat(item.amount).toFixed(2), style: "productRight" });
			}
			if (isGST) {
				if (isIGST) {
					product.push({ text: "", style: "product" });
					product.push({ text: "", style: "productRight" });
					product.push({ text: "", style: "product" });
					product.push({ text: "", style: "productRight" });
					product.push({ text: "", style: "productRight" });
					product.push({ text: item.gst, style: "product" });
					product.push({ text: Number.parseFloat(item.gstAmount).toFixed(2), style: "productRight" });
					totalObj.IGST_val += Number.parseFloat(item.gstAmount);
				} else {
					product.push({ text: Number.parseFloat(item.gst / 2).toFixed(2), style: "product" });
					product.push({ text: Number.parseFloat(item.gstAmount / 2).toFixed(2), style: "productRight" });
					product.push({ text: Number.parseFloat(item.gst / 2).toFixed(2), style: "product" });
					product.push({ text: Number.parseFloat(item.gstAmount / 2).toFixed(2), style: "productRight" });
					product.push({ text: "", style: "product" });
					product.push({ text: "", style: "productRight" });
					totalObj.CGST_val += Number.parseFloat(item.gstAmount / 2);
					totalObj.SGST_val += Number.parseFloat(item.gstAmount / 2);
				}

			}
			product.push({ text: " ₹ " + Number.parseFloat(Number.parseFloat(item.gstAmount) + Number.parseFloat(item.amount)).toFixed(2), style: "productRight" });
			totalObj.quantity += 1;
			totalObj.basicPrice += Number.parseFloat(item.amount);
			totalObj.totlePrice += Number.parseFloat(item.gstAmount) + Number.parseFloat(item.amount);
			productList.push(product);
		})
	}

	if (isGST) {
		productList.push([
			{ text: '', style: "product" },
			{ text: 'Total', style: "total" },
			{ text: totalObj.quantity, style: "total" },
			{ text: '', style: "product" },
			{ text: '', style: "product" },
			{ text: '', style: "product" },
			{ text: '', style: "product" },
			{ text: totalObj.basicPrice.toFixed(2), style: "totalRight" },
			{ text: '', style: "totalRight" },
			{ text: totalObj.CGST_val.toFixed(2), style: "totalRight" },
			{ text: '', style: "totalRight" },
			{ text: totalObj.SGST_val.toFixed(2), style: "totalRight" },
			{ text: '', style: "totalright" },
			{ text: totalObj.IGST_val.toFixed(2), style: "totalRight" },
			{ text: totalObj.totlePrice.toFixed(2), style: "totalRight" },]);
		return productList;
	} else {
		productList.push([
			{ text: '', style: "product" },
			{ text: 'Total', style: "total" },
			{ text: (totalObj.quantity).toFixed(2), style: "totalRight" },
			{ text: '', style: "product" },
			{ text: (totalObj.fat).toFixed(2), style: "product" },
			{ text: '', style: "product" },
			{ text: totalObj.basicPrice.toFixed(2), style: "totalRight" }]);
		//{ text: totalObj.totlePrice.toFixed(2), style: "total" }]);
		return productList;
	}
}
// End of New Development For Dairy Business

export const getCustomerDetails = (metaData, type) => {
	if (metaData.invoiceData.billingDetails) {
		return metaData.invoiceData.billingDetails[type] ? metaData.invoiceData.billingDetails[type] : '';
	} else {
		return metaData.customer[type] ? metaData.customer[type] : '';
	}
}
// playground requires you to assign document definition to a variable called dd
export const convertToPDFProductWithExtraDetails = (businessType, items, isGST, invoiceData) => {
	let productList = [];
	let totalObj = {
		quantity: 0,
		basicPrice: 0,
		totlePrice: 0,
		CGST_val: 0,
		SGST_val: 0,
		IGST_val: 0
	}
	const getBusinessfields = (businessType, item, index) => {
		switch (businessType) {
			case 'Jwellery': {
				switch (index) {
					case 1: {
						return item['grossWeight'] + " gm";
						break;
					}
					case 2: {
						return item['netWeight'] + " gm";
						break;
					}
					case 3: {
						return item['purity'] + " %";
						break;
					}
				}
				break;
			}
			case 'Grain': {
				switch (index) {
					// case 1 : {
					// 	return item['grossWeight'] + " gm";
					// 	break;
					// }
					case 2: {
						return item['netWeight'] + item.unit;
						break;
					}
					case 3: {
						return item['purity'] + " %";
						break;
					}
				}
				break;
			}
			case 'Medical/Pesticides': {
				switch (index) {
					case 1: {
						return item['batchNumber'];
						break;
					}
					case 2: {
						return item['manufacturingDate'];
						break;
					}
					case 3: {
						return item['expiryDate'];
						break;
					}
				}
				break;
			}
			case 'Clothes': {
				switch (index) {
					case 1: {
						return item['productBrandName'];
						break;
					}
					case 2: {
						return item['color'];
						break;
					}
					case 3: {
						return item['size'];
						break;
					}
				}
				break;
			}
			case 'Automobile/Spare Parts': {
				switch (index) {
					case 1: {
						return item['engineNumber'];
						break;
					}
					case 2: {
						return item['chasisNumber'];
						break;
					}
					case 3: {
						return item['extra'];
						break;
					}
				}
				break;
			}
			default: {
				switch (index) {
					case 1: {
						return item['extra'];
						break;
					}
					case 2: {
						return item['extra'];
						break;
					}
					case 3: {
						return item['extra'];
						break;
					}
				}
				break;
			}
		}
	}
	let lastIndex = 0;
	items.map((item, index) => {
		lastIndex = index;
		let product = [];
		product.push({ text: index + 1, style: "product" });
		// product.push({ text: item.productName, style: "product" });
		product.push({ text: item.productName + (item.subDescription ? "\n( " + item.subDescription + ") \n" : ""), style: "subproduct" });
		product.push({ text: item.HSN_code, style: "product" });
		product.push({ text: item.quantity, style: "product" });
		product.push({ text: item.unit, style: "product" });
		product.push({ text: "₹ " + item.rate, style: "product" });
		product.push({ text: getBusinessfields(businessType, item, 1), style: "product" });
		product.push({ text: getBusinessfields(businessType, item, 2), style: "product" });
		product.push({ text: getBusinessfields(businessType, item, 3), style: "product" });
		product.push({ text: "₹ " + item.basicPrice, style: "productRight" });
		product.push({ text: item.CGST, style: "product" });
		product.push({ text: item.CGST_val, style: "productRight" });
		product.push({ text: item.SGST, style: "product" });
		product.push({ text: item.SGST_val, style: "productRight" });
		product.push({ text: item.IGST, style: "product" });
		product.push({ text: item.IGST_val, style: "productRight" });
		product.push({ text: "₹ " + item.totlePrice, style: "productRight" });
		totalObj.quantity += item.quantity;
		totalObj.basicPrice += Number.parseFloat(item.basicPrice);
		totalObj.totlePrice += Number.parseFloat(item.totlePrice);
		totalObj.CGST_val += Number.parseFloat(item.CGST_val);
		totalObj.SGST_val += Number.parseFloat(item.SGST_val);
		totalObj.IGST_val += Number.parseFloat(item.IGST_val);
		productList.push(product);
	})

	if (invoiceData.gstOnExtraChanrges) {
		let isIGST = invoiceData.gstType == 'IGST' ? true : false;
		invoiceData.extraCharges.map((item, index) => {
			let product = [];
			lastIndex++;
			product.push({ text: lastIndex + 1, style: "product" });
			// product.push({ text: item.productName, style: "product" });
			product.push({ text: item.name + (item.subDescription ? "\n( " + item.subDescription + ") \n" : ""), style: "subproduct" });
			product.push({ text: "", style: "product" });
			product.push({ text: "", style: "product" });
			product.push({ text: "", style: "product" });
			product.push({ text: "", style: "product" });
			product.push({ text: "", style: "product" });
			product.push({ text: "", style: "product" });
			product.push({ text: "", style: "product" });
			product.push({ text: "₹ " + item.amount, style: "productRight" });
			if (!isIGST) {
				product.push({ text: Number.parseFloat(item.gst / 2).toFixed(2), style: "product" });
				product.push({ text: Number.parseFloat(item.gstAmount / 2).toFixed(2), style: "productRight" });
				product.push({ text: Number.parseFloat(item.gst / 2).toFixed(2), style: "product" });
				product.push({ text: Number.parseFloat(item.gstAmount / 2).toFixed(2), style: "productRight" });
				totalObj.CGST_val += Number.parseFloat(item.gstAmount / 2);
				totalObj.SGST_val += Number.parseFloat(item.gstAmount / 2);
				roduct.push({ text: 0, style: "product" });
				product.push({ text: 0, style: "productRight" });
			} else {
				product.push({ text: "", style: "product" });
				product.push({ text: "", style: "productRight" });
				product.push({ text: "", style: "product" });
				product.push({ text: "", style: "productRight" });
				product.push({ text: item.gst, style: "product" });
				product.push({ text: item.gstAmount, style: "productRight" });
				totalObj.IGST_val += Number.parseFloat(item.gstAmount);
			}
			product.push({ text: "₹ " + Number.parseFloat(Number.parseFloat(item.gstAmount) + Number.parseFloat(item.amount)).toFixed(2), style: "productRight" });
			totalObj.quantity += 0;
			totalObj.basicPrice += Number.parseFloat(item.amount);
			totalObj.totlePrice += Number.parseFloat(Number.parseFloat(item.gstAmount) + Number.parseFloat(item.amount));
			productList.push(product);
		})
	}

	productList.push([
		{ text: '', style: "product" },
		{ text: 'Total', style: "total" },
		{ text: '', style: "product" },
		{ text: totalObj.quantity, style: "total" },
		{ text: '', style: "product" },
		{ text: '', style: "product" },
		{ text: '', style: "product" },
		{ text: '', style: "product" },
		{ text: '', style: "product" },
		{ text: "₹ " + totalObj.basicPrice.toFixed(2), style: "totalRight" },
		{ text: '', style: "totalRight" },
		{ text: "₹ " + totalObj.CGST_val.toFixed(2), style: "totalRight" },
		{ text: '', style: "totalRight" },
		{ text: "₹ " + totalObj.SGST_val.toFixed(2), style: "totalRight" },
		{ text: '', style: "totalRight" },
		{ text: "₹ " + totalObj.IGST_val.toFixed(2), style: "totalRight" },
		{ text: "₹ " + totalObj.totlePrice.toFixed(2), style: "totalRight" },]);

	return productList;
}

export const convertToGST = (items) => {
	let totalObj = {
		quantity: 0,
		basicPrice: 0,
		GSTValue: 0,
		CGST_val: 0,
		SGST_val: 0,
		IGST_val: 0
	}
	let result = items.reduce(function (r, a) {
		if (r[a.HSN_code]) {
			r[a.HSN_code].quantity += a.quantity;
			r[a.HSN_code].basicPrice += Number.parseFloat(a.basicPrice);
			r[a.HSN_code].GSTValue += Number.parseFloat(a.GSTValue);
			r[a.HSN_code].CGST_val += Number.parseFloat(a.CGST_val);
			r[a.HSN_code].SGST_val += Number.parseFloat(a.SGST_val);
			r[a.HSN_code].IGST_val += Number.parseFloat(a.IGST_val);
		}
		else {
			r[a.HSN_code] = {
				quantity: a.quantity,
				basicPrice: Number.parseFloat(a.basicPrice),
				GSTValue: Number.parseFloat(a.GSTValue),
				CGST_val: Number.parseFloat(a.CGST_val),
				SGST_val: Number.parseFloat(a.SGST_val),
				IGST_val: Number.parseFloat(a.IGST_val),
				CGST: a.CGST,
				SGST: a.SGST,
				IGST: a.IGST
			}
		}
		totalObj.quantity += a.quantity;
		totalObj.basicPrice += Number.parseFloat(a.basicPrice);
		totalObj.GSTValue += Number.parseFloat(a.GSTValue);
		totalObj.CGST_val += Number.parseFloat(a.CGST_val);
		totalObj.SGST_val += Number.parseFloat(a.SGST_val);
		totalObj.IGST_val += Number.parseFloat(a.IGST_val);

		return r;
	}, Object.create(null));
	result.totalObj = totalObj;
	return result;
}

export const convertToEwayBillType1 = (metaData) => {

	let pdfDoc = {
		content: [
			{ text: 'TAX INVOICE\n', style: "bigger" },
			{
				table: {
					widths: ['67.5%', '32.5%',],
					body: [
						[
							{ text: 'FIRM DETAILS', style: "topHeader" },
							{ text: 'INVOICE  DETAILS', style: "topHeader" },
						],
						[
							{
								text:
									[
										{ text: ' ', bold: true, style: "topFirmHeader" },
										{ text: 'Google\n', style: "topFirmHeader" },
										{ text: ' ', bold: true, style: "firmHeader" },
										{ text: '1600 Amphitheatre Parkway in Mountain View, California, United States, near San Jose. \n', style: "firmHeader" },
										{ text: ' ', bold: true, style: "firmHeader" },
										{ text: '88776655\n', style: "firmHeader" },
										{ text: '  ', bold: true, style: "firmHeader" },
										{ text: '123456\n', style: "firmHeader" },
										{ text: '  ', bold: true, style: "firmHeader" },
										{ text: '\n', style: "firmHeader" },
										{ text: ' ', bold: true, style: "firmHeader" },
										{ text: '\n', style: "firmHeader" },
										{ text: ' ', bold: true, style: "firmHeader" },
										{ text: '\n', style: "firmHeader" },
									]
							},
							{
								text:
									[
										{ text: 'Invoice No        :  ', bold: true, style: "firmHeader" },
										{ text: '787878\n', style: "firmHeader" },
										{ text: 'Invoice Date     :  ', bold: true, style: "firmHeader" },
										{ text: '12/12/90 \n', style: "firmHeader" },
										{ text: 'Invoice Status  :  ', bold: true, style: 'firmHeader' },
										{ text: '12/12/90 \n', style: 'topRemainingHeader' },
										{ text: 'Payment Date  :  ', bold: true, style: "firmHeader" },
										{ text: '13/12/90\n', style: "firmHeader" },
										{ text: 'E-Way Bill No   :  ', bold: true, style: 'firmHeader' },
										{ text: '787878\n', style: 'firmHeader' },
										{ text: 'Order Number  :  ', bold: true, style: 'firmHeader' },
										{ text: '787878\n', style: 'firmHeader' },
										{ text: 'Order Date        :   ', bold: true, style: 'firmHeader' },
										{ text: '12/12/90 \n', style: 'firmHeader' },
									]
							}],
					]
				}
			},

			{
				table: {
					widths: ['*', '*', '*'],
					body: [
						[
							{ text: 'RECIPIENT DETAILS', style: "topHeader" },
							{ text: 'CONSIGNEE DETAILS', style: "topHeader" },
							{ text: 'TRANSPORT DETAILS', style: "topHeader" },
						],
						[
							{
								text:
									[
										{ text: ' ', bold: true, style: "topFirmHeader1" },
										{ text: 'Google\n', style: "topFirmHeader1" },
										{ text: ' ', bold: true, style: "firmHeader" },
										{ text: '1600 Amphitheatre Parkway in Mountain View, California, United States, near San Jose. \n', style: "firmHeader" },
										{ text: ' ', bold: true, style: "firmHeader" },
										{ text: '7788996655\n', style: "firmHeader" },
										{ text: ' ', bold: true, style: "firmHeader" },
										{ text: '7788996655\n', style: "firmHeader" },
										{ text: 'Contact Number : ', bold: true, style: "firmHeader" },
										{ text: '1679905\n', style: "firmHeader" },
										{ text: 'Place of Supply  : ', bold: true, style: "firmHeader" },
										{ text: '23\n', style: "firmHeader" },
										{ text: 'State Code          : ', bold: true, style: "firmHeader" },
										{ text: '23\n', style: "firmHeader" },
									]
							},

							{
								text:
									[
										{ text: ' ', bold: true, style: "topfirmHeader1" },
										{ text: 'Google\n', style: "topFirmHeader1" },
										{ text: ' ', bold: true, style: "firmHeader" },
										{ text: '1600 Amphitheatre Parkway in Mountain View, California, United States, near San Jose. \n', style: "firmHeader" },
										{ text: ' ', bold: true, style: "firmHeader" },
										{ text: '7788996655\n', style: "firmHeader" },
										{ text: ' ', bold: true, style: "firmHeader" },
										{ text: '7788996655\n', style: "firmHeader" },
										{ text: 'Contact Number : ', bold: true, style: "firmHeader" },
										{ text: '1679905\n', style: "firmHeader" },
										{ text: 'Place of Supply  : ', bold: true, style: "firmHeader" },
										{ text: '23\n', style: "firmHeader" },
										{ text: 'State Code          : ', bold: true, style: "firmHeader" },
										{ text: '23\n', style: "firmHeader" },
									]
							},
							{
								text:
									[
										{ text: 'Transporter   :   ', bold: true, style: "firmHeader" },
										{ text: 'San Jose. \n', style: "firmHeader" },
										{ text: 'GR/LR No       :   ', bold: true, style: "firmHeader" },
										{ text: '88776655\n', style: "firmHeader" },
										{ text: 'Vehicle No     :   ', bold: true, style: "firmHeader" },
										{ text: 'Google\n', style: "firmHeader" },
										{ text: 'Driver Name  :   ', bold: true, style: "firmHeader" },
										{ text: 'San Jose. \n', style: "firmHeader" },
										{ text: 'Driver M.No   :   ', bold: true, style: "firmHeader" },
										{ text: '88776655\n', style: "firmHeader" },
										{ text: ' ', bold: true, style: "firmHeader" },
										{ text: '12/06/89\n', style: "firmHeader" },
										// { text: 'Address: ', bold: true, style: "firmHeader" },
										// { text: '123456\n', style: "firmHeader" },
									]
							},
						],
					]
				}
			},

			{
				table: {

					body: [
						[
							{ text: 'S.No', style: "productHeader", rowSpan: 2 },
							{ text: 'Product Name', style: "productHeader", rowSpan: 2 },
							{ text: 'HSN code', style: "productHeader", rowSpan: 2 },
							{ text: 'Qty', style: "productHeader", rowSpan: 2 },
							{ text: 'Units', style: "productHeader", rowSpan: 2 },
							{ text: 'Rate', style: "productHeader", rowSpan: 2 },
							{ text: 'Taxable  Amount', style: "productHeader", rowSpan: 2 },
							{ text: 'CGST', style: "productHeader", colSpan: 2, rowSpan: 1 },
							{ text: '', style: "productHeader" },
							{ text: 'SGST', style: "productHeader", colSpan: 2, rowSpan: 1 },
							{ text: '', style: "productHeader" },
							{ text: 'IGST', style: "productHeader", colSpan: 2, rowSpan: 1 },
							{ text: '', style: "productHeader" },
							{ text: 'Total Amount', style: "productHeader", rowSpan: 2 }
						],
						[
							{ text: 'S.No', style: "productHeader" },
							{ text: 'Product Name', style: "productHeader" },
							{ text: 'HSN code', style: "productHeader" },
							{ text: 'Qty', style: "productHeader" },
							{ text: 'Units', style: "productHeader" },
							{ text: 'Rate', style: "productHeader" },
							{ text: 'Taxable Amount', style: "productHeader" },
							{ text: '%', style: "productHeader" },
							{ text: '₹', style: "productHeader" },
							{ text: '%', style: "productHeader" },
							{ text: '₹', style: "productHeader" },
							{ text: '%', style: "productHeader" },
							{ text: '₹', style: "productHeader" },
							{ text: 'Total Amount', style: "productHeader" }
						],
					]
				}
			},
			{
				table: {

					body: [
						[
							{ text: 'HSN SUMMARY', style: "topHeader", colSpan: 10, decoration: 'underline', },
							{ text: '', style: "topHeader" },
							{ text: '', style: "topHeader" },
							{ text: '', style: "topHeader" },
							{ text: '', style: "topHeader" },
							{ text: '', style: "topHeader" },
							{ text: '', style: "topHeader" },
							{ text: '', style: "topHeader" },
							{ text: '', style: "topHeader" },
							{ text: '', style: "topHeader" }
						],
						[

							{ text: 'HSN/SAC', style: "gstHeader", rowSpan: 2 },
							{ text: 'QUANTITY', style: "gstHeader", rowSpan: 2 },
							{ text: 'TAXABLE AMOUNT', style: "gstHeader", rowSpan: 2 },
							{ text: 'CGST', style: "gstHeader", colSpan: 2, rowSpan: 1 },
							{ text: '', style: "gstHeader", rowSpan: 2 },
							{ text: 'SGST', style: "gstHeader", colSpan: 2, rowSpan: 1 },
							{ text: '', style: "gstHeader", rowSpan: 2 },
							{ text: 'IGST', style: "gstHeader", colSpan: 2, rowSpan: 1 },
							{ text: '', style: "gstHeader", rowSpan: 2 },
							{ text: 'TAX AMOUNT', style: "gstHeader", rowSpan: 2 },

						],
						[

							{ text: 'HSN/SAC', style: "gstHeader" },
							{ text: 'QUANTITY', style: "gstHeader" },
							{ text: 'TAXABLE AMOUNT ', style: "gstHeader" },
							{ text: '%', style: "gstHeader" },
							{ text: 'AMOUNT', style: "gstHeader" },
							{ text: '%', style: "gstHeader" },
							{ text: 'AMOUNT', style: "gstHeader" },
							{ text: '%', style: "gstHeader" },
							{ text: 'AMOUNT', style: "gstHeader" },
							{ text: 'TAX AMOUNT', style: "gstHeader" },
						],
					]
				}
			},
			{
				table: {
					widths: ['65%', '*'],
					body: [

						[
							[
								{
									table: {
										widths: ['*'],
										body: [
											[
												{ text: 'PAYMENT DETAILS', style: "topHeader" },
											],
										],
									},
									style: 'tab2Head',

								}, {
									table: {
										widths: ['*'],
										body: [
											[
												{
													text:
														[]

												},
											]
										]
									},
									style: 'tab2',
								},
								{
									table: {
										widths: ['*'],
										body: [
											[
												{ text: 'TERMS & CONDITIONS', style: "topHeader" },
											],
										],
									},
									style: 'tab2Head',

								}, {
									table: {
										widths: ['*'],
										body: [
											[
												{
													text: "",
												},
											]
										]
									},
									style: 'tab2',
								},

							],
							{
								text:
									[
										{ text: 'Taxable Amount:    ', bold: true, style: "firmHeader" },
										{ text: '12122\n', style: "firmHeader" },
										{ text: 'CGST Amount:        ', bold: true, style: "firmHeader" },
										{ text: '12122\n', style: "firmHeader" },
										{ text: 'SGST Amount:        ', bold: true, style: "firmHeader" },
										{ text: '12122\n', style: "firmHeader" },
										{ text: 'IGST Amount:         ', bold: true, style: "firmHeader" },
										{ text: '12122\n', style: "firmHeader" },
										// { text: 'Labour Charge:-                ', bold: true },
										// { text: '12122\n' },
										{ text: 'Discount:                 ', bold: true, style: "firmHeader" },
										{ text: '12122\n', style: "firmHeader" },
										{ text: 'RoundOff:                ', bold: true, style: "firmHeader" },
										{ text: '12122\n', style: "firmHeader" },
										{ text: 'Total Amount:         ', bold: true, style: "firmHeader" },
										{ text: '12122\n', style: "firmHeader" },
										{ text: 'Paid Amount:          ', bold: true, style: "firmHeader" },
										{ text: '12122\n', style: "firmHeader" },
										{ text: 'Due Amount:           ', bold: true, style: "firmHeader" },
										{ text: '12122\n', style: "firmHeader" },
										// 	{ text: 'Payment Type:-       ', bold: true },
										// { text: '12122\n' },
									]

							},

						],
					],


				},
				style: 'tab2',


			},
			{
				table: {
					widths: ['60%', '*'],
					body: [
						[
							{
								text:
									[

									]

							},
							{
								text:
									[{ text: '' },
									{ text: 'Firm Name  ', bold: true, alignment: 'center', style: 'topFirmBasicAuthority' },
									{ text: '\n\n\n' },

									{ text: 'AUTHORITY SIGNATURE  ', bold: true, alignment: 'center', style: 'topFirmBasicAuthority' },
									{ text: '\n' },
									]

							},

						],
					],


				},
				style: 'tab2',

			},
			{
				table: {
					widths: ['*'],
					body: [
						[
							{ text: 'Thank you', alignment: 'center', },
						],
					],
				},
				style: 'tab2',
				pageBreak: 'after'
			},
			{
				table: {
					widths: ['*', '*'],
					body: [
						[
							{ text: 'BASIC DETAILS', style: "header" },
							{ text: 'PART A', style: "header" }
						],
						[
							{
								text:
									[
										{ text: 'E-way Bill No:-     ', bold: true },
										{ text: 'Google\n' },
										{ text: 'E-way Bill Date:-  ', bold: true },
										{ text: '1600 Amphitheatre Parkway in Mountain View, California, United States, near San Jose. \n' },
										{ text: 'Generated By:-     ', bold: true },
										{ text: '88776655\n' },
										{ text: 'Valid From:           ', bold: true },
										{ text: '123456\n' },
										{ text: 'Valid Till:-              ', bold: true },
										{ text: 'njnjn@jnn.com\n' },
									]

							},
							{
								text:
									[
										{ text: 'GSTIN of Supplier:-    ', bold: true },
										{ text: 'Google\n' },
										{ text: 'Place Of Dispatch:-    ', bold: true },
										{ text: '1600 Amphitheatre Parkway in Mountain View, California, United States, near San Jose. \n' },
										{ text: 'GSTIN of Recipient:-  ', bold: true },
										{ text: '88776655\n' },
										{ text: 'Place of Delivery:-     ', bold: true },
										{ text: '123456\n' },
										{ text: 'Document No:-            ', bold: true },
										{ text: 'njnjn@jnn.com\n' },
										{ text: 'Value of Goods:-         ', bold: true },
										{ text: '123456\n' },
										{ text: 'Reason of Transportation:-  ', bold: true },
										{ text: 'www.123456.com\n' },
										{ text: 'Document Date:-         ', bold: true },
										{ text: 'www.123456.com\n' },
										{ text: 'HSN code:-                   ', bold: true },
										{ text: 'www.123456.com\n' },
									]

							}
						],
					]
				}
			},
			{
				table: {

					body: [
						[
							{ text: 'PART B', style: "header", colSpan: 7 },
							{ text: '', style: "header" },
							{ text: '', style: "header" },
							{ text: '', style: "header" },
							{ text: '', style: "header" },
							{ text: '', style: "header" },
							{ text: '', style: "header" },
						],
						[

							{ text: 'Mode', style: "gstHeader" },
							{ text: 'Vehicle No', style: "gstHeader" },
							{ text: 'Entered By', style: "gstHeader" },
							{ text: 'Date &Time', style: "gstHeader" },
							{ text: 'From', style: "gstHeader" },
							{ text: 'To', style: "gstHeader" },
							{ text: 'CEWB No.', style: "gstHeader" },
						],

					]
				}

			},
		],
		footer: {
			columns: [
				{
					text: 'Powered By ACUIFY',
					alignment: 'right',
					color: '#160091'
				}
			],
			margin: [10, 10]
		},
		styles: {
			header: {
				fontSize: 10,
				bold: true,
				alignment: 'center'
			},
			productHeader: {
				fontSize: 10,
				color: '#160091',
				bold: true,
				alignment: 'center'
			},
			gstHeader: {
				fontSize: 10,
				bold: true,
				alignment: 'center'
			},
			product: {
				fontSize: 9,
				alignment: 'center',
			},
			total: {
				fontSize: 10,
				alignment: 'center',
				bold: true
			},
			topFirmBasicAuthority: {
				color: '#160091',
				fontSize: 10,
				bold: true,
			},
			topRemainingHeader: {
				color: '#FF0000',
				fontSize: 10,
				bold: true,
			},
			topHeader: {
				color: 'white',
				fontSize: 10,
				alignment: 'center',
				bold: true,
				fillColor: '#15155d',
			},
			firmHeader: {
				fontSize: 10,
				bold: true,
			},
			bankDetails: {
				fontSize: 10,
				bold: true,
			},
			topFirmHeader: {
				color: '#160091',
				fontSize: 12,
				bold: true,
			},
			topFirmHeader1: {
				color: '#160091',
				fontSize: 11,
				bold: true,
			},
			bigger: {
				fontSize: 14,
				bold: true,
				color: "#160091",
				alignment: 'center',
				// decoration: 'underline',
				decorationStyle: 'solid',
				// decorationColor: 'black'
			}
		}
	}

	//Firm Details 
	pdfDoc.content[1].table.body[1][0].text[1].text = (metaData.firm.name ? (metaData.firm.name).toUpperCase() : '') + "\n";
	pdfDoc.content[1].table.body[1][0].text[3].text = (metaData.firm.GST_number ? metaData.firm.GST_number : '') + "\n";
	pdfDoc.content[1].table.body[1][0].text[5].text = (metaData.firm.liveAddress ? metaData.firm.liveAddress : '') + "\n";
	pdfDoc.content[1].table.body[1][0].text[7].text = (metaData.firm.address ? metaData.firm.address : '') + "\n";
	pdfDoc.content[1].table.body[1][0].text[9].text = (metaData.firm.mobileNumber ? metaData.firm.mobileNumber : '') + "\n";
	// pdfDoc.content[1].table.body[1][0].text[7].text = (metaData.firm.panNumber ? metaData.firm.panNumber : '') + "\n";
	pdfDoc.content[1].table.body[1][0].text[11].text = (metaData.firm.email ? metaData.firm.email : '') + "\n";
	pdfDoc.content[1].table.body[1][0].text[13].text = (metaData.firm.website ? metaData.firm.website : '') + "\n";

	//Invoice Details
	let date = new Date(metaData.invoiceData.date)
	let paymentDueDate = date.setDate(date.getDate() + (metaData.invoiceData.duration ? parseInt(metaData.invoiceData.duration) : 0));
	pdfDoc.content[1].table.body[1][1].text[1].text = metaData.invoiceData.invoiceId + "\n";
	pdfDoc.content[1].table.body[1][1].text[3].text = new Date(metaData.invoiceData.date).toLocaleDateString('en-GB').toString() + "\n";
	pdfDoc.content[1].table.body[1][1].text[5].text = (metaData.invoiceData.status ? metaData.invoiceData.status.toUpperCase() : '') + "\n";
	pdfDoc.content[1].table.body[1][1].text[7].text = new Date(paymentDueDate).toLocaleDateString('en-GB').toString() + "\n";
	pdfDoc.content[1].table.body[1][1].text[9].text = (metaData.ebillDetails.billNo ? metaData.ebillDetails.billNo : '') + "\n";   //E-Way Bill NUMBER
	pdfDoc.content[1].table.body[1][1].text[11].text = (metaData.invoiceData.orderNumber ? metaData.invoiceData.orderNumber : '-') + "\n";
	pdfDoc.content[1].table.body[1][1].text[13].text = (metaData.invoiceData.orderDate ? new Date(metaData.invoiceData.orderDate).toLocaleDateString('en-GB').toString() : '-') + "\n";

	//Receipient Details
	pdfDoc.content[2].table.body[1][0].text[1].text = (metaData.customer.name ? metaData.customer.name : '') + "\n";
	pdfDoc.content[2].table.body[1][0].text[3].text = (metaData.customer.GST_number ? metaData.customer.GST_number : '') + "\n";
	pdfDoc.content[2].table.body[1][0].text[5].text = (metaData.customer.localAddress ? metaData.customer.localAddress : '') + "\n";
	pdfDoc.content[2].table.body[1][0].text[7].text = (metaData.customer.address ? metaData.customer.address : '') + "\n";
	pdfDoc.content[2].table.body[1][0].text[9].text = (metaData.customer.mobile ? metaData.customer.mobile : '') + "\n"
	pdfDoc.content[2].table.body[1][0].text[11].text = (metaData.invoiceData.placeOfSupply ? metaData.invoiceData.placeOfSupply : '') + "\n";
	pdfDoc.content[2].table.body[1][0].text[13].text = (metaData.customer.stateCode ? metaData.customer.stateCode : '') + "\n";


	//Consignee Details
	pdfDoc.content[2].table.body[1][1].text[1].text = (metaData.consignee.name ? metaData.consignee.name : '') + "\n";
	pdfDoc.content[2].table.body[1][1].text[3].text = (metaData.consignee.GST_number ? metaData.consignee.GST_number : '') + "\n";
	pdfDoc.content[2].table.body[1][1].text[5].text = (metaData.customer.localAddress ? metaData.consignee.localAddress : '') + "\n";
	pdfDoc.content[2].table.body[1][1].text[7].text = (metaData.consignee.address ? metaData.consignee.address : '') + "\n";
	pdfDoc.content[2].table.body[1][1].text[9].text = (metaData.consignee.mobile ? metaData.consignee.mobile : '') + "\n";
	pdfDoc.content[2].table.body[1][1].text[11].text = (metaData.invoiceData.placeOfSupply ? metaData.invoiceData.placeOfSupply : '') + "\n";
	pdfDoc.content[2].table.body[1][1].text[13].text = (metaData.consignee.stateCode ? metaData.consignee.stateCode : '') + "\n";


	//transpotation Details
	pdfDoc.content[2].table.body[1][2].text[1].text = (metaData.transportationDetails.transporterName ? metaData.transportationDetails.transporterName : '') + "\n";
	pdfDoc.content[2].table.body[1][2].text[3].text = (metaData.transportationDetails.goodsReceiptNumber ? metaData.transportationDetails.goodsReceiptNumber : '') + "\n";
	pdfDoc.content[2].table.body[1][2].text[5].text = (metaData.transportationDetails.vehicleNo ? metaData.transportationDetails.vehicleNo : '') + "\n";
	pdfDoc.content[2].table.body[1][2].text[7].text = (metaData.transportationDetails.driverName ? metaData.transportationDetails.driverName : '') + "\n";
	pdfDoc.content[2].table.body[1][2].text[9].text = (metaData.transportationDetails.driverNumber ? metaData.transportationDetails.driverNumber : '') + "\n";
	pdfDoc.content[2].table.body[1][2].text[11].text = (metaData.transportationDetails.supplyDate ? new Date(metaData.transportationDetails.supplyDate).toLocaleDateString('en-GB').toString() : '') + "\n";
	// pdfDoc.content[2].table.body[1][2].text[13].text = (metaData.consignee.address ? metaData.consignee.address : '') + "\n";


	//Products
	// let productList = convertToPDFProducts(metaData.invoiceData.items,true);
	let productList = convertToPDFProducts(metaData.invoiceData.items, true, metaData.invoiceData, metaData);
	productList.map((item) => {
		pdfDoc.content[3].table.body.push(item);
	});
	let gstObj = convertToGST(metaData.invoiceData.items);
	Object.keys(gstObj).forEach((key) => {
		if (key != "totalObj") {
			pdfDoc.content[4].table.body.push([
				{ text: key, style: "product" },
				{ text: gstObj[key].quantity, style: "product" },
				{ text: Number.parseFloat(gstObj[key].basicPrice).toFixed(2), style: "total" },
				{ text: gstObj[key].CGST + '%', style: "product" },
				{ text: gstObj[key].CGST_val, style: "product" },
				{ text: gstObj[key].SGST + '%', style: "product" },
				{ text: gstObj[key].SGST_val, style: "product" },
				{ text: gstObj[key].IGST + '%', style: "product" },
				{ text: gstObj[key].IGST_val, style: "product" },
				{ text: Number.parseFloat(Number.parseFloat(gstObj[key].basicPrice) + Number.parseFloat(gstObj[key].GSTValue)).toFixed(2), style: "product" }])
		}
	});

	pdfDoc.content[4].table.body.push([
		{ text: 'Total', style: "total" },
		{ text: gstObj.totalObj.quantity, style: "total" },
		{ text: Number.parseFloat(gstObj.totalObj.basicPrice).toFixed(2), style: "total" },
		{ text: '', style: "total" },
		{ text: Number.parseFloat(gstObj.totalObj.CGST_val).toFixed(2), style: "total" },
		{ text: '', style: "total" },
		{ text: Number.parseFloat(gstObj.totalObj.SGST_val).toFixed(2), style: "total" },
		{ text: '', style: "total" },
		{ text: Number.parseFloat(gstObj.totalObj.IGST_val).toFixed(2), style: "total" },
		{ text: Number.parseFloat(Number.parseFloat(gstObj.totalObj.basicPrice) + Number.parseFloat(gstObj.totalObj.GSTValue)).toFixed(2), style: "total" }]);


	//Bank Account Details
	if (metaData.terms.banks.length) {
		metaData.terms.banks.map((bankDetails) => {
			pdfDoc.content[5].table.body[0][0][1].table.body[0][0].text.push({ text: bankDetails.bankName + "\n", style: 'bankDetails' })
			pdfDoc.content[5].table.body[0][0][1].table.body[0][1].text.push({ text: "NAME: " + bankDetails.accountHolderName + "\n", style: 'bankDetails' })
			pdfDoc.content[5].table.body[0][0][1].table.body[0][0].text.push({ text: "A/C NO: " + bankDetails.accountnumber + "\n", style: 'bankDetails' })
			pdfDoc.content[5].table.body[0][0][1].table.body[0][0].text.push({ text: "IFSC: " + bankDetails.ifsccode + "\n", style: 'bankDetails' })
			pdfDoc.content[5].table.body[0][0][1].table.body[0][0].text.push({ text: bankDetails.address + "\n", style: 'bankDetails' })
		})

	}

	//Terms and cond
	pdfDoc.content[5].table.body[0][0][3].table.body[0][0] = metaData.terms.termsAndConditions;

	//gst details
	// pdfDoc.content[5].table.body[0][1].text[1].text = (metaData.invoiceData.totalAmount ? Number.parseFloat(metaData.invoiceData.totalAmount).toFixed(2) - Number.parseFloat(metaData.gstTotal.CGST_val + metaData.gstTotal.SGST_val + metaData.gstTotal.IGST_val).toFixed(2) : '0') + "\n";
	// pdfDoc.content[5].table.body[0][1].text[1].text = (metaData.invoiceData.totalAmount - metaData.invoiceData.roundOffAmount ? Number.parseFloat(metaData.invoiceData.totalAmount - metaData.invoiceData.roundOffAmount).toFixed(2) - Number.parseFloat(metaData.gstTotal.CGST_val + metaData.gstTotal.SGST_val + metaData.gstTotal.IGST_val).toFixed(2) : '0').toFixed(2) + "\n";
	pdfDoc.content[5].table.body[0][1].text[1].text = (
		Number.parseFloat(metaData.invoiceData.totalAmount) +
		Number.parseFloat(metaData.invoiceData.discountAmount || 0) +
		Number.parseFloat(metaData.invoiceData.gstOnExtraChanrges ? 0 : (-Number.parseFloat(metaData.invoiceData.totalExtraCharges))) -
		Number.parseFloat(metaData.invoiceData.gstOnExtraChanrges ? Number.parseFloat(metaData.invoiceData.totalExtraChargesGST) : 0) -
		Number.parseFloat(metaData.invoiceData.roundOffAmount || 0) -
		(Number.parseFloat(
			metaData.gstTotal.SGST_val
		) +
			Number.parseFloat(
				metaData.gstTotal.CGST_val
			) +
			Number.parseFloat(
				metaData.gstTotal.IGST_val
			))
	).toFixed(2) + "\n";
	// pdfDoc.content[5].table.body[0][1].text[3].text = (metaData.gstTotal.CGST_val ? Number.parseFloat(metaData.gstTotal.CGST_val).toFixed(2) : '0') + "\n";
	// pdfDoc.content[5].table.body[0][1].text[5].text = (metaData.gstTotal.SGST_val ? Number.parseFloat(metaData.gstTotal.SGST_val).toFixed(2) : '0') + "\n";
	// pdfDoc.content[5].table.body[0][1].text[7].text = (metaData.gstTotal.IGST_val ? Number.parseFloat(metaData.gstTotal.IGST_val).toFixed(2) : '0') + "\n";
	pdfDoc.content[5].table.body[0][1].text[3].text = (metaData.gstTotal.CGST_val ? (Number.parseFloat(metaData.gstTotal.CGST_val) + Number.parseFloat(metaData.invoiceData.gstOnExtraChanrges ? Number.parseFloat(metaData.invoiceData.totalExtraChargesGST) / 2 : 0)).toFixed(2) : '0.00') + "\n";
	pdfDoc.content[5].table.body[0][1].text[5].text = (metaData.gstTotal.SGST_val ? (Number.parseFloat(metaData.gstTotal.SGST_val) + Number.parseFloat(metaData.invoiceData.gstOnExtraChanrges ? Number.parseFloat(metaData.invoiceData.totalExtraChargesGST) / 2 : 0)).toFixed(2) : '0.00') + "\n";
	pdfDoc.content[5].table.body[0][1].text[7].text = (metaData.gstTotal.IGST_val ? (Number.parseFloat(metaData.gstTotal.IGST_val) + Number.parseFloat(metaData.invoiceData.gstOnExtraChanrges ? Number.parseFloat(metaData.invoiceData.totalExtraChargesGST) : 0)).toFixed(2) : '0.00') + "\n";
	// pdfDoc.content[5].table.body[0][1].text[9].text = (metaData.invoiceData.labourAmount ? Number.parseFloat(metaData.invoiceData.labourAmount).toFixed(2) : '0') + "\n";
	let offset = 0;
	// if(metaData.invoiceData.extraCharges && metaData.invoiceData.extraCharges.length) {
	if (!metaData.invoiceData.gstOnExtraChanrges && metaData.invoiceData.extraCharges && metaData.invoiceData.extraCharges.length) {
		metaData.invoiceData.extraCharges.map((charge) => {
			pdfDoc.content[5].table.body[0][1].text.splice(8 + offset, 0, { text: '' + charge.name + ':        ', bold: true, style: 'firmHeader' })
			offset++;
			pdfDoc.content[5].table.body[0][1].text.splice(8 + offset, 0, { text: Number.parseFloat(charge.amount).toFixed(2) + '\n', style: 'firmHeader' })
			offset++;
		})
	}
	pdfDoc.content[5].table.body[0][1].text[9 + offset].text = (metaData.invoiceData.discountAmount ? Number.parseFloat(metaData.invoiceData.discountAmount).toFixed(2) : '0') + "\n";
	pdfDoc.content[5].table.body[0][1].text[11 + offset].text = (metaData.invoiceData.roundOffAmount ? Number.parseFloat(metaData.invoiceData.roundOffAmount).toFixed(2) : '0') + "\n";
	pdfDoc.content[5].table.body[0][1].text[13 + offset].text = (metaData.invoiceData.totalAmount ? Number.parseFloat(metaData.invoiceData.totalAmount).toFixed(2) : '0') + "\n";
	pdfDoc.content[5].table.body[0][1].text[15 + offset].text = (metaData.invoiceData.paidAmount ? Number.parseFloat(metaData.invoiceData.paidAmount).toFixed(2) : '0') + "\n";
	pdfDoc.content[5].table.body[0][1].text[17 + offset].text = (metaData.invoiceData.remainingAmount ? Number.parseFloat(metaData.invoiceData.remainingAmount).toFixed(2) : '') + "\n";

	// if(metaData.invoiceData.extraCharges && metaData.invoiceData.extraCharges.length) {
	// 						metaData.invoiceData.extraCharges.map((charge)=>{
	// 							pdfDoc.content[5].table.body[0][1].text.push({ text: ''+charge.name+':-          ', bold: true })
	// 							pdfDoc.content[5].table.body[0][1].text.push({ text:charge.amount+'\n' })
	// 						})
	// 					}
	// pdfDoc.content[6].table.body[0][1].text[17].text = (metaData.invoiceData.paymentType ? metaData.invoiceData.paymentType : '') + "\n";

	//authority
	pdfDoc.content[6].table.body[0][1].text[1].text = (metaData.firm.name ? (metaData.firm.name).toUpperCase() : '');

	//thank you
	// pdfDoc.content[7].table.body[0][0].text =  "Thank You " + (metaData.customer.name.toUpperCase() ? metaData.customer.name.toUpperCase() : '') +" For Choosing us!" ;
	pdfDoc.content[7].table.body[0][0].text = metaData.terms.termsAndConditions.greetingMessage || ("Thank You " + ((metaData.customer && metaData.customer.name) ? metaData.customer.name.toUpperCase() : '') + " For Choosing us!");

	//Basic Details
	pdfDoc.content[8].table.body[1][0].text[1].text = (metaData.ebillDetails.billNo ? metaData.ebillDetails.billNo : '') + "\n";   //eway bill number
	pdfDoc.content[8].table.body[1][0].text[3].text = (metaData.ebillDetails.billDate ? new Date(metaData.ebillDetails.billDate).toLocaleDateString('en-GB').toString() : '') + "\n";   //e-way bill date
	pdfDoc.content[8].table.body[1][0].text[5].text = (metaData.ebillDetails.generatedBy ? metaData.ebillDetails.generatedBy : '') + "\n";   //generated by
	pdfDoc.content[8].table.body[1][0].text[7].text = (metaData.invoiceData.date ? new Date(metaData.ebillDetails.date).toLocaleDateString('en-GB').toString() : '') + "\n";   //Valid from
	pdfDoc.content[8].table.body[1][0].text[9].text = (metaData.ebillDetails.validUntil ? new Date(metaData.ebillDetails.validUntil).toLocaleDateString('en-GB').toString() : '') + "\n";   //Valid Till

	//Part A
	pdfDoc.content[8].table.body[1][1].text[1].text = (metaData.ebillDetails.GSTofSupplier ? metaData.ebillDetails.GSTofSupplier : '') + "\n";   //gstin of supplier
	pdfDoc.content[8].table.body[1][1].text[3].text = (metaData.ebillDetails.placeOfDispatch ? metaData.ebillDetails.placeOfDispatch : '') + "\n";   //place of dispatch
	pdfDoc.content[8].table.body[1][1].text[5].text = (metaData.ebillDetails.GSTofReceipient ? metaData.ebillDetails.GSTofReceipient : '') + "\n";   //gstin of receipent
	pdfDoc.content[8].table.body[1][1].text[7].text = (metaData.ebillDetails.placeOfDelivery ? metaData.ebillDetails.placeOfDelivery : '') + "\n";   //place of delivary
	pdfDoc.content[8].table.body[1][1].text[9].text = (metaData.ebillDetails.documentNo ? metaData.ebillDetails.documentNo : '') + "\n";   //document number
	pdfDoc.content[8].table.body[1][1].text[11].text = (metaData.ebillDetails.valueOfGoods ? metaData.ebillDetails.valueOfGoods : '') + "\n";   //value of goods
	pdfDoc.content[8].table.body[1][1].text[13].text = (metaData.ebillDetails.reasonOfTransportation ? metaData.ebillDetails.reasonOfTransportation : '') + "\n";   //reason of transpotation
	pdfDoc.content[8].table.body[1][1].text[15].text = (metaData.ebillDetails.documentDate ? new Date(metaData.ebillDetails.documentDate).toLocaleDateString('en-GB').toString() : '') + "\n";   //document date
	pdfDoc.content[8].table.body[1][1].text[17].text = '' + "\n";   //hsn code

	//part b

	pdfDoc.content[9].table.body.push(
		[
			{ text: metaData.ebillDetails.transportationDetails.mode, style: "Header3" }, //mode
			{ text: metaData.ebillDetails.transportationDetails.vehicleNo, style: "Header3" }, //vehicle no
			{ text: metaData.ebillDetails.transportationDetails.enteredBy, style: "Header3" }, //entered by
			{ text: metaData.ebillDetails.transportationDetails.departureDate, style: "Header3" }, //time and date
			{ text: metaData.ebillDetails.transportationDetails.from, style: "Header3" }, //from
			{ text: metaData.ebillDetails.transportationDetails.to, style: "Header3" }, //to
			{ text: metaData.ebillDetails.transportationDetails.CEWBno, style: "Header3" }, //cewb no
		]
	);

	return pdfDoc;
}


export const convertToBasicInvoice = async (metaData) => {
	let pdfDoc = {
		content: [
			{
				table: {
					widths: ['*'],
					body: [
						[
							{ text: 'TAX INVOICE', style: "topHeader1" },
						],
					],

				},
				layout: 'noBorders'
			},
			{
				table: {
					widths: ['0%', '45%', '*'],
					body: [

						[
							{
								text: ''

							},
							{
								image: '',
								width: 100,
								height: 80,
							},
							{
								text:
									[
										{ text: ' ', bold: true, style: 'topFirmAuthorityRight' },
										{ text: '\n', style: 'topFirmAuthorityRight' },
										{ text: ' ', bold: true, style: 'topHeaderRight' },
										{ text: '1600 Amphitheatre Parkway in Mountain View, California, United States, near San Jose. \n', style: 'topHeaderRight' },
										{ text: ' ', bold: true, style: 'topHeaderRight' },
										{ text: '1600 Amphitheatre Parkway in Mountain View, California, United States, near San Jose. \n', style: 'topHeaderRight' },
										{ text: '', bold: true, style: 'topHeaderRight' },
										{ text: '88776655\n', style: 'topHeaderRight' },
										{ text: '', bold: true, style: 'topHeaderRight' }, //icon gift
										{ text: 'njnjn@jnn.com\n', style: 'topHeaderRight' },
										{ text: ' ', bold: true, style: 'topHeaderRight' },
										{ text: '123456\n', style: 'topHeaderRight' },
									]

							},
							// {
							// 	text: ''

							// },
						],
					]
				},
				layout: 'noBorders',
				style: "topTab"
			},
			{
				table: {
					widths: ['0%', '65%', '*'],
					body: [
						[
							{ text: '', style: "billToHeader" },
							{ text: 'BILL TO', style: "billToHeader" },
							{ text: 'INVOICE DETAILS', style: "invoiceDetailHeader" },
						],

					],

				},
				style: 'tab2Head',
				layout: 'noBorders',
			},
			{
				table: {
					widths: ['0%', '65%', '*'],
					body: [
						[
							{
								text: ''

							},
							{
								text:
									[
										{ text: ' ', bold: true, style: 'topCustomerHeader' },
										{ text: 'Google\n', style: 'topCustomerHeader' },
										{ text: ' ', bold: true, style: 'topHeader' },
										{ text: '1679905\n', style: 'topHeader' },
										{ text: '  ', bold: true, style: 'topHeader' },
										{ text: '7788996655\n', style: 'topHeader' },
										{ text: '  ', bold: true, style: 'topHeader' },
										{ text: '1600 Amphitheatre Parkway in Mountain View, California, United States, near San Jose. \n', style: 'topHeader' },
										{ text: 'Mobile Number: ', bold: true, style: 'topHeader' },
										{ text: '23\n', style: 'topHeader' },
										{ text: 'Place of supply:   ', bold: true, style: 'topHeader' },
										{ text: '13/12/90\n', style: 'topHeader' },
										{ text: 'State Code:   ', bold: true, style: 'topHeader' },
										{ text: '13/12/90\n', style: 'topHeader' },
									]
							},
							{
								text:
									[
										{ text: 'Invoice No:                  ', bold: true, style: 'topHeader' },
										{ text: '787878\n', style: 'topHeader' },
										{ text: 'Invoice Date:               ', bold: true, style: 'topHeader' },
										{ text: '12/12/90 \n', style: 'topHeader' },
										{ text: 'Invoice Status:            ', bold: true, style: 'topHeader' },
										{ text: '12/12/90 \n', style: 'topRemainingHeader' },
										{ text: 'Payment Due Date:    ', bold: true, style: 'topHeader' },
										{ text: '13/12/90\n', style: 'topHeader' },
										{ text: 'Remark:    ', bold: true, style: 'topHeader' },
										{ text: '13/12/90\n', style: 'topHeader' },
									]
							},

						],
					],


				},
				style: 'tab2',
				layout: 'noBorders',

			},
			{
				table: {
					widths: ['*', '*',],
					body: [
						[
							{ text: 'PRODUCT DETAILS', style: "emptyHeader" },
							{ text: '', style: "emptyHeader" },
						],

					],

				},
				layout: 'noBorders',
			},
			{
				table: {

					body: [
						[
							{ text: 'S.No', style: "productHeader", rowSpan: 2 },
							{ text: 'Product Name', style: "productHeader", rowSpan: 2 },
							{ text: 'HSN code', style: "productHeader", rowSpan: 2 },
							{ text: 'Qty', style: "productHeader", rowSpan: 2 },
							{ text: 'Units', style: "productHeader", rowSpan: 2 },
							{ text: 'Unit Price', style: "productHeader", rowSpan: 2 },
							{ text: 'Taxable  Amount', style: "productHeader", rowSpan: 2 },
							{ text: 'CGST', style: "productHeader", colSpan: 2, rowSpan: 1 },
							{ text: '', style: "productHeader" },
							{ text: 'SGST', style: "productHeader", colSpan: 2, rowSpan: 1 },
							{ text: '', style: "productHeader" },
							{ text: 'IGST', style: "productHeader", colSpan: 2, rowSpan: 1 },
							{ text: '', style: "productHeader" },
							{ text: 'Total Amount', style: "productHeader", rowSpan: 2 }
						],
						[
							{ text: 'S.No', style: "productHeader" },
							{ text: 'Product Name', style: "productHeader" },
							{ text: 'HSN code', style: "productHeader" },
							{ text: 'Qty', style: "productHeader" },
							{ text: 'Units', style: "productHeader" },
							{ text: 'Rate', style: "productHeader" },
							{ text: 'Taxable Amount', style: "productHeader" },
							{ text: '%', style: "productHeader" },
							{ text: '₹', style: "productHeader" },
							{ text: '%', style: "productHeader" },
							{ text: '₹', style: "productHeader" },
							{ text: '%', style: "productHeader" },
							{ text: '₹', style: "productHeader" },
							{ text: 'Total Amount', style: "productHeader" }
						],
					]
				}
			},
			{
				table: {
					widths: ['70%', '*'],
					body: [

						[
							[
								{
									table: {
										widths: ['*'],
										body: [
											[
												{ text: 'PAYMENT DETAILS', style: "leftHeader" }
											],

										],


									},
									style: 'tab2Head',
									layout: 'noBorders',

								}, {
									table: {
										widths: ['3%', '*'],
										body: [
											[{
												text: ''

											},
											{
												text:
													[]
											},
											]
										]
									},
									style: 'tab2',
									layout: 'noBorders',
								},
								{
									table: {
										widths: ['*'],
										body: [
											[
												{ text: 'TERMS & CONDITIONS', style: "leftHeader" },

											],

										],


									},
									style: 'tab2Head',
									layout: 'noBorders',

								}, {
									table: {
										widths: ['3%', '*'],
										body: [
											[
												{
													text: ''

												},
												{
													text: "",

												},
											]
										]
									},
									style: 'tab2',
									layout: 'noBorders',
								},

							],
							{
								text:
									[
										{ text: 'Taxable Amount:     ', bold: true, style: 'topHeader' },
										{ text: '12122\n', style: 'topHeader' },
										{ text: 'CGST Amount:         ', bold: true, style: 'topHeader' },
										{ text: '12122\n', style: 'topHeader' },
										{ text: 'SGST Amount:         ', bold: true, style: 'topHeader' },
										{ text: '12122\n', style: 'topHeader' },
										{ text: 'IGST Amount:          ', bold: true, style: 'topHeader' },
										{ text: '12122\n', style: 'topHeader' },
										// { text: 'Labour Charge:       ', bold: true, style: 'topHeader' },
										// { text: '12122\n', style: 'topHeader' },
										{ text: 'Discount:                  ', bold: true, style: 'topHeader' },
										{ text: '12122\n', style: 'topHeader' },
										{ text: 'RoundOff:                 ', bold: true, style: 'topHeader' },
										{ text: '12122\n', style: 'topHeader' },
										{ text: 'Total Amount:          ', bold: true, style: 'topHeader11' },
										{ text: '12122\n', style: 'topHeader11' },
										{ text: 'Paid Amount:           ', bold: true, style: 'topHeader' },
										{ text: '12122\n', style: 'topHeader' },
										{ text: 'Due Amount:            ', bold: true, style: 'topRemainingHeader' },
										{ text: '12122\n', style: 'topRemainingHeader' },
										// 	{ text: 'Payment Type:-       ', bold: true },
										// { text: '12122\n' },
									]

							},

						],
					],


				},
				style: 'tab2',
				layout: 'lightHorizontalLines',

			},
			{
				table: {
					widths: ['*', '*',],
					body: [
						[
							{ text: 'OUTSTANDING DETAILS', style: "emptyHeader" },
							{ text: '', style: "emptyHeader" },
						],

					],

				},
				layout: 'noBorders',
			},

			// Start of Previous + current = Total Column
			{
				table: {
					widths: ['34%', '39%', '27%'],
					body: [
						[
							{ text: '', style: "topBlankHeader" },
							{ text: '', style: "topMainHeader" },
							{ text: '', style: "topBlankHeader" },
						],
						[
							{
								text:
									[
										{ text: 'PREVIOUS BALANCE :  ', bold: true, style: 'topHeader11' },
										{ text: '\n', style: 'topHeader11' },
									]
							},
							{
								text:
									[
										{ text: 'CURRENT BALANCE :  ', bold: true, style: 'topHeader11' },
										{ text: '\n', style: 'topHeader11' },
									]
							},

							{
								text:
									[
										{ text: 'TOTAL BALANCE :  ', bold: true, style: 'topRemainingHeader' },
										{ text: '\n', style: 'topRemainingHeader' },
									]
							},

						],
					]
				},
				layout: {
					hLineWidth: function (i, node) {
						return (i === 0 || i === node.table.body.length) ? 1 : 0;
					},
					vLineWidth: function (i, node) {
						return (i === 0 || i === node.table.widths.length) ? 1 : 0;
					},
					hLineColor: function (i, node) {
						return (i === 0 || i === node.table.body.length) ? 'black' : 'black';
					},
					vLineColor: function (i, node) {
						return (i === 0 || i === node.table.widths.length) ? 'black' : 'black';
					},
				}
			},
			// End of Previous + current = Total Column

			{
				table: {
					widths: ['60%', '*'],
					body: [
						[
							{
								text:
									[

									]

							},
							
									[{ text: '' },
									{ text: 'Firm Name  ', bold: true, alignment: 'center', style: 'topFirmBasicAuthority' },
									{ text: '\n\n\n' },

									{ text: 'AUTHORITY SIGNATURE  ', bold: true, alignment: 'center', style: 'topFirmBasicAuthority' },
									{ text: '\n' },
									]

							
						],
					],


				},
				style: 'tab2',
				layout: 'noBorders',

			},
			{
				table: {
					widths: ['*'],
					body: [
						[
							{ text: 'Thank you', alignment: 'center', },

						],

					],

				},
				layout: 'noBorders',
				style: 'tab2',
			},
		],
		footer: {
			columns: [
				{
					text: 'Powered By ACUIFY',
					alignment: 'right',
					color: '#160091'
				}
			],
			margin: [10, 10]
		},
		styles: {
			header: {
				fontSize: 10,
				bold: true,
				alignment: 'center'
			},
			billToHeader: {
				fontSize: 12,
				bold: true,
				alignment: 'left',
			},
			invoiceDetailHeader: {
				fontSize: 12,
				bold: true,
				alignment: 'left'
			},
			header1: {
				color: '#160091',
				fontSize: 10,
				bold: true,
				fillColor: '#15155d',
			},
			product: {
				fontSize: 9,
				alignment: 'center',
			},
			productRight: {
				fontSize: 10,
				alignment: 'right',
				// bold: true
			},
			totalRight: {
				fontSize: 10,
				alignment: 'right',
				bold: true
			},
			total: {
				fontSize: 10,
				alignment: 'center',
				bold: true
			},
			topHeader: {
				fontSize: 10,
				bold: true,
				fillColor: '#15155d',
			},
			topHeaderRight: {
				fontSize: 10,
				bold: true,
				fillColor: '#15155d',
				alignment: 'right'
			},
			topCustomerHeader: {
				fontSize: 12,
				bold: true,
				color: '#160091',
			},
			topHeader1: {
				color: 'white',
				fontSize: 14,
				bold: true,
				alignment: 'center',
				fillColor: '#15155d',
			},
			topHeader11: {
				color: '#160091',
				fontSize: 10,
				bold: true,
			},
			topRemainingHeader: {
				color: '#FF0000',
				fontSize: 10,
				bold: true,
			},
			topFirmAuthority: {
				color: '#160091',
				fontSize: 12,
				bold: true,
			},
			topFirmAuthorityRight: {
				color: '#160091',
				fontSize: 14,
				bold: true,
				alignment: 'right'
			},
			topFirmBasicAuthority: {
				color: '#160091',
				fontSize: 10,
				bold: true,
			},
			leftHeader: {
				fontSize: 10,
				bold: true,
				alignment: 'left'
			},
			emptyHeader: {
				fontSize: 10,
				color: 'white',
				fillColor: '#15155d',
				bold: true,
			},
			topTab: {
				fillColor: '#ececec',
			},
			tab2Head: {
				color: 'white',
				fillColor: '#015155d',
			},
			tab2: {
				fillColor: '#ececec',
			},
			bankDetails: {
				fontSize: 10,
				bold: true,
			},
			productHeader: {
				fontSize: 10,
				bold: true,
				alignment: 'center',
				color: '#160091',
			},
			hiddenTab: {
				fillColor: '#ececec',
				color: '#ececec',
			},
		}
	}
	//Firm Details 
	// pdfDoc.content[1].table.body[0][2].text[1].text = (metaData.firm.name.toUpperCase() ? metaData.firm.name.toUpperCase() : '') + "\n";
	pdfDoc.content[1].table.body[0][2].text[1].text = ((metaData.firm && metaData.firm.name) ? metaData.firm.name.toUpperCase() : '') + "\n";
	pdfDoc.content[1].table.body[0][2].text[3].text = (metaData.firm.GST_number ? metaData.firm.GST_number : '') + "\n";
	pdfDoc.content[1].table.body[0][2].text[5].text = (metaData.firm.liveAddress ? metaData.firm.liveAddress : '') + "\n";
	pdfDoc.content[1].table.body[0][2].text[7].text = (metaData.firm.address ? metaData.firm.address : '') + "\n";
	pdfDoc.content[1].table.body[0][2].text[9].text = (metaData.firm.mobileNumber ? metaData.firm.mobileNumber : '') + "\n";
	pdfDoc.content[1].table.body[0][2].text[11].text = (metaData.firm.email ? metaData.firm.email : '') + "\n";

	//Receipient Details
	// pdfDoc.content[3].table.body[0][1].text[1].text = (metaData.customer.name.toUpperCase() ? metaData.customer.name.toUpperCase() : '') + "\n";
	// pdfDoc.content[3].table.body[0][1].text[1].text = ((metaData.customer.name && metaData.customer.name )? metaData.customer.name.toUpperCase() : '') + "\n";
	pdfDoc.content[3].table.body[0][1].text[1].text = (getCustomerDetails(metaData, 'name').toUpperCase()) + "\n";
	pdfDoc.content[3].table.body[0][1].text[3].text = (metaData.customer.GST_number ? metaData.customer.GST_number : '') + "\n";
	pdfDoc.content[3].table.body[0][1].text[5].text = (metaData.customer.localAddress ? metaData.customer.localAddress : '') + "\n";
	// pdfDoc.content[3].table.body[0][1].text[7].text = (metaData.customer.address ? metaData.customer.address : '') + "\n";	
	pdfDoc.content[3].table.body[0][1].text[7].text = (getCustomerDetails(metaData, 'address')) + "\n";
	pdfDoc.content[3].table.body[0][1].text[9].text = (getCustomerDetails(metaData, 'mobile').toUpperCase()) + "\n";
	// pdfDoc.content[3].table.body[0][1].text[9].text = (metaData.customer.mobile ? metaData.customer.mobile : '') + "\n";
	// pdfDoc.content[3].table.body[0][1].text[9].text = (metaData.customer.placeOfSupply ? metaData.customer.placeOfSupply : '') + "\n";
	pdfDoc.content[3].table.body[0][1].text[11].text = (metaData.invoiceData.placeOfSupply ? metaData.invoiceData.placeOfSupply : '') + "\n";
	pdfDoc.content[3].table.body[0][1].text[13].text = (metaData.customer.stateCode ? metaData.customer.stateCode : '') + "\n";

	//Invoice Details
	let date = new Date(metaData.invoiceData.date)
	let paymentDueDate = date.setDate(date.getDate() + (metaData.invoiceData.duration ? parseInt(metaData.invoiceData.duration) : 0));
	pdfDoc.content[3].table.body[0][2].text[1].text = metaData.invoiceData.invoiceId + "\n";
	pdfDoc.content[3].table.body[0][2].text[3].text = new Date(metaData.invoiceData.date).toLocaleDateString('en-GB').toString() + "\n";
	pdfDoc.content[3].table.body[0][2].text[5].text = (metaData.invoiceData.status ? metaData.invoiceData.status.toUpperCase() : '') + "\n";
	pdfDoc.content[3].table.body[0][2].text[7].text = new Date(paymentDueDate).toLocaleDateString('en-GB').toString() + "\n";
	pdfDoc.content[3].table.body[0][2].text[9].text = (metaData.invoiceData.remark ? metaData.invoiceData.remark : '') + "\n";

	// Products
	// let productList = convertToPDFProducts(metaData.invoiceData.items,true);
	let productList = convertToPDFProducts(metaData.invoiceData.items, true, metaData.invoiceData, metaData);
	productList.map((item) => {
		pdfDoc.content[5].table.body.push(item);
	});

	// Payment Details

	// pdfDoc.content[6].table.body[0][0][1].table.body[0][1].text[1].text = (metaData.invoiceData.paymentType ? metaData.invoiceData.paymentType : '') + "\n";
	// pdfDoc.content[6].table.body[0][0][1].table.body[0][1].text[3].text = (metaData.invoiceData.transactionType ? metaData.invoiceData.transactionType : '') + "\n";

	// Bank Account Details
	if (metaData.terms.banks.length) {
		metaData.terms.banks.map((bankDetails) => {
			pdfDoc.content[6].table.body[0][0][1].table.body[0][1].text.push({ text: bankDetails.bankName + " \n", style: 'bankDetails' })
			pdfDoc.content[6].table.body[0][0][1].table.body[0][1].text.push({ text: "NAME: " + bankDetails.accountHolderName + "\n", style: 'bankDetails' })
			pdfDoc.content[6].table.body[0][0][1].table.body[0][1].text.push({ text: "A/C No: " + bankDetails.accountnumber + "\n", style: 'bankDetails' })
			pdfDoc.content[6].table.body[0][0][1].table.body[0][1].text.push({ text: "IFSC: " + bankDetails.ifsccode + "\n", style: 'bankDetails' })
			pdfDoc.content[6].table.body[0][0][1].table.body[0][1].text.push({ text: bankDetails.address + "\n", style: 'bankDetails' })
		})
	}
	// Terms and cond
	pdfDoc.content[6].table.body[0][0][3].table.body[0][1] = metaData.terms.termsAndConditions;

	// gst details
	// pdfDoc.content[6].table.body[0][1].text[1].text = ((metaData.invoiceData.totalAmount - metaData.invoiceData.roundOffAmount ? Number.parseFloat(metaData.invoiceData.totalAmount - metaData.invoiceData.roundOffAmount).toFixed(2) - Number.parseFloat(metaData.gstTotal.CGST_val + metaData.gstTotal.SGST_val + metaData.gstTotal.IGST_val).toFixed(2) : '0')).toFixed(2) + "\n";
	pdfDoc.content[6].table.body[0][1].text[1].text = (
		Number.parseFloat(metaData.invoiceData.totalAmount) +
		Number.parseFloat(metaData.invoiceData.discountAmount || 0) +
		Number.parseFloat(metaData.invoiceData.gstOnExtraChanrges ? 0 : (-Number.parseFloat(metaData.invoiceData.totalExtraCharges))) -
		Number.parseFloat(metaData.invoiceData.gstOnExtraChanrges ? Number.parseFloat(metaData.invoiceData.totalExtraChargesGST) : 0) -
		Number.parseFloat(metaData.invoiceData.roundOffAmount || 0) -
		(Number.parseFloat(
			metaData.gstTotal.SGST_val
		) +
			Number.parseFloat(
				metaData.gstTotal.CGST_val
			) +
			Number.parseFloat(
				metaData.gstTotal.IGST_val
			))
	).toFixed(2) + "\n";
	pdfDoc.content[6].table.body[0][1].text[3].text = (metaData.gstTotal.CGST_val ? (Number.parseFloat(metaData.gstTotal.CGST_val) + Number.parseFloat(metaData.invoiceData.gstOnExtraChanrges ? Number.parseFloat(metaData.invoiceData.totalExtraChargesGST) / 2 : 0)).toFixed(2) : '0.00') + "\n";
	pdfDoc.content[6].table.body[0][1].text[5].text = (metaData.gstTotal.SGST_val ? (Number.parseFloat(metaData.gstTotal.SGST_val) + Number.parseFloat(metaData.invoiceData.gstOnExtraChanrges ? Number.parseFloat(metaData.invoiceData.totalExtraChargesGST) / 2 : 0)).toFixed(2) : '0.00') + "\n";
	pdfDoc.content[6].table.body[0][1].text[7].text = (metaData.gstTotal.IGST_val ? (Number.parseFloat(metaData.gstTotal.IGST_val) + Number.parseFloat(metaData.invoiceData.gstOnExtraChanrges ? Number.parseFloat(metaData.invoiceData.totalExtraChargesGST) : 0)).toFixed(2) : '0.00') + "\n";
	// pdfDoc.content[6].table.body[0][1].text[9].text = (metaData.invoiceData.labourAmount ? Number.parseFloat(metaData.invoiceData.labourAmount).toFixed(2) : '0.00') + "\n";
	let offset = 0;
	if (!metaData.invoiceData.gstOnExtraChanrges && metaData.invoiceData.extraCharges && metaData.invoiceData.extraCharges.length) {
		metaData.invoiceData.extraCharges.map((charge) => {
			pdfDoc.content[6].table.body[0][1].text.splice(8 + offset, 0, { text: '' + charge.name + ':        ', bold: true, style: 'topHeader' })
			offset++;
			pdfDoc.content[6].table.body[0][1].text.splice(8 + offset, 0, { text: Number.parseFloat(charge.amount).toFixed(2) + '\n', style: 'topHeader' })
			offset++;
		})
	}
	pdfDoc.content[6].table.body[0][1].text[9 + offset].text = (metaData.invoiceData.discountAmount ? Number.parseFloat(metaData.invoiceData.discountAmount).toFixed(2) : '0.00') + "\n";
	pdfDoc.content[6].table.body[0][1].text[11 + offset].text = (metaData.invoiceData.roundOffAmount ? Number.parseFloat(metaData.invoiceData.roundOffAmount).toFixed(2) : '0.00') + "\n";
	// pdfDoc.content[6].table.body[0][1].text[15].text = (metaData.invoiceData.totalAmount + metaData.invoiceData.labourAmount -  metaData.invoiceData.discountAmount ? Number.parseFloat(Number.parseFloat(metaData.invoiceData.totalAmount) + Number.parseFloat(metaData.invoiceData.labourAmount) - Number.parseFloat(metaData.invoiceData.discountAmount)).toFixed(2) : '0') + "\n";
	pdfDoc.content[6].table.body[0][1].text[13 + offset].text = (metaData.invoiceData.totalAmount ? Number.parseFloat(metaData.invoiceData.totalAmount).toFixed(2) : '0.00') + "\n";
	pdfDoc.content[6].table.body[0][1].text[15 + offset].text = (metaData.invoiceData.paidAmount ? Number.parseFloat(metaData.invoiceData.paidAmount).toFixed(2) : '0.00') + "\n";
	pdfDoc.content[6].table.body[0][1].text[17 + offset].text = (metaData.invoiceData.remainingAmount ? Number.parseFloat(metaData.invoiceData.remainingAmount).toFixed(2) : '0.00') + "\n";
	// pdfDoc.content[6].table.body[0][1].text[17].text = (metaData.invoiceData.paymentType ? metaData.invoiceData.paymentType : '') + "\n";

	// if(metaData.invoiceData.extraCharges && metaData.invoiceData.extraCharges.length) {
	// 	metaData.invoiceData.extraCharges.map((charge)=>{
	// 	pdfDoc.content[6].table.body[0][1].text.push({ text: ''+charge.name+':        ', bold: true, style: 'topHeader' })
	// 	pdfDoc.content[6].table.body[0][1].text.push({ text: Number.parseFloat(charge.amount).toFixed(2)+'\n', bold: true, style: 'topHeader' })
	// 	})
	// }
	if (metaData.balance && metaData.terms.isPreviousCurrentTotalBalance) {
		pdfDoc.content[8].table.body[1][0].text[1].text = Number.parseFloat(Number.parseFloat(metaData.balance) - Number.parseFloat(metaData.invoiceData.remainingAmount).toFixed(2)).toFixed(2) + "\n";
		pdfDoc.content[8].table.body[1][1].text[1].text = (metaData.invoiceData.remainingAmount ? Number.parseFloat(metaData.invoiceData.remainingAmount).toFixed(2) : '0.00') + "\n";
		pdfDoc.content[8].table.body[1][2].text[1].text = (metaData.balance ? Number.parseFloat(metaData.balance).toFixed(2) : '0.00') + "\n";
	} else {
		pdfDoc.content[8] = {};
		pdfDoc.content[7] = {};
	}

	//authority
	pdfDoc.content[9].table.body[0][1][1].text = (metaData.firm.name ? (metaData.firm.name).toUpperCase() : '');

	//thank you
	// pdfDoc.content[9].table.body[0][0].text =  metaData.terms.termsAndConditions.greetingMessage || ("Thank You " + ((metaData.customer && metaData.customer.name )? metaData.customer.name.toUpperCase() : '') +" For Choosing us!" )
	// pdfDoc.content[9].table.body[0][0].text =  "Thank You " + (metaData.customer.name.toUpperCase() ? metaData.customer.name.toUpperCase() : '') +" For Choosing us!" 
	pdfDoc.content[10].table.body[0][0].text = metaData.terms.greetingMessage || ("Thank You " + (getCustomerDetails(metaData, 'name').toUpperCase()) + " for doing business with us!")

	if (metaData.terms.isBlankHeader) {
		pdfDoc.content[1].table.body[0][1] = { text: '' };
		pdfDoc.content[1].style = 'hiddenTab';
		pdfDoc.content[1].table.body[0][2].text[1].style = 'hiddenTab'
	} else {
		if (metaData.terms.printLogo) {
			try {
				let logoData = await getBase64ImageFromURL(metaData.terms.printLogo)
				pdfDoc.content[1].table.body[0][1].image = logoData;
				let invoiceImages = document.getElementById('invoiceImages');
					if (invoiceImages && invoiceImages.files && invoiceImages.files.length) {
						let temp = {columns: []};
						if(invoiceImages.files[0]) {
							temp.columns.push({
								image: await toBase64(invoiceImages.files[0]).catch(e => Error(e)),
								width: 150
							})
						}
						if(invoiceImages.files[1]) {
							temp.columns.push({
								image: await toBase64(invoiceImages.files[1]).catch(e => Error(e)),
								width: 150
							})
						}
						if(invoiceImages.files[2]) {
							temp.columns.push({
								image: await toBase64(invoiceImages.files[2]).catch(e => Error(e)),
								width: 150
							})
						}
						pdfDoc.content.push(temp)
					}
					if(metaData.terms.signature) {
						let temp = {columns: []};
						temp.columns.push({
							image: await getBase64ImageFromURL(metaData.terms.signature),
							width: 150,
							height: 40,
							alignment:'right'
						})
						//pdfDoc.content.push(temp)
						pdfDoc.content[9].table.body[0][1][2] = temp.columns[0];
					}
				return pdfDoc;
			} catch (error) {
				console.log(error)
			}
		} else {
			var imgToExport = document.getElementById('pdfimgToExport');
			var canvas = document.createElement('canvas');
			canvas.width = imgToExport.width;
			canvas.height = imgToExport.height;
			canvas.getContext('2d').drawImage(imgToExport, 0, 0);
			let base64 = canvas.toDataURL('image/png')
			pdfDoc.content[1].table.body[0][1].image = base64;
			let invoiceImages = document.getElementById('invoiceImages');
					if (invoiceImages && invoiceImages.files && invoiceImages.files.length) {
						let temp = {columns: []};
						if(invoiceImages.files[0]) {
							temp.columns.push({
								image: await toBase64(invoiceImages.files[0]).catch(e => Error(e)),
								width: 150
							})
						}
						if(invoiceImages.files[1]) {
							temp.columns.push({
								image: await toBase64(invoiceImages.files[1]).catch(e => Error(e)),
								width: 150
							})
						}
						if(invoiceImages.files[2]) {
							temp.columns.push({
								image: await toBase64(invoiceImages.files[2]).catch(e => Error(e)),
								width: 150
							})
						}
						pdfDoc.content.push(temp)
					}
				}
			}
			if(metaData.terms.signature) {
				let temp = {columns: []};
				temp.columns.push({
					image: await getBase64ImageFromURL(metaData.terms.signature),
					width: 150,
					alignment:'right'
				})
				pdfDoc.content[9].table.body[0][1][2] = temp.columns[0];
				//pdfDoc.content.push(temp)
			}
		return pdfDoc;
	}

	export const toBase64 = file => new Promise((resolve, reject) => {
		const reader = new FileReader();
		reader.readAsDataURL(file);
		reader.onload = () => resolve(reader.result);
		reader.onerror = error => reject(error);
	});

	// Start of New Photo Resize Format
	export const convertToBasicShortInvoice = async (metaData) => {
		let pdfDoc = {
			content: [
				{
					table: {
						widths: ['*'],
						body: [
							[
								{ text: 'TRAIL INVOICE', style: "topHeader1" },
							],
						],
	
					},
					layout: 'noBorders'
				},
				{
					table: {
						widths: ['25%', '25%', '25%', '25%'],
						body: [
	
							[
								{
									text: ''
	
								},
								{
									image: '',
									width: 100,
									height: 80,
								},
								{
									text:
										[
											{ text: ' ', bold: true, style: 'topFirmAuthorityRight' },
											{ text: '\n', style: 'topFirmAuthorityRight' },
											{ text: ' ', bold: true, style: 'topHeaderRight' },
											{ text: '1600 Amphitheatre Parkway in Mountain View, California, United States, near San Jose. \n', style: 'topHeaderRight' },
											{ text: ' ', bold: true, style: 'topHeaderRight' },
											{ text: '1600 Amphitheatre Parkway in Mountain View, California, United States, near San Jose. \n', style: 'topHeaderRight' },
											{ text: '', bold: true, style: 'topHeaderRight' },
											{ text: '88776655\n', style: 'topHeaderRight' },
											{ text: '', bold: true, style: 'topHeaderRight' }, //icon gift
											{ text: 'njnjn@jnn.com\n', style: 'topHeaderRight' },
											{ text: ' ', bold: true, style: 'topHeaderRight' },
											{ text: '123456\n', style: 'topHeaderRight' },
										]
	
								},
								{
									text:
										[
											{ text: ' ', bold: true, style: 'topCustomerHeader' },
											{ text: 'Google\n', style: 'topCustomerHeader' },
											{ text: ' ', bold: true, style: 'topHeader' },
											{ text: '1679905\n', style: 'topHeader' },
											{ text: '  ', bold: true, style: 'topHeader' },
											{ text: '7788996655\n', style: 'topHeader' },
											{ text: '  ', bold: true, style: 'topHeader' },
											{ text: '1600 Amphitheatre Parkway in Mountain View, California, United States, near San Jose. \n', style: 'topHeader' },
											{ text: 'Mobile Number: ', bold: true, style: 'topHeader' },
											{ text: '23\n', style: 'topHeader' },
											{ text: 'Place of supply:   ', bold: true, style: 'topHeader' },
											{ text: '13/12/90\n', style: 'topHeader' },
											{ text: 'State Code:   ', bold: true, style: 'topHeader' },
											{ text: '13/12/90\n', style: 'topHeader' },
										]
								},
								{
									text:
										[
											{ text: 'Invoice No:                  ', bold: true, style: 'topHeader' },
											{ text: '787878\n', style: 'topHeader' },
											{ text: 'Invoice Date:               ', bold: true, style: 'topHeader' },
											{ text: '12/12/90 \n', style: 'topHeader' },
											{ text: 'Invoice Status:            ', bold: true, style: 'topHeader' },
											{ text: '12/12/90 \n', style: 'topRemainingHeader' },
											{ text: 'Payment Due Date:    ', bold: true, style: 'topHeader' },
											{ text: '13/12/90\n', style: 'topHeader' },
										]
								},
								// {
								// 	text: ''
	
								// },
							],
						]
					},
					layout: 'noBorders',
					style: "topTab"
				},
				{
					table: {
						widths: ['0%', '65%', '*'],
						body: [
							[
								{ text: '', style: "billToHeader" },
								{ text: 'BILL TO', style: "billToHeader" },
								{ text: 'INVOICE DETAILS', style: "invoiceDetailHeader" },
							],
	
						],
	
					},
					style: 'tab2Head',
					layout: 'noBorders',
				},
				{
					table: {
						widths: ['0%', '65%', '*'],
						body: [
							[
								{
									text: ''
	
								},
								{
									text:
										[
											{ text: ' ', bold: true, style: 'topCustomerHeader' },
											{ text: 'Google\n', style: 'topCustomerHeader' },
											{ text: ' ', bold: true, style: 'topHeader' },
											{ text: '1679905\n', style: 'topHeader' },
											{ text: '  ', bold: true, style: 'topHeader' },
											{ text: '7788996655\n', style: 'topHeader' },
											{ text: '  ', bold: true, style: 'topHeader' },
											{ text: '1600 Amphitheatre Parkway in Mountain View, California, United States, near San Jose. \n', style: 'topHeader' },
											{ text: 'Mobile Number: ', bold: true, style: 'topHeader' },
											{ text: '23\n', style: 'topHeader' },
											{ text: 'Place of supply:   ', bold: true, style: 'topHeader' },
											{ text: '13/12/90\n', style: 'topHeader' },
											{ text: 'State Code:   ', bold: true, style: 'topHeader' },
											{ text: '13/12/90\n', style: 'topHeader' },
										]
								},
								{
									text:
										[
											{ text: 'Invoice No:                  ', bold: true, style: 'topHeader' },
											{ text: '787878\n', style: 'topHeader' },
											{ text: 'Invoice Date:               ', bold: true, style: 'topHeader' },
											{ text: '12/12/90 \n', style: 'topHeader' },
											{ text: 'Invoice Status:            ', bold: true, style: 'topHeader' },
											{ text: '12/12/90 \n', style: 'topRemainingHeader' },
											{ text: 'Payment Due Date:    ', bold: true, style: 'topHeader' },
											{ text: '13/12/90\n', style: 'topHeader' },
										]
								},
	
							],
						],
	
	
					},
					style: 'tab2',
					layout: 'noBorders',
	
				},
				{
					table: {
						widths: ['*', '*',],
						body: [
							[
								{ text: 'PRODUCT DETAILS', style: "emptyHeader" },
								{ text: '', style: "emptyHeader" },
							],
	
						],
	
					},
					layout: 'noBorders',
				},
				{
					table: {
	
						body: [
							[
								{ text: 'S.No', style: "productHeader", rowSpan: 2 },
								{ text: 'Product Name', style: "productHeader", rowSpan: 2 },
								{ text: 'HSN code', style: "productHeader", rowSpan: 2 },
								{ text: 'Qty', style: "productHeader", rowSpan: 2 },
								{ text: 'Units', style: "productHeader", rowSpan: 2 },
								{ text: 'Unit Price', style: "productHeader", rowSpan: 2 },
								{ text: 'Taxable  Amount', style: "productHeader", rowSpan: 2 },
								{ text: 'CGST', style: "productHeader", colSpan: 2, rowSpan: 1 },
								{ text: '', style: "productHeader" },
								{ text: 'SGST', style: "productHeader", colSpan: 2, rowSpan: 1 },
								{ text: '', style: "productHeader" },
								{ text: 'IGST', style: "productHeader", colSpan: 2, rowSpan: 1 },
								{ text: '', style: "productHeader" },
								{ text: 'Total Amount', style: "productHeader", rowSpan: 2 }
							],
							[
								{ text: 'S.No', style: "productHeader" },
								{ text: 'Product Name', style: "productHeader" },
								{ text: 'HSN code', style: "productHeader" },
								{ text: 'Qty', style: "productHeader" },
								{ text: 'Units', style: "productHeader" },
								{ text: 'Rate', style: "productHeader" },
								{ text: 'Taxable Amount', style: "productHeader" },
								{ text: '%', style: "productHeader" },
								{ text: '₹', style: "productHeader" },
								{ text: '%', style: "productHeader" },
								{ text: '₹', style: "productHeader" },
								{ text: '%', style: "productHeader" },
								{ text: '₹', style: "productHeader" },
								{ text: 'Total Amount', style: "productHeader" }
							],
						]
					}
				},
				{
					table: {
						widths: ['70%', '*'],
						body: [
	
							[
								[
									{
										table: {
											widths: ['*'],
											body: [
												[
													{ text: 'PAYMENT DETAILS', style: "leftHeader" }
												],
	
											],
	
	
										},
										style: 'tab2Head',
										layout: 'noBorders',
	
									}, {
										table: {
											widths: ['3%', '*'],
											body: [
												[{
													text: ''
	
												},
												{
													text:
														[]
												},
												]
											]
										},
										style: 'tab2',
										layout: 'noBorders',
									},
									{
										table: {
											widths: ['*'],
											body: [
												[
													{ text: 'TERMS & CONDITIONS', style: "leftHeader" },
	
												],
	
											],
	
	
										},
										style: 'tab2Head',
										layout: 'noBorders',
	
									}, {
										table: {
											widths: ['3%', '*'],
											body: [
												[
													{
														text: ''
	
													},
													{
														text: "",
	
													},
												]
											]
										},
										style: 'tab2',
										layout: 'noBorders',
									},
	
								],
								{
									text:
										[
											{ text: 'Taxable Amount:     ', bold: true, style: 'topHeader' },
											{ text: '12122\n', style: 'topHeader' },
											{ text: 'CGST Amount:         ', bold: true, style: 'topHeader' },
											{ text: '12122\n', style: 'topHeader' },
											{ text: 'SGST Amount:         ', bold: true, style: 'topHeader' },
											{ text: '12122\n', style: 'topHeader' },
											{ text: 'IGST Amount:          ', bold: true, style: 'topHeader' },
											{ text: '12122\n', style: 'topHeader' },
											// { text: 'Labour Charge:       ', bold: true, style: 'topHeader' },
											// { text: '12122\n', style: 'topHeader' },
											{ text: 'Discount:                  ', bold: true, style: 'topHeader' },
											{ text: '12122\n', style: 'topHeader' },
											{ text: 'RoundOff:                 ', bold: true, style: 'topHeader' },
											{ text: '12122\n', style: 'topHeader' },
											{ text: 'Total Amount:          ', bold: true, style: 'topHeader11' },
											{ text: '12122\n', style: 'topHeader11' },
											{ text: 'Paid Amount:           ', bold: true, style: 'topHeader' },
											{ text: '12122\n', style: 'topHeader' },
											{ text: 'Due Amount:            ', bold: true, style: 'topRemainingHeader' },
											{ text: '12122\n', style: 'topRemainingHeader' },
											// 	{ text: 'Payment Type:-       ', bold: true },
											// { text: '12122\n' },
										]
	
								},
	
							],
						],
	
	
					},
					style: 'tab2',
					layout: 'lightHorizontalLines',
	
				},
				{
					table: {
						widths: ['*', '*',],
						body: [
							[
								{ text: 'OUTSTANDING DETAILS', style: "emptyHeader" },
								{ text: '', style: "emptyHeader" },
							],
	
						],
	
					},
					layout: 'noBorders',
				},
	
				// Start of Previous + current = Total Column
				{
					table: {
						widths: ['34%', '39%', '27%'],
						body: [
							[
								{ text: '', style: "topBlankHeader" },
								{ text: '', style: "topMainHeader" },
								{ text: '', style: "topBlankHeader" },
							],
							[
								{
									text:
										[
											{ text: 'PREVIOUS BALANCE :  ', bold: true, style: 'topHeader11' },
											{ text: '\n', style: 'topHeader11' },
										]
								},
								{
									text:
										[
											{ text: 'CURRENT BALANCE :  ', bold: true, style: 'topHeader11' },
											{ text: '\n', style: 'topHeader11' },
										]
								},
	
								{
									text:
										[
											{ text: 'TOTAL BALANCE :  ', bold: true, style: 'topRemainingHeader' },
											{ text: '\n', style: 'topRemainingHeader' },
										]
								},
	
							],
						]
					},
					layout: {
						hLineWidth: function (i, node) {
							return (i === 0 || i === node.table.body.length) ? 1 : 0;
						},
						vLineWidth: function (i, node) {
							return (i === 0 || i === node.table.widths.length) ? 1 : 0;
						},
						hLineColor: function (i, node) {
							return (i === 0 || i === node.table.body.length) ? 'black' : 'black';
						},
						vLineColor: function (i, node) {
							return (i === 0 || i === node.table.widths.length) ? 'black' : 'black';
						},
					}
				},
				// End of Previous + current = Total Column
	
				{
					table: {
						widths: ['60%', '*'],
						body: [
							[
								{
									text:
										[
	
										]
	
								},
								
										[{ text: '' },
										{ text: 'Firm Name  ', bold: true, alignment: 'center', style: 'topFirmBasicAuthority' },
										{ text: '\n\n\n' },
	
										{ text: 'AUTHORITY SIGNATURE  ', bold: true, alignment: 'center', style: 'topFirmBasicAuthority' },
										{ text: '\n' },
										]
	
							],
						],
	
	
					},
					style: 'tab2',
					layout: 'noBorders',
	
				},
				{
					table: {
						widths: ['*'],
						body: [
							[
								{ text: 'Thank you', alignment: 'center', },
	
							],
	
						],
	
					},
					layout: 'noBorders',
					style: 'tab2',
				},
			],
			footer: {
				columns: [
					{
						text: 'Powered By ACUIFY',
						alignment: 'right',
						color: '#160091'
					}
				],
				margin: [10, 10]
			},
			styles: {
				header: {
					fontSize: 10,
					bold: true,
					alignment: 'center'
				},
				billToHeader: {
					fontSize: 12,
					bold: true,
					alignment: 'left',
				},
				invoiceDetailHeader: {
					fontSize: 12,
					bold: true,
					alignment: 'left'
				},
				header1: {
					color: '#160091',
					fontSize: 10,
					bold: true,
					fillColor: '#15155d',
				},
				product: {
					fontSize: 9,
					alignment: 'center',
				},
				productRight: {
					fontSize: 10,
					alignment: 'right',
					// bold: true
				},
				totalRight: {
					fontSize: 10,
					alignment: 'right',
					bold: true
				},
				total: {
					fontSize: 10,
					alignment: 'center',
					bold: true
				},
				topHeader: {
					fontSize: 10,
					bold: true,
					fillColor: '#15155d',
				},
				topHeaderRight: {
					fontSize: 10,
					bold: true,
					fillColor: '#15155d',
					alignment: 'right'
				},
				topCustomerHeader: {
					fontSize: 12,
					bold: true,
					color: '#160091',
				},
				topHeader1: {
					color: 'white',
					fontSize: 14,
					bold: true,
					alignment: 'center',
					fillColor: '#15155d',
				},
				topHeader11: {
					color: '#160091',
					fontSize: 10,
					bold: true,
				},
				topRemainingHeader: {
					color: '#FF0000',
					fontSize: 10,
					bold: true,
				},
				topFirmAuthority: {
					color: '#160091',
					fontSize: 12,
					bold: true,
				},
				topFirmAuthorityRight: {
					color: '#160091',
					fontSize: 14,
					bold: true,
					alignment: 'right'
				},
				topFirmBasicAuthority: {
					color: '#160091',
					fontSize: 10,
					bold: true,
				},
				leftHeader: {
					fontSize: 10,
					bold: true,
					alignment: 'left'
				},
				emptyHeader: {
					fontSize: 10,
					color: 'white',
					fillColor: '#15155d',
					bold: true,
				},
				topTab: {
					fillColor: '#ececec',
				},
				tab2Head: {
					color: 'white',
					fillColor: '#015155d',
				},
				tab2: {
					fillColor: '#ececec',
				},
				bankDetails: {
					fontSize: 10,
					bold: true,
				},
				productHeader: {
					fontSize: 10,
					bold: true,
					alignment: 'center',
					color: '#160091',
				},
				hiddenTab: {
					fillColor: '#ececec',
					color: '#ececec',
				},
			}
		}
		//Firm Details 
		// pdfDoc.content[1].table.body[0][2].text[1].text = (metaData.firm.name.toUpperCase() ? metaData.firm.name.toUpperCase() : '') + "\n";
		pdfDoc.content[1].table.body[0][2].text[1].text = ((metaData.firm && metaData.firm.name) ? metaData.firm.name.toUpperCase() : '') + "\n";
		pdfDoc.content[1].table.body[0][2].text[3].text = (metaData.firm.GST_number ? metaData.firm.GST_number : '') + "\n";
		pdfDoc.content[1].table.body[0][2].text[5].text = (metaData.firm.liveAddress ? metaData.firm.liveAddress : '') + "\n";
		pdfDoc.content[1].table.body[0][2].text[7].text = (metaData.firm.address ? metaData.firm.address : '') + "\n";
		pdfDoc.content[1].table.body[0][2].text[9].text = (metaData.firm.mobileNumber ? metaData.firm.mobileNumber : '') + "\n";
		pdfDoc.content[1].table.body[0][2].text[11].text = (metaData.firm.email ? metaData.firm.email : '') + "\n";

		// Start of Trail New Code
		//Receipient Details
		// pdfDoc.content[3].table.body[0][1].text[1].text = (metaData.customer.name.toUpperCase() ? metaData.customer.name.toUpperCase() : '') + "\n";
		// pdfDoc.content[3].table.body[0][1].text[1].text = ((metaData.customer.name && metaData.customer.name )? metaData.customer.name.toUpperCase() : '') + "\n";
		pdfDoc.content[1].table.body[0][3].text[1].text = (getCustomerDetails(metaData, 'name').toUpperCase()) + "\n";
		pdfDoc.content[1].table.body[0][3].text[3].text = (metaData.customer.GST_number ? metaData.customer.GST_number : '') + "\n";
		pdfDoc.content[1].table.body[0][3].text[5].text = (metaData.customer.localAddress ? metaData.customer.localAddress : '') + "\n";
		// pdfDoc.content[3].table.body[0][1].text[7].text = (metaData.customer.address ? metaData.customer.address : '') + "\n";	
		pdfDoc.content[1].table.body[0][3].text[7].text = (getCustomerDetails(metaData, 'address')) + "\n";
		pdfDoc.content[1].table.body[0][3].text[9].text = (getCustomerDetails(metaData, 'mobile').toUpperCase()) + "\n";
		// pdfDoc.content[3].table.body[0][1].text[9].text = (metaData.customer.mobile ? metaData.customer.mobile : '') + "\n";
		// pdfDoc.content[3].table.body[0][1].text[9].text = (metaData.customer.placeOfSupply ? metaData.customer.placeOfSupply : '') + "\n";
		pdfDoc.content[1].table.body[0][3].text[11].text = (metaData.invoiceData.placeOfSupply ? metaData.invoiceData.placeOfSupply : '') + "\n";
		pdfDoc.content[1].table.body[0][3].text[13].text = (metaData.customer.stateCode ? metaData.customer.stateCode : '') + "\n";
	
		//Invoice Details
		let vdate = new Date(metaData.invoiceData.date)
		let vpaymentDueDate = vdate.setDate(vdate.getDate() + (metaData.invoiceData.duration ? parseInt(metaData.invoiceData.duration) : 0));
		pdfDoc.content[1].table.body[0][4].text[1].text = metaData.invoiceData.invoiceId + "\n";
		pdfDoc.content[1].table.body[0][4].text[3].text = new Date(metaData.invoiceData.date).toLocaleDateString('en-GB').toString() + "\n";
		pdfDoc.content[1].table.body[0][4].text[5].text = (metaData.invoiceData.status ? metaData.invoiceData.status.toUpperCase() : '') + "\n";
		pdfDoc.content[1].table.body[0][4].text[7].text = new Date(vpaymentDueDate).toLocaleDateString('en-GB').toString() + "\n";

		// End of Trail New Code
	
		//Receipient Details
		// pdfDoc.content[3].table.body[0][1].text[1].text = (metaData.customer.name.toUpperCase() ? metaData.customer.name.toUpperCase() : '') + "\n";
		// pdfDoc.content[3].table.body[0][1].text[1].text = ((metaData.customer.name && metaData.customer.name )? metaData.customer.name.toUpperCase() : '') + "\n";
		pdfDoc.content[3].table.body[0][1].text[1].text = (getCustomerDetails(metaData, 'name').toUpperCase()) + "\n";
		pdfDoc.content[3].table.body[0][1].text[3].text = (metaData.customer.GST_number ? metaData.customer.GST_number : '') + "\n";
		pdfDoc.content[3].table.body[0][1].text[5].text = (metaData.customer.localAddress ? metaData.customer.localAddress : '') + "\n";
		// pdfDoc.content[3].table.body[0][1].text[7].text = (metaData.customer.address ? metaData.customer.address : '') + "\n";	
		pdfDoc.content[3].table.body[0][1].text[7].text = (getCustomerDetails(metaData, 'address')) + "\n";
		pdfDoc.content[3].table.body[0][1].text[9].text = (getCustomerDetails(metaData, 'mobile').toUpperCase()) + "\n";
		// pdfDoc.content[3].table.body[0][1].text[9].text = (metaData.customer.mobile ? metaData.customer.mobile : '') + "\n";
		// pdfDoc.content[3].table.body[0][1].text[9].text = (metaData.customer.placeOfSupply ? metaData.customer.placeOfSupply : '') + "\n";
		pdfDoc.content[3].table.body[0][1].text[11].text = (metaData.invoiceData.placeOfSupply ? metaData.invoiceData.placeOfSupply : '') + "\n";
		pdfDoc.content[3].table.body[0][1].text[13].text = (metaData.customer.stateCode ? metaData.customer.stateCode : '') + "\n";
	
		//Invoice Details
		let date = new Date(metaData.invoiceData.date)
		let paymentDueDate = date.setDate(date.getDate() + (metaData.invoiceData.duration ? parseInt(metaData.invoiceData.duration) : 0));
		pdfDoc.content[3].table.body[0][2].text[1].text = metaData.invoiceData.invoiceId + "\n";
		pdfDoc.content[3].table.body[0][2].text[3].text = new Date(metaData.invoiceData.date).toLocaleDateString('en-GB').toString() + "\n";
		pdfDoc.content[3].table.body[0][2].text[5].text = (metaData.invoiceData.status ? metaData.invoiceData.status.toUpperCase() : '') + "\n";
		pdfDoc.content[3].table.body[0][2].text[7].text = new Date(paymentDueDate).toLocaleDateString('en-GB').toString() + "\n";
	
		// Products
		// let productList = convertToPDFProducts(metaData.invoiceData.items,true);
		let productList = convertToPDFProducts(metaData.invoiceData.items, true, metaData.invoiceData, metaData);
		productList.map((item) => {
			pdfDoc.content[5].table.body.push(item);
		});
	
		// Payment Details
	
		// pdfDoc.content[6].table.body[0][0][1].table.body[0][1].text[1].text = (metaData.invoiceData.paymentType ? metaData.invoiceData.paymentType : '') + "\n";
		// pdfDoc.content[6].table.body[0][0][1].table.body[0][1].text[3].text = (metaData.invoiceData.transactionType ? metaData.invoiceData.transactionType : '') + "\n";
	
		// Bank Account Details
		if (metaData.terms.banks.length) {
			metaData.terms.banks.map((bankDetails) => {
				pdfDoc.content[6].table.body[0][0][1].table.body[0][1].text.push({ text: bankDetails.bankName + " \n", style: 'bankDetails' })
				pdfDoc.content[6].table.body[0][0][1].table.body[0][1].text.push({ text: "NAME: " + bankDetails.accountHolderName + "\n", style: 'bankDetails' })
				pdfDoc.content[6].table.body[0][0][1].table.body[0][1].text.push({ text: "A/C No: " + bankDetails.accountnumber + "\n", style: 'bankDetails' })
				pdfDoc.content[6].table.body[0][0][1].table.body[0][1].text.push({ text: "IFSC: " + bankDetails.ifsccode + "\n", style: 'bankDetails' })
				pdfDoc.content[6].table.body[0][0][1].table.body[0][1].text.push({ text: bankDetails.address + "\n", style: 'bankDetails' })
			})
		}
		// Terms and cond
		pdfDoc.content[6].table.body[0][0][3].table.body[0][1] = metaData.terms.termsAndConditions;
	
		// gst details
		// pdfDoc.content[6].table.body[0][1].text[1].text = ((metaData.invoiceData.totalAmount - metaData.invoiceData.roundOffAmount ? Number.parseFloat(metaData.invoiceData.totalAmount - metaData.invoiceData.roundOffAmount).toFixed(2) - Number.parseFloat(metaData.gstTotal.CGST_val + metaData.gstTotal.SGST_val + metaData.gstTotal.IGST_val).toFixed(2) : '0')).toFixed(2) + "\n";
		pdfDoc.content[6].table.body[0][1].text[1].text = (
			Number.parseFloat(metaData.invoiceData.totalAmount) +
			Number.parseFloat(metaData.invoiceData.discountAmount || 0) +
			Number.parseFloat(metaData.invoiceData.gstOnExtraChanrges ? 0 : (-Number.parseFloat(metaData.invoiceData.totalExtraCharges))) -
			Number.parseFloat(metaData.invoiceData.gstOnExtraChanrges ? Number.parseFloat(metaData.invoiceData.totalExtraChargesGST) : 0) -
			Number.parseFloat(metaData.invoiceData.roundOffAmount || 0) -
			(Number.parseFloat(
				metaData.gstTotal.SGST_val
			) +
				Number.parseFloat(
					metaData.gstTotal.CGST_val
				) +
				Number.parseFloat(
					metaData.gstTotal.IGST_val
				))
		).toFixed(2) + "\n";
		pdfDoc.content[6].table.body[0][1].text[3].text = (metaData.gstTotal.CGST_val ? (Number.parseFloat(metaData.gstTotal.CGST_val) + Number.parseFloat(metaData.invoiceData.gstOnExtraChanrges ? Number.parseFloat(metaData.invoiceData.totalExtraChargesGST) / 2 : 0)).toFixed(2) : '0.00') + "\n";
		pdfDoc.content[6].table.body[0][1].text[5].text = (metaData.gstTotal.SGST_val ? (Number.parseFloat(metaData.gstTotal.SGST_val) + Number.parseFloat(metaData.invoiceData.gstOnExtraChanrges ? Number.parseFloat(metaData.invoiceData.totalExtraChargesGST) / 2 : 0)).toFixed(2) : '0.00') + "\n";
		pdfDoc.content[6].table.body[0][1].text[7].text = (metaData.gstTotal.IGST_val ? (Number.parseFloat(metaData.gstTotal.IGST_val) + Number.parseFloat(metaData.invoiceData.gstOnExtraChanrges ? Number.parseFloat(metaData.invoiceData.totalExtraChargesGST) : 0)).toFixed(2) : '0.00') + "\n";
		// pdfDoc.content[6].table.body[0][1].text[9].text = (metaData.invoiceData.labourAmount ? Number.parseFloat(metaData.invoiceData.labourAmount).toFixed(2) : '0.00') + "\n";
		let offset = 0;
		if (!metaData.invoiceData.gstOnExtraChanrges && metaData.invoiceData.extraCharges && metaData.invoiceData.extraCharges.length) {
			metaData.invoiceData.extraCharges.map((charge) => {
				pdfDoc.content[6].table.body[0][1].text.splice(8 + offset, 0, { text: '' + charge.name + ':        ', bold: true, style: 'topHeader' })
				offset++;
				pdfDoc.content[6].table.body[0][1].text.splice(8 + offset, 0, { text: Number.parseFloat(charge.amount).toFixed(2) + '\n', style: 'topHeader' })
				offset++;
			})
		}
		pdfDoc.content[6].table.body[0][1].text[9 + offset].text = (metaData.invoiceData.discountAmount ? Number.parseFloat(metaData.invoiceData.discountAmount).toFixed(2) : '0.00') + "\n";
		pdfDoc.content[6].table.body[0][1].text[11 + offset].text = (metaData.invoiceData.roundOffAmount ? Number.parseFloat(metaData.invoiceData.roundOffAmount).toFixed(2) : '0.00') + "\n";
		// pdfDoc.content[6].table.body[0][1].text[15].text = (metaData.invoiceData.totalAmount + metaData.invoiceData.labourAmount -  metaData.invoiceData.discountAmount ? Number.parseFloat(Number.parseFloat(metaData.invoiceData.totalAmount) + Number.parseFloat(metaData.invoiceData.labourAmount) - Number.parseFloat(metaData.invoiceData.discountAmount)).toFixed(2) : '0') + "\n";
		pdfDoc.content[6].table.body[0][1].text[13 + offset].text = (metaData.invoiceData.totalAmount ? Number.parseFloat(metaData.invoiceData.totalAmount).toFixed(2) : '0.00') + "\n";
		pdfDoc.content[6].table.body[0][1].text[15 + offset].text = (metaData.invoiceData.paidAmount ? Number.parseFloat(metaData.invoiceData.paidAmount).toFixed(2) : '0.00') + "\n";
		pdfDoc.content[6].table.body[0][1].text[17 + offset].text = (metaData.invoiceData.remainingAmount ? Number.parseFloat(metaData.invoiceData.remainingAmount).toFixed(2) : '0.00') + "\n";
		// pdfDoc.content[6].table.body[0][1].text[17].text = (metaData.invoiceData.paymentType ? metaData.invoiceData.paymentType : '') + "\n";
	
		// if(metaData.invoiceData.extraCharges && metaData.invoiceData.extraCharges.length) {
		// 	metaData.invoiceData.extraCharges.map((charge)=>{
		// 	pdfDoc.content[6].table.body[0][1].text.push({ text: ''+charge.name+':        ', bold: true, style: 'topHeader' })
		// 	pdfDoc.content[6].table.body[0][1].text.push({ text: Number.parseFloat(charge.amount).toFixed(2)+'\n', bold: true, style: 'topHeader' })
		// 	})
		// }
		if (metaData.balance && metaData.terms.isPreviousCurrentTotalBalance) {
			pdfDoc.content[8].table.body[1][0].text[1].text = Number.parseFloat(Number.parseFloat(metaData.balance) - Number.parseFloat(metaData.invoiceData.remainingAmount).toFixed(2)).toFixed(2) + "\n";
			pdfDoc.content[8].table.body[1][1].text[1].text = (metaData.invoiceData.remainingAmount ? Number.parseFloat(metaData.invoiceData.remainingAmount).toFixed(2) : '0.00') + "\n";
			pdfDoc.content[8].table.body[1][2].text[1].text = (metaData.balance ? Number.parseFloat(metaData.balance).toFixed(2) : '0.00') + "\n";
		} else {
			pdfDoc.content[8] = {};
			pdfDoc.content[7] = {};
		}
	
		//authority
		pdfDoc.content[9].table.body[0][1][1].text = (metaData.firm.name ? (metaData.firm.name).toUpperCase() : '');
	
		//thank you
		// pdfDoc.content[9].table.body[0][0].text =  metaData.terms.termsAndConditions.greetingMessage || ("Thank You " + ((metaData.customer && metaData.customer.name )? metaData.customer.name.toUpperCase() : '') +" For Choosing us!" )
		// pdfDoc.content[9].table.body[0][0].text =  "Thank You " + (metaData.customer.name.toUpperCase() ? metaData.customer.name.toUpperCase() : '') +" For Choosing us!" 
		pdfDoc.content[10].table.body[0][0].text = metaData.terms.greetingMessage || ("Thank You " + (getCustomerDetails(metaData, 'name').toUpperCase()) + " for doing business with us!")
	
		if (metaData.terms.isBlankHeader) {
			pdfDoc.content[1].table.body[0][1] = { text: '' };
			pdfDoc.content[1].style = 'hiddenTab';
			pdfDoc.content[1].table.body[0][2].text[1].style = 'hiddenTab'
		} else {
			if (metaData.terms.printLogo) {
				try {
					let logoData = await getBase64ImageFromURL(metaData.terms.printLogo)
					pdfDoc.content[1].table.body[0][1].image = logoData;
					let invoiceImages = document.getElementById('invoiceImages');
					if (invoiceImages && invoiceImages.files && invoiceImages.files.length) {
						let temp = {columns: []};
						if(invoiceImages.files[0]) {
							temp.columns.push({
								image: await toBase64(invoiceImages.files[0]).catch(e => Error(e)),
								width: 150
							})
						}
						if(invoiceImages.files[1]) {
							temp.columns.push({
								image: await toBase64(invoiceImages.files[1]).catch(e => Error(e)),
								width: 150
							})
						}
						if(invoiceImages.files[2]) {
							temp.columns.push({
								image: await toBase64(invoiceImages.files[2]).catch(e => Error(e)),
								width: 150
							})
						}
						pdfDoc.content.push(temp)
					}
					if(metaData.terms.signature) {
						let temp = {columns: []};
						temp.columns.push({
							image: await getBase64ImageFromURL(metaData.terms.signature),
							width: 150,
							alignment: 'right'
						})
						//pdfDoc.content.push(temp)
						pdfDoc.content[9].table.body[0][1][2] = temp.columns[0];
					}
					return pdfDoc;
				} catch (error) {
					console.log(error)
				}
			} else {
				var imgToExport = document.getElementById('pdfimgToExport');
				var canvas = document.createElement('canvas');
				canvas.width = imgToExport.width;
				canvas.height = imgToExport.height;
				canvas.getContext('2d').drawImage(imgToExport, 0, 0);
				let base64 = canvas.toDataURL('image/png')
				pdfDoc.content[1].table.body[0][1].image = base64;
				let invoiceImages = document.getElementById('invoiceImages');
					if (invoiceImages && invoiceImages.files && invoiceImages.files.length) {
						let temp = {columns: []};
						if(invoiceImages.files[0]) {
							temp.columns.push({
								image: await toBase64(invoiceImages.files[0]).catch(e => Error(e)),
								width: 150
							})
						}
						if(invoiceImages.files[1]) {
							temp.columns.push({
								image: await toBase64(invoiceImages.files[1]).catch(e => Error(e)),
								width: 150
							})
						}
						if(invoiceImages.files[2]) {
							temp.columns.push({
								image: await toBase64(invoiceImages.files[2]).catch(e => Error(e)),
								width: 150
							})
						}
						pdfDoc.content.push(temp)
					}
			}
		}
		if(metaData.terms.signature) {
			let temp = {columns: []};
			temp.columns.push({
				image: await getBase64ImageFromURL(metaData.terms.signature),
				width: 150,
				alignment: 'right'
			})
			pdfDoc.content[9].table.body[0][1][2] = temp.columns[0];
			//pdfDoc.content.push(temp)
		}
			return pdfDoc;
		}
	
		// export const toBase64 = file => new Promise((resolve, reject) => {
		// 	const reader = new FileReader();
		// 	reader.readAsDataURL(file);
		// 	reader.onload = () => resolve(reader.result);
		// 	reader.onerror = error => reject(error);
		// });
	// End of New Photo Resize Format 

	export const convertToBasicInvoiceHorizontal = async (metaData) => {
		let pdfDoc = {
			pageOrientation: 'landscape',
			content: [
				{
					table: {
						widths: ['44%', '45%', '11%'],
						body: [
							[
								{
									//   image: '',
									//   width: 120,
									//   height: 65,
								},
								{
									text:
										[
											{ text: 'TAX INVOICE', style: 'topHeaderHead' },
											//   { text: 'firm name\n', style: 'topFirmAuthority' },
											//   { text: ' ', style: 'topFirmAuthority' },
											//   { text: 'GSTIN number. \n', style:'topHeader22' },
											//   { text: ' ', style:'topHeader22' },
											//   { text: 'PAN Number \n', style:'topHeader22' },
											//   { text: '', bold: true, style:'topHeader22'  },
											//   { text: '88776655\n', style:'topHeader22'},
											//   { text: '' ,style:'topHeader'},
											//   { text: 'address\n', style:'topHeader22' },
										]
								},
								//   {
								// 	  text:
								// 		  [
								// 			  { text: 'ADDRESS\n' ,style:'topHeader'},
								// 			  { text: 'address\n', style:'topHeader22' },
								// 		  ]
								//   },
								{
									text:
										[
											//   { text: '' ,style:'topHeader22'},
											//   { text: 'mobile\n', style:'topHeader22' },
											//   { text: 'email\n', style:'topHeader22'},
											//   { text: 'website\n', style:'topHeader22'},									  
										]
								}
							],
						],

					},
					layout: {
						hLineWidth: function (i, node) {
							return (i === 0 || i === node.table.body.length) ? 2 : 0;
						},
						vLineWidth: function (i, node) {
							return (i === 0 || i === node.table.widths.length) ? 2 : 0;
						},
						hLineColor: function (i, node) {
							return (i === 0 || i === node.table.body.length) ? 'black' : 'white';
						},
						vLineColor: function (i, node) {
							return (i === 0 || i === node.table.widths.length) ? 'black' : 'white';
						},
					}
				},

				{
					table: {
						widths: ['*', '*', '*', '*', '*'],
						body: [
							[
								{ text: 'FROM', style: "topHeader" },
								{ text: 'BILL TO', style: "topHeader" },
								{ text: 'SHIP TO', style: "topHeader" },
								{ text: 'INVOICE DETAILS', style: "topHeader" },
								{ text: 'OTHER DETAILS', style: "topHeader" },
							],
							[
								{
									text:
										[
											{ text: ' ', bold: true, style: 'topCustomerHeader' },
											{ text: 'Google\n', style: 'topCustomerHeader' },
											{ text: ' ', bold: true, style: 'topHeader22' },
											{ text: '1600 Amphitheatre Parkway in Mountain View, California, United States, near San Jose. \n', style: 'topHeader22' },
											{ text: ' ', bold: true, style: 'topHeader22' },
											{ text: '7788996655\n', style: 'topHeader22' },
											{ text: ' ', bold: true, style: 'topHeader22' },
											{ text: '7788996655\n', style: 'topHeader22' },
											{ text: ' ', bold: true, style: 'topHeader22' },
											{ text: '1679905\n', style: 'topHeader22' },
											{ text: ' ', bold: true, style: 'topHeader22' },
											{ text: '23\n', style: 'topHeader22' },
										]
								},
								// End of NEw of Development
								{
									text:
										[
											{ text: ' ', bold: true, style: 'topCustomerHeader' },
											{ text: 'Google\n', style: 'topCustomerHeader' },
											{ text: ' ', bold: true, style: 'topHeader22' },
											{ text: '1600 Amphitheatre Parkway in Mountain View, California, United States, near San Jose. \n', style: 'topHeader22' },
											{ text: ' ', bold: true, style: 'topHeader22' },
											{ text: '7788996655\n', style: 'topHeader22' },
											{ text: ' ', bold: true, style: 'topHeader22' },
											{ text: '7788996655\n', style: 'topHeader22' },
											{ text: ' ', bold: true, style: 'topHeader22' },
											{ text: '1679905\n', style: 'topHeader22' },
											{ text: ' ', bold: true, style: 'topHeader22' },
											{ text: '23\n', style: 'topHeader22' },
										]
								},

								{
									text:
										[
											{ text: ' ', bold: true, style: 'topCustomerHeader' },
											{ text: 'Google\n', style: 'topCustomerHeader' },
											{ text: ' ', bold: true, style: 'topHeader22' },
											{ text: '1600 Amphitheatre Parkway in Mountain View, California, United States, near San Jose. \n', style: 'topHeader22' },
											{ text: ' ', bold: true, style: 'topHeader22' },
											{ text: '7788996655\n', style: 'topHeader22' },
											{ text: ' ', bold: true, style: 'topHeader22' },
											{ text: '7788996655\n', style: 'topHeader22' },
											{ text: ' ', bold: true, style: 'topHeader22' },
											{ text: '1679905\n', style: 'topHeader22' },
											{ text: ' ', bold: true, style: 'topHeader22' },
											{ text: '23\n', style: 'topHeader22' },
										]
								},
								{
									text:
										[
											{ text: 'Invoice No    :  ', bold: true, style: 'topHeader22' },
											{ text: '787878\n', style: 'topHeader22' },
											{ text: 'Invoice Date :  ', bold: true, style: 'topHeader22' },
											{ text: '12/12/90 \n', style: 'topHeader22' },
											{ text: 'Status            :  ', bold: true, style: 'topHeader22' },
											{ text: '12/12/90 \n', style: 'topRemainingHeader' },
											{ text: 'Due Date       :   ', bold: true, style: 'topHeader22' },
											{ text: '13/12/90 \n', style: 'topHeader22' },
										]
								},
								{
									text:
										[
											{ text: 'Order No           :  	', bold: true, style: 'topHeader22' },
											{ text: '787878\n', style: 'topHeader22' },
											{ text: 'Order Date        :      ', bold: true, style: 'topHeader22' },
											{ text: '12/12/90 \n', style: 'topHeader22' },
											{ text: 'Application No :      ', bold: true, style: 'topHeader22' },
											{ text: '12/12/90 \n', style: 'topHeader22' },
											{ text: 'Sanction Date   :      ', bold: true, style: 'topHeader22' },
											{ text: '13/12/90\n', style: 'topHeader22' },
										]
								},
							],
						]
					}
				},

				{
					table: {

						body: [
							[
								{ text: 'S.No', style: "productHeader", rowSpan: 2 },
								{ text: 'Product Description', style: "productHeader", rowSpan: 2 },
								{ text: 'HSN', style: "productHeader", rowSpan: 2 },
								{ text: 'Qty', style: "productHeader", rowSpan: 2 },
								{ text: 'Units', style: "productHeader", rowSpan: 2 },
								{ text: 'Unit Price', style: "productHeader", rowSpan: 2 },
								{ text: 'Gross weight', style: "productHeader", rowSpan: 2 },
								{ text: 'Net weight', style: "productHeader", rowSpan: 2 },
								{ text: 'Purity', style: "productHeader", rowSpan: 2 },
								{ text: 'Taxable  Amount', style: "productHeader", rowSpan: 2 },
								{ text: 'CGST', style: "productHeader", colSpan: 2, rowSpan: 1 },
								{ text: '', style: "productHeader" },
								{ text: 'SGST', style: "productHeader", colSpan: 2, rowSpan: 1 },
								{ text: '', style: "productHeader" },
								{ text: 'IGST', style: "productHeader", colSpan: 2, rowSpan: 1 },
								{ text: '', style: "productHeader" },
								{ text: 'Total Amount', style: "productHeader", rowSpan: 2 }
							],
							[
								{ text: 'S.No', style: "productHeader" },
								{ text: 'Product Description', style: "productHeader" },
								{ text: 'HSN', style: "productHeader" },
								{ text: 'Qty', style: "productHeader" },
								{ text: 'Units', style: "productHeader" },
								{ text: 'Unit Price', style: "productHeader" },
								{ text: 'Gross weight', style: "productHeader" },
								{ text: 'Net weight', style: "productHeader" },
								{ text: 'Purity', style: "productHeader" },
								{ text: 'Taxable Amount', style: "productHeader" },
								{ text: '%', style: "productHeader" },
								{ text: '₹', style: "productHeader" },
								{ text: '%', style: "productHeader" },
								{ text: '₹', style: "productHeader" },
								{ text: '%', style: "productHeader" },
								{ text: '₹', style: "productHeader" },
								{ text: 'Total Amount', style: "productHeader" },
							],
						]
					}
				},
				{
					table: {
						widths: ['75%', '*'],
						body: [

							[
								[
									{
										table: {

											body: [
												[
													{ text: 'HSN SUMMARY', style: "gstHeader", colSpan: 10 },
													{ text: 'QUANTITY', style: "gstHeader" },
													{ text: 'TAXABLE AMOUNT', style: "gstHeader" },
													{ text: '%', style: "gstHeader" },
													{ text: 'AMOUNT', style: "gstHeader" },
													{ text: '%', style: "gstHeader" },
													{ text: 'AMOUNT', style: "gstHeader" },
													{ text: '%', style: "gstHeader" },
													{ text: 'AMOUNT', style: "gstHeader" },
													{ text: 'TOTAL TAX AMOUNT', style: "gstHeader" }
												],
												[

													{ text: 'HSN/SAC', style: "gstHeader", rowSpan: 2 },
													{ text: 'QUANTITY', style: "gstHeader", rowSpan: 2 },
													{ text: 'TAXABLE AMOUNT', style: "gstHeader", rowSpan: 2 },
													{ text: 'CGST', style: "gstHeader", colSpan: 2, rowSpan: 1 },
													{ text: '', style: "gstHeader", rowSpan: 2 },
													{ text: 'SGST', style: "gstHeader", colSpan: 2, rowSpan: 1 },
													{ text: '', style: "gstHeader", rowSpan: 2 },
													{ text: 'IGST', style: "gstHeader", colSpan: 2, rowSpan: 1 },
													{ text: '', style: "gstHeader", rowSpan: 2 },
													{ text: 'TOTAL TAX AMOUNT', style: "gstHeader", rowSpan: 2 },
												],
												[

													{ text: 'HSN/SAC', style: "gstHeader" },
													{ text: 'QUANTITY', style: "gstHeader" },
													{ text: 'TAXABLE AMOUNT', style: "gstHeader" },
													{ text: '%', style: "gstHeader" },
													{ text: 'AMOUNT', style: "gstHeader" },
													{ text: '%', style: "gstHeader" },
													{ text: 'AMOUNT', style: "gstHeader" },
													{ text: '%', style: "gstHeader" },
													{ text: 'AMOUNT', style: "gstHeader" },
													{ text: 'TAX AMOUNT', style: "gstHeader" },
												],
											]
										}
									},

									{
										table: {
											widths: ['30%', '40%', '30%'],
											body: [
												[
													[{ text: 'PAYMENT DETAILS', style: "topHeader" }],
													[{ text: 'TERMS & CONDITIONS', style: "topHeader" }],
													[{ text: 'AUTHORITY SIGNATURE', style: "topHeader" }],
												],
											],
										},
										style: 'tab2Head',
									}, {
										table: {
											widths: ['30%', '40%', '30%'],
											body: [
												[[

												],
												[
													{
														text: "",
													},
												],
												// {
												// 	text:
														[{ text: '' },
														{ text: 'Firm Name  ', bold: true, alignment: 'center', style: 'topFirmAuthority' },
														{ text: '\n\n\n\n' },

														{ text: 'AUTHORITY SIGNATURE  ', bold: true, alignment: 'center', style: 'topFirmAuthority' },
														{ text: '\n' },
														]

												// },
												]
											]
										},
										style: 'tab2',
									},

								],
								{
									text:
										[
											{ text: 'Taxable Amount:       ', bold: true, style: 'topHeader33' },
											{ text: '12122\n', style: 'topHeader33' },
											{ text: 'CGST Amount:           ', bold: true, style: 'topHeader33' },
											{ text: '12122\n', style: 'topHeader33' },
											{ text: 'SGST Amount:           ', bold: true, style: 'topHeader33' },
											{ text: '12122\n', style: 'topHeader33' },
											{ text: 'IGST Amount:            ', bold: true, style: 'topHeader33' },
											{ text: '12122\n', style: 'topHeader33' },
											//   { text: 'Extra Charge:             ', bold: true, style:'topHeader33' },
											//   { text: '12122\n', style:'topHeader33' },
											{ text: 'Discount:                    ', bold: true, style: 'topHeader33' },
											{ text: '12122\n', style: 'topHeader33' },
											{ text: 'RoundOff:                   ', bold: true, style: 'topHeader33' },
											{ text: '12122\n', style: 'topHeader33' },
											{ text: 'Total Amount:            ', style: 'topHeader11' },
											{ text: '12122\n', style: 'topHeader11' },
											{ text: 'Paid Amount:             ', bold: true, style: 'topHeader33' },
											{ text: '12122\n', style: 'topHeader33' },
											{ text: 'Due Amount:              ', bold: true, style: 'topRemainingHeader' },
											{ text: '12122\n', style: 'topRemainingHeader' },
											// 	{ text: 'Payment Type:-       ', bold: true },
											// { text: '12122\n' },
										]

								},

							],
						],

					},
					//style:'tab2', pageBreak: 'after'
				},
				{
					table: {
						widths: ['15%', '60%', '25%'],
						body: [
							[
								{
									// image: '',
									// width: 110,
									// height: 70,
								},
								{
									text:
										[
											// { text: '' ,style:'topHeader'},
											// { text: 'For More Information, Visit\n', style: 'topLeftHeader'},
											// { text: 'https://info.parvsacuify.com\n' },
											// { text: 'https://parvsacuify.com\n' },
											// { text: '+91 6232623333\n'},
											// { text: 'careacuify@gmail.com \n' },
										]
								},
								{
									text:
										[
											//   { text: '' },
											//   { text: 'Firm Name  ', bold: true,	alignment: 'center', style: 'topFirmAuthority' },
											//   { text: '\n\n\n\n' }, 
											//   { text: 'AUTHORITY SIGNATURE  ', bold: true, alignment: 'center',style: 'topFirmAuthority'},
											//   { text: '\n' },
										]

								},
								//   {
								// 	  text:
								// 		  [
								// 			//   { text: 'Paid Amount:-         ', bold: true },
								// 			//   { text: '12122\n' },
								// 			//   { text: 'Due Amount:-          ', bold: true },
								// 			//   { text: '12122\n' },
								// 			  // 	{ text: 'Payment Type:-       ', bold: true },
								// 			  // { text: '12122\n' },
								// 		  ]

								//   },
							],
						],

					},
					layout: {
						hLineWidth: function (i, node) {
							return (i === 0 || i === node.table.body.length) ? 2 : 0;
						},
						vLineWidth: function (i, node) {
							return (i === 0 || i === node.table.widths.length) ? 2 : 0;
						},
						hLineColor: function (i, node) {
							return (i === 0 || i === node.table.body.length) ? 'black' : 'white';
						},
						vLineColor: function (i, node) {
							return (i === 0 || i === node.table.widths.length) ? 'black' : 'white';
						},
					}
				}
			],
			footer: {
				columns: [
					{
						text: 'Powered By ACUIFY',
						alignment: 'right',
						color: '#160091'
					}
				],
				margin: [10, 10]
			},
			styles: {
				header: {
					fontSize: 10,
					bold: true,
					alignment: 'center'
				},
				productHeader: {
					fontSize: 10,
					bold: true,
					alignment: 'center',
					color: '#160091',
				},
				gstHeader: {
					fontSize: 10,
					color: '#160091',
					bold: true,
					alignment: 'center'
				},
				product: {
					fontSize: 9,
					alignment: 'center',
				},
				total: {
					fontSize: 10,
					alignment: 'center',
					bold: true
				},
				productRight: {
					fontSize: 10,
					alignment: 'right',
					// bold: true
				},
				totalRight: {
					fontSize: 10,
					alignment: 'right',
					bold: true
				},
				topHeader: {
					color: '#160091',
					fontSize: 10,
					alignment: 'center',
					bold: true,
				},
				topLeftHeader: {
					color: '#160091',
					fontSize: 12,
					alignment: 'left',
					bold: true,
				},
				topHeader22: {
					fontSize: 10,
					bold: true,
				},
				topHeaderHead: {
					fontSize: 14,
					bold: true,
					color: '#160091',
				},
				topCustomerHeader: {
					color: '#160091',
					fontSize: 10,
					bold: true,
				},
				topHeader33: {
					fontSize: 10,
					bold: true,
				},
				topHeader11: {
					color: '#160091',
					fontSize: 10,
					bold: true,
				},
				topRemainingHeader: {
					color: '#FF0000',
					fontSize: 10,
					bold: true,
				},
				bankDetails: {
					fontSize: 10,
					bold: true,
				},
				topFirmAuthority: {
					color: '#160091',
					fontSize: 11,
					bold: true,
				},
			}
		}

		//Firm Details 
		// pdfDoc.content[0].table.body[0][1].text[1].text = (metaData.firm.name.toUpperCase() ? metaData.firm.name.toUpperCase() : '') + "\n";
		pdfDoc.content[1].table.body[1][0].text[1].text = ((metaData.firm && metaData.firm.name) ? metaData.firm.name.toUpperCase() : '') + "\n";
		pdfDoc.content[1].table.body[1][0].text[3].text = (metaData.firm.GST_number ? metaData.firm.GST_number : '') + "\n";
		pdfDoc.content[1].table.body[1][0].text[5].text = (metaData.firm.liveAddress ? metaData.firm.liveAddress : '') + "\n";
		pdfDoc.content[1].table.body[1][0].text[7].text = (metaData.firm.address ? metaData.firm.address : '') + "\n";
		pdfDoc.content[1].table.body[1][0].text[9].text = (metaData.firm.mobileNumber ? metaData.firm.mobileNumber : '') + "\n";
		pdfDoc.content[1].table.body[1][0].text[11].text = (metaData.firm.email ? metaData.firm.email : '') + "\n";
		// pdfDoc.content[1].table.body[1][0].text[13].text = (metaData.firm.website ? metaData.firm.website : '') + "\n";

		//Bill to Details
		// pdfDoc.content[1].table.body[1][0].text[1].text = (metaData.customer.name.toUpperCase() ? metaData.customer.name.toUpperCase() : '') + "\n";
		// pdfDoc.content[1].table.body[1][0].text[1].text = ((metaData.customer && metaData.customer.name )? metaData.customer.name.toUpperCase() : '') + "\n";
		pdfDoc.content[1].table.body[1][1].text[1].text = (getCustomerDetails(metaData, 'name').toUpperCase()) + "\n";
		pdfDoc.content[1].table.body[1][1].text[3].text = (metaData.customer.GST_number ? metaData.customer.GST_number : '') + "\n";
		// pdfDoc.content[1].table.body[1][1].text[5].text= (metaData.customer.address ? metaData.customer.address : '') + "\n";
		// pdfDoc.content[1].table.body[1][1].text[7].text = (metaData.customer.mobile ? metaData.customer.mobile : '') + "\n";
		pdfDoc.content[1].table.body[1][1].text[5].text = (metaData.customer.localAddress ? metaData.customer.localAddress : '') + "\n";
		pdfDoc.content[1].table.body[1][1].text[7].text = (getCustomerDetails(metaData, 'address')) + "\n";
		pdfDoc.content[1].table.body[1][1].text[9].text = (getCustomerDetails(metaData, 'mobile').toUpperCase()) + "\n";
		pdfDoc.content[1].table.body[1][1].text[11].text = (metaData.invoiceData.placeOfSupply ? metaData.invoiceData.placeOfSupply : '') + "\n";

		//SHIP TO Details
		// pdfDoc.content[1].table.body[1][1].text[1].text = ((metaData.customer && metaData.customer.name )? metaData.customer.name.toUpperCase() : '') + "\n";
		pdfDoc.content[1].table.body[1][2].text[1].text = (metaData.customer.name.toUpperCase() ? metaData.customer.name.toUpperCase() : '') + "\n";
		pdfDoc.content[1].table.body[1][2].text[3].text = (metaData.customer.GST_number ? metaData.customer.GST_number : '') + "\n";
		pdfDoc.content[1].table.body[1][2].text[5].text = (metaData.customer.localAddress ? metaData.customer.localAddress : '') + "\n";
		pdfDoc.content[1].table.body[1][2].text[7].text = (metaData.customer.address ? metaData.customer.address : '') + "\n";
		pdfDoc.content[1].table.body[1][2].text[9].text = (metaData.customer.mobile ? metaData.customer.mobile : '') + "\n";
		pdfDoc.content[1].table.body[1][2].text[11].text = (metaData.invoiceData.placeOfSupply ? metaData.invoiceData.placeOfSupply : '') + "\n";

		//Invoice Details
		let date = new Date(metaData.invoiceData.date)
		let paymentDueDate = date.setDate(date.getDate() + (metaData.invoiceData.duration ? parseInt(metaData.invoiceData.duration) : 0));
		pdfDoc.content[1].table.body[1][3].text[1].text = metaData.invoiceData.invoiceId + "\n";
		pdfDoc.content[1].table.body[1][3].text[3].text = new Date(metaData.invoiceData.date).toLocaleDateString('en-GB').toString() + "\n";
		pdfDoc.content[1].table.body[1][3].text[5].text = (metaData.invoiceData.status ? (metaData.invoiceData.status).toUpperCase() : '') + "\n";
		pdfDoc.content[1].table.body[1][3].text[7].text = new Date(paymentDueDate).toLocaleDateString('en-GB').toString() + "\n";

		//extra details
		pdfDoc.content[1].table.body[1][4].text[1].text = (metaData.invoiceData.orderNumber ? metaData.invoiceData.orderNumber : '-') + "\n";
		pdfDoc.content[1].table.body[1][4].text[3].text = (metaData.invoiceData.orderDate ? new Date(metaData.invoiceData.orderDate).toLocaleDateString('en-GB').toString() : '-') + "\n";
		pdfDoc.content[1].table.body[1][4].text[5].text = (metaData.invoiceData.applicationNumber ? metaData.invoiceData.applicationNumber : '-') + "\n";
		pdfDoc.content[1].table.body[1][4].text[7].text = (metaData.invoiceData.sanctionDate ? new Date(metaData.invoiceData.sanctionDate).toLocaleDateString('en-GB').toString() : '-') + "\n";


		//pending
		switch (metaData.firm.businessType) {
			case 'Jwellery': {
				pdfDoc.content[2].table.body[0][6].text = "Gross weight";
				pdfDoc.content[2].table.body[0][7].text = "Net weight";
				pdfDoc.content[2].table.body[0][8].text = "Purity";
				break;
			}
			case 'Grain': {
				//pdfDoc.content[2].table.body[0][6].text = "Gross weight";
				pdfDoc.content[2].table.body[0][7].text = "Net weight";
				pdfDoc.content[2].table.body[0][8].text = "Packing";
				break;
			}
			case 'Medical/Pesticides': {
				pdfDoc.content[2].table.body[0][6].text = "Batch";
				pdfDoc.content[2].table.body[0][7].text = "MFG Date";
				pdfDoc.content[2].table.body[0][8].text = "EXP Date";
				break;
			}
			case 'Clothes': {
				pdfDoc.content[2].table.body[0][6].text = "Brand";
				pdfDoc.content[2].table.body[0][7].text = "Color";
				pdfDoc.content[2].table.body[0][8].text = "Size";
				break;
			}
			case 'Automobile/Spare Parts': {
				pdfDoc.content[2].table.body[0][6].text = "ENG No.";
				pdfDoc.content[2].table.body[0][7].text = "Chasis No.";
				pdfDoc.content[2].table.body[0][8].text = "Extra";
				break;
			}
			default: {
				pdfDoc.content[2].table.body[0][6].text = "Extra";
				pdfDoc.content[2].table.body[0][7].text = "Extra";
				pdfDoc.content[2].table.body[0][8].text = "Extra";
				break;
			}
		}

		// Products
		// let productList = convertToPDFProductWithExtraDetails(metaData.firm.businessType,metaData.invoiceData.items,true);
		let productList = convertToPDFProductWithExtraDetails(metaData.firm.businessType, metaData.invoiceData.items, true, metaData.invoiceData);
		productList.map((item) => {
			pdfDoc.content[2].table.body.push(item);
		});
		let gstObj = convertToGST(metaData.invoiceData.items);
		Object.keys(gstObj).forEach((key) => {
			if (key != "totalObj") {
				pdfDoc.content[3].table.body[0][0][0].table.body.push([
					{ text: key, style: "product" },
					{ text: gstObj[key].quantity, style: "product" },
					{ text: Number.parseFloat(gstObj[key].basicPrice).toFixed(2), style: "total" },
					{ text: gstObj[key].CGST + '%', style: "product" },
					{ text: gstObj[key].CGST_val, style: "product" },
					{ text: gstObj[key].SGST + '%', style: "product" },
					{ text: gstObj[key].SGST_val, style: "product" },
					{ text: gstObj[key].IGST + '%', style: "product" },
					{ text: gstObj[key].IGST_val, style: "product" },
					{ text: Number.parseFloat(gstObj[key].GSTValue).toFixed(2), style: "product" }])
			}
		});

		pdfDoc.content[3].table.body[0][0][0].table.body.push([
			{ text: 'Total', style: "total" },
			{ text: gstObj.totalObj.quantity, style: "total" },
			{ text: Number.parseFloat(gstObj.totalObj.basicPrice).toFixed(2), style: "total" },
			{ text: '', style: "total" },
			{ text: Number.parseFloat(gstObj.totalObj.CGST_val).toFixed(2), style: "total" },
			{ text: '', style: "total" },
			{ text: Number.parseFloat(gstObj.totalObj.SGST_val).toFixed(2), style: "total" },
			{ text: '', style: "total" },
			{ text: Number.parseFloat(gstObj.totalObj.IGST_val).toFixed(2), style: "total" },
			{ text: Number.parseFloat(gstObj.totalObj.GSTValue).toFixed(2), style: "total" }]);

		// Payment Details

		// pdfDoc.content[6].table.body[0][0][1].table.body[0][1].text[1].text = (metaData.invoiceData.paymentType ? metaData.invoiceData.paymentType : '') + "\n";
		// pdfDoc.content[6].table.body[0][0][1].table.body[0][1].text[3].text = (metaData.invoiceData.transactionType ? metaData.invoiceData.transactionType : '') + "\n";

		//authority
		pdfDoc.content[3].table.body[0][0][2].table.body[0][2][1].text = (metaData.firm.name ? (metaData.firm.name).toUpperCase() : '');

		// Terms and cond
		pdfDoc.content[3].table.body[0][0][2].table.body[0][1][0].text = metaData.terms.termsAndConditions;

		//Bank Account Details
		if (metaData.terms.banks.length) {
			metaData.terms.banks.map((bankDetails) => {
				pdfDoc.content[3].table.body[0][0][2].table.body[0][0].push({ text: bankDetails.bankName + "\n", style: 'bankDetails' })
				pdfDoc.content[3].table.body[0][0][2].table.body[0][0].push({ text: "NAME: " + bankDetails.accountHolderName + "\n", style: 'bankDetails' })
				pdfDoc.content[3].table.body[0][0][2].table.body[0][0].push({ text: "A/C NO: " + bankDetails.accountnumber + "\n", style: 'bankDetails' })
				pdfDoc.content[3].table.body[0][0][2].table.body[0][0].push({ text: "IFSC:   " + bankDetails.ifsccode + "\n", style: 'bankDetails' })
				pdfDoc.content[3].table.body[0][0][2].table.body[0][0].push({ text: bankDetails.address + "\n", style: 'bankDetails' })
			})
		}
		// pdfDoc.content[3].table.body[0][0][2].table.body[0][0].text = metaData.terms.termsAndConditions;

		// gst details
		// pdfDoc.content[3].table.body[0][1].text[1].text = ((metaData.invoiceData.totalAmount - metaData.invoiceData.roundOffAmount ? Number.parseFloat(metaData.invoiceData.totalAmount - metaData.invoiceData.roundOffAmount).toFixed(2) - Number.parseFloat(metaData.gstTotal.CGST_val + metaData.gstTotal.SGST_val + metaData.gstTotal.IGST_val).toFixed(2) : '0')).toFixed(2) + "\n";
		pdfDoc.content[3].table.body[0][1].text[1].text = (
			Number.parseFloat(metaData.invoiceData.totalAmount) +
			Number.parseFloat(metaData.invoiceData.discountAmount || 0) +
			Number.parseFloat(metaData.invoiceData.gstOnExtraChanrges ? 0 : (-Number.parseFloat(metaData.invoiceData.totalExtraCharges))) -
			Number.parseFloat(metaData.invoiceData.gstOnExtraChanrges ? Number.parseFloat(metaData.invoiceData.totalExtraChargesGST) : 0) -
			Number.parseFloat(metaData.invoiceData.roundOffAmount || 0) -
			(Number.parseFloat(
				metaData.gstTotal.SGST_val
			) +
				Number.parseFloat(
					metaData.gstTotal.CGST_val
				) +
				Number.parseFloat(
					metaData.gstTotal.IGST_val
				))
		).toFixed(2) + "\n";
		pdfDoc.content[3].table.body[0][1].text[3].text = (metaData.gstTotal.CGST_val ? (Number.parseFloat(metaData.gstTotal.CGST_val) + Number.parseFloat(metaData.invoiceData.gstOnExtraChanrges ? Number.parseFloat(metaData.invoiceData.totalExtraChargesGST) / 2 : 0)).toFixed(2) : '0.00') + "\n";
		pdfDoc.content[3].table.body[0][1].text[5].text = (metaData.gstTotal.SGST_val ? (Number.parseFloat(metaData.gstTotal.SGST_val) + Number.parseFloat(metaData.invoiceData.gstOnExtraChanrges ? Number.parseFloat(metaData.invoiceData.totalExtraChargesGST) / 2 : 0)).toFixed(2) : '0.00') + "\n";
		pdfDoc.content[3].table.body[0][1].text[7].text = (metaData.gstTotal.IGST_val ? (Number.parseFloat(metaData.gstTotal.IGST_val) + Number.parseFloat(metaData.invoiceData.gstOnExtraChanrges ? Number.parseFloat(metaData.invoiceData.totalExtraChargesGST) : 0)).toFixed(2) : '0.00') + "\n";
		let offset = 0;
		if (!metaData.invoiceData.gstOnExtraChanrges && metaData.invoiceData.extraCharges && metaData.invoiceData.extraCharges.length) {
			metaData.invoiceData.extraCharges.map((charge) => {
				pdfDoc.content[3].table.body[0][1].text.splice(8 + offset, 0, { text: '' + charge.name + ':         ', bold: true, style: 'topHeader33' })
				offset++;
				pdfDoc.content[3].table.body[0][1].text.splice(8 + offset, 0, { text: Number.parseFloat(charge.amount).toFixed(2) + '\n', style: 'topHeader33' })
				offset++;
			})
		}
		// pdfDoc.content[3].table.body[0][1].text[9].text = (metaData.invoiceData.labourAmount ? Number.parseFloat(metaData.invoiceData.labourAmount).toFixed(2) : '0.00') + "\n";
		pdfDoc.content[3].table.body[0][1].text[9 + offset].text = (metaData.invoiceData.discountAmount ? Number.parseFloat(metaData.invoiceData.discountAmount).toFixed(2) : '0.00') + "\n";
		pdfDoc.content[3].table.body[0][1].text[11 + offset].text = (metaData.invoiceData.roundOffAmount ? Number.parseFloat(metaData.invoiceData.roundOffAmount).toFixed(2) : '0.00') + "\n";
		// pdfDoc.content[6].table.body[0][1].text[15].text = (metaData.invoiceData.totalAmount + metaData.invoiceData.labourAmount -  metaData.invoiceData.discountAmount ? Number.parseFloat(Number.parseFloat(metaData.invoiceData.totalAmount) + Number.parseFloat(metaData.invoiceData.labourAmount) - Number.parseFloat(metaData.invoiceData.discountAmount)).toFixed(2) : '0') + "\n";
		pdfDoc.content[3].table.body[0][1].text[13 + offset].text = (metaData.invoiceData.totalAmount ? Number.parseFloat(metaData.invoiceData.totalAmount).toFixed(2) : '0.00') + "\n";
		pdfDoc.content[3].table.body[0][1].text[15 + offset].text = (metaData.invoiceData.paidAmount ? Number.parseFloat(metaData.invoiceData.paidAmount).toFixed(2) : '0.00') + "\n";
		pdfDoc.content[3].table.body[0][1].text[17 + offset].text = (metaData.invoiceData.remainingAmount ? Number.parseFloat(metaData.invoiceData.remainingAmount).toFixed(2) : '0.00') + "\n";
		// pdfDoc.content[4].table.body[0][3].text[1].text = (metaData.invoiceData.paidAmount ? metaData.invoiceData.paidAmount : '0') + "\n";
		// pdfDoc.content[4].table.body[0][3].text[3].text = (metaData.invoiceData.remainingAmount ? metaData.invoiceData.remainingAmount : '') + "\n";
		// pdfDoc.content[6].table.body[0][1].text[17].text = (metaData.invoiceData.paymentType ? metaData.invoiceData.paymentType : '') + "\n";

		// if(metaData.invoiceData.extraCharges && metaData.invoiceData.extraCharges.length) {
		// 		metaData.invoiceData.extraCharges.map((charge)=>{
		// 		pdfDoc.content[3].table.body[0][1].text.push({ text: ''+charge.name+':          ', bold: true, style:'topHeader33' })
		// 		pdfDoc.content[3].table.body[0][1].text.push({ text:Number.parseFloat(charge.amount).toFixed(2)+'\n', style:'topHeader33' })
		// 	})
		// }

		//authority

		//pdfDoc.content[4].table.body[0][2].text[1].text =  (metaData.firm.name ? (metaData.firm.name).toUpperCase() : '');

		if (metaData.terms.printLogo) {
			try {
				// let logoData = await getBase64ImageFromURL(metaData.terms.printLogo)
				// pdfDoc.content[0].table.body[0][0].image = logoData;
				var imgToExport = document.getElementById('pdfimgToExport');
				var canvas = document.createElement('canvas');
				canvas.width = imgToExport.width;
				canvas.height = imgToExport.height;
				canvas.getContext('2d').drawImage(imgToExport, 0, 0);
				let invoiceImages = document.getElementById('invoiceImages');
					if (invoiceImages && invoiceImages.files && invoiceImages.files.length) {
						let temp = {columns: []};
						if(invoiceImages.files[0]) {
							temp.columns.push({
								image: await toBase64(invoiceImages.files[0]).catch(e => Error(e)),
								width: 150
							})
						}
						if(invoiceImages.files[1]) {
							temp.columns.push({
								image: await toBase64(invoiceImages.files[1]).catch(e => Error(e)),
								width: 150
							})
						}
						if(invoiceImages.files[2]) {
							temp.columns.push({
								image: await toBase64(invoiceImages.files[2]).catch(e => Error(e)),
								width: 150
							})
						}
						pdfDoc.content.push(temp)
					}
				//let base64 = canvas.toDataURL('image/png')
				//pdfDoc.content[4].table.body[0][0].image = base64;
				if(metaData.terms.signature) {
					let temp = {columns: []};
					temp.columns.push({
						image: await getBase64ImageFromURL(metaData.terms.signature),
						width: 150,
						alignment: 'right'
					})
					//pdfDoc.content.push(temp)
					pdfDoc.content[3].table.body[0][2][2] = temp.columns[0]					
				}
				return pdfDoc;
			} catch (error) {
				console.log(error)
			}
		} else {
			var imgToExport = document.getElementById('pdfimgToExport');
			var canvas = document.createElement('canvas');
			canvas.width = imgToExport.width;
			canvas.height = imgToExport.height;
			canvas.getContext('2d').drawImage(imgToExport, 0, 0);
			let invoiceImages = document.getElementById('invoiceImages');
					if (invoiceImages && invoiceImages.files && invoiceImages.files.length) {
						let temp = {columns: []};
						if(invoiceImages.files[0]) {
							temp.columns.push({
								image: await toBase64(invoiceImages.files[0]).catch(e => Error(e)),
								width: 150
							})
						}
						if(invoiceImages.files[1]) {
							temp.columns.push({
								image: await toBase64(invoiceImages.files[1]).catch(e => Error(e)),
								width: 150
							})
						}
						if(invoiceImages.files[2]) {
							temp.columns.push({
								image: await toBase64(invoiceImages.files[2]).catch(e => Error(e)),
								width: 150
							})
						}
						pdfDoc.content.push(temp)
					}
			// let base64 = canvas.toDataURL('image/png')
			// pdfDoc.content[0].table.body[0][0].image = base64;
			// pdfDoc.content[4].table.body[0][0].image = base64;
		}

		if(metaData.terms.signature) {
			let temp = {columns: []};
			temp.columns.push({
				image: await getBase64ImageFromURL(metaData.terms.signature),
				width: 150,
				alignment: 'right'
			})
			//pdfDoc.content.push(temp)
			pdfDoc.content[3].table.body[0][2][2] = temp.columns[0]
		}
		return pdfDoc;
	}

	// Start of New Photo Resize Format Second
	export const convertToBasicShortInvoiceHorizontal = async (metaData) => {
		let pdfDoc = {
			pageOrientation: 'landscape',
			content: [
				{
					table: {
						widths: ['44%', '45%', '11%'],
						body: [
							[
								{
									//   image: '',
									//   width: 120,
									//   height: 65,
								},
								{
									text:
										[
											{ text: 'TRAIL INVOICE', style: 'topHeaderHead' },
											//   { text: 'firm name\n', style: 'topFirmAuthority' },
											//   { text: ' ', style: 'topFirmAuthority' },
											//   { text: 'GSTIN number. \n', style:'topHeader22' },
											//   { text: ' ', style:'topHeader22' },
											//   { text: 'PAN Number \n', style:'topHeader22' },
											//   { text: '', bold: true, style:'topHeader22'  },
											//   { text: '88776655\n', style:'topHeader22'},
											//   { text: '' ,style:'topHeader'},
											//   { text: 'address\n', style:'topHeader22' },
										]
								},
								//   {
								// 	  text:
								// 		  [
								// 			  { text: 'ADDRESS\n' ,style:'topHeader'},
								// 			  { text: 'address\n', style:'topHeader22' },
								// 		  ]
								//   },
								{
									text:
										[
											//   { text: '' ,style:'topHeader22'},
											//   { text: 'mobile\n', style:'topHeader22' },
											//   { text: 'email\n', style:'topHeader22'},
											//   { text: 'website\n', style:'topHeader22'},									  
										]
								}
							],
						],

					},
					layout: {
						hLineWidth: function (i, node) {
							return (i === 0 || i === node.table.body.length) ? 2 : 0;
						},
						vLineWidth: function (i, node) {
							return (i === 0 || i === node.table.widths.length) ? 2 : 0;
						},
						hLineColor: function (i, node) {
							return (i === 0 || i === node.table.body.length) ? 'black' : 'white';
						},
						vLineColor: function (i, node) {
							return (i === 0 || i === node.table.widths.length) ? 'black' : 'white';
						},
					}
				},

				{
					table: {
						widths: ['*', '*', '*', '*', '*'],
						body: [
							[
								{ text: 'FROM', style: "topHeader" },
								{ text: 'BILL TO', style: "topHeader" },
								{ text: 'SHIP TO', style: "topHeader" },
								{ text: 'INVOICE DETAILS', style: "topHeader" },
								{ text: 'OTHER DETAILS', style: "topHeader" },
							],
							[
								{
									text:
										[
											{ text: ' ', bold: true, style: 'topCustomerHeader' },
											{ text: 'Google\n', style: 'topCustomerHeader' },
											{ text: ' ', bold: true, style: 'topHeader22' },
											{ text: '1600 Amphitheatre Parkway in Mountain View, California, United States, near San Jose. \n', style: 'topHeader22' },
											{ text: ' ', bold: true, style: 'topHeader22' },
											{ text: '7788996655\n', style: 'topHeader22' },
											{ text: ' ', bold: true, style: 'topHeader22' },
											{ text: '7788996655\n', style: 'topHeader22' },
											{ text: ' ', bold: true, style: 'topHeader22' },
											{ text: '1679905\n', style: 'topHeader22' },
											{ text: ' ', bold: true, style: 'topHeader22' },
											{ text: '23\n', style: 'topHeader22' },
										]
								},
								// End of NEw of Development
								{
									text:
										[
											{ text: ' ', bold: true, style: 'topCustomerHeader' },
											{ text: 'Google\n', style: 'topCustomerHeader' },
											{ text: ' ', bold: true, style: 'topHeader22' },
											{ text: '1600 Amphitheatre Parkway in Mountain View, California, United States, near San Jose. \n', style: 'topHeader22' },
											{ text: ' ', bold: true, style: 'topHeader22' },
											{ text: '7788996655\n', style: 'topHeader22' },
											{ text: ' ', bold: true, style: 'topHeader22' },
											{ text: '7788996655\n', style: 'topHeader22' },
											{ text: ' ', bold: true, style: 'topHeader22' },
											{ text: '1679905\n', style: 'topHeader22' },
											{ text: ' ', bold: true, style: 'topHeader22' },
											{ text: '23\n', style: 'topHeader22' },
										]
								},

								{
									text:
										[
											{ text: ' ', bold: true, style: 'topCustomerHeader' },
											{ text: 'Google\n', style: 'topCustomerHeader' },
											{ text: ' ', bold: true, style: 'topHeader22' },
											{ text: '1600 Amphitheatre Parkway in Mountain View, California, United States, near San Jose. \n', style: 'topHeader22' },
											{ text: ' ', bold: true, style: 'topHeader22' },
											{ text: '7788996655\n', style: 'topHeader22' },
											{ text: ' ', bold: true, style: 'topHeader22' },
											{ text: '7788996655\n', style: 'topHeader22' },
											{ text: ' ', bold: true, style: 'topHeader22' },
											{ text: '1679905\n', style: 'topHeader22' },
											{ text: ' ', bold: true, style: 'topHeader22' },
											{ text: '23\n', style: 'topHeader22' },
										]
								},
								{
									text:
										[
											{ text: 'Invoice No    :  ', bold: true, style: 'topHeader22' },
											{ text: '787878\n', style: 'topHeader22' },
											{ text: 'Invoice Date :  ', bold: true, style: 'topHeader22' },
											{ text: '12/12/90 \n', style: 'topHeader22' },
											{ text: 'Status            :  ', bold: true, style: 'topHeader22' },
											{ text: '12/12/90 \n', style: 'topRemainingHeader' },
											{ text: 'Due Date       :   ', bold: true, style: 'topHeader22' },
											{ text: '13/12/90 \n', style: 'topHeader22' },
										]
								},
								{
									text:
										[
											{ text: 'Order No           :  	', bold: true, style: 'topHeader22' },
											{ text: '787878\n', style: 'topHeader22' },
											{ text: 'Order Date        :      ', bold: true, style: 'topHeader22' },
											{ text: '12/12/90 \n', style: 'topHeader22' },
											{ text: 'Application No :      ', bold: true, style: 'topHeader22' },
											{ text: '12/12/90 \n', style: 'topHeader22' },
											{ text: 'Sanction Date   :      ', bold: true, style: 'topHeader22' },
											{ text: '13/12/90\n', style: 'topHeader22' },
										]
								},
							],
						]
					}
				},

				{
					table: {

						body: [
							[
								{ text: 'S.No', style: "productHeader", rowSpan: 2 },
								{ text: 'Product Description', style: "productHeader", rowSpan: 2 },
								{ text: 'HSN', style: "productHeader", rowSpan: 2 },
								{ text: 'Qty', style: "productHeader", rowSpan: 2 },
								{ text: 'Units', style: "productHeader", rowSpan: 2 },
								{ text: 'Unit Price', style: "productHeader", rowSpan: 2 },
								{ text: 'Gross weight', style: "productHeader", rowSpan: 2 },
								{ text: 'Net weight', style: "productHeader", rowSpan: 2 },
								{ text: 'Purity', style: "productHeader", rowSpan: 2 },
								{ text: 'Taxable  Amount', style: "productHeader", rowSpan: 2 },
								{ text: 'CGST', style: "productHeader", colSpan: 2, rowSpan: 1 },
								{ text: '', style: "productHeader" },
								{ text: 'SGST', style: "productHeader", colSpan: 2, rowSpan: 1 },
								{ text: '', style: "productHeader" },
								{ text: 'IGST', style: "productHeader", colSpan: 2, rowSpan: 1 },
								{ text: '', style: "productHeader" },
								{ text: 'Total Amount', style: "productHeader", rowSpan: 2 }
							],
							[
								{ text: 'S.No', style: "productHeader" },
								{ text: 'Product Description', style: "productHeader" },
								{ text: 'HSN', style: "productHeader" },
								{ text: 'Qty', style: "productHeader" },
								{ text: 'Units', style: "productHeader" },
								{ text: 'Unit Price', style: "productHeader" },
								{ text: 'Gross weight', style: "productHeader" },
								{ text: 'Net weight', style: "productHeader" },
								{ text: 'Purity', style: "productHeader" },
								{ text: 'Taxable Amount', style: "productHeader" },
								{ text: '%', style: "productHeader" },
								{ text: '₹', style: "productHeader" },
								{ text: '%', style: "productHeader" },
								{ text: '₹', style: "productHeader" },
								{ text: '%', style: "productHeader" },
								{ text: '₹', style: "productHeader" },
								{ text: 'Total Amount', style: "productHeader" },
							],
						]
					}
				},
				{
					table: {
						widths: ['75%', '*'],
						body: [

							[
								[
									{
										table: {

											body: [
												[
													{ text: 'HSN SUMMARY', style: "gstHeader", colSpan: 10 },
													{ text: 'QUANTITY', style: "gstHeader" },
													{ text: 'TAXABLE AMOUNT', style: "gstHeader" },
													{ text: '%', style: "gstHeader" },
													{ text: 'AMOUNT', style: "gstHeader" },
													{ text: '%', style: "gstHeader" },
													{ text: 'AMOUNT', style: "gstHeader" },
													{ text: '%', style: "gstHeader" },
													{ text: 'AMOUNT', style: "gstHeader" },
													{ text: 'TOTAL TAX AMOUNT', style: "gstHeader" }
												],
												[

													{ text: 'HSN/SAC', style: "gstHeader", rowSpan: 2 },
													{ text: 'QUANTITY', style: "gstHeader", rowSpan: 2 },
													{ text: 'TAXABLE AMOUNT', style: "gstHeader", rowSpan: 2 },
													{ text: 'CGST', style: "gstHeader", colSpan: 2, rowSpan: 1 },
													{ text: '', style: "gstHeader", rowSpan: 2 },
													{ text: 'SGST', style: "gstHeader", colSpan: 2, rowSpan: 1 },
													{ text: '', style: "gstHeader", rowSpan: 2 },
													{ text: 'IGST', style: "gstHeader", colSpan: 2, rowSpan: 1 },
													{ text: '', style: "gstHeader", rowSpan: 2 },
													{ text: 'TOTAL TAX AMOUNT', style: "gstHeader", rowSpan: 2 },
												],
												[

													{ text: 'HSN/SAC', style: "gstHeader" },
													{ text: 'QUANTITY', style: "gstHeader" },
													{ text: 'TAXABLE AMOUNT', style: "gstHeader" },
													{ text: '%', style: "gstHeader" },
													{ text: 'AMOUNT', style: "gstHeader" },
													{ text: '%', style: "gstHeader" },
													{ text: 'AMOUNT', style: "gstHeader" },
													{ text: '%', style: "gstHeader" },
													{ text: 'AMOUNT', style: "gstHeader" },
													{ text: 'TAX AMOUNT', style: "gstHeader" },
												],
											]
										}
									},

									{
										table: {
											widths: ['30%', '40%', '30%'],
											body: [
												[
													[{ text: 'PAYMENT DETAILS', style: "topHeader" }],
													[{ text: 'TERMS & CONDITIONS', style: "topHeader" }],
													[{ text: 'AUTHORITY SIGNATURE', style: "topHeader" }],
												],
											],
										},
										style: 'tab2Head',
									}, {
										table: {
											widths: ['30%', '40%', '30%'],
											body: [
												[[

												],
												[
													{
														text: "",
													},
												],
												// {
												// 	text:
														[{ text: '' },
														{ text: 'Firm Name  ', bold: true, alignment: 'center', style: 'topFirmAuthority' },
														{ text: '\n\n\n\n' },

														{ text: 'AUTHORITY SIGNATURE  ', bold: true, alignment: 'center', style: 'topFirmAuthority' },
														{ text: '\n' },
														]

												// },
												]
											]
										},
										style: 'tab2',
									},

								],
								{
									text:
										[
											{ text: 'Taxable Amount:       ', bold: true, style: 'topHeader33' },
											{ text: '12122\n', style: 'topHeader33' },
											{ text: 'CGST Amount:           ', bold: true, style: 'topHeader33' },
											{ text: '12122\n', style: 'topHeader33' },
											{ text: 'SGST Amount:           ', bold: true, style: 'topHeader33' },
											{ text: '12122\n', style: 'topHeader33' },
											{ text: 'IGST Amount:            ', bold: true, style: 'topHeader33' },
											{ text: '12122\n', style: 'topHeader33' },
											//   { text: 'Extra Charge:             ', bold: true, style:'topHeader33' },
											//   { text: '12122\n', style:'topHeader33' },
											{ text: 'Discount:                    ', bold: true, style: 'topHeader33' },
											{ text: '12122\n', style: 'topHeader33' },
											{ text: 'RoundOff:                   ', bold: true, style: 'topHeader33' },
											{ text: '12122\n', style: 'topHeader33' },
											{ text: 'Total Amount:            ', style: 'topHeader11' },
											{ text: '12122\n', style: 'topHeader11' },
											{ text: 'Paid Amount:             ', bold: true, style: 'topHeader33' },
											{ text: '12122\n', style: 'topHeader33' },
											{ text: 'Due Amount:              ', bold: true, style: 'topRemainingHeader' },
											{ text: '12122\n', style: 'topRemainingHeader' },
											// 	{ text: 'Payment Type:-       ', bold: true },
											// { text: '12122\n' },
										]

								},

							],
						],

					},
					//style:'tab2', pageBreak: 'after'
				},
				{
					table: {
						widths: ['15%', '60%', '25%'],
						body: [
							[
								{
									// image: '',
									// width: 110,
									// height: 70,
								},
								{
									text:
										[
											// { text: '' ,style:'topHeader'},
											// { text: 'For More Information, Visit\n', style: 'topLeftHeader'},
											// { text: 'https://info.parvsacuify.com\n' },
											// { text: 'https://parvsacuify.com\n' },
											// { text: '+91 6232623333\n'},
											// { text: 'careacuify@gmail.com \n' },
										]
								},
								{
									text:
										[
											//   { text: '' },
											//   { text: 'Firm Name  ', bold: true,	alignment: 'center', style: 'topFirmAuthority' },
											//   { text: '\n\n\n\n' }, 
											//   { text: 'AUTHORITY SIGNATURE  ', bold: true, alignment: 'center',style: 'topFirmAuthority'},
											//   { text: '\n' },
										]

								},
								//   {
								// 	  text:
								// 		  [
								// 			//   { text: 'Paid Amount:-         ', bold: true },
								// 			//   { text: '12122\n' },
								// 			//   { text: 'Due Amount:-          ', bold: true },
								// 			//   { text: '12122\n' },
								// 			  // 	{ text: 'Payment Type:-       ', bold: true },
								// 			  // { text: '12122\n' },
								// 		  ]

								//   },
							],
						],

					},
					layout: {
						hLineWidth: function (i, node) {
							return (i === 0 || i === node.table.body.length) ? 2 : 0;
						},
						vLineWidth: function (i, node) {
							return (i === 0 || i === node.table.widths.length) ? 2 : 0;
						},
						hLineColor: function (i, node) {
							return (i === 0 || i === node.table.body.length) ? 'black' : 'white';
						},
						vLineColor: function (i, node) {
							return (i === 0 || i === node.table.widths.length) ? 'black' : 'white';
						},
					}
				}
			],
			footer: {
				columns: [
					{
						text: 'Powered By ACUIFY',
						alignment: 'right',
						color: '#160091'
					}
				],
				margin: [10, 10]
			},
			styles: {
				header: {
					fontSize: 10,
					bold: true,
					alignment: 'center'
				},
				productHeader: {
					fontSize: 10,
					bold: true,
					alignment: 'center',
					color: '#160091',
				},
				gstHeader: {
					fontSize: 10,
					color: '#160091',
					bold: true,
					alignment: 'center'
				},
				product: {
					fontSize: 9,
					alignment: 'center',
				},
				total: {
					fontSize: 10,
					alignment: 'center',
					bold: true
				},
				productRight: {
					fontSize: 10,
					alignment: 'right',
					// bold: true
				},
				totalRight: {
					fontSize: 10,
					alignment: 'right',
					bold: true
				},
				topHeader: {
					color: '#160091',
					fontSize: 10,
					alignment: 'center',
					bold: true,
				},
				topLeftHeader: {
					color: '#160091',
					fontSize: 12,
					alignment: 'left',
					bold: true,
				},
				topHeader22: {
					fontSize: 10,
					bold: true,
				},
				topHeaderHead: {
					fontSize: 14,
					bold: true,
					color: '#160091',
				},
				topCustomerHeader: {
					color: '#160091',
					fontSize: 10,
					bold: true,
				},
				topHeader33: {
					fontSize: 10,
					bold: true,
				},
				topHeader11: {
					color: '#160091',
					fontSize: 10,
					bold: true,
				},
				topRemainingHeader: {
					color: '#FF0000',
					fontSize: 10,
					bold: true,
				},
				bankDetails: {
					fontSize: 10,
					bold: true,
				},
				topFirmAuthority: {
					color: '#160091',
					fontSize: 11,
					bold: true,
				},
			}
		}

		//Firm Details 
		// pdfDoc.content[0].table.body[0][1].text[1].text = (metaData.firm.name.toUpperCase() ? metaData.firm.name.toUpperCase() : '') + "\n";
		pdfDoc.content[1].table.body[1][0].text[1].text = ((metaData.firm && metaData.firm.name) ? metaData.firm.name.toUpperCase() : '') + "\n";
		pdfDoc.content[1].table.body[1][0].text[3].text = (metaData.firm.GST_number ? metaData.firm.GST_number : '') + "\n";
		pdfDoc.content[1].table.body[1][0].text[5].text = (metaData.firm.liveAddress ? metaData.firm.liveAddress : '') + "\n";
		pdfDoc.content[1].table.body[1][0].text[7].text = (metaData.firm.address ? metaData.firm.address : '') + "\n";
		pdfDoc.content[1].table.body[1][0].text[9].text = (metaData.firm.mobileNumber ? metaData.firm.mobileNumber : '') + "\n";
		pdfDoc.content[1].table.body[1][0].text[11].text = (metaData.firm.email ? metaData.firm.email : '') + "\n";
		// pdfDoc.content[1].table.body[1][0].text[13].text = (metaData.firm.website ? metaData.firm.website : '') + "\n";

		//Bill to Details
		// pdfDoc.content[1].table.body[1][0].text[1].text = (metaData.customer.name.toUpperCase() ? metaData.customer.name.toUpperCase() : '') + "\n";
		// pdfDoc.content[1].table.body[1][0].text[1].text = ((metaData.customer && metaData.customer.name )? metaData.customer.name.toUpperCase() : '') + "\n";
		pdfDoc.content[1].table.body[1][1].text[1].text = (getCustomerDetails(metaData, 'name').toUpperCase()) + "\n";
		pdfDoc.content[1].table.body[1][1].text[3].text = (metaData.customer.GST_number ? metaData.customer.GST_number : '') + "\n";
		// pdfDoc.content[1].table.body[1][1].text[5].text= (metaData.customer.address ? metaData.customer.address : '') + "\n";
		// pdfDoc.content[1].table.body[1][1].text[7].text = (metaData.customer.mobile ? metaData.customer.mobile : '') + "\n";
		pdfDoc.content[1].table.body[1][1].text[5].text = (metaData.customer.localAddress ? metaData.customer.localAddress : '') + "\n";
		pdfDoc.content[1].table.body[1][1].text[7].text = (getCustomerDetails(metaData, 'address')) + "\n";
		pdfDoc.content[1].table.body[1][1].text[9].text = (getCustomerDetails(metaData, 'mobile').toUpperCase()) + "\n";
		pdfDoc.content[1].table.body[1][1].text[11].text = (metaData.invoiceData.placeOfSupply ? metaData.invoiceData.placeOfSupply : '') + "\n";

		//SHIP TO Details
		// pdfDoc.content[1].table.body[1][1].text[1].text = ((metaData.customer && metaData.customer.name )? metaData.customer.name.toUpperCase() : '') + "\n";
		pdfDoc.content[1].table.body[1][2].text[1].text = (metaData.customer.name.toUpperCase() ? metaData.customer.name.toUpperCase() : '') + "\n";
		pdfDoc.content[1].table.body[1][2].text[3].text = (metaData.customer.GST_number ? metaData.customer.GST_number : '') + "\n";
		pdfDoc.content[1].table.body[1][2].text[5].text = (metaData.customer.localAddress ? metaData.customer.localAddress : '') + "\n";
		pdfDoc.content[1].table.body[1][2].text[7].text = (metaData.customer.address ? metaData.customer.address : '') + "\n";
		pdfDoc.content[1].table.body[1][2].text[9].text = (metaData.customer.mobile ? metaData.customer.mobile : '') + "\n";
		pdfDoc.content[1].table.body[1][2].text[11].text = (metaData.invoiceData.placeOfSupply ? metaData.invoiceData.placeOfSupply : '') + "\n";

		//Invoice Details
		let date = new Date(metaData.invoiceData.date)
		let paymentDueDate = date.setDate(date.getDate() + (metaData.invoiceData.duration ? parseInt(metaData.invoiceData.duration) : 0));
		pdfDoc.content[1].table.body[1][3].text[1].text = metaData.invoiceData.invoiceId + "\n";
		pdfDoc.content[1].table.body[1][3].text[3].text = new Date(metaData.invoiceData.date).toLocaleDateString('en-GB').toString() + "\n";
		pdfDoc.content[1].table.body[1][3].text[5].text = (metaData.invoiceData.status ? (metaData.invoiceData.status).toUpperCase() : '') + "\n";
		pdfDoc.content[1].table.body[1][3].text[7].text = new Date(paymentDueDate).toLocaleDateString('en-GB').toString() + "\n";

		//extra details
		pdfDoc.content[1].table.body[1][4].text[1].text = (metaData.invoiceData.orderNumber ? metaData.invoiceData.orderNumber : '-') + "\n";
		pdfDoc.content[1].table.body[1][4].text[3].text = (metaData.invoiceData.orderDate ? new Date(metaData.invoiceData.orderDate).toLocaleDateString('en-GB').toString() : '-') + "\n";
		pdfDoc.content[1].table.body[1][4].text[5].text = (metaData.invoiceData.applicationNumber ? metaData.invoiceData.applicationNumber : '-') + "\n";
		pdfDoc.content[1].table.body[1][4].text[7].text = (metaData.invoiceData.sanctionDate ? new Date(metaData.invoiceData.sanctionDate).toLocaleDateString('en-GB').toString() : '-') + "\n";


		//pending
		switch (metaData.firm.businessType) {
			case 'Jwellery': {
				pdfDoc.content[2].table.body[0][6].text = "Gross weight";
				pdfDoc.content[2].table.body[0][7].text = "Net weight";
				pdfDoc.content[2].table.body[0][8].text = "Purity";
				break;
			}
			case 'Grain': {
				//pdfDoc.content[2].table.body[0][6].text = "Gross weight";
				pdfDoc.content[2].table.body[0][7].text = "Net weight";
				pdfDoc.content[2].table.body[0][8].text = "Packing";
				break;
			}
			case 'Medical/Pesticides': {
				pdfDoc.content[2].table.body[0][6].text = "Batch";
				pdfDoc.content[2].table.body[0][7].text = "MFG Date";
				pdfDoc.content[2].table.body[0][8].text = "EXP Date";
				break;
			}
			case 'Clothes': {
				pdfDoc.content[2].table.body[0][6].text = "Brand";
				pdfDoc.content[2].table.body[0][7].text = "Color";
				pdfDoc.content[2].table.body[0][8].text = "Size";
				break;
			}
			case 'Automobile/Spare Parts': {
				pdfDoc.content[2].table.body[0][6].text = "ENG No.";
				pdfDoc.content[2].table.body[0][7].text = "Chasis No.";
				pdfDoc.content[2].table.body[0][8].text = "Extra";
				break;
			}
			default: {
				pdfDoc.content[2].table.body[0][6].text = "Extra";
				pdfDoc.content[2].table.body[0][7].text = "Extra";
				pdfDoc.content[2].table.body[0][8].text = "Extra";
				break;
			}
		}

		// Products
		// let productList = convertToPDFProductWithExtraDetails(metaData.firm.businessType,metaData.invoiceData.items,true);
		let productList = convertToPDFProductWithExtraDetails(metaData.firm.businessType, metaData.invoiceData.items, true, metaData.invoiceData);
		productList.map((item) => {
			pdfDoc.content[2].table.body.push(item);
		});
		let gstObj = convertToGST(metaData.invoiceData.items);
		Object.keys(gstObj).forEach((key) => {
			if (key != "totalObj") {
				pdfDoc.content[3].table.body[0][0][0].table.body.push([
					{ text: key, style: "product" },
					{ text: gstObj[key].quantity, style: "product" },
					{ text: Number.parseFloat(gstObj[key].basicPrice).toFixed(2), style: "total" },
					{ text: gstObj[key].CGST + '%', style: "product" },
					{ text: gstObj[key].CGST_val, style: "product" },
					{ text: gstObj[key].SGST + '%', style: "product" },
					{ text: gstObj[key].SGST_val, style: "product" },
					{ text: gstObj[key].IGST + '%', style: "product" },
					{ text: gstObj[key].IGST_val, style: "product" },
					{ text: Number.parseFloat(gstObj[key].GSTValue).toFixed(2), style: "product" }])
			}
		});

		pdfDoc.content[3].table.body[0][0][0].table.body.push([
			{ text: 'Total', style: "total" },
			{ text: gstObj.totalObj.quantity, style: "total" },
			{ text: Number.parseFloat(gstObj.totalObj.basicPrice).toFixed(2), style: "total" },
			{ text: '', style: "total" },
			{ text: Number.parseFloat(gstObj.totalObj.CGST_val).toFixed(2), style: "total" },
			{ text: '', style: "total" },
			{ text: Number.parseFloat(gstObj.totalObj.SGST_val).toFixed(2), style: "total" },
			{ text: '', style: "total" },
			{ text: Number.parseFloat(gstObj.totalObj.IGST_val).toFixed(2), style: "total" },
			{ text: Number.parseFloat(gstObj.totalObj.GSTValue).toFixed(2), style: "total" }]);

		// Payment Details

		// pdfDoc.content[6].table.body[0][0][1].table.body[0][1].text[1].text = (metaData.invoiceData.paymentType ? metaData.invoiceData.paymentType : '') + "\n";
		// pdfDoc.content[6].table.body[0][0][1].table.body[0][1].text[3].text = (metaData.invoiceData.transactionType ? metaData.invoiceData.transactionType : '') + "\n";

		//authority
		pdfDoc.content[3].table.body[0][0][2].table.body[0][2][1].text = (metaData.firm.name ? (metaData.firm.name).toUpperCase() : '');

		// Terms and cond
		pdfDoc.content[3].table.body[0][0][2].table.body[0][1][0].text = metaData.terms.termsAndConditions;

		//Bank Account Details
		if (metaData.terms.banks.length) {
			metaData.terms.banks.map((bankDetails) => {
				pdfDoc.content[3].table.body[0][0][2].table.body[0][0].push({ text: bankDetails.bankName + "\n", style: 'bankDetails' })
				pdfDoc.content[3].table.body[0][0][2].table.body[0][0].push({ text: "NAME: " + bankDetails.accountHolderName + "\n", style: 'bankDetails' })
				pdfDoc.content[3].table.body[0][0][2].table.body[0][0].push({ text: "A/C NO: " + bankDetails.accountnumber + "\n", style: 'bankDetails' })
				pdfDoc.content[3].table.body[0][0][2].table.body[0][0].push({ text: "IFSC:   " + bankDetails.ifsccode + "\n", style: 'bankDetails' })
				pdfDoc.content[3].table.body[0][0][2].table.body[0][0].push({ text: bankDetails.address + "\n", style: 'bankDetails' })
			})
		}
		// pdfDoc.content[3].table.body[0][0][2].table.body[0][0].text = metaData.terms.termsAndConditions;

		// gst details
		// pdfDoc.content[3].table.body[0][1].text[1].text = ((metaData.invoiceData.totalAmount - metaData.invoiceData.roundOffAmount ? Number.parseFloat(metaData.invoiceData.totalAmount - metaData.invoiceData.roundOffAmount).toFixed(2) - Number.parseFloat(metaData.gstTotal.CGST_val + metaData.gstTotal.SGST_val + metaData.gstTotal.IGST_val).toFixed(2) : '0')).toFixed(2) + "\n";
		pdfDoc.content[3].table.body[0][1].text[1].text = (
			Number.parseFloat(metaData.invoiceData.totalAmount) +
			Number.parseFloat(metaData.invoiceData.discountAmount || 0) +
			Number.parseFloat(metaData.invoiceData.gstOnExtraChanrges ? 0 : (-Number.parseFloat(metaData.invoiceData.totalExtraCharges))) -
			Number.parseFloat(metaData.invoiceData.gstOnExtraChanrges ? Number.parseFloat(metaData.invoiceData.totalExtraChargesGST) : 0) -
			Number.parseFloat(metaData.invoiceData.roundOffAmount || 0) -
			(Number.parseFloat(
				metaData.gstTotal.SGST_val
			) +
				Number.parseFloat(
					metaData.gstTotal.CGST_val
				) +
				Number.parseFloat(
					metaData.gstTotal.IGST_val
				))
		).toFixed(2) + "\n";
		pdfDoc.content[3].table.body[0][1].text[3].text = (metaData.gstTotal.CGST_val ? (Number.parseFloat(metaData.gstTotal.CGST_val) + Number.parseFloat(metaData.invoiceData.gstOnExtraChanrges ? Number.parseFloat(metaData.invoiceData.totalExtraChargesGST) / 2 : 0)).toFixed(2) : '0.00') + "\n";
		pdfDoc.content[3].table.body[0][1].text[5].text = (metaData.gstTotal.SGST_val ? (Number.parseFloat(metaData.gstTotal.SGST_val) + Number.parseFloat(metaData.invoiceData.gstOnExtraChanrges ? Number.parseFloat(metaData.invoiceData.totalExtraChargesGST) / 2 : 0)).toFixed(2) : '0.00') + "\n";
		pdfDoc.content[3].table.body[0][1].text[7].text = (metaData.gstTotal.IGST_val ? (Number.parseFloat(metaData.gstTotal.IGST_val) + Number.parseFloat(metaData.invoiceData.gstOnExtraChanrges ? Number.parseFloat(metaData.invoiceData.totalExtraChargesGST) : 0)).toFixed(2) : '0.00') + "\n";
		let offset = 0;
		if (!metaData.invoiceData.gstOnExtraChanrges && metaData.invoiceData.extraCharges && metaData.invoiceData.extraCharges.length) {
			metaData.invoiceData.extraCharges.map((charge) => {
				pdfDoc.content[3].table.body[0][1].text.splice(8 + offset, 0, { text: '' + charge.name + ':         ', bold: true, style: 'topHeader33' })
				offset++;
				pdfDoc.content[3].table.body[0][1].text.splice(8 + offset, 0, { text: Number.parseFloat(charge.amount).toFixed(2) + '\n', style: 'topHeader33' })
				offset++;
			})
		}
		// pdfDoc.content[3].table.body[0][1].text[9].text = (metaData.invoiceData.labourAmount ? Number.parseFloat(metaData.invoiceData.labourAmount).toFixed(2) : '0.00') + "\n";
		pdfDoc.content[3].table.body[0][1].text[9 + offset].text = (metaData.invoiceData.discountAmount ? Number.parseFloat(metaData.invoiceData.discountAmount).toFixed(2) : '0.00') + "\n";
		pdfDoc.content[3].table.body[0][1].text[11 + offset].text = (metaData.invoiceData.roundOffAmount ? Number.parseFloat(metaData.invoiceData.roundOffAmount).toFixed(2) : '0.00') + "\n";
		// pdfDoc.content[6].table.body[0][1].text[15].text = (metaData.invoiceData.totalAmount + metaData.invoiceData.labourAmount -  metaData.invoiceData.discountAmount ? Number.parseFloat(Number.parseFloat(metaData.invoiceData.totalAmount) + Number.parseFloat(metaData.invoiceData.labourAmount) - Number.parseFloat(metaData.invoiceData.discountAmount)).toFixed(2) : '0') + "\n";
		pdfDoc.content[3].table.body[0][1].text[13 + offset].text = (metaData.invoiceData.totalAmount ? Number.parseFloat(metaData.invoiceData.totalAmount).toFixed(2) : '0.00') + "\n";
		pdfDoc.content[3].table.body[0][1].text[15 + offset].text = (metaData.invoiceData.paidAmount ? Number.parseFloat(metaData.invoiceData.paidAmount).toFixed(2) : '0.00') + "\n";
		pdfDoc.content[3].table.body[0][1].text[17 + offset].text = (metaData.invoiceData.remainingAmount ? Number.parseFloat(metaData.invoiceData.remainingAmount).toFixed(2) : '0.00') + "\n";
		// pdfDoc.content[4].table.body[0][3].text[1].text = (metaData.invoiceData.paidAmount ? metaData.invoiceData.paidAmount : '0') + "\n";
		// pdfDoc.content[4].table.body[0][3].text[3].text = (metaData.invoiceData.remainingAmount ? metaData.invoiceData.remainingAmount : '') + "\n";
		// pdfDoc.content[6].table.body[0][1].text[17].text = (metaData.invoiceData.paymentType ? metaData.invoiceData.paymentType : '') + "\n";

		// if(metaData.invoiceData.extraCharges && metaData.invoiceData.extraCharges.length) {
		// 		metaData.invoiceData.extraCharges.map((charge)=>{
		// 		pdfDoc.content[3].table.body[0][1].text.push({ text: ''+charge.name+':          ', bold: true, style:'topHeader33' })
		// 		pdfDoc.content[3].table.body[0][1].text.push({ text:Number.parseFloat(charge.amount).toFixed(2)+'\n', style:'topHeader33' })
		// 	})
		// }

		//authority

		//pdfDoc.content[4].table.body[0][2].text[1].text =  (metaData.firm.name ? (metaData.firm.name).toUpperCase() : '');

		if (metaData.terms.printLogo) {
			try {
				// let logoData = await getBase64ImageFromURL(metaData.terms.printLogo)
				// pdfDoc.content[0].table.body[0][0].image = logoData;
				var imgToExport = document.getElementById('pdfimgToExport');
				var canvas = document.createElement('canvas');
				canvas.width = imgToExport.width;
				canvas.height = imgToExport.height;
				canvas.getContext('2d').drawImage(imgToExport, 0, 0);
				let invoiceImages = document.getElementById('invoiceImages');
					if (invoiceImages && invoiceImages.files && invoiceImages.files.length) {
						let temp = {columns: []};
						if(invoiceImages.files[0]) {
							temp.columns.push({
								image: await toBase64(invoiceImages.files[0]).catch(e => Error(e)),
								width: 150
							})
						}
						if(invoiceImages.files[1]) {
							temp.columns.push({
								image: await toBase64(invoiceImages.files[1]).catch(e => Error(e)),
								width: 150
							})
						}
						if(invoiceImages.files[2]) {
							temp.columns.push({
								image: await toBase64(invoiceImages.files[2]).catch(e => Error(e)),
								width: 150
							})
						}
						pdfDoc.content.push(temp)
					}
				//let base64 = canvas.toDataURL('image/png')
				//pdfDoc.content[4].table.body[0][0].image = base64;
				if(metaData.terms.signature) {
					let temp = {columns: []};
					temp.columns.push({
						image: await getBase64ImageFromURL(metaData.terms.signature),
						width: 150,
						alignment: 'right'
					})
					//pdfDoc.content.push(temp)
					pdfDoc.content[3].table.body[0][2][2] = temp.columns[0]
				}
				return pdfDoc;
			} catch (error) {
				console.log(error)
			}
		} else {
			var imgToExport = document.getElementById('pdfimgToExport');
			var canvas = document.createElement('canvas');
			canvas.width = imgToExport.width;
			canvas.height = imgToExport.height;
			canvas.getContext('2d').drawImage(imgToExport, 0, 0);
			let invoiceImages = document.getElementById('invoiceImages');
					if (invoiceImages && invoiceImages.files && invoiceImages.files.length) {
						let temp = {columns: []};
						if(invoiceImages.files[0]) {
							temp.columns.push({
								image: await toBase64(invoiceImages.files[0]).catch(e => Error(e)),
								width: 150
							})
						}
						if(invoiceImages.files[1]) {
							temp.columns.push({
								image: await toBase64(invoiceImages.files[1]).catch(e => Error(e)),
								width: 150
							})
						}
						if(invoiceImages.files[2]) {
							temp.columns.push({
								image: await toBase64(invoiceImages.files[2]).catch(e => Error(e)),
								width: 150
							})
						}
						pdfDoc.content.push(temp)
					}
			// let base64 = canvas.toDataURL('image/png')
			// pdfDoc.content[0].table.body[0][0].image = base64;
			// pdfDoc.content[4].table.body[0][0].image = base64;
		}

		if(metaData.terms.signature) {
			let temp = {columns: []};
			temp.columns.push({
				image: await getBase64ImageFromURL(metaData.terms.signature),
				width: 150,
				alignment: 'right'
			})
			//pdfDoc.content.push(temp)
			pdfDoc.content[3].table.body[0][2][2] = temp.columns[0]
		}
		return pdfDoc;
	}
	// End of New Photo Resize Format Second

	export const convertToBasicInvoiceWithoutGST = async (metaData) => {
		let pdfDoc = {
			content: [
				{
					table: {
						widths: ['*'],
						body: [
							[
								{ text: 'PROFORMA INVOICE', style: "topHeader" },
							],

						],

					},
					layout: 'noBorders'
				},
				{
					table: {
						widths: ['0%', '48%', '*'],
						body: [

							[
								{
									text: ''

								},
								{
									image: '',
									width: 140,
									height: 100,
								},
								{
									text:
										[
											{ text: ' ', bold: true, style: 'topFirmAuthorityRight' },
											{ text: '\n', style: 'topFirmAuthorityRight' },
											{ text: '', bold: true, style: 'firmHeaderOneRight' },
											{ text: '88776655\n', style: 'firmHeaderOneRight' },
											// { text: ' ', bold: true, style: 'icon' },
											// { text: '1600 Amphitheatre Parkway in Mountain View, California, United States, near San Jose. \nRight'},
											{ text: '', bold: true, style: 'firmHeaderOneRight' },
											{ text: '88776655\n', style: 'firmHeaderOneRight' },
											{ text: '', bold: true, style: 'firmHeaderOneRight' }, //icon gift
											{ text: 'njnjn@jnn.com\n', style: 'firmHeaderOneRight' },
											{ text: ' ', bold: true, style: 'firmHeaderOneRight' },
											{ text: '123456\n', style: 'firmHeaderOneRight' },
										]
								},
								// {
								// 	text: ''

								// },
							],
						]
					},
					layout: 'noBorders',
					style: "topTab"
				},
				{
					table: {
						widths: ['60%', '*'],
						body: [
							[
								{ text: 'BILL TO', style: "billHeader" },
								{ text: 'INVOICE DETAILS', style: "billHeader" },
							],

						],


					},
					style: 'tab2Head',
					layout: 'noBorders',
				},
				{
					table: {
						widths: ['0%', '55%', '*'],
						body: [
							[
								{
									text: ''

								},
								{
									text:
										[
											{ text: ' ', bold: true, style: 'topFirmAuthority' },
											{ text: 'Google\n', style: 'topFirmAuthority' },
											{ text: ' ', bold: true, style: 'firmHeaderOne' },
											{ text: '1679905\n', style: 'firmHeaderOne' },
											{ text: '  ', bold: true, style: 'firmHeaderOne' },
											{ text: '7788996655\n', style: 'firmHeaderOne' },
											{ text: 'Mobile Number :   ', bold: true, style: 'firmHeaderOne' },
											{ text: '1600 Amphitheatre Parkway in Mountain View, California, United States, near San Jose. \n', style: 'firmHeaderOne' },
											{ text: 'Place of Supply :   ', bold: true, style: 'firmHeaderOne' },
											{ text: '13/12/90\n', style: 'firmHeaderOne' },
											{ text: 'State Code         :   ', bold: true, style: 'firmHeaderOne' },
											{ text: '23\n', style: 'firmHeaderOne' },
										]
								},
								{
									text:
										[
											{ text: 'Invoice No                :   ', bold: true, style: 'firmHeaderOne' },
											{ text: '787878\n', style: 'firmHeaderOne' },
											{ text: 'Invoice Date             :   ', bold: true, style: 'firmHeaderOne' },
											{ text: '12/12/90 \n', style: 'firmHeaderOne' },
											{ text: 'Invoice Status          :   ', bold: true, style: 'topRemainingHeader' },
											{ text: '12/12/90 \n', style: 'topRemainingHeader' },
											{ text: 'Payment Due Date  :   ', bold: true, style: 'firmHeaderOne' },
											{ text: '13/12/90\n', style: 'firmHeaderOne' },
											{ text: 'Remark  :   ', bold: true, style: 'firmHeaderOne' },
											{ text: '13/12/90\n', style: 'firmHeaderOne' },
										]
								},

							],
						],

					},
					style: 'tab2',
					layout: 'noBorders',

				},
				{
					table: {
						widths: ['*', '*',],
						body: [
							[
								{ text: 'ITEMS', style: "emptyHeader1" },
								{ text: '', style: "emptyHeader1" },
							],

						],

					},
					layout: 'noBorders',
				},
				{
					table: {

						body: [
							[
								{ text: 'S.NO', style: "productHeader11", rowSpan: 2 },
								{ text: 'DESCRIPTION OF PRODUCTS', style: "productHeader11", rowSpan: 2 },
								// { text: 'HSN/SAC', style: "productHeader1", rowSpan: 2 },
								{ text: 'QUANTITY', style: "productHeader11", rowSpan: 2 },
								{ text: 'UNITS', style: "productHeader11", rowSpan: 2 },
								{ text: 'PRODUCTS RATE', style: "productHeader11", rowSpan: 2 },
								// { text: 'Basic  Amount', style: "productHeader", rowSpan: 2 },
								{ text: 'TOTAL AMOUNT', style: "productHeader11", rowSpan: 2 },
							],
							[
								{ text: 'S.NO', style: "productHeader11" },
								{ text: 'DESCRIPTION OF PRODUCTS', style: "productHeader11" },
								// { text: 'HSN/SAC', style: "productHeader1" },
								{ text: 'QUANTITY', style: "productHeader11" },
								{ text: 'UNITS', style: "productHeader11" },
								{ text: 'PRODUCTS RATE', style: "productHeader11" },
								// { text: 'Basic Amount', style: "productHeader" },
								{ text: 'TOTAL AMOUNT', style: "productHeader11" },
							],
						]
					}
				},
				{
					table: {
						widths: ['65%', '*'],
						body: [

							[
								[
									{
										table: {
											widths: ['*'],
											body: [
												[
													{ text: 'PAYMENT DETAILS', style: "topHeader1" }
												],

											],


										},
										style: 'tab2Head',
										layout: 'noBorders',

									}, {
										table: {
											widths: ['3%', '*'],
											body: [
												[{
													text: ''

												},
												{
													text:
														[]
												},
												]
											]
										},
										style: 'tab2',
										layout: 'noBorders',
									},
									{
										table: {
											widths: ['*'],
											body: [
												[
													{ text: 'TERMS & CONDITIONS', style: "topHeader1" },

												],

											],


										},
										style: 'tab2Head',
										layout: 'noBorders',

									}, {
										table: {
											widths: ['3%', '*'],
											body: [
												[
													{
														text: ''

													},
													{
														text: "",

													},
												]
											]
										},
										style: 'tab2',
										layout: 'noBorders',
									},

								],
								{
									text:
										[
											{ text: 'Basic Amount   :   ', bold: true, style: 'headerOne' },
											{ text: '12122\n', style: 'headerOne' },
											// { text: 'Labour Charge:      ', bold: true, style:'headerOne' },
											// { text: '12122\n', style:'headerOne' },
											{ text: 'Discount            :   ', bold: true, style: 'headerOne' },
											{ text: '12122\n', style: 'headerOne' },
											{ text: 'RoundOff           :   ', bold: true, style: 'headerOne' },
											{ text: '12122\n', style: 'headerOne' },
											{ text: 'Total Amount    :   ', bold: true, style: 'topTotalAmount' },
											{ text: '12122\n', style: 'topTotalAmount' },
											{ text: 'Paid Amount     :   ', bold: true, style: 'headerOne' },
											{ text: '12122\n', style: 'headerOne' },
											{ text: 'Due Amount      :   ', bold: true, style: 'topRemainingHeader' },
											{ text: '12122\n', style: 'topRemainingHeader' },
											// 	{ text: 'Payment Type:-       ', bold: true },
											// { text: '12122\n' },
										]

								},

							],
						],


					},
					style: 'tab2',
					layout: 'lightHorizontalLines',

				},
				{
					table: {
						widths: ['*', '*',],
						body: [
							[
								{ text: 'OUTSTANDING DETAILS', style: "emptyHeader" },
								{ text: 'he', style: "emptyHeader1" },
							],

						],

					},
					layout: 'noBorders',
				},

				// Start of Previous + current = Total Column
				{
					table: {
						widths: ['34%', '39%', '27%'],
						body: [
							[
								{ text: '', style: "topBlankHeader" },
								{ text: '', style: "topMainHeader" },
								{ text: '', style: "topBlankHeader" },
							],
							[
								{
									text:
										[
											{ text: 'PREVIOUS BALANCE :  ', bold: true, style: 'topHeader11' },
											{ text: '\n', style: 'topHeader11' },
										]
								},
								{
									text:
										[
											{ text: 'CURRENT BALANCE :  ', bold: true, style: 'topHeader11' },
											{ text: '\n', style: 'topHeader11' },
										]
								},

								{
									text:
										[
											{ text: 'TOTAL BALANCE :  ', bold: true, style: 'topRemainingHeader1' },
											{ text: '\n', style: 'topRemainingHeader1' },
										]
								},

							],
						]
					},
					layout: {
						hLineWidth: function (i, node) {
							return (i === 0 || i === node.table.body.length) ? 1 : 0;
						},
						vLineWidth: function (i, node) {
							return (i === 0 || i === node.table.widths.length) ? 1 : 0;
						},
						hLineColor: function (i, node) {
							return (i === 0 || i === node.table.body.length) ? 'black' : 'black';
						},
						vLineColor: function (i, node) {
							return (i === 0 || i === node.table.widths.length) ? 'black' : 'black';
						},
					}
				},
				// End of Previous + current = Total Column

				{
					table: {
						widths: ['*'],
						body: [
							[
								{ text: 'Authority', style: 'emptyHeader1' },
							],

						],

					},
					layout: 'noBorders',
					style: 'tab2',
				},

				{
					table: {
						widths: ['70%', '*'],
						body: [
							[
								{
									text:
										[

										]

								},
								// {
								// 	text:
										[{ text: '' },
										{ text: 'Firm Name  ', bold: true, alignment: 'center', style: 'topFirmAuthority' },
										{ text: '\n\n\n\n\n' },

										{ text: 'AUTHORITY SIGNAUTRE  ', bold: true, alignment: 'center', style: 'topFirmAuthority' },
										{ text: '\n' },
										]

								// },

							],
						],


					},
					style: 'tab2',
					layout: 'noBorders',

				},
				{
					table: {
						widths: ['*'],
						body: [
							[
								{ text: 'Thank you \n', style: 'emptyHeader2' },
							],

						],

					},
					layout: 'noBorders',
					style: 'tab2',
				},
			],
			footer: {
				columns: [
					{
						text: 'Powered By ACUIFY',
						alignment: 'right',
						color: '#160091'
					}
				],
				margin: [10, 10]
			},
			styles: {
				header: {
					fontSize: 12,
					bold: true,
					alignment: 'center'
				},
				headerOne: {
					fontSize: 12,
					bold: true,
				},
				firmHeaderOne: {
					fontSize: 12,
					bold: true,
				},
				firmHeaderOneRight: {
					fontSize: 12,
					bold: true,
					alignment: 'right'
				},
				billHeader: {
					color: 'white',
					fontSize: 12,
					bold: true,
					alignment: 'left',
					fillColor: '#15155d',
				},
				product: {
					fontSize: 12,
					alignment: 'center',
				},
				total: {
					fontSize: 12,
					alignment: 'center',
					bold: true
				},
				productRight: {
					fontSize: 12,
					alignment: 'right',
					// bold: true
				},
				totalRight: {
					fontSize: 12,
					alignment: 'right',
					bold: true
				},
				topHeader: {
					color: 'white',
					fontSize: 14,
					alignment: 'center',
					bold: true,
					fillColor: '#15155d',
				},
				topHeader1: {
					color: 'white',
					fontSize: 12,
					alignment: 'left',
					bold: true,
					fillColor: '#15155d',
				},
				emptyHeader: {
					color: 'white',
					fillColor: '#15155d',
					alignment: 'left',
					bold: true
				},
				emptyHeader1: {
					color: '#15155d',
					fillColor: '#15155d',
					alignment: 'left',
				},
				emptyHeader2: {
					color: 'white',
					fillColor: '#15155d',
					alignment: 'center',
					bold: true
				},
				topTab: {
					// fillColor: '#ececec',
				},
				tab2Head: {
					color: 'white',
					// fillColor: '#015155d',
				},
				tab2: {
					// fillColor: '#ececec',
				},
				topFirmAuthority: {
					color: '#160091',
					fontSize: 12,
					bold: true,
				},
				topFirmAuthorityRight: {
					color: '#160091',
					fontSize: 14,
					bold: true,
					alignment: 'right'
				},
				topTotalAmount: {
					color: '#160091',
					fontSize: 12,
					bold: true,
				},
				topRemainingHeader: {
					color: '#FF0000',
					fontSize: 12,
					bold: true,
				},
				topRemainingHeader1: {
					color: '#FF0000',
					fontSize: 10,
					bold: true,
				},
				bankDetails: {
					fontSize: 12,
					bold: true,
				},
				productHeader: {
					color: '#160091',
					fontSize: 12,
					bold: true,
					alignment: 'center'
				},
				productHeader1: {
					fontSize: 12,
					bold: true,
					alignment: 'center'
				},
				topHeader11: {
					color: '#160091',
					fontSize: 10,
					bold: true,
				},
				productHeader11: {
					fontSize: 12,
					color: '#160091',
					bold: true,
					alignment: 'center'
				},
				hiddenTab: {
					fillColor: '#ffffff',
					color: '#ffffff',
				},
			}
		}

		//Firm Details 
		// pdfDoc.content[1].table.body[0][2].text[1].text = (metaData.firm.name.toUpperCase() ? metaData.firm.name.toUpperCase() : '') + "\n";
		pdfDoc.content[1].table.body[0][2].text[1].text = ((metaData.firm && metaData.firm.name) ? metaData.firm.name.toUpperCase() : '') + "\n";
		// pdfDoc.content[1].table.body[0][2].text[3].text = (metaData.firm.GST_number ? metaData.firm.GST_number : '') + "\n";
		pdfDoc.content[1].table.body[0][2].text[3].text = (metaData.firm.liveAddress ? metaData.firm.liveAddress : '') + "\n";
		pdfDoc.content[1].table.body[0][2].text[5].text = (metaData.firm.address ? metaData.firm.address : '') + "\n";
		pdfDoc.content[1].table.body[0][2].text[7].text = (metaData.firm.mobileNumber ? metaData.firm.mobileNumber : '') + "\n";
		pdfDoc.content[1].table.body[0][2].text[9].text = (metaData.firm.email ? metaData.firm.email : '') + "\n";


		//Receipient Details
		// pdfDoc.content[3].table.body[0][1].text[1].text = (metaData.customer.name.toUpperCase() ? metaData.customer.name.toUpperCase() : '') + "\n";
		// pdfDoc.content[3].table.body[0][1].text[1].text = ((metaData.customer && metaData.customer.name )? metaData.customer.name.toUpperCase() : '') + "\n";
		pdfDoc.content[3].table.body[0][1].text[1].text = (getCustomerDetails(metaData, 'name').toUpperCase()) + "\n";
		// pdfDoc.content[3].table.body[0][1].text[3].text = (metaData.customer.GST_number ? metaData.customer.GST_number : '') + "\n";
		// pdfDoc.content[3].table.body[0][1].text[5].text = (metaData.customer.address ? metaData.customer.address : '') + "\n";
		// pdfDoc.content[3].table.body[0][1].text[7].text = (metaData.customer.mobile ? metaData.customer.mobile : '') + "\n";
		pdfDoc.content[3].table.body[0][1].text[3].text = (metaData.customer.localAddress ? metaData.customer.localAddress : '') + "\n";
		pdfDoc.content[3].table.body[0][1].text[5].text = (getCustomerDetails(metaData, 'address')) + "\n";
		pdfDoc.content[3].table.body[0][1].text[7].text = (getCustomerDetails(metaData, 'mobile').toUpperCase()) + "\n";
		pdfDoc.content[3].table.body[0][1].text[9].text = (metaData.invoiceData.placeOfSupply ? metaData.invoiceData.placeOfSupply : '') + "\n";
		pdfDoc.content[3].table.body[0][1].text[11].text = (metaData.customer.stateCode ? metaData.customer.stateCode : '') + "\n";


		//Invoice Details
		let date = new Date(metaData.invoiceData.date)
		let paymentDueDate = date.setDate(date.getDate() + (metaData.invoiceData.duration ? parseInt(metaData.invoiceData.duration) : 0));
		pdfDoc.content[3].table.body[0][2].text[1].text = metaData.invoiceData.invoiceId + "\n";
		pdfDoc.content[3].table.body[0][2].text[3].text = new Date(metaData.invoiceData.date).toLocaleDateString('en-GB').toString() + "\n";
		pdfDoc.content[3].table.body[0][2].text[5].text = (metaData.invoiceData.status ? metaData.invoiceData.status.toUpperCase() : '') + "\n";
		pdfDoc.content[3].table.body[0][2].text[7].text = new Date(paymentDueDate).toLocaleDateString('en-GB').toString() + "\n";
		pdfDoc.content[3].table.body[0][2].text[9].text = (metaData.invoiceData.remark ? metaData.invoiceData.remark : '') + "\n";

		//Products
		let productList = convertToPDFProducts(metaData.invoiceData.items, false, metaData.invoiceData, metaData);
		productList.map((item) => {
			pdfDoc.content[5].table.body.push(item);
		});

		// Payment Details

		// pdfDoc.content[6].table.body[0][0][1].table.body[0][1].text[1].text = (metaData.invoiceData.paymentType ? metaData.invoiceData.paymentType : '') + "\n";
		// pdfDoc.content[6].table.body[0][0][1].table.body[0][1].text[3].text = (metaData.invoiceData.transactionType ? metaData.invoiceData.transactionType : '') + "\n";

		// Bank Details
		if (metaData.terms.banks.length) {
			metaData.terms.banks.map((bankDetails) => {
				pdfDoc.content[6].table.body[0][0][1].table.body[0][1].text.push({ text: bankDetails.bankName + " \n", style: "bankDetails" })
				pdfDoc.content[6].table.body[0][0][1].table.body[0][1].text.push({ text: "NAME: " + bankDetails.accountHolderName + "\n", style: 'bankDetails' })
				pdfDoc.content[6].table.body[0][0][1].table.body[0][1].text.push({ text: "A/C No: " + bankDetails.accountnumber + "\n", style: "bankDetails" })
				pdfDoc.content[6].table.body[0][0][1].table.body[0][1].text.push({ text: "IFSC: " + bankDetails.ifsccode + "\n", style: "bankDetails" })
				pdfDoc.content[6].table.body[0][0][1].table.body[0][1].text.push({ text: bankDetails.address + " \n", style: "bankDetails" })
			})
		}
		// Terms and cond
		pdfDoc.content[6].table.body[0][0][3].table.body[0][1] = metaData.terms.termsAndConditions;

		// gst details
		// pdfDoc.content[6].table.body[0][1].text[1].text = ((metaData.invoiceData.totalAmount - metaData.invoiceData.roundOffAmount ? Number.parseFloat(metaData.invoiceData.totalAmount - metaData.invoiceData.roundOffAmount).toFixed(2) - Number.parseFloat(metaData.gstTotal.CGST_val + metaData.gstTotal.SGST_val + metaData.gstTotal.IGST_val).toFixed(2) : '0')).toFixed(2) + "\n";
		pdfDoc.content[6].table.body[0][1].text[1].text = (
			Number.parseFloat(metaData.invoiceData.totalAmount) +
			Number.parseFloat(metaData.invoiceData.discountAmount || 0) +
			Number.parseFloat(metaData.invoiceData.gstOnExtraChanrges ? 0 : (-Number.parseFloat(metaData.invoiceData.totalExtraCharges))) -
			Number.parseFloat(metaData.invoiceData.gstOnExtraChanrges ? Number.parseFloat(metaData.invoiceData.totalExtraChargesGST) : 0) -
			Number.parseFloat(metaData.invoiceData.roundOffAmount || 0) -
			(Number.parseFloat(
				metaData.gstTotal.SGST_val
			) +
				Number.parseFloat(
					metaData.gstTotal.CGST_val
				) +
				Number.parseFloat(
					metaData.gstTotal.IGST_val
				))
		).toFixed(2) + "\n";
		let offset = 0;
		if (!metaData.invoiceData.gstOnExtraChanrges && metaData.invoiceData.extraCharges && metaData.invoiceData.extraCharges.length) {
			metaData.invoiceData.extraCharges.map((charge) => {
				pdfDoc.content[6].table.body[0][1].text.splice(2 + offset, 0, { text: '' + charge.name + ' :   ', bold: true, style: 'headerOne' });
				offset++;
				pdfDoc.content[6].table.body[0][1].text.splice(2 + offset, 0, { text: Number.parseFloat(charge.amount).toFixed(2) + '\n', style: 'headerOne' });
				offset++;
			})
		}
		// pdfDoc.content[6].table.body[0][1].text[3].text = (metaData.invoiceData.labourAmount ? Number.parseFloat(metaData.invoiceData.labourAmount).toFixed(2) : '0.00') + "\n";
		pdfDoc.content[6].table.body[0][1].text[3 + offset].text = (metaData.invoiceData.discountAmount ? Number.parseFloat(metaData.invoiceData.discountAmount).toFixed(2) : '0.00') + "\n";
		pdfDoc.content[6].table.body[0][1].text[5 + offset].text = (metaData.invoiceData.roundOffAmount ? Number.parseFloat(metaData.invoiceData.roundOffAmount).toFixed(2) : '0.00') + "\n";
		// pdfDoc.content[6].table.body[0][1].text[9].text = (metaData.invoiceData.totalAmount ? Number.parseFloat(metaData.invoiceData.totalAmount).toFixed(2) : '0') + "\n";
		// pdfDoc.content[6].table.body[0][1].text[9].text = (metaData.invoiceData.totalAmount + metaData.invoiceData.labourAmount -  metaData.invoiceData.discountAmount ? Number.parseFloat(Number.parseFloat(metaData.invoiceData.totalAmount) + Number.parseFloat(metaData.invoiceData.labourAmount) - Number.parseFloat(metaData.invoiceData.discountAmount)).toFixed(2) : '0') + "\n";
		pdfDoc.content[6].table.body[0][1].text[7 + offset].text = (metaData.invoiceData.totalAmount ? Number.parseFloat(metaData.invoiceData.totalAmount) : '0.00').toFixed(2) + "\n";
		pdfDoc.content[6].table.body[0][1].text[9 + offset].text = (metaData.invoiceData.paidAmount ? Number.parseFloat(metaData.invoiceData.paidAmount).toFixed(2) : '0.00') + "\n";
		pdfDoc.content[6].table.body[0][1].text[11 + offset].text = (metaData.invoiceData.remainingAmount ? Number.parseFloat(metaData.invoiceData.remainingAmount).toFixed(2) : '0.00') + "\n";
		// pdfDoc.content[6].table.body[0][1].text[17].text = (metaData.invoiceData.paymentType ? metaData.invoiceData.paymentType : '') + "\n";
		// if(metaData.invoiceData.extraCharges && metaData.invoiceData.extraCharges.length) {
		// 	metaData.invoiceData.extraCharges.map((charge)=>{
		// 				pdfDoc.content[6].table.body[0][1].text.push({ text: ''+charge.name+':-          ', bold: true })
		// 				pdfDoc.content[6].table.body[0][1].text.push({ text:charge.amount+'\n' })
		// 	})
		// }

		// Overall Balance
		if (metaData.balance && metaData.terms.isPreviousCurrentTotalBalance) {
			pdfDoc.content[8].table.body[1][0].text[1].text = Number.parseFloat(Number.parseFloat(metaData.balance) - Number.parseFloat(metaData.invoiceData.remainingAmount).toFixed(2)).toFixed(2) + "\n";
			pdfDoc.content[8].table.body[1][1].text[1].text = (metaData.invoiceData.remainingAmount ? Number.parseFloat(metaData.invoiceData.remainingAmount).toFixed(2) : '0.00') + "\n";
			pdfDoc.content[8].table.body[1][2].text[1].text = (metaData.balance ? Number.parseFloat(metaData.balance).toFixed(2) : '0.00') + "\n";
		} else {
			pdfDoc.content[8] = {};
			pdfDoc.content[7] = {}
		}

		// authority
		pdfDoc.content[10].table.body[0][1][1].text = (metaData.firm.name ? (metaData.firm.name).toUpperCase() : '');

		// thank you
		// pdfDoc.content[9].table.body[0][0].text =  "Thank You " + (metaData.customer.name.toUpperCase() ? metaData.customer.name.toUpperCase() : '') +" For Choosing us!" 
		// pdfDoc.content[9].table.body[0][0].text =  metaData.terms.termsAndConditions.greetingMessage || ("Thank You " + ((metaData.customer && metaData.customer.name )? metaData.customer.name.toUpperCase() : '') +" For Choosing us!" )
		pdfDoc.content[11].table.body[0][0].text = metaData.terms.greetingMessage || ("Thank You " + (getCustomerDetails(metaData, 'name').toUpperCase()) + " for doing business with us!")

		if (metaData.terms.isBlankHeader) {
			pdfDoc.content[1].table.body[0][1] = { text: '' };
			pdfDoc.content[1].style = 'hiddenTab';
			pdfDoc.content[1].table.body[0][2].text[1].style = 'hiddenTab'
		} else {
			if (metaData.terms.printLogo) {
				try {
					let logoData = await getBase64ImageFromURL(metaData.terms.printLogo)
					pdfDoc.content[1].table.body[0][1].image = logoData;
					let invoiceImages = document.getElementById('invoiceImages');
					if (invoiceImages && invoiceImages.files && invoiceImages.files.length) {
						let temp = {columns: []};
						if(invoiceImages.files[0]) {
							temp.columns.push({
								image: await toBase64(invoiceImages.files[0]).catch(e => Error(e)),
								width: 150
							})
						}
						if(invoiceImages.files[1]) {
							temp.columns.push({
								image: await toBase64(invoiceImages.files[1]).catch(e => Error(e)),
								width: 150
							})
						}
						if(invoiceImages.files[2]) {
							temp.columns.push({
								image: await toBase64(invoiceImages.files[2]).catch(e => Error(e)),
								width: 150
							})
						}
						pdfDoc.content.push(temp)
					}
					if(metaData.terms.signature) {
						let temp = {columns: []};
						temp.columns.push({
							image: await getBase64ImageFromURL(metaData.terms.signature),
							width: 150,
							height: 40,
							alignment: 'right'
						})
						//pdfDoc.content.push(temp)
						pdfDoc.content[10].table.body[0][1][2] = temp.columns[0];
					}
					return pdfDoc;
				} catch (error) {
					console.log(error)
				}
			} else {
				var imgToExport = document.getElementById('pdfimgToExport');
				var canvas = document.createElement('canvas');
				canvas.width = imgToExport.width;
				canvas.height = imgToExport.height;
				canvas.getContext('2d').drawImage(imgToExport, 0, 0);
				let base64 = canvas.toDataURL('image/png')
				pdfDoc.content[1].table.body[0][1].image = base64;
				let invoiceImages = document.getElementById('invoiceImages');
					if (invoiceImages && invoiceImages.files && invoiceImages.files.length) {
						let temp = {columns: []};
						if(invoiceImages.files[0]) {
							temp.columns.push({
								image: await toBase64(invoiceImages.files[0]).catch(e => Error(e)),
								width: 150
							})
						}
						if(invoiceImages.files[1]) {
							temp.columns.push({
								image: await toBase64(invoiceImages.files[1]).catch(e => Error(e)),
								width: 150
							})
						}
						if(invoiceImages.files[2]) {
							temp.columns.push({
								image: await toBase64(invoiceImages.files[2]).catch(e => Error(e)),
								width: 150
							})
						}
						pdfDoc.content.push(temp)
					}
			}
		}
		if(metaData.terms.signature) {
			let temp = {columns: []};
			temp.columns.push({
				image: await getBase64ImageFromURL(metaData.terms.signature),
				width: 150,
				height: 40,
				alignment: 'right'
			})
			//pdfDoc.content.push(temp)
			pdfDoc.content[10].table.body[0][1][2] = temp.columns[0]

		}	
			return pdfDoc;
		}
		// End of Without GST Invoice-Format

		
		// New Format Without GST For Dairy Business 
		export const convertToBasicInvoiceForDairyWithoutGST = async (metaData) => {
			let pdfDoc = {
				content: [
					{
						table: {
							widths: ['*'],
							body: [
								[
									{ text: 'INVOICE', style: "topHeader" },
								],
	
							],
	
						},
						layout: 'noBorders'
					},
					{
						table: {
							widths: ['0%', '48%', '*'],
							body: [
	
								[
									{
										text: ''
	
									},
									{
										image: '',
										width: 140,
										height: 100,
									},
									{
										text:
											[
												{ text: ' ', bold: true, style: 'topFirmAuthorityRight' },
												{ text: '\n', style: 'topFirmAuthorityRight' },
												{ text: '', bold: true, style: 'firmHeaderOneRight' },
												{ text: '88776655\n', style: 'firmHeaderOneRight' },
												// { text: ' ', bold: true, style: 'icon' },
												// { text: '1600 Amphitheatre Parkway in Mountain View, California, United States, near San Jose. \nRight'},
												{ text: '', bold: true, style: 'firmHeaderOneRight' },
												{ text: '88776655\n', style: 'firmHeaderOneRight' },
												{ text: '', bold: true, style: 'firmHeaderOneRight' }, //icon gift
												{ text: 'njnjn@jnn.com\n', style: 'firmHeaderOneRight' },
												{ text: ' ', bold: true, style: 'firmHeaderOneRight' },
												{ text: '123456\n', style: 'firmHeaderOneRight' },
											]
									},
									// {
									// 	text: ''
	
									// },
								],
							]
						},
						layout: 'noBorders',
						style: "topTab"
					},
					{
						table: {
							widths: ['60%', '*'],
							body: [
								[
									{ text: 'BILL TO', style: "billHeader" },
									{ text: 'INVOICE DETAILS', style: "billHeader" },
								],
	
							],
	
	
						},
						style: 'tab2Head',
						layout: 'noBorders',
					},
					{
						table: {
							widths: ['0%', '55%', '*'],
							body: [
								[
									{
										text: ''
	
									},
									{
										text:
											[
												{ text: ' ', bold: true, style: 'topFirmAuthority' },
												{ text: 'Google\n', style: 'topFirmAuthority' },
												{ text: ' ', bold: true, style: 'firmHeaderOne' },
												{ text: '1679905\n', style: 'firmHeaderOne' },
												{ text: '  ', bold: true, style: 'firmHeaderOne' },
												{ text: '7788996655\n', style: 'firmHeaderOne' },
												{ text: 'Mobile Number :   ', bold: true, style: 'firmHeaderOne' },
												{ text: '1600 Amphitheatre Parkway in Mountain View, California, United States, near San Jose. \n', style: 'firmHeaderOne' },
												{ text: 'Place of Supply :   ', bold: true, style: 'firmHeaderOne' },
												{ text: '13/12/90\n', style: 'firmHeaderOne' },
												{ text: 'State Code         :   ', bold: true, style: 'firmHeaderOne' },
												{ text: '23\n', style: 'firmHeaderOne' },
											]
									},
									{
										text:
											[
												{ text: 'Invoice No                :   ', bold: true, style: 'firmHeaderOne' },
												{ text: '787878\n', style: 'firmHeaderOne' },
												{ text: 'Invoice Date             :   ', bold: true, style: 'firmHeaderOne' },
												{ text: '12/12/90 \n', style: 'firmHeaderOne' },
												{ text: 'Invoice Status          :   ', bold: true, style: 'topRemainingHeader' },
												{ text: '12/12/90 \n', style: 'topRemainingHeader' },
												{ text: 'Payment Due Date  :   ', bold: true, style: 'firmHeaderOne' },
												{ text: '13/12/90\n', style: 'firmHeaderOne' },
											]
									},
	
								],
							],
	
						},
						style: 'tab2',
						layout: 'noBorders',
	
					},
					{
						table: {
							widths: ['*', '*',],
							body: [
								[
									{ text: 'ITEMS', style: "emptyHeader1" },
									{ text: '', style: "emptyHeader1" },
								],
	
							],
	
						},
						layout: 'noBorders',
					},
					{
						table: {
	
							body: [
								[
									{ text: 'S.NO', style: "productHeader11", rowSpan: 2 },
									{ text: 'DESCRIPTION OF PRODUCTS', style: "productHeader11", rowSpan: 2 },
									// { text: 'HSN/SAC', style: "productHeader1", rowSpan: 2 },
									{ text: 'QUANTITY', style: "productHeader11", rowSpan: 2 },
									{ text: 'UNITS', style: "productHeader11", rowSpan: 2 },
									{ text: 'FAT', style: "productHeader11", rowSpan: 2 },
									{ text: 'PRODUCTS RATE', style: "productHeader11", rowSpan: 2 },
									// { text: 'Basic  Amount', style: "productHeader", rowSpan: 2 },
									{ text: 'TOTAL AMOUNT', style: "productHeader11", rowSpan: 2 },
								],
								[
									{ text: 'S.NO', style: "productHeader11" },
									{ text: 'DESCRIPTION OF PRODUCTS', style: "productHeader11" },
									// { text: 'HSN/SAC', style: "productHeader1" },
									{ text: 'QUANTITY', style: "productHeader11" },
									{ text: 'UNITS', style: "productHeader11" },
									{ text: 'FAT', style: "productHeader11", rowSpan: 2 },
									{ text: 'PRODUCTS RATE', style: "productHeader11" },
									// { text: 'Basic Amount', style: "productHeader" },
									{ text: 'TOTAL AMOUNT', style: "productHeader11" },
								],
							]
						}
					},
					{
						table: {
							widths: ['65%', '*'],
							body: [
	
								[
									[
										{
											table: {
												widths: ['*'],
												body: [
													[
														{ text: 'PAYMENT DETAILS', style: "topHeader1" }
													],
	
												],
	
	
											},
											style: 'tab2Head',
											layout: 'noBorders',
	
										}, {
											table: {
												widths: ['3%', '*'],
												body: [
													[{
														text: ''
	
													},
													{
														text:
															[]
													},
													]
												]
											},
											style: 'tab2',
											layout: 'noBorders',
										},
										{
											table: {
												widths: ['*'],
												body: [
													[
														{ text: 'TERMS & CONDITIONS', style: "topHeader1" },
	
													],
	
												],
	
	
											},
											style: 'tab2Head',
											layout: 'noBorders',
	
										}, {
											table: {
												widths: ['3%', '*'],
												body: [
													[
														{
															text: ''
	
														},
														{
															text: "",
	
														},
													]
												]
											},
											style: 'tab2',
											layout: 'noBorders',
										},
	
									],
									{
										text:
											[
												{ text: 'Basic Amount   :   ', bold: true, style: 'headerOne' },
												{ text: '12122\n', style: 'headerOne' },
												// { text: 'Labour Charge:      ', bold: true, style:'headerOne' },
												// { text: '12122\n', style:'headerOne' },
												{ text: 'Discount            :   ', bold: true, style: 'headerOne' },
												{ text: '12122\n', style: 'headerOne' },
												{ text: 'RoundOff           :   ', bold: true, style: 'headerOne' },
												{ text: '12122\n', style: 'headerOne' },
												{ text: 'Total Amount    :   ', bold: true, style: 'topTotalAmount' },
												{ text: '12122\n', style: 'topTotalAmount' },
												{ text: 'Paid Amount     :   ', bold: true, style: 'headerOne' },
												{ text: '12122\n', style: 'headerOne' },
												{ text: 'Due Amount      :   ', bold: true, style: 'topRemainingHeader' },
												{ text: '12122\n', style: 'topRemainingHeader' },
												// 	{ text: 'Payment Type:-       ', bold: true },
												// { text: '12122\n' },
											]
	
									},
	
								],
							],
	
	
						},
						style: 'tab2',
						layout: 'lightHorizontalLines',
	
					},
					{
						table: {
							widths: ['*', '*',],
							body: [
								[
									{ text: 'OUTSTANDING DETAILS', style: "emptyHeader" },
									{ text: 'he', style: "emptyHeader1" },
								],
	
							],
	
						},
						layout: 'noBorders',
					},
	
					// Start of Previous + current = Total Column
					{
						table: {
							widths: ['34%', '39%', '27%'],
							body: [
								[
									{ text: '', style: "topBlankHeader" },
									{ text: '', style: "topMainHeader" },
									{ text: '', style: "topBlankHeader" },
								],
								[
									{
										text:
											[
												{ text: 'PREVIOUS BALANCE :  ', bold: true, style: 'topHeader11' },
												{ text: '\n', style: 'topHeader11' },
											]
									},
									{
										text:
											[
												{ text: 'CURRENT BALANCE :  ', bold: true, style: 'topHeader11' },
												{ text: '\n', style: 'topHeader11' },
											]
									},
	
									{
										text:
											[
												{ text: 'TOTAL BALANCE :  ', bold: true, style: 'topRemainingHeader1' },
												{ text: '\n', style: 'topRemainingHeader1' },
											]
									},
	
								],
							]
						},
						layout: {
							hLineWidth: function (i, node) {
								return (i === 0 || i === node.table.body.length) ? 1 : 0;
							},
							vLineWidth: function (i, node) {
								return (i === 0 || i === node.table.widths.length) ? 1 : 0;
							},
							hLineColor: function (i, node) {
								return (i === 0 || i === node.table.body.length) ? 'black' : 'black';
							},
							vLineColor: function (i, node) {
								return (i === 0 || i === node.table.widths.length) ? 'black' : 'black';
							},
						}
					},
					// End of Previous + current = Total Column
	
					{
						table: {
							widths: ['*'],
							body: [
								[
									{ text: 'Authority', style: 'emptyHeader1' },
								],
	
							],
	
						},
						layout: 'noBorders',
						style: 'tab2',
					},
	
					{
						table: {
							widths: ['70%', '*'],
							body: [
								[
									{
										text:
											[
	
											]
	
									},
									// {
									// 	text:
											[{ text: '' },
											{ text: 'Firm Name  ', bold: true, alignment: 'center', style: 'topFirmAuthority' },
											{ text: '\n\n\n\n\n' },
	
											{ text: 'AUTHORITY SIGNAUTRE  ', bold: true, alignment: 'center', style: 'topFirmAuthority' },
											{ text: '\n' },
											]
	
									// },
	
								],
							],
	
	
						},
						style: 'tab2',
						layout: 'noBorders',
	
					},
					{
						table: {
							widths: ['*'],
							body: [
								[
									{ text: 'Thank you \n', style: 'emptyHeader2' },
								],
	
							],
	
						},
						layout: 'noBorders',
						style: 'tab2',
					},
				],
				footer: {
					columns: [
						{
							text: 'Powered By ACUIFY',
							alignment: 'right',
							color: '#160091'
						}
					],
					margin: [10, 10]
				},
				styles: {
					header: {
						fontSize: 12,
						bold: true,
						alignment: 'center'
					},
					headerOne: {
						fontSize: 12,
						bold: true,
					},
					firmHeaderOne: {
						fontSize: 12,
						bold: true,
					},
					firmHeaderOneRight: {
						fontSize: 12,
						bold: true,
						alignment: 'right'
					},
					billHeader: {
						color: 'white',
						fontSize: 12,
						bold: true,
						alignment: 'left',
						fillColor: '#15155d',
					},
					product: {
						fontSize: 12,
						alignment: 'center',
					},
					total: {
						fontSize: 12,
						alignment: 'center',
						bold: true
					},
					productRight: {
						fontSize: 12,
						alignment: 'right',
						// bold: true
					},
					totalRight: {
						fontSize: 12,
						alignment: 'right',
						bold: true
					},
					topHeader: {
						color: 'white',
						fontSize: 14,
						alignment: 'center',
						bold: true,
						fillColor: '#15155d',
					},
					topHeader1: {
						color: 'white',
						fontSize: 12,
						alignment: 'left',
						bold: true,
						fillColor: '#15155d',
					},
					emptyHeader: {
						color: 'white',
						fillColor: '#15155d',
						alignment: 'left',
						bold: true
					},
					emptyHeader1: {
						color: '#15155d',
						fillColor: '#15155d',
						alignment: 'left',
					},
					emptyHeader2: {
						color: 'white',
						fillColor: '#15155d',
						alignment: 'center',
						bold: true
					},
					topTab: {
						// fillColor: '#ececec',
					},
					tab2Head: {
						color: 'white',
						// fillColor: '#015155d',
					},
					tab2: {
						// fillColor: '#ececec',
					},
					topFirmAuthority: {
						color: '#160091',
						fontSize: 12,
						bold: true,
					},
					topFirmAuthorityRight: {
						color: '#160091',
						fontSize: 14,
						bold: true,
						alignment: 'right'
					},
					topTotalAmount: {
						color: '#160091',
						fontSize: 12,
						bold: true,
					},
					topRemainingHeader: {
						color: '#FF0000',
						fontSize: 12,
						bold: true,
					},
					topRemainingHeader1: {
						color: '#FF0000',
						fontSize: 10,
						bold: true,
					},
					bankDetails: {
						fontSize: 12,
						bold: true,
					},
					productHeader: {
						color: '#160091',
						fontSize: 12,
						bold: true,
						alignment: 'center'
					},
					productHeader1: {
						fontSize: 12,
						bold: true,
						alignment: 'center'
					},
					topHeader11: {
						color: '#160091',
						fontSize: 10,
						bold: true,
					},
					productHeader11: {
						fontSize: 12,
						color: '#160091',
						bold: true,
						alignment: 'center'
					},
					hiddenTab: {
						fillColor: '#ffffff',
						color: '#ffffff',
					},
				}
			}
	
			//Firm Details 
			// pdfDoc.content[1].table.body[0][2].text[1].text = (metaData.firm.name.toUpperCase() ? metaData.firm.name.toUpperCase() : '') + "\n";
			pdfDoc.content[1].table.body[0][2].text[1].text = ((metaData.firm && metaData.firm.name) ? metaData.firm.name.toUpperCase() : '') + "\n";
			// pdfDoc.content[1].table.body[0][2].text[3].text = (metaData.firm.GST_number ? metaData.firm.GST_number : '') + "\n";
			pdfDoc.content[1].table.body[0][2].text[3].text = (metaData.firm.liveAddress ? metaData.firm.liveAddress : '') + "\n";
			pdfDoc.content[1].table.body[0][2].text[5].text = (metaData.firm.address ? metaData.firm.address : '') + "\n";
			pdfDoc.content[1].table.body[0][2].text[7].text = (metaData.firm.mobileNumber ? metaData.firm.mobileNumber : '') + "\n";
			pdfDoc.content[1].table.body[0][2].text[9].text = (metaData.firm.email ? metaData.firm.email : '') + "\n";
	
	
			//Receipient Details
			// pdfDoc.content[3].table.body[0][1].text[1].text = (metaData.customer.name.toUpperCase() ? metaData.customer.name.toUpperCase() : '') + "\n";
			// pdfDoc.content[3].table.body[0][1].text[1].text = ((metaData.customer && metaData.customer.name )? metaData.customer.name.toUpperCase() : '') + "\n";
			pdfDoc.content[3].table.body[0][1].text[1].text = (getCustomerDetails(metaData, 'name').toUpperCase()) + "\n";
			// pdfDoc.content[3].table.body[0][1].text[3].text = (metaData.customer.GST_number ? metaData.customer.GST_number : '') + "\n";
			// pdfDoc.content[3].table.body[0][1].text[5].text = (metaData.customer.address ? metaData.customer.address : '') + "\n";
			// pdfDoc.content[3].table.body[0][1].text[7].text = (metaData.customer.mobile ? metaData.customer.mobile : '') + "\n";
			pdfDoc.content[3].table.body[0][1].text[3].text = (metaData.customer.localAddress ? metaData.customer.localAddress : '') + "\n";
			pdfDoc.content[3].table.body[0][1].text[5].text = (getCustomerDetails(metaData, 'address')) + "\n";
			pdfDoc.content[3].table.body[0][1].text[7].text = (getCustomerDetails(metaData, 'mobile').toUpperCase()) + "\n";
			pdfDoc.content[3].table.body[0][1].text[9].text = (metaData.invoiceData.placeOfSupply ? metaData.invoiceData.placeOfSupply : '') + "\n";
			pdfDoc.content[3].table.body[0][1].text[11].text = (metaData.customer.stateCode ? metaData.customer.stateCode : '') + "\n";
	
	
			//Invoice Details
			let date = new Date(metaData.invoiceData.date)
			let paymentDueDate = date.setDate(date.getDate() + (metaData.invoiceData.duration ? parseInt(metaData.invoiceData.duration) : 0));
			pdfDoc.content[3].table.body[0][2].text[1].text = metaData.invoiceData.invoiceId + "\n";
			pdfDoc.content[3].table.body[0][2].text[3].text = new Date(metaData.invoiceData.date).toLocaleDateString('en-GB').toString() + "\n";
			pdfDoc.content[3].table.body[0][2].text[5].text = (metaData.invoiceData.status ? metaData.invoiceData.status.toUpperCase() : '') + "\n";
			pdfDoc.content[3].table.body[0][2].text[7].text = new Date(paymentDueDate).toLocaleDateString('en-GB').toString() + "\n";
	
			//Products
			let productList = convertToDairyPDFProducts(metaData.invoiceData.items, false, metaData.invoiceData, metaData);
			productList.map((item) => {
				pdfDoc.content[5].table.body.push(item);
			});
	
			// Payment Details
	
			// pdfDoc.content[6].table.body[0][0][1].table.body[0][1].text[1].text = (metaData.invoiceData.paymentType ? metaData.invoiceData.paymentType : '') + "\n";
			// pdfDoc.content[6].table.body[0][0][1].table.body[0][1].text[3].text = (metaData.invoiceData.transactionType ? metaData.invoiceData.transactionType : '') + "\n";
	
			// Bank Details
			if (metaData.terms.banks.length) {
				metaData.terms.banks.map((bankDetails) => {
					pdfDoc.content[6].table.body[0][0][1].table.body[0][1].text.push({ text: bankDetails.bankName + " \n", style: "bankDetails" })
					pdfDoc.content[6].table.body[0][0][1].table.body[0][1].text.push({ text: "NAME: " + bankDetails.accountHolderName + "\n", style: 'bankDetails' })
					pdfDoc.content[6].table.body[0][0][1].table.body[0][1].text.push({ text: "A/C No: " + bankDetails.accountnumber + "\n", style: "bankDetails" })
					pdfDoc.content[6].table.body[0][0][1].table.body[0][1].text.push({ text: "IFSC: " + bankDetails.ifsccode + "\n", style: "bankDetails" })
					pdfDoc.content[6].table.body[0][0][1].table.body[0][1].text.push({ text: bankDetails.address + " \n", style: "bankDetails" })
				})
			}
			// Terms and cond
			pdfDoc.content[6].table.body[0][0][3].table.body[0][1] = metaData.terms.termsAndConditions;
	
			// gst details
			// pdfDoc.content[6].table.body[0][1].text[1].text = ((metaData.invoiceData.totalAmount - metaData.invoiceData.roundOffAmount ? Number.parseFloat(metaData.invoiceData.totalAmount - metaData.invoiceData.roundOffAmount).toFixed(2) - Number.parseFloat(metaData.gstTotal.CGST_val + metaData.gstTotal.SGST_val + metaData.gstTotal.IGST_val).toFixed(2) : '0')).toFixed(2) + "\n";
			pdfDoc.content[6].table.body[0][1].text[1].text = (
				Number.parseFloat(metaData.invoiceData.totalAmount) +
				Number.parseFloat(metaData.invoiceData.discountAmount || 0) +
				Number.parseFloat(metaData.invoiceData.gstOnExtraChanrges ? 0 : (-Number.parseFloat(metaData.invoiceData.totalExtraCharges))) -
				Number.parseFloat(metaData.invoiceData.gstOnExtraChanrges ? Number.parseFloat(metaData.invoiceData.totalExtraChargesGST) : 0) -
				Number.parseFloat(metaData.invoiceData.roundOffAmount || 0) -
				(Number.parseFloat(
					metaData.gstTotal.SGST_val
				) +
					Number.parseFloat(
						metaData.gstTotal.CGST_val
					) +
					Number.parseFloat(
						metaData.gstTotal.IGST_val
					))
			).toFixed(2) + "\n";
			let offset = 0;
			if (!metaData.invoiceData.gstOnExtraChanrges && metaData.invoiceData.extraCharges && metaData.invoiceData.extraCharges.length) {
				metaData.invoiceData.extraCharges.map((charge) => {
					pdfDoc.content[6].table.body[0][1].text.splice(2 + offset, 0, { text: '' + charge.name + ' :   ', bold: true, style: 'headerOne' });
					offset++;
					pdfDoc.content[6].table.body[0][1].text.splice(2 + offset, 0, { text: Number.parseFloat(charge.amount).toFixed(2) + '\n', style: 'headerOne' });
					offset++;
				})
			}
			// pdfDoc.content[6].table.body[0][1].text[3].text = (metaData.invoiceData.labourAmount ? Number.parseFloat(metaData.invoiceData.labourAmount).toFixed(2) : '0.00') + "\n";
			pdfDoc.content[6].table.body[0][1].text[3 + offset].text = (metaData.invoiceData.discountAmount ? Number.parseFloat(metaData.invoiceData.discountAmount).toFixed(2) : '0.00') + "\n";
			pdfDoc.content[6].table.body[0][1].text[5 + offset].text = (metaData.invoiceData.roundOffAmount ? Number.parseFloat(metaData.invoiceData.roundOffAmount).toFixed(2) : '0.00') + "\n";
			// pdfDoc.content[6].table.body[0][1].text[9].text = (metaData.invoiceData.totalAmount ? Number.parseFloat(metaData.invoiceData.totalAmount).toFixed(2) : '0') + "\n";
			// pdfDoc.content[6].table.body[0][1].text[9].text = (metaData.invoiceData.totalAmount + metaData.invoiceData.labourAmount -  metaData.invoiceData.discountAmount ? Number.parseFloat(Number.parseFloat(metaData.invoiceData.totalAmount) + Number.parseFloat(metaData.invoiceData.labourAmount) - Number.parseFloat(metaData.invoiceData.discountAmount)).toFixed(2) : '0') + "\n";
			pdfDoc.content[6].table.body[0][1].text[7 + offset].text = (metaData.invoiceData.totalAmount ? Number.parseFloat(metaData.invoiceData.totalAmount) : '0.00').toFixed(2) + "\n";
			pdfDoc.content[6].table.body[0][1].text[9 + offset].text = (metaData.invoiceData.paidAmount ? Number.parseFloat(metaData.invoiceData.paidAmount).toFixed(2) : '0.00') + "\n";
			pdfDoc.content[6].table.body[0][1].text[11 + offset].text = (metaData.invoiceData.remainingAmount ? Number.parseFloat(metaData.invoiceData.remainingAmount).toFixed(2) : '0.00') + "\n";
			// pdfDoc.content[6].table.body[0][1].text[17].text = (metaData.invoiceData.paymentType ? metaData.invoiceData.paymentType : '') + "\n";
			// if(metaData.invoiceData.extraCharges && metaData.invoiceData.extraCharges.length) {
			// 	metaData.invoiceData.extraCharges.map((charge)=>{
			// 				pdfDoc.content[6].table.body[0][1].text.push({ text: ''+charge.name+':-          ', bold: true })
			// 				pdfDoc.content[6].table.body[0][1].text.push({ text:charge.amount+'\n' })
			// 	})
			// }
	
			// Overall Balance
			if (metaData.balance && metaData.terms.isPreviousCurrentTotalBalance) {
				pdfDoc.content[8].table.body[1][0].text[1].text = Number.parseFloat(Number.parseFloat(metaData.balance) - Number.parseFloat(metaData.invoiceData.remainingAmount).toFixed(2)).toFixed(2) + "\n";
				pdfDoc.content[8].table.body[1][1].text[1].text = (metaData.invoiceData.remainingAmount ? Number.parseFloat(metaData.invoiceData.remainingAmount).toFixed(2) : '0.00') + "\n";
				pdfDoc.content[8].table.body[1][2].text[1].text = (metaData.balance ? Number.parseFloat(metaData.balance).toFixed(2) : '0.00') + "\n";
			} else {
				pdfDoc.content[8] = {};
				pdfDoc.content[7] = {}
			}
	
			// authority
			pdfDoc.content[10].table.body[0][1][1].text = (metaData.firm.name ? (metaData.firm.name).toUpperCase() : '');
	
			// thank you
			// pdfDoc.content[9].table.body[0][0].text =  "Thank You " + (metaData.customer.name.toUpperCase() ? metaData.customer.name.toUpperCase() : '') +" For Choosing us!" 
			// pdfDoc.content[9].table.body[0][0].text =  metaData.terms.termsAndConditions.greetingMessage || ("Thank You " + ((metaData.customer && metaData.customer.name )? metaData.customer.name.toUpperCase() : '') +" For Choosing us!" )
			pdfDoc.content[11].table.body[0][0].text = metaData.terms.greetingMessage || ("Thank You " + (getCustomerDetails(metaData, 'name').toUpperCase()) + " for doing business with us!")
	
			if (metaData.terms.isBlankHeader) {
				pdfDoc.content[1].table.body[0][1] = { text: '' };
				pdfDoc.content[1].style = 'hiddenTab';
				pdfDoc.content[1].table.body[0][2].text[1].style = 'hiddenTab'
			} else {
				if (metaData.terms.printLogo) {
					try {
						let logoData = await getBase64ImageFromURL(metaData.terms.printLogo)
						pdfDoc.content[1].table.body[0][1].image = logoData;
						let invoiceImages = document.getElementById('invoiceImages');
						if (invoiceImages && invoiceImages.files && invoiceImages.files.length) {
							let temp = {columns: []};
							if(invoiceImages.files[0]) {
								temp.columns.push({
									image: await toBase64(invoiceImages.files[0]).catch(e => Error(e)),
									width: 150
								})
							}
							if(invoiceImages.files[1]) {
								temp.columns.push({
									image: await toBase64(invoiceImages.files[1]).catch(e => Error(e)),
									width: 150
								})
							}
							if(invoiceImages.files[2]) {
								temp.columns.push({
									image: await toBase64(invoiceImages.files[2]).catch(e => Error(e)),
									width: 150
								})
							}
							pdfDoc.content.push(temp)
						}
						if(metaData.terms.signature) {
							let temp = {columns: []};
							temp.columns.push({
								image: await getBase64ImageFromURL(metaData.terms.signature),
								width: 150,
								height: 40,
								alignment: 'right'
							})
							//pdfDoc.content.push(temp)
							pdfDoc.content[10].table.body[0][1][2] = temp.columns[0];
						}
						return pdfDoc;
					} catch (error) {
						console.log(error)
					}
				} else {
					var imgToExport = document.getElementById('pdfimgToExport');
					var canvas = document.createElement('canvas');
					canvas.width = imgToExport.width;
					canvas.height = imgToExport.height;
					canvas.getContext('2d').drawImage(imgToExport, 0, 0);
					let base64 = canvas.toDataURL('image/png')
					pdfDoc.content[1].table.body[0][1].image = base64;
					let invoiceImages = document.getElementById('invoiceImages');
						if (invoiceImages && invoiceImages.files && invoiceImages.files.length) {
							let temp = {columns: []};
							if(invoiceImages.files[0]) {
								temp.columns.push({
									image: await toBase64(invoiceImages.files[0]).catch(e => Error(e)),
									width: 150
								})
							}
							if(invoiceImages.files[1]) {
								temp.columns.push({
									image: await toBase64(invoiceImages.files[1]).catch(e => Error(e)),
									width: 150
								})
							}
							if(invoiceImages.files[2]) {
								temp.columns.push({
									image: await toBase64(invoiceImages.files[2]).catch(e => Error(e)),
									width: 150
								})
							}
							pdfDoc.content.push(temp)
						}
				}
			}
			if(metaData.terms.signature) {
				let temp = {columns: []};
				temp.columns.push({
					image: await getBase64ImageFromURL(metaData.terms.signature),
					width: 150,
					height: 40,
					aligment: 'right',
				})
				//pdfDoc.content.push(temp)
				pdfDoc.content[10].table.body[0][1][2] = temp.columns[0];
			}
				return pdfDoc;
			}

		// End of New Format Without GST For Dairy Business 

		// Start of New Photo Resize Format Third
		export const convertToBasicShortInvoiceWithoutGST = async (metaData) => {
			let pdfDoc = {
				content: [
					{
						table: {
							widths: ['*'],
							body: [
								[
									{ text: 'INVOICE', style: "topHeader" },
								],
	
							],
	
						},
						layout: 'noBorders'
					},
					{
						table: {
							widths: ['0%','20%', '35%', '5%', '40%'],
							body: [
	
								[
									{
										text: ''
	
									},
									{
										image: '',
										width: 100,
										height: 100,
									},
									{
										text:
											[
												{ text: ' ', bold: true, style: 'topFirmAuthorityRight' },
												{ text: '\n', style: 'topFirmAuthorityRight' },
												{ text: '', bold: true, style: 'firmHeaderOneRight' },
												{ text: '88776655\n', style: 'firmHeaderOneRight' },
												// { text: ' ', bold: true, style: 'icon' },
												// { text: '1600 Amphitheatre Parkway in Mountain View, California, United States, near San Jose. \nRight'},
												{ text: '', bold: true, style: 'firmHeaderOneRight' },
												{ text: '88776655\n', style: 'firmHeaderOneRight' },
												{ text: '', bold: true, style: 'firmHeaderOneRight' }, //icon gift
												{ text: 'njnjn@jnn.com\n', style: 'firmHeaderOneRight' },
												{ text: ' ', bold: true, style: 'firmHeaderOneRight' },
												{ text: '123456\n', style: 'firmHeaderOneRight' },
											]
									},
									{
										text: ''	
									},
									{
										text:
											[
												{ text: ' ', bold: true, style: 'topFirmAuthority' },
												{ text: 'Google\n', style: 'topFirmAuthority' },
												{ text: ' ', bold: true, style: 'firmHeaderOne' },
												{ text: '1679905\n', style: 'firmHeaderOne' },
												{ text: '  ', bold: true, style: 'firmHeaderOne' },
												{ text: '7788996655\n', style: 'firmHeaderOne' },
												{ text: 'Mobile Number :   ', bold: true, style: 'firmHeaderOne' },
												{ text: '1600 Amphitheatre Parkway in Mountain View, California, United States, near San Jose. \n', style: 'firmHeaderOne' },
												{ text: 'Place of Supply :   ', bold: true, style: 'firmHeaderOne' },
												{ text: '13/12/90\n', style: 'firmHeaderOne' },
												{ text: 'State Code         :   ', bold: true, style: 'firmHeaderOne' },
												{ text: '23\n', style: 'firmHeaderOne' },
												{ text: 'Remark               :   ', bold: true, style: 'firmHeaderOne' },
												{ text: '787878\n', style: 'firmHeaderOne' },
												// { text: 'Invoice Date             :   ', bold: true, style: 'firmHeaderOne' },
												// { text: '12/12/90 \n', style: 'firmHeaderOne' },
												// { text: 'Invoice Status          :   ', bold: true, style: 'topRemainingHeader' },
												// { text: '12/12/90 \n', style: 'topRemainingHeader' },
											]
									},
									// {
									// 	text:
									// 		[
									// 			{ text: 'Invoice No                :   ', bold: true, style: 'firmHeaderOne' },
									// 			{ text: '787878\n', style: 'firmHeaderOne' },
									// 			{ text: 'Invoice Date             :   ', bold: true, style: 'firmHeaderOne' },
									// 			{ text: '12/12/90 \n', style: 'firmHeaderOne' },
									// 			{ text: 'Invoice Status          :   ', bold: true, style: 'topRemainingHeader' },
									// 			{ text: '12/12/90 \n', style: 'topRemainingHeader' },
									// 			{ text: 'Payment Due Date  :   ', bold: true, style: 'firmHeaderOne' },
									// 			{ text: '13/12/90\n', style: 'firmHeaderOne' },
									// 		]
									// },
									// {
									// 	text: ''
	
									// },
								],
							]
						},
						layout: 'noBorders',
						style: "topTab"
					},
					{
						table: {
							widths: ['33%', '33%', '33%'],
							body: [
								[
									{ text: '', style: "billHeader" },
									{ text: 'INVOICE DETAILS', style: "billHeader" },
									{ text: '', style: "billHeader" },
								],
	
							],
	
	
						},
						style: 'tab2Head',
						layout: 'noBorders',
					},
					{
						table: {
							widths: ['0%', '38%', '34%', '28%'],
							body: [
								[
									{
										text: ''
	
									},
									// {
									// 	text:
									// 		[
									// 			{ text: ' ', bold: true, style: 'topFirmAuthority' },
									// 			{ text: 'Google\n', style: 'topFirmAuthority' },
									// 			{ text: ' ', bold: true, style: 'firmHeaderOne' },
									// 			{ text: '1679905\n', style: 'firmHeaderOne' },
									// 			{ text: '  ', bold: true, style: 'firmHeaderOne' },
									// 			{ text: '7788996655\n', style: 'firmHeaderOne' },
									// 			{ text: 'Mobile Number :   ', bold: true, style: 'firmHeaderOne' },
									// 			{ text: '1600 Amphitheatre Parkway in Mountain View, California, United States, near San Jose. \n', style: 'firmHeaderOne' },
									// 			{ text: 'Place of Supply :   ', bold: true, style: 'firmHeaderOne' },
									// 			{ text: '13/12/90\n', style: 'firmHeaderOne' },
									// 			{ text: 'State Code         :   ', bold: true, style: 'firmHeaderOne' },
									// 			{ text: '23\n', style: 'firmHeaderOne' },
									// 		]
									// },
									{
										text:
											[
												{ text: 'Invoice No:   ', bold: true, style: 'firmHeaderOne' },
												{ text: '787878\n', style: 'firmHeaderOne' },
											]
									},
									{
										text:
											[
												{ text: 'Date:   ', bold: true, style: 'firmHeaderOne' },
												{ text: '12/12/90 \n', style: 'firmHeaderOne' },
											]
									},
									{
										text:
											[
												{ text: 'Status:   ', bold: true, style: 'topRemainingHeader' },
												{ text: 'Paid/Pending \n', style: 'topRemainingHeader' },
											]
									},
	
								],
							],
	
						},
						style: 'tab2',
						layout: 'noBorders',
	
					},
					{
						table: {
							widths: ['*', '*',],
							body: [
								[
									{ text: 'ITEMS', style: "emptyHeader1" },
									{ text: '', style: "emptyHeader1" },
								],
	
							],
	
						},
						layout: 'noBorders',
					},
					{
						table: {
	
							body: [
								[
									{ text: 'S.NO', style: "productHeader11", rowSpan: 2 },
									{ text: 'PRODUCTS DESCRIPTION', style: "productHeader11", rowSpan: 2 },
									// { text: 'HSN/SAC', style: "productHeader1", rowSpan: 2 },
									{ text: 'QUANTITY', style: "productHeader11", rowSpan: 2 },
									{ text: 'UNITS', style: "productHeader11", rowSpan: 2 },
									{ text: 'PRODUCTS RATE', style: "productHeader11", rowSpan: 2 },
									// { text: 'Basic  Amount', style: "productHeader", rowSpan: 2 },
									{ text: 'TOTAL AMOUNT', style: "productHeader11", rowSpan: 2 },
								],
								[
									{ text: 'S.NO', style: "productHeader11" },
									{ text: 'PRODUCTS DESCRIPTION', style: "productHeader11" },
									// { text: 'HSN/SAC', style: "productHeader1" },
									{ text: 'QUANTITY', style: "productHeader11" },
									{ text: 'UNITS', style: "productHeader11" },
									{ text: 'PRODUCTS RATE', style: "productHeader11" },
									// { text: 'Basic Amount', style: "productHeader" },
									{ text: 'AMOUNT', style: "productHeader11" },
								],
							]
						}
					},
					{
						table: {
							widths: ['*'],
							body: [
								[
									{ text: "In Words: ", style: 'invoiceDetails' },
								],
							],
						},
					},
					// {
					// 	table: {
					// 		widths: ['65%', '*'],
					// 		body: [
	
					// 			[
					// 				[
					// 					{
					// 						table: {
					// 							widths: ['*'],
					// 							body: [
					// 								[
					// 									{ text: 'PAYMENT DETAILS', style: "topHeader1" }
					// 								],
	
					// 							],
	
	
					// 						},
					// 						style: 'tab2Head',
					// 						layout: 'noBorders',
	
					// 					}, {
					// 						table: {
					// 							widths: ['3%', '*'],
					// 							body: [
					// 								[{
					// 									text: ''
	
					// 								},
					// 								{
					// 									text:
					// 										[]
					// 								},
					// 								]
					// 							]
					// 						},
					// 						style: 'tab2',
					// 						layout: 'noBorders',
					// 					},
					// 					{
					// 						table: {
					// 							widths: ['*'],
					// 							body: [
					// 								[
					// 									{ text: 'TERMS & CONDITIONS', style: "topHeader1" },
	
					// 								],
	
					// 							],
	
	
					// 						},
					// 						style: 'tab2Head',
					// 						layout: 'noBorders',
	
					// 					}, {
					// 						table: {
					// 							widths: ['3%', '*'],
					// 							body: [
					// 								[
					// 									{
					// 										text: ''
	
					// 									},
					// 									{
					// 										text: "",
	
					// 									},
					// 								]
					// 							]
					// 						},
					// 						style: 'tab2',
					// 						layout: 'noBorders',
					// 					},
	
					// 				],
					// 				{
					// 					text:
					// 						[
					// 							{ text: 'Basic Amount   :   ', bold: true, style: 'headerOne' },
					// 							{ text: '12122\n', style: 'headerOne' },
					// 							// { text: 'Labour Charge:      ', bold: true, style:'headerOne' },
					// 							// { text: '12122\n', style:'headerOne' },
					// 							{ text: 'Discount            :   ', bold: true, style: 'headerOne' },
					// 							{ text: '12122\n', style: 'headerOne' },
					// 							{ text: 'RoundOff           :   ', bold: true, style: 'headerOne' },
					// 							{ text: '12122\n', style: 'headerOne' },
					// 							{ text: 'Total Amount    :   ', bold: true, style: 'topTotalAmount' },
					// 							{ text: '12122\n', style: 'topTotalAmount' },
					// 							{ text: 'Paid Amount     :   ', bold: true, style: 'headerOne' },
					// 							{ text: '12122\n', style: 'headerOne' },
					// 							{ text: 'Due Amount      :   ', bold: true, style: 'topRemainingHeader' },
					// 							{ text: '12122\n', style: 'topRemainingHeader' },
					// 							// 	{ text: 'Payment Type:-       ', bold: true },
					// 							// { text: '12122\n' },
					// 						]
	
					// 				},
	
					// 			],
					// 		],
	
	
					// 	},
					// 	style: 'tab2',
					// 	layout: 'lightHorizontalLines',
	
					// },
					// {
					// 	table: {
					// 		widths: ['*', '*',],
					// 		body: [
					// 			[
					// 				{ text: 'OUTSTANDING DETAILS', style: "emptyHeader" },
					// 				{ text: 'he', style: "emptyHeader1" },
					// 			],
	
					// 		],
	
					// 	},
					// 	layout: 'noBorders',
					// },
	
					// Start of Previous + current = Total Column
					{
						table: {
							widths: ['34%', '39%', '27%'],
							body: [
								[
									{ text: '', style: "topBlankHeader" },
									{ text: '', style: "topMainHeader" },
									{ text: '', style: "topBlankHeader" },
								],
								[
									{
										text:
											[
												{ text: 'PREVIOUS BALANCE :  ', bold: true, style: 'topHeader11' },
												{ text: '\n', style: 'topHeader11' },
											]
									},
									{
										text:
											[
												{ text: 'CURRENT BALANCE :  ', bold: true, style: 'topHeader11' },
												{ text: '\n', style: 'topHeader11' },
											]
									},
	
									{
										text:
											[
												{ text: 'TOTAL BALANCE :  ', bold: true, style: 'topRemainingHeader1' },
												{ text: '\n', style: 'topRemainingHeader1' },
											]
									},
	
								],
							]
						},
						layout: {
							hLineWidth: function (i, node) {
								return (i === 0 || i === node.table.body.length) ? 1 : 0;
							},
							vLineWidth: function (i, node) {
								return (i === 0 || i === node.table.widths.length) ? 1 : 0;
							},
							hLineColor: function (i, node) {
								return (i === 0 || i === node.table.body.length) ? 'black' : 'black';
							},
							vLineColor: function (i, node) {
								return (i === 0 || i === node.table.widths.length) ? 'black' : 'black';
							},
						}
					},
					// End of Previous + current = Total Column
	
					// {
					// 	table: {
					// 		widths: ['*'],
					// 		body: [
					// 			[
					// 				{ text: 'Authority', style: 'emptyHeader1' },
					// 			],
	
					// 		],
	
					// 	},
					// 	layout: 'noBorders',
					// 	style: 'tab2',
					// },
	
					// {
					// 	table: {
					// 		widths: ['70%', '*'],
					// 		body: [
					// 			[
					// 				{
					// 					text:
					// 						[
	
					// 						]
	
					// 				},
					// 				{
					// 					text:
					// 						[{ text: '' },
					// 						{ text: 'Firm Name  ', bold: true, alignment: 'center', style: 'topFirmAuthority' },
					// 						{ text: '\n\n\n\n\n' },
	
					// 						{ text: 'AUTHORITY SIGNAUTRE  ', bold: true, alignment: 'center', style: 'topFirmAuthority' },
					// 						{ text: '\n' },
					// 						]
	
					// 				},
	
					// 			],
					// 		],
	
	
					// 	},
					// 	style: 'tab2',
					// 	layout: 'noBorders',
	
					// },
					// {
					// 	table: {
					// 		widths: ['*'],
					// 		body: [
					// 			[
					// 				{ text: 'Thank you \n', style: 'emptyHeader2' },
					// 			],
	
					// 		],
	
					// 	},
					// 	layout: 'noBorders',
					// 	style: 'tab2',
					// },
				],
				footer: {
					columns: [
						{
							text: 'Powered By ACUIFY',
							alignment: 'right',
							color: '#160091'
						}
					],
					margin: [10, 10]
				},
				styles: {
					header: {
						fontSize: 12,
						bold: true,
						alignment: 'center'
					},
					headerOne: {
						fontSize: 12,
						bold: true,
					},
					firmHeaderOne: {
						fontSize: 12,
						bold: true,
					},
					firmHeaderOneRight: {
						fontSize: 12,
						bold: true,
						alignment: 'right'
					},
					billHeader: {
						color: 'white',
						fontSize: 12,
						bold: true,
						alignment: 'left',
						fillColor: '#15155d',
					},
					product: {
						fontSize: 12,
						alignment: 'center',
					},
					total: {
						fontSize: 12,
						alignment: 'center',
						bold: true
					},
					productRight: {
						fontSize: 12,
						alignment: 'right',
						// bold: true
					},
					totalRight: {
						fontSize: 12,
						alignment: 'right',
						bold: true
					},
					topHeader: {
						color: 'white',
						fontSize: 14,
						alignment: 'center',
						bold: true,
						fillColor: '#15155d',
					},
					topHeader1: {
						color: 'white',
						fontSize: 12,
						alignment: 'left',
						bold: true,
						fillColor: '#15155d',
					},
					emptyHeader: {
						color: 'white',
						fillColor: '#15155d',
						alignment: 'left',
						bold: true
					},
					emptyHeader1: {
						color: '#15155d',
						fillColor: '#15155d',
						alignment: 'left',
					},
					emptyHeader2: {
						color: 'white',
						fillColor: '#15155d',
						alignment: 'center',
						bold: true
					},
					topTab: {
						// fillColor: '#ececec',
					},
					tab2Head: {
						color: 'white',
						// fillColor: '#015155d',
					},
					tab2: {
						// fillColor: '#ececec',
					},
					topFirmAuthority: {
						color: '#160091',
						fontSize: 12,
						bold: true,
					},
					topFirmAuthorityRight: {
						color: '#160091',
						fontSize: 14,
						bold: true,
						alignment: 'right'
					},
					topTotalAmount: {
						color: '#160091',
						fontSize: 12,
						bold: true,
					},
					topRemainingHeader: {
						color: '#FF0000',
						fontSize: 12,
						bold: true,
					},
					topRemainingHeader1: {
						color: '#FF0000',
						fontSize: 10,
						bold: true,
					},
					bankDetails: {
						fontSize: 12,
						bold: true,
					},
					productHeader: {
						color: '#160091',
						fontSize: 12,
						bold: true,
						alignment: 'center'
					},
					productHeader1: {
						fontSize: 12,
						bold: true,
						alignment: 'center'
					},
					topHeader11: {
						color: '#160091',
						fontSize: 10,
						bold: true,
					},
					productHeader11: {
						fontSize: 12,
						color: '#160091',
						bold: true,
						alignment: 'center'
					},
					hiddenTab: {
						fillColor: '#ffffff',
						color: '#ffffff',
					},
				}
			}
	
			//Firm Details 
			// pdfDoc.content[1].table.body[0][2].text[1].text = (metaData.firm.name.toUpperCase() ? metaData.firm.name.toUpperCase() : '') + "\n";
			pdfDoc.content[1].table.body[0][2].text[1].text = ((metaData.firm && metaData.firm.name) ? metaData.firm.name.toUpperCase() : '') + "\n";
			// pdfDoc.content[1].table.body[0][2].text[3].text = (metaData.firm.GST_number ? metaData.firm.GST_number : '') + "\n";
			pdfDoc.content[1].table.body[0][2].text[3].text = (metaData.firm.liveAddress ? metaData.firm.liveAddress : '') + "\n";
			pdfDoc.content[1].table.body[0][2].text[5].text = (metaData.firm.address ? metaData.firm.address : '') + "\n";
			pdfDoc.content[1].table.body[0][2].text[7].text = (metaData.firm.mobileNumber ? metaData.firm.mobileNumber : '') + "\n";
			pdfDoc.content[1].table.body[0][2].text[9].text = (metaData.firm.email ? metaData.firm.email : '') + "\n";

			//  Start of Trail Code

			//Receipient Details
			// pdfDoc.content[3].table.body[0][1].text[1].text = (metaData.customer.name.toUpperCase() ? metaData.customer.name.toUpperCase() : '') + "\n";
			// pdfDoc.content[3].table.body[0][1].text[1].text = ((metaData.customer && metaData.customer.name )? metaData.customer.name.toUpperCase() : '') + "\n";
			pdfDoc.content[1].table.body[0][4].text[1].text = (getCustomerDetails(metaData, 'name').toUpperCase()) + "\n";
			// pdfDoc.content[3].table.body[0][1].text[3].text = (metaData.customer.GST_number ? metaData.customer.GST_number : '') + "\n";
			// pdfDoc.content[3].table.body[0][1].text[5].text = (metaData.customer.address ? metaData.customer.address : '') + "\n";
			// pdfDoc.content[3].table.body[0][1].text[7].text = (metaData.customer.mobile ? metaData.customer.mobile : '') + "\n";
			pdfDoc.content[1].table.body[0][4].text[3].text = (metaData.customer.localAddress ? metaData.customer.localAddress : '') + "\n";
			pdfDoc.content[1].table.body[0][4].text[5].text = (getCustomerDetails(metaData, 'address')) + "\n";
			pdfDoc.content[1].table.body[0][4].text[7].text = (getCustomerDetails(metaData, 'mobile').toUpperCase()) + "\n";
			pdfDoc.content[1].table.body[0][4].text[9].text = (metaData.invoiceData.placeOfSupply ? metaData.invoiceData.placeOfSupply : '') + "\n";
			pdfDoc.content[1].table.body[0][4].text[11].text = (metaData.customer.stateCode ? metaData.customer.stateCode : '') + "\n";	
			pdfDoc.content[1].table.body[0][4].text[13].text = (metaData.invoiceData.remark ? metaData.invoiceData.remark : '') + "\n";
	
			//Invoice Details
			// let vdate = new Date(metaData.invoiceData.date)
			// let vpaymentDueDate = vdate.setDate(vdate.getDate() + (metaData.invoiceData.duration ? parseInt(metaData.invoiceData.duration) : 0));
			// pdfDoc.content[1].table.body[0][3].text[13].text = metaData.invoiceData.invoiceId + "\n";
			// pdfDoc.content[1].table.body[0][3].text[15].text = new Date(metaData.invoiceData.date).toLocaleDateString('en-GB').toString() + "\n";
			// pdfDoc.content[1].table.body[0][3].text[17].text = (metaData.invoiceData.status ? metaData.invoiceData.status.toUpperCase() : '') + "\n";
			// pdfDoc.content[1].table.body[0][3].text[7].text = new Date(vpaymentDueDate).toLocaleDateString('en-GB').toString() + "\n";
			// End of Trail Code
	
	
			//Receipient Details
			// pdfDoc.content[3].table.body[0][1].text[1].text = (metaData.customer.name.toUpperCase() ? metaData.customer.name.toUpperCase() : '') + "\n";
			// pdfDoc.content[3].table.body[0][1].text[1].text = ((metaData.customer && metaData.customer.name )? metaData.customer.name.toUpperCase() : '') + "\n";
			// pdfDoc.content[3].table.body[0][1].text[1].text = (getCustomerDetails(metaData, 'name').toUpperCase()) + "\n";
			// pdfDoc.content[3].table.body[0][1].text[3].text = (metaData.customer.GST_number ? metaData.customer.GST_number : '') + "\n";
			// pdfDoc.content[3].table.body[0][1].text[5].text = (metaData.customer.address ? metaData.customer.address : '') + "\n";
			// pdfDoc.content[3].table.body[0][1].text[7].text = (metaData.customer.mobile ? metaData.customer.mobile : '') + "\n";
			// pdfDoc.content[3].table.body[0][1].text[3].text = (metaData.customer.localAddress ? metaData.customer.localAddress : '') + "\n";
			// pdfDoc.content[3].table.body[0][1].text[5].text = (getCustomerDetails(metaData, 'address')) + "\n";
			// pdfDoc.content[3].table.body[0][1].text[7].text = (getCustomerDetails(metaData, 'mobile').toUpperCase()) + "\n";
			// pdfDoc.content[3].table.body[0][1].text[9].text = (metaData.invoiceData.placeOfSupply ? metaData.invoiceData.placeOfSupply : '') + "\n";
			// pdfDoc.content[3].table.body[0][1].text[11].text = (metaData.customer.stateCode ? metaData.customer.stateCode : '') + "\n";
	
	
			//Invoice Details
			let date = new Date(metaData.invoiceData.date)
			let paymentDueDate = date.setDate(date.getDate() + (metaData.invoiceData.duration ? parseInt(metaData.invoiceData.duration) : 0));
			pdfDoc.content[3].table.body[0][1].text[1].text = metaData.invoiceData.invoiceId + "\n";
			pdfDoc.content[3].table.body[0][2].text[1].text = new Date(metaData.invoiceData.date).toLocaleDateString('en-GB').toString() + "\n";
			pdfDoc.content[3].table.body[0][3].text[1].text = (metaData.invoiceData.status ? metaData.invoiceData.status.toUpperCase() : '') + "\n";
			//pdfDoc.content[3].table.body[0][2].text[7].text = new Date(paymentDueDate).toLocaleDateString('en-GB').toString() + "\n";
	
			//Products
			let productList = convertToPDFProducts(metaData.invoiceData.items, false, metaData.invoiceData, metaData);
			productList.map((item) => {
				pdfDoc.content[5].table.body.push(item);
			});
			pdfDoc.content[6].table.body[0][0].text = ("In Words: " + _.startCase(digitsToWords(metaData.invoiceData.totalAmount)))
	
			// Payment Details
	
			// pdfDoc.content[6].table.body[0][0][1].table.body[0][1].text[1].text = (metaData.invoiceData.paymentType ? metaData.invoiceData.paymentType : '') + "\n";
			// pdfDoc.content[6].table.body[0][0][1].table.body[0][1].text[3].text = (metaData.invoiceData.transactionType ? metaData.invoiceData.transactionType : '') + "\n";
	
			// Bank Details
			// if (metaData.terms.banks.length) {
			// 	metaData.terms.banks.map((bankDetails) => {
			// 		pdfDoc.content[6].table.body[0][0][1].table.body[0][1].text.push({ text: bankDetails.bankName + " \n", style: "bankDetails" })
			// 		pdfDoc.content[6].table.body[0][0][1].table.body[0][1].text.push({ text: "A/C No: " + bankDetails.accountnumber + "\n", style: "bankDetails" })
			// 		pdfDoc.content[6].table.body[0][0][1].table.body[0][1].text.push({ text: "IFSC: " + bankDetails.ifsccode + "\n", style: "bankDetails" })
			// 		pdfDoc.content[6].table.body[0][0][1].table.body[0][1].text.push({ text: bankDetails.address + " \n", style: "bankDetails" })
			// 	})
			// }
			// Terms and cond
			// pdfDoc.content[6].table.body[0][0][3].table.body[0][1] = metaData.terms.termsAndConditions;
	
			// gst details
			// pdfDoc.content[6].table.body[0][1].text[1].text = ((metaData.invoiceData.totalAmount - metaData.invoiceData.roundOffAmount ? Number.parseFloat(metaData.invoiceData.totalAmount - metaData.invoiceData.roundOffAmount).toFixed(2) - Number.parseFloat(metaData.gstTotal.CGST_val + metaData.gstTotal.SGST_val + metaData.gstTotal.IGST_val).toFixed(2) : '0')).toFixed(2) + "\n";
			// pdfDoc.content[6].table.body[0][1].text[1].text = (
			// 	Number.parseFloat(metaData.invoiceData.totalAmount) +
			// 	Number.parseFloat(metaData.invoiceData.discountAmount || 0) +
			// 	Number.parseFloat(metaData.invoiceData.gstOnExtraChanrges ? 0 : (-Number.parseFloat(metaData.invoiceData.totalExtraCharges))) -
			// 	Number.parseFloat(metaData.invoiceData.gstOnExtraChanrges ? Number.parseFloat(metaData.invoiceData.totalExtraChargesGST) : 0) -
			// 	Number.parseFloat(metaData.invoiceData.roundOffAmount || 0) -
			// 	(Number.parseFloat(
			// 		metaData.gstTotal.SGST_val
			// 	) +
			// 		Number.parseFloat(
			// 			metaData.gstTotal.CGST_val
			// 		) +
			// 		Number.parseFloat(
			// 			metaData.gstTotal.IGST_val
			// 		))
			// ).toFixed(2) + "\n";
			// let offset = 0;
			// if (!metaData.invoiceData.gstOnExtraChanrges && metaData.invoiceData.extraCharges && metaData.invoiceData.extraCharges.length) {
			// 	metaData.invoiceData.extraCharges.map((charge) => {
			// 		pdfDoc.content[6].table.body[0][1].text.splice(2 + offset, 0, { text: '' + charge.name + ' :   ', bold: true, style: 'headerOne' });
			// 		offset++;
			// 		pdfDoc.content[6].table.body[0][1].text.splice(2 + offset, 0, { text: Number.parseFloat(charge.amount).toFixed(2) + '\n', style: 'headerOne' });
			// 		offset++;
			// 	})
			// }
			// pdfDoc.content[6].table.body[0][1].text[3].text = (metaData.invoiceData.labourAmount ? Number.parseFloat(metaData.invoiceData.labourAmount).toFixed(2) : '0.00') + "\n";
			// pdfDoc.content[6].table.body[0][1].text[3 + offset].text = (metaData.invoiceData.discountAmount ? Number.parseFloat(metaData.invoiceData.discountAmount).toFixed(2) : '0.00') + "\n";
			// pdfDoc.content[6].table.body[0][1].text[5 + offset].text = (metaData.invoiceData.roundOffAmount ? Number.parseFloat(metaData.invoiceData.roundOffAmount).toFixed(2) : '0.00') + "\n";
			// pdfDoc.content[6].table.body[0][1].text[9].text = (metaData.invoiceData.totalAmount ? Number.parseFloat(metaData.invoiceData.totalAmount).toFixed(2) : '0') + "\n";
			// pdfDoc.content[6].table.body[0][1].text[9].text = (metaData.invoiceData.totalAmount + metaData.invoiceData.labourAmount -  metaData.invoiceData.discountAmount ? Number.parseFloat(Number.parseFloat(metaData.invoiceData.totalAmount) + Number.parseFloat(metaData.invoiceData.labourAmount) - Number.parseFloat(metaData.invoiceData.discountAmount)).toFixed(2) : '0') + "\n";
			// pdfDoc.content[6].table.body[0][1].text[7 + offset].text = (metaData.invoiceData.totalAmount ? Number.parseFloat(metaData.invoiceData.totalAmount) : '0.00').toFixed(2) + "\n";
			// pdfDoc.content[6].table.body[0][1].text[9 + offset].text = (metaData.invoiceData.paidAmount ? Number.parseFloat(metaData.invoiceData.paidAmount).toFixed(2) : '0.00') + "\n";
			// pdfDoc.content[6].table.body[0][1].text[11 + offset].text = (metaData.invoiceData.remainingAmount ? Number.parseFloat(metaData.invoiceData.remainingAmount).toFixed(2) : '0.00') + "\n";
			// pdfDoc.content[6].table.body[0][1].text[17].text = (metaData.invoiceData.paymentType ? metaData.invoiceData.paymentType : '') + "\n";
			// if(metaData.invoiceData.extraCharges && metaData.invoiceData.extraCharges.length) {
			// 	metaData.invoiceData.extraCharges.map((charge)=>{
			// 				pdfDoc.content[6].table.body[0][1].text.push({ text: ''+charge.name+':-          ', bold: true })
			// 				pdfDoc.content[6].table.body[0][1].text.push({ text:charge.amount+'\n' })
			// 	})
			// }
	
			// Overall Balance
			if (metaData.balance && metaData.terms.isPreviousCurrentTotalBalance) {
				pdfDoc.content[7].table.body[1][0].text[1].text = Number.parseFloat(Number.parseFloat(metaData.balance) - Number.parseFloat(metaData.invoiceData.remainingAmount).toFixed(2)).toFixed(2) + "\n";
				pdfDoc.content[7].table.body[1][1].text[1].text = (metaData.invoiceData.remainingAmount ? Number.parseFloat(metaData.invoiceData.remainingAmount).toFixed(2) : '0.00') + "\n";
				pdfDoc.content[7].table.body[1][2].text[1].text = (metaData.balance ? Number.parseFloat(metaData.balance).toFixed(2) : '0.00') + "\n";
			} else {
				pdfDoc.content[7] = {};
				//pdfDoc.content[6] = {}
			}
	
			// authority
			// pdfDoc.content[10].table.body[0][1].text[1].text = (metaData.firm.name ? (metaData.firm.name).toUpperCase() : '');
	
			// thank you
			// pdfDoc.content[9].table.body[0][0].text =  "Thank You " + (metaData.customer.name.toUpperCase() ? metaData.customer.name.toUpperCase() : '') +" For Choosing us!" 
			// pdfDoc.content[9].table.body[0][0].text =  metaData.terms.termsAndConditions.greetingMessage || ("Thank You " + ((metaData.customer && metaData.customer.name )? metaData.customer.name.toUpperCase() : '') +" For Choosing us!" )
			// pdfDoc.content[11].table.body[0][0].text = metaData.terms.greetingMessage || ("Thank You " + (getCustomerDetails(metaData, 'name').toUpperCase()) + " for doing business with us!")
	
			if (metaData.terms.isBlankHeader) {
				pdfDoc.content[1].table.body[0][1] = { text: '' };
				pdfDoc.content[1].style = 'hiddenTab';
				pdfDoc.content[1].table.body[0][2].text[1].style = 'hiddenTab'
			} else {
				if (metaData.terms.printLogo) {
					try {
						let logoData = await getBase64ImageFromURL(metaData.terms.printLogo)
						pdfDoc.content[1].table.body[0][1].image = logoData;
						let invoiceImages = document.getElementById('invoiceImages');
					if (invoiceImages && invoiceImages.files && invoiceImages.files.length) {
						let temp = {columns: []};
						if(invoiceImages.files[0]) {
							temp.columns.push({
								image: await toBase64(invoiceImages.files[0]).catch(e => Error(e)),
								width: 150
							})
						}
						if(invoiceImages.files[1]) {
							temp.columns.push({
								image: await toBase64(invoiceImages.files[1]).catch(e => Error(e)),
								width: 150
							})
						}
						if(invoiceImages.files[2]) {
							temp.columns.push({
								image: await toBase64(invoiceImages.files[2]).catch(e => Error(e)),
								width: 150
							})
						}
						pdfDoc.content.push(temp)
					}
					// if(metaData.terms.signature) {
					// 	let temp = {columns: []};
					// 	temp.columns.push({
					// 		image: await getBase64ImageFromURL(metaData.terms.signature),
					// 		width: 150,
					// 		alignment: 'right'
					// 	})

					// 	pdfDoc.content[9].table.body[0][1][2] = temp.columns[0];
					// }
						return pdfDoc;
					} catch (error) {
						console.log(error)
					}
				} else {
					var imgToExport = document.getElementById('pdfimgToExport');
					var canvas = document.createElement('canvas');
					canvas.width = imgToExport.width;
					canvas.height = imgToExport.height;
					canvas.getContext('2d').drawImage(imgToExport, 0, 0);
					let base64 = canvas.toDataURL('image/png')
					pdfDoc.content[1].table.body[0][1].image = base64;
					let invoiceImages = document.getElementById('invoiceImages');
					if (invoiceImages && invoiceImages.files && invoiceImages.files.length) {
						let temp = {columns: []};
						if(invoiceImages.files[0]) {
							temp.columns.push({
								image: await toBase64(invoiceImages.files[0]).catch(e => Error(e)),
								width: 150
							})
						}
						if(invoiceImages.files[1]) {
							temp.columns.push({
								image: await toBase64(invoiceImages.files[1]).catch(e => Error(e)),
								width: 150
							})
						}
						if(invoiceImages.files[2]) {
							temp.columns.push({
								image: await toBase64(invoiceImages.files[2]).catch(e => Error(e)),
								width: 150
							})
						}
						pdfDoc.content.push(temp)
					}
				}
			}
			// if(metaData.terms.signature) {
			// 	let temp = {columns: []};
			// 	temp.columns.push({
			// 		image: await getBase64ImageFromURL(metaData.terms.signature),
			// 		width: 150,
			// 		alignment: 'right'
			// 	})
			// 	pdfDoc.content.push(temp)
			// 	pdfDoc.content[9].table.body[0][1][2] = temp.columns[0];
			// }
	
				return pdfDoc;
			}
		// End of New Photo Resize Format Third	

		export const convertToPDFGST_1_individual = (metaData) => {
			let pdfDoc = {
				content: [
					{ text: 'GST Report\n\n', style: "bigger" },
					{
						table: {
							widths: ['*'],
							body: [
								[
									{ text: 'Firm Details', style: "header" },
								],
								[
									{
										text:
											[
												{ text: 'Firm Name:-         ', bold: true },
												{ text: 'Google\n' },
												{ text: 'Address:-              ', bold: true },
												{ text: '1600 Amphitheatre Parkway in Mountain View, California, United States, near San Jose. \n' },
												{ text: 'Mobile Number:- ', bold: true },
												{ text: '88776655\n' },
												{ text: 'PAN No:-               ', bold: true },
												{ text: '123456\n' },
												{ text: 'Email:-                   ', bold: true },
												{ text: 'njnjn@jnn.com\n' },
												{ text: 'GSTIN:-                 ', bold: true },
												{ text: '123456\n' },
												{ text: 'Website:-               ', bold: true },
												{ text: 'www.123456.com\n' },
											]

									}
								],
							]
						}
					},
					{
						table: {

							body: [
								[
									{ text: 'HSN SUMMARY', style: "header", colSpan: 8 },
									{ text: '', style: "header" },
									{ text: '', style: "header" },
									{ text: '', style: "header" },
									{ text: '', style: "header" },
									{ text: '', style: "header" },
									{ text: '', style: "header" },
									{ text: '', style: "header" },
								],
								[

									{ text: 'Description of Invoices', style: "gstHeader", rowSpan: 2 },
									{ text: 'Voucher Count', style: "gstHeader", rowSpan: 2 },
									{ text: 'Total Taxable Value', style: "gstHeader", rowSpan: 2 },
									{ text: 'TAX Amounts', style: "gstHeader", colSpan: 4, rowSpan: 1 },
									{ text: '', style: "gstHeader", rowSpan: 2 },
									{ text: '', style: "gstHeader", rowSpan: 2 },
									{ text: '', style: "gstHeader", rowSpan: 2 },
									{ text: 'Total Invoices', style: "gstHeader", rowSpan: 2 }
								],
								[

									{ text: 'Description of Invoices', style: "gstHeader" },
									{ text: 'Voucher Count', style: "gstHeader" },
									{ text: 'Total Taxable Value', style: "gstHeader" },
									{ text: 'IGST A.', style: "gstHeader" },
									{ text: 'CGST A.', style: "gstHeader" },
									{ text: 'SGST A.', style: "gstHeader" },
									{ text: 'CESS', style: "gstHeader" },
									{ text: 'Total Invoices', style: "gstHeader" }
								]
							]
						}
					},
					{
						table: {

							body: [
								[
									{ text: 'GSTR-1', style: "header", colSpan: 10, decoration: 'underline', },
									{ text: '', style: "header" },
									{ text: '', style: "header" },
									{ text: '', style: "header" },
									{ text: '', style: "header" },
									{ text: '', style: "header" },
									{ text: '', style: "header" },
									{ text: '', style: "header" },
									{ text: '', style: "header" },
									{ text: '', style: "header" },
								],
								[

									{ text: 'S. No', style: "gstHeader", rowSpan: 2 },
									{ text: 'Customer Name GSTIN/UIN Location', style: "gstHeader", rowSpan: 2 },
									{ text: 'Invoice Number', style: "gstHeader", rowSpan: 2 },
									{ text: 'Date', style: "gstHeader", rowSpan: 2 },
									{ text: 'Taxable Value', style: "gstHeader", rowSpan: 2 },
									{ text: 'TAX Amounts', style: "gstHeader", colSpan: 4, rowSpan: 1 },
									{ text: '', style: "gstHeader", rowSpan: 2 },
									{ text: '', style: "gstHeader", rowSpan: 2 },
									{ text: '', style: "gstHeader", rowSpan: 2 },
									{ text: 'Invoice Amount', style: "gstHeader", rowSpan: 2 }
								],
								[

									{ text: 'Description of Invoices', style: "gstHeader" },
									{ text: 'Voucher Count', style: "gstHeader" },
									{ text: 'Total Taxable Value', style: "gstHeader" },
									{ text: 'Voucher Count', style: "gstHeader" },
									{ text: 'Total Taxable Value', style: "gstHeader" },
									{ text: 'IGST A.', style: "gstHeader" },
									{ text: 'CGST A.', style: "gstHeader" },
									{ text: 'SGST A.', style: "gstHeader" },
									{ text: 'CESS', style: "gstHeader" },
									{ text: 'Total Invoices', style: "gstHeader" }
								]
							]
						}
					},
				],
				footer: {
					columns: [
						{
							text: 'Powered By ACUIFY',
							alignment: 'right',
							color: '#160091'
						}
					],
					margin: [10, 10]
				},

				styles: {
					header: {
						fontSize: 14,
						bold: true,
						alignment: 'center'
					},
					gstHeader: {
						fontSize: 10,
						bold: true,
						alignment: 'center'
					},
					gstData: {
						fontSize: 9,
						alignment: 'center',

					},
					bigger: {
						fontSize: 18,
						bold: true,
						alignment: 'center',
						decoration: 'underline',
						decorationStyle: 'solid',
						decorationColor: 'black'
					}
				}
			}

			//Firm Details 
			pdfDoc.content[1].table.body[1][0].text[1].text = (metaData.firm.name ? metaData.firm.name : '') + "\n";
			pdfDoc.content[1].table.body[1][0].text[3].text = (metaData.firm.address ? metaData.firm.address : '') + "\n";
			pdfDoc.content[1].table.body[1][0].text[5].text = (metaData.firm.mobileNumber ? metaData.firm.mobileNumber : '') + "\n";
			pdfDoc.content[1].table.body[1][0].text[7].text = (metaData.firm.panNumber ? metaData.firm.panNumber : '') + "\n";
			pdfDoc.content[1].table.body[1][0].text[9].text = (metaData.firm.email ? metaData.firm.email : '') + "\n";
			pdfDoc.content[1].table.body[1][0].text[11].text = (metaData.firm.GST_number ? metaData.firm.GST_number : '') + "\n";
			pdfDoc.content[1].table.body[1][0].text[13].text = (metaData.firm.website ? metaData.firm.website : '') + "\n";


			// selected GST Category details

			pdfDoc.content[2].table.body.push(
				[

					{ text: metaData.selectedGSTCat.title, style: "gstData" },
					{ text: metaData.selectedGSTCat.voucherCount, style: "gstData" },
					{ text: metaData.selectedGSTCat.totalBaseAmount, style: "gstData" },
					{ text: metaData.selectedGSTCat.IGST, style: "gstData" },
					{ text: metaData.selectedGSTCat.CGST, style: "gstData" },
					{ text: metaData.selectedGSTCat.SGST, style: "gstData" },
					{ text: metaData.selectedGSTCat.CESS, style: "gstData" },
					{ text: metaData.selectedGSTCat.totalInvoice, style: "gstData" },
				]
			)
			metaData.selectedGSTCat.invoices.map((invoice, index) => {
				pdfDoc.content[3].table.body.push(
					[

						{ text: index + 1, style: "gstData" },
						[{ text: invoice.buyer.name, style: "gstHeader" }, { text: invoice.buyer.GST_number, style: "gstData" }, { text: invoice.buyer.state, style: "gstData" }],
						{ text: invoice.invoiceId, style: "gstData" },
						{ text: new Date(invoice.date).toLocaleDateString('en-GB'), style: "gstData" },
						{ text: invoice.basicAmount, style: "gstData" },
						{ text: invoice.IGST_val, style: "gstData" },
						{ text: invoice.CGST_val, style: "gstData" },
						{ text: invoice.SGST_val, style: "gstData" },
						{ text: invoice.CESS, style: "gstData" },
						{ text: invoice.totalAmount, style: "gstData" }
					],
				)
			});

			return pdfDoc;
		}

		export const convertToPDFGST_1 = (metaData) => {
			let pdfDoc = {
				content: [
					{ text: 'GST Report\n\n', style: "bigger" },
					{
						table: {
							widths: ['*'],
							body: [
								[
									{ text: 'Firm Details', style: "header" },
								],
								[
									{
										text:
											[
												{ text: 'Firm Name:-         ', bold: true },
												{ text: 'Google\n' },
												{ text: 'Address:-              ', bold: true },
												{ text: '1600 Amphitheatre Parkway in Mountain View, California, United States, near San Jose. \n' },
												{ text: 'Mobile Number:- ', bold: true },
												{ text: '88776655\n' },
												{ text: 'PAN No:-               ', bold: true },
												{ text: '123456\n' },
												{ text: 'Email:-                   ', bold: true },
												{ text: 'njnjn@jnn.com\n' },
												{ text: 'GSTIN:-                 ', bold: true },
												{ text: '123456\n' },
												{ text: 'Website:-               ', bold: true },
												{ text: 'www.123456.com\n' },
											]
									}
								],
							]
						}
					},
					{
						table: {
							body: [
								[
									{ text: 'GST Summary', style: "header", colSpan: 7, decoration: 'underline' },
									{ text: '', style: "header" },
									{ text: '', style: "header" },
									{ text: '', style: "header" },
									{ text: '', style: "header" },
									{ text: '', style: "header" },
									{ text: '', style: "header" },
								],
								[
									{ text: 'Description of Invoices', style: "gstHeader", rowSpan: 2 },
									{ text: 'Total Taxable Value', style: "gstHeader", rowSpan: 2 },
									{ text: 'TAX Amounts', style: "gstHeader", colSpan: 4, rowSpan: 1 },
									{ text: '', style: "gstHeader", rowSpan: 2 },
									{ text: '', style: "gstHeader", rowSpan: 2 },
									{ text: '', style: "gstHeader", rowSpan: 2 },
									{ text: 'Total Invoices', style: "gstHeader", rowSpan: 2 }
								],
								[
									{ text: 'Description of Invoices', style: "gstHeader" },
									{ text: 'Total Taxable Value', style: "gstHeader" },
									{ text: 'IGST A.', style: "gstHeader" },
									{ text: 'CGST A.', style: "gstHeader" },
									{ text: 'SGST A.', style: "gstHeader" },
									{ text: 'CESS', style: "gstHeader" },
									{ text: 'Total Invoices', style: "gstHeader" }
								],
								[
									{ text: 'OUTWARD SUPPLIES', style: "Header2" },
									{ text: '0', style: "Header2" },
									{ text: '0', style: "Header2" },
									{ text: '0', style: "Header2" },
									{ text: '0', style: "Header2" },
									{ text: '0', style: "Header2" },
									{ text: '0', style: "Header2" }
								],
								[
									{ text: '(A). Intra state', style: "Header3" },
									{ text: '0', style: "Header3" },
									{ text: '0', style: "Header3" },
									{ text: '0', style: "Header3" },
									{ text: '0', style: "Header3" },
									{ text: '0', style: "Header3" },
									{ text: '0', style: "Header3" }
								],
								[
									{ text: '(i). Taxable', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" }
								],
								[

									{ text: 'GST 3%', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" }
								],
								[

									{ text: 'GST 5%', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" }
								],
								[

									{ text: 'GST 12%', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" }
								],
								[

									{ text: 'GST 18%', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" }
								],
								[
									{ text: 'GST 28%', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" }
								],
								[
									{ text: '(ii). Exempted', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" }
								],
								[
									{ text: '(iii). Nill Rated', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" }
								],
								[
									{ text: '(iv). Others', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" }
								],
								[
									{ text: '(A). Inter state', style: "Header3" },
									{ text: '0', style: "Header3" },
									{ text: '0', style: "Header3" },
									{ text: '0', style: "Header3" },
									{ text: '0', style: "Header3" },
									{ text: '0', style: "Header3" },
									{ text: '0', style: "Header3" }
								],
								[
									{ text: '(i). Taxable', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" }
								],
								[

									{ text: 'GST 3%', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" }
								],
								[

									{ text: 'GST 5%', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" }
								],
								[

									{ text: 'GST 12%', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" }
								],
								[

									{ text: 'GST 18%', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" }
								],
								[

									{ text: 'GST 28%', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" }
								],
								[
									{ text: '(ii). Exempted', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" }
								],
								[
									{ text: '(iii). Nill Rated', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" }
								],
								[
									{ text: '(iv). Others', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" }
								],
							]
						}
					},
					{
						table: {
							body: [
								[
									{ text: 'GSTR-1', style: "header", colSpan: 9, decoration: 'underline', },
									{ text: '', style: "header" },
									{ text: '', style: "header" },
									{ text: '', style: "header" },
									{ text: '', style: "header" },
									{ text: '', style: "header" },
									{ text: '', style: "header" },
									{ text: '', style: "header" },
									{ text: '', style: "header" },
								],
								[
									{ text: 'S. No', style: "Header3", rowSpan: 2 },
									{ text: 'Description Of Invoices', style: "Header3", rowSpan: 2 },
									{ text: 'Voucher Count', style: "Header3", rowSpan: 2 },
									{ text: 'Total Taxable Value', style: "Header3", rowSpan: 2 },
									{ text: 'TAX/GST Amounts', style: "Header3", colSpan: 4, rowSpan: 1 },
									{ text: '', style: "Header3", rowSpan: 2 },
									{ text: '', style: "Header3", rowSpan: 2 },
									{ text: '', style: "Header3", rowSpan: 2 },
									{ text: 'Invoice Amount', style: "Header3", rowSpan: 2 }
								],
								[
									{ text: 'Description of Invoices', style: "Header3" },
									{ text: 'Voucher Count', style: "Header3" },
									{ text: 'Voucher Count', style: "Header3" },
									{ text: 'Total Taxable Value', style: "Header3" },
									{ text: 'IGST A.', style: "Header3" },
									{ text: 'CGST A.', style: "Header3" },
									{ text: 'SGST A.', style: "Header3" },
									{ text: 'CESS', style: "Header3" },
									{ text: 'Total Invoices', style: "Header3" }
								],

							]
						}
					},
				],
				footer: {
					columns: [
						{
							text: 'Powered By ACUIFY',
							alignment: 'right',
							color: '#160091'
						}
					],
					margin: [10, 10]
				},
				styles: {
					header: {
						fontSize: 14,
						bold: true,
						alignment: 'center'
					},
					gstHeader: {
						fontSize: 13,
						bold: true,
						alignment: 'center'
					},
					Header2: {
						fontSize: 12,
						bold: true,
						alignment: 'center'
					},
					Header3: {
						fontSize: 11,
						bold: true,
						alignment: 'center'
					},
					Header4: {
						fontSize: 10,
						alignment: 'center'
					},
					gstData: {
						fontSize: 9,
						alignment: 'center',
					},
					bigger: {
						fontSize: 18,
						bold: true,
						alignment: 'center',
						decoration: 'underline',
						decorationStyle: 'solid',
						decorationColor: 'black'
					}
				}
			};
			//Firm Details 
			pdfDoc.content[1].table.body[1][0].text[1].text = (metaData.firm.name ? metaData.firm.name : '') + "\n";
			pdfDoc.content[1].table.body[1][0].text[3].text = (metaData.firm.address ? metaData.firm.address : '') + "\n";
			pdfDoc.content[1].table.body[1][0].text[5].text = (metaData.firm.mobileNumber ? metaData.firm.mobileNumber : '') + "\n";
			pdfDoc.content[1].table.body[1][0].text[7].text = (metaData.firm.panNumber ? metaData.firm.panNumber : '') + "\n";
			pdfDoc.content[1].table.body[1][0].text[9].text = (metaData.firm.email ? metaData.firm.email : '') + "\n";
			pdfDoc.content[1].table.body[1][0].text[11].text = (metaData.firm.GST_number ? metaData.firm.GST_number : '') + "\n";
			pdfDoc.content[1].table.body[1][0].text[13].text = (metaData.firm.website ? metaData.firm.website : '') + "\n";
			//gst summary


			//outward

			pdfDoc.content[2].table.body[3][1].text = Number.parseFloat(metaData.outwardSupplies.totalBaseAmount).toFixed(2)
			pdfDoc.content[2].table.body[3][2].text = Number.parseFloat(metaData.outwardSupplies.IGST).toFixed(2)
			pdfDoc.content[2].table.body[3][3].text = Number.parseFloat(metaData.outwardSupplies.CGST).toFixed(2)
			pdfDoc.content[2].table.body[3][4].text = Number.parseFloat(metaData.outwardSupplies.SGST).toFixed(2)
			pdfDoc.content[2].table.body[3][5].text = Number.parseFloat(metaData.outwardSupplies.CESS).toFixed(2)
			pdfDoc.content[2].table.body[3][6].text = Number.parseFloat(metaData.outwardSupplies.totalInvoiceAmount).toFixed(2)

			pdfDoc.content[2].table.body[4][1].text = Number.parseFloat(metaData.outwardSupplies.intraState.totalBaseAmount).toFixed(2)
			pdfDoc.content[2].table.body[4][2].text = Number.parseFloat(metaData.outwardSupplies.intraState.IGST).toFixed(2)
			pdfDoc.content[2].table.body[4][3].text = Number.parseFloat(metaData.outwardSupplies.intraState.CGST).toFixed(2)
			pdfDoc.content[2].table.body[4][4].text = Number.parseFloat(metaData.outwardSupplies.intraState.SGST).toFixed(2)
			pdfDoc.content[2].table.body[4][5].text = Number.parseFloat(metaData.outwardSupplies.intraState.CESS).toFixed(2)
			pdfDoc.content[2].table.body[4][6].text = Number.parseFloat(metaData.outwardSupplies.intraState.totalInvoiceAmount).toFixed(2)

			pdfDoc.content[2].table.body[5][1].text = Number.parseFloat(metaData.outwardSupplies.intraState.taxable.totalBaseAmount).toFixed(2)
			pdfDoc.content[2].table.body[5][2].text = Number.parseFloat(metaData.outwardSupplies.intraState.taxable.IGST).toFixed(2)
			pdfDoc.content[2].table.body[5][3].text = Number.parseFloat(metaData.outwardSupplies.intraState.taxable.CGST).toFixed(2)
			pdfDoc.content[2].table.body[5][4].text = Number.parseFloat(metaData.outwardSupplies.intraState.taxable.SGST).toFixed(2)
			pdfDoc.content[2].table.body[5][5].text = Number.parseFloat(metaData.outwardSupplies.intraState.taxable.CESS).toFixed(2)
			pdfDoc.content[2].table.body[5][6].text = Number.parseFloat(metaData.outwardSupplies.intraState.taxable.totalInvoiceAmount).toFixed(2)

			pdfDoc.content[2].table.body[6][1].text = Number.parseFloat(metaData.outwardSupplies.intraState.taxable.GST_3.totalBaseAmount).toFixed(2)
			pdfDoc.content[2].table.body[6][2].text = Number.parseFloat(metaData.outwardSupplies.intraState.taxable.GST_3.IGST).toFixed(2)
			pdfDoc.content[2].table.body[6][3].text = Number.parseFloat(metaData.outwardSupplies.intraState.taxable.GST_3.CGST).toFixed(2)
			pdfDoc.content[2].table.body[6][4].text = Number.parseFloat(metaData.outwardSupplies.intraState.taxable.GST_3.SGST).toFixed(2)
			pdfDoc.content[2].table.body[6][5].text = Number.parseFloat(metaData.outwardSupplies.intraState.taxable.GST_3.CESS).toFixed(2)
			pdfDoc.content[2].table.body[6][6].text = Number.parseFloat(metaData.outwardSupplies.intraState.taxable.GST_3.totalInvoiceAmount).toFixed(2)

			pdfDoc.content[2].table.body[7][1].text = Number.parseFloat(metaData.outwardSupplies.intraState.taxable.GST_5.totalBaseAmount).toFixed(2)
			pdfDoc.content[2].table.body[7][2].text = Number.parseFloat(metaData.outwardSupplies.intraState.taxable.GST_5.IGST).toFixed(2)
			pdfDoc.content[2].table.body[7][3].text = Number.parseFloat(metaData.outwardSupplies.intraState.taxable.GST_5.CGST).toFixed(2)
			pdfDoc.content[2].table.body[7][4].text = Number.parseFloat(metaData.outwardSupplies.intraState.taxable.GST_5.SGST).toFixed(2)
			pdfDoc.content[2].table.body[7][5].text = Number.parseFloat(metaData.outwardSupplies.intraState.taxable.GST_5.CESS).toFixed(2)
			pdfDoc.content[2].table.body[7][6].text = Number.parseFloat(metaData.outwardSupplies.intraState.taxable.GST_5.totalInvoiceAmount).toFixed(2)

			pdfDoc.content[2].table.body[8][1].text = Number.parseFloat(metaData.outwardSupplies.intraState.taxable.GST_12.totalBaseAmount).toFixed(2)
			pdfDoc.content[2].table.body[8][2].text = Number.parseFloat(metaData.outwardSupplies.intraState.taxable.GST_12.IGST).toFixed(2)
			pdfDoc.content[2].table.body[8][3].text = Number.parseFloat(metaData.outwardSupplies.intraState.taxable.GST_12.CGST).toFixed(2)
			pdfDoc.content[2].table.body[8][4].text = Number.parseFloat(metaData.outwardSupplies.intraState.taxable.GST_12.SGST).toFixed(2)
			pdfDoc.content[2].table.body[8][5].text = Number.parseFloat(metaData.outwardSupplies.intraState.taxable.GST_12.CESS).toFixed(2)
			pdfDoc.content[2].table.body[8][6].text = Number.parseFloat(metaData.outwardSupplies.intraState.taxable.GST_12.totalInvoiceAmount).toFixed(2)

			pdfDoc.content[2].table.body[9][1].text = Number.parseFloat(metaData.outwardSupplies.intraState.taxable.GST_18.totalBaseAmount).toFixed(2)
			pdfDoc.content[2].table.body[9][2].text = Number.parseFloat(metaData.outwardSupplies.intraState.taxable.GST_18.IGST).toFixed(2)
			pdfDoc.content[2].table.body[9][3].text = Number.parseFloat(metaData.outwardSupplies.intraState.taxable.GST_18.CGST).toFixed(2)
			pdfDoc.content[2].table.body[9][4].text = Number.parseFloat(metaData.outwardSupplies.intraState.taxable.GST_18.SGST).toFixed(2)
			pdfDoc.content[2].table.body[9][5].text = Number.parseFloat(metaData.outwardSupplies.intraState.taxable.GST_18.CESS).toFixed(2)
			pdfDoc.content[2].table.body[9][6].text = Number.parseFloat(metaData.outwardSupplies.intraState.taxable.GST_18.totalInvoiceAmount).toFixed(2)

			pdfDoc.content[2].table.body[10][1].text = Number.parseFloat(metaData.outwardSupplies.intraState.taxable.GST_28.totalBaseAmount).toFixed(2)
			pdfDoc.content[2].table.body[10][2].text = Number.parseFloat(metaData.outwardSupplies.intraState.taxable.GST_28.IGST).toFixed(2)
			pdfDoc.content[2].table.body[10][3].text = Number.parseFloat(metaData.outwardSupplies.intraState.taxable.GST_28.CGST).toFixed(2)
			pdfDoc.content[2].table.body[10][4].text = Number.parseFloat(metaData.outwardSupplies.intraState.taxable.GST_28.SGST).toFixed(2)
			pdfDoc.content[2].table.body[10][5].text = Number.parseFloat(metaData.outwardSupplies.intraState.taxable.GST_28.CESS).toFixed(2)
			pdfDoc.content[2].table.body[10][6].text = Number.parseFloat(metaData.outwardSupplies.intraState.taxable.GST_28.totalInvoiceAmount).toFixed(2)

			pdfDoc.content[2].table.body[11][1].text = Number.parseFloat(metaData.outwardSupplies.intraState.exempted.totalBaseAmount).toFixed(2)
			pdfDoc.content[2].table.body[11][2].text = Number.parseFloat(metaData.outwardSupplies.intraState.exempted.IGST).toFixed(2)
			pdfDoc.content[2].table.body[11][3].text = Number.parseFloat(metaData.outwardSupplies.intraState.exempted.CGST).toFixed(2)
			pdfDoc.content[2].table.body[11][4].text = Number.parseFloat(metaData.outwardSupplies.intraState.exempted.SGST).toFixed(2)
			pdfDoc.content[2].table.body[11][5].text = Number.parseFloat(metaData.outwardSupplies.intraState.exempted.CESS).toFixed(2)
			pdfDoc.content[2].table.body[11][6].text = Number.parseFloat(metaData.outwardSupplies.intraState.exempted.totalInvoiceAmount).toFixed(2)

			pdfDoc.content[2].table.body[12][1].text = Number.parseFloat(metaData.outwardSupplies.intraState.nillrated.totalBaseAmount).toFixed(2)
			pdfDoc.content[2].table.body[12][2].text = Number.parseFloat(metaData.outwardSupplies.intraState.nillrated.IGST).toFixed(2)
			pdfDoc.content[2].table.body[12][3].text = Number.parseFloat(metaData.outwardSupplies.intraState.nillrated.CGST).toFixed(2)
			pdfDoc.content[2].table.body[12][4].text = Number.parseFloat(metaData.outwardSupplies.intraState.nillrated.SGST).toFixed(2)
			pdfDoc.content[2].table.body[12][5].text = Number.parseFloat(metaData.outwardSupplies.intraState.nillrated.CESS).toFixed(2)
			pdfDoc.content[2].table.body[12][6].text = Number.parseFloat(metaData.outwardSupplies.intraState.nillrated.totalInvoiceAmount).toFixed(2)

			pdfDoc.content[2].table.body[13][1].text = Number.parseFloat(metaData.outwardSupplies.intraState.others.totalBaseAmount).toFixed(2)
			pdfDoc.content[2].table.body[13][2].text = Number.parseFloat(metaData.outwardSupplies.intraState.others.IGST).toFixed(2)
			pdfDoc.content[2].table.body[13][3].text = Number.parseFloat(metaData.outwardSupplies.intraState.others.CGST).toFixed(2)
			pdfDoc.content[2].table.body[13][4].text = Number.parseFloat(metaData.outwardSupplies.intraState.others.SGST).toFixed(2)
			pdfDoc.content[2].table.body[13][5].text = Number.parseFloat(metaData.outwardSupplies.intraState.others.CESS).toFixed(2)
			pdfDoc.content[2].table.body[13][6].text = Number.parseFloat(metaData.outwardSupplies.intraState.others.totalInvoiceAmount).toFixed(2)

			pdfDoc.content[2].table.body[14][1].text = Number.parseFloat(metaData.outwardSupplies.interState.totalBaseAmount).toFixed(2)
			pdfDoc.content[2].table.body[14][2].text = Number.parseFloat(metaData.outwardSupplies.interState.IGST).toFixed(2)
			pdfDoc.content[2].table.body[14][3].text = Number.parseFloat(metaData.outwardSupplies.interState.CGST).toFixed(2)
			pdfDoc.content[2].table.body[14][4].text = Number.parseFloat(metaData.outwardSupplies.interState.SGST).toFixed(2)
			pdfDoc.content[2].table.body[14][5].text = Number.parseFloat(metaData.outwardSupplies.interState.CESS).toFixed(2)
			pdfDoc.content[2].table.body[14][6].text = Number.parseFloat(metaData.outwardSupplies.interState.totalInvoiceAmount).toFixed(2)

			pdfDoc.content[2].table.body[15][1].text = Number.parseFloat(metaData.outwardSupplies.interState.taxable.totalBaseAmount).toFixed(2)
			pdfDoc.content[2].table.body[15][2].text = Number.parseFloat(metaData.outwardSupplies.interState.taxable.IGST).toFixed(2)
			pdfDoc.content[2].table.body[15][3].text = Number.parseFloat(metaData.outwardSupplies.interState.taxable.CGST).toFixed(2)
			pdfDoc.content[2].table.body[15][4].text = Number.parseFloat(metaData.outwardSupplies.interState.taxable.SGST).toFixed(2)
			pdfDoc.content[2].table.body[15][5].text = Number.parseFloat(metaData.outwardSupplies.interState.taxable.CESS).toFixed(2)
			pdfDoc.content[2].table.body[15][6].text = Number.parseFloat(metaData.outwardSupplies.interState.taxable.totalInvoiceAmount).toFixed(2)

			pdfDoc.content[2].table.body[16][1].text = Number.parseFloat(metaData.outwardSupplies.interState.taxable.GST_3.totalBaseAmount).toFixed(2)
			pdfDoc.content[2].table.body[16][2].text = Number.parseFloat(metaData.outwardSupplies.interState.taxable.GST_3.IGST).toFixed(2)
			pdfDoc.content[2].table.body[16][3].text = Number.parseFloat(metaData.outwardSupplies.interState.taxable.GST_3.CGST).toFixed(2)
			pdfDoc.content[2].table.body[16][4].text = Number.parseFloat(metaData.outwardSupplies.interState.taxable.GST_3.SGST).toFixed(2)
			pdfDoc.content[2].table.body[16][5].text = Number.parseFloat(metaData.outwardSupplies.interState.taxable.GST_3.CESS).toFixed(2)
			pdfDoc.content[2].table.body[16][6].text = Number.parseFloat(metaData.outwardSupplies.interState.taxable.GST_3.totalInvoiceAmount).toFixed(2)

			pdfDoc.content[2].table.body[17][1].text = Number.parseFloat(metaData.outwardSupplies.interState.taxable.GST_5.totalBaseAmount).toFixed(2)
			pdfDoc.content[2].table.body[17][2].text = Number.parseFloat(metaData.outwardSupplies.interState.taxable.GST_5.IGST).toFixed(2)
			pdfDoc.content[2].table.body[17][3].text = Number.parseFloat(metaData.outwardSupplies.interState.taxable.GST_5.CGST).toFixed(2)
			pdfDoc.content[2].table.body[17][4].text = Number.parseFloat(metaData.outwardSupplies.interState.taxable.GST_5.SGST).toFixed(2)
			pdfDoc.content[2].table.body[17][5].text = Number.parseFloat(metaData.outwardSupplies.interState.taxable.GST_5.CESS).toFixed(2)
			pdfDoc.content[2].table.body[17][6].text = Number.parseFloat(metaData.outwardSupplies.interState.taxable.GST_5.totalInvoiceAmount).toFixed(2)

			pdfDoc.content[2].table.body[18][1].text = Number.parseFloat(metaData.outwardSupplies.interState.taxable.GST_12.totalBaseAmount).toFixed(2)
			pdfDoc.content[2].table.body[18][2].text = Number.parseFloat(metaData.outwardSupplies.interState.taxable.GST_12.IGST).toFixed(2)
			pdfDoc.content[2].table.body[18][3].text = Number.parseFloat(metaData.outwardSupplies.interState.taxable.GST_12.CGST).toFixed(2)
			pdfDoc.content[2].table.body[18][4].text = Number.parseFloat(metaData.outwardSupplies.interState.taxable.GST_12.SGST).toFixed(2)
			pdfDoc.content[2].table.body[18][5].text = Number.parseFloat(metaData.outwardSupplies.interState.taxable.GST_12.CESS).toFixed(2)
			pdfDoc.content[2].table.body[18][6].text = Number.parseFloat(metaData.outwardSupplies.interState.taxable.GST_12.totalInvoiceAmount).toFixed(2)

			pdfDoc.content[2].table.body[19][1].text = Number.parseFloat(metaData.outwardSupplies.interState.taxable.GST_18.totalBaseAmount).toFixed(2)
			pdfDoc.content[2].table.body[19][2].text = Number.parseFloat(metaData.outwardSupplies.interState.taxable.GST_18.IGST).toFixed(2)
			pdfDoc.content[2].table.body[19][3].text = Number.parseFloat(metaData.outwardSupplies.interState.taxable.GST_18.CGST).toFixed(2)
			pdfDoc.content[2].table.body[19][4].text = Number.parseFloat(metaData.outwardSupplies.interState.taxable.GST_18.SGST).toFixed(2)
			pdfDoc.content[2].table.body[19][5].text = Number.parseFloat(metaData.outwardSupplies.interState.taxable.GST_18.CESS).toFixed(2)
			pdfDoc.content[2].table.body[19][6].text = Number.parseFloat(metaData.outwardSupplies.interState.taxable.GST_18.totalInvoiceAmount).toFixed(2)

			pdfDoc.content[2].table.body[20][1].text = Number.parseFloat(metaData.outwardSupplies.interState.taxable.GST_28.totalBaseAmount).toFixed(2)
			pdfDoc.content[2].table.body[20][2].text = Number.parseFloat(metaData.outwardSupplies.interState.taxable.GST_28.IGST).toFixed(2)
			pdfDoc.content[2].table.body[20][3].text = Number.parseFloat(metaData.outwardSupplies.interState.taxable.GST_28.CGST).toFixed(2)
			pdfDoc.content[2].table.body[20][4].text = Number.parseFloat(metaData.outwardSupplies.interState.taxable.GST_28.SGST).toFixed(2)
			pdfDoc.content[2].table.body[20][5].text = Number.parseFloat(metaData.outwardSupplies.interState.taxable.GST_28.CESS).toFixed(2)
			pdfDoc.content[2].table.body[20][6].text = Number.parseFloat(metaData.outwardSupplies.interState.taxable.GST_28.totalInvoiceAmount).toFixed(2)

			pdfDoc.content[2].table.body[21][1].text = Number.parseFloat(metaData.outwardSupplies.interState.exempted.totalBaseAmount).toFixed(2)
			pdfDoc.content[2].table.body[21][2].text = Number.parseFloat(metaData.outwardSupplies.interState.exempted.IGST).toFixed(2)
			pdfDoc.content[2].table.body[21][3].text = Number.parseFloat(metaData.outwardSupplies.interState.exempted.CGST).toFixed(2)
			pdfDoc.content[2].table.body[21][4].text = Number.parseFloat(metaData.outwardSupplies.interState.exempted.SGST).toFixed(2)
			pdfDoc.content[2].table.body[21][5].text = Number.parseFloat(metaData.outwardSupplies.interState.exempted.CESS).toFixed(2)
			pdfDoc.content[2].table.body[21][6].text = Number.parseFloat(metaData.outwardSupplies.interState.exempted.totalInvoiceAmount).toFixed(2)

			pdfDoc.content[2].table.body[22][1].text = Number.parseFloat(metaData.outwardSupplies.interState.nillrated.totalBaseAmount).toFixed(2)
			pdfDoc.content[2].table.body[22][2].text = Number.parseFloat(metaData.outwardSupplies.interState.nillrated.IGST).toFixed(2)
			pdfDoc.content[2].table.body[22][3].text = Number.parseFloat(metaData.outwardSupplies.interState.nillrated.CGST).toFixed(2)
			pdfDoc.content[2].table.body[22][4].text = Number.parseFloat(metaData.outwardSupplies.interState.nillrated.SGST).toFixed(2)
			pdfDoc.content[2].table.body[22][5].text = Number.parseFloat(metaData.outwardSupplies.interState.nillrated.CESS).toFixed(2)
			pdfDoc.content[2].table.body[22][6].text = Number.parseFloat(metaData.outwardSupplies.interState.nillrated.totalInvoiceAmount).toFixed(2)

			pdfDoc.content[2].table.body[23][1].text = Number.parseFloat(metaData.outwardSupplies.interState.others.totalBaseAmount).toFixed(2)
			pdfDoc.content[2].table.body[23][2].text = Number.parseFloat(metaData.outwardSupplies.interState.others.IGST).toFixed(2)
			pdfDoc.content[2].table.body[23][3].text = Number.parseFloat(metaData.outwardSupplies.interState.others.CGST).toFixed(2)
			pdfDoc.content[2].table.body[23][4].text = Number.parseFloat(metaData.outwardSupplies.interState.others.SGST).toFixed(2)
			pdfDoc.content[2].table.body[23][5].text = Number.parseFloat(metaData.outwardSupplies.interState.others.CESS).toFixed(2)
			pdfDoc.content[2].table.body[23][6].text = Number.parseFloat(metaData.outwardSupplies.interState.others.totalInvoiceAmount).toFixed(2)


			//gst1 summary

			Object.keys(metaData.gst1).forEach(function (key, index) {
				if (index != 11) {
					pdfDoc.content[3].table.body.push(
						[

							{ text: index + 1, style: "Header4" },
							[{ text: metaData.gst1[key].title, style: "Header2" }, { text: metaData.gst1[key].description, style: "Header4" }],
							{ text: metaData.gst1[key].voucherCount, style: "Header4" },
							{ text: Number.parseFloat(metaData.gst1[key].totalBaseAmount).toFixed(2), style: "Header4" },
							{ text: Number.parseFloat(metaData.gst1[key].ICGST).toFixed(2), style: "Header4" },
							{ text: Number.parseFloat(metaData.gst1[key].CGST).toFixed(2), style: "Header4" },
							{ text: Number.parseFloat(metaData.gst1[key].SGST).toFixed(2), style: "Header4" },
							{ text: Number.parseFloat(metaData.gst1[key].CESS).toFixed(2), style: "Header4" },
							{ text: Number.parseFloat(metaData.gst1[key].totalInvoice).toFixed(2), style: "Header4" }
						],
					)
				}
			});

			return pdfDoc;
		}


		export const convertToPDFGST_3 = (metaData) => {
			let pdfDoc = {
				content: [
					{ text: 'GST Report\n\n', style: "bigger" },
					{
						table: {
							widths: ['*'],
							body: [
								[
									{ text: 'Firm Details', style: "header" },
								],
								[
									{
										text:
											[
												{ text: 'Firm Name:-         ', bold: true },
												{ text: 'Google\n' },
												{ text: 'Address:-              ', bold: true },
												{ text: '1600 Amphitheatre Parkway in Mountain View, California, United States, near San Jose. \n' },
												{ text: 'Mobile Number:- ', bold: true },
												{ text: '88776655\n' },
												{ text: 'PAN No:-               ', bold: true },
												{ text: '123456\n' },
												{ text: 'Email:-                   ', bold: true },
												{ text: 'njnjn@jnn.com\n' },
												{ text: 'GSTIN:-                 ', bold: true },
												{ text: '123456\n' },
												{ text: 'Website:-               ', bold: true },
												{ text: 'www.123456.com\n' },
											]

									}
								],
							]
						}
					},
					{
						table: {

							body: [
								[
									{ text: 'GST Summary', style: "header", colSpan: 7, decoration: 'underline' },
									{ text: '', style: "header" },
									{ text: '', style: "header" },
									{ text: '', style: "header" },
									{ text: '', style: "header" },
									{ text: '', style: "header" },
									{ text: '', style: "header" },
								],
								[

									{ text: 'Description of Invoices', style: "gstHeader", rowSpan: 2 },
									{ text: 'Total Taxable Value', style: "gstHeader", rowSpan: 2 },
									{ text: 'TAX Amounts', style: "gstHeader", colSpan: 4, rowSpan: 1 },
									{ text: '', style: "gstHeader", rowSpan: 2 },
									{ text: '', style: "gstHeader", rowSpan: 2 },
									{ text: '', style: "gstHeader", rowSpan: 2 },
									{ text: 'Total Invoices', style: "gstHeader", rowSpan: 2 }
								],
								[

									{ text: 'Description of Invoices', style: "gstHeader" },
									{ text: 'Total Taxable Value', style: "gstHeader" },
									{ text: 'IGST A.', style: "gstHeader" },
									{ text: 'CGST A.', style: "gstHeader" },
									{ text: 'SGST A.', style: "gstHeader" },
									{ text: 'CESS', style: "gstHeader" },
									{ text: 'Total Invoices', style: "gstHeader" }
								],
								[

									{ text: 'OUTWARD SUPPLIES', style: "Header2" },
									{ text: '0', style: "Header2" },
									{ text: '0', style: "Header2" },
									{ text: '0', style: "Header2" },
									{ text: '0', style: "Header2" },
									{ text: '0', style: "Header2" },
									{ text: '0', style: "Header2" }
								],
								[

									{ text: '(A). Intra state', style: "Header3" },
									{ text: '0', style: "Header3" },
									{ text: '0', style: "Header3" },
									{ text: '0', style: "Header3" },
									{ text: '0', style: "Header3" },
									{ text: '0', style: "Header3" },
									{ text: '0', style: "Header3" }
								],
								[

									{ text: '(i). Taxable', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" }
								],
								[

									{ text: 'GST 3%', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" }
								],
								[

									{ text: 'GST 5%', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" }
								],
								[

									{ text: 'GST 12%', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" }
								],
								[

									{ text: 'GST 18%', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" }
								],
								[

									{ text: 'GST 28%', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" }
								],
								[
									{ text: '(ii). Exempted', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" }
								],
								[
									{ text: '(iii). Nill Rated', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" }
								],
								[
									{ text: '(iv). Others', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" }
								],
								[

									{ text: '(A). Inter state', style: "Header3" },
									{ text: '0', style: "Header3" },
									{ text: '0', style: "Header3" },
									{ text: '0', style: "Header3" },
									{ text: '0', style: "Header3" },
									{ text: '0', style: "Header3" },
									{ text: '0', style: "Header3" }
								],
								[

									{ text: '(i). Taxable', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" }
								],
								[

									{ text: 'GST 3%', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" }
								],
								[

									{ text: 'GST 5%', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" }
								],
								[

									{ text: 'GST 12%', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" }
								],
								[

									{ text: 'GST 18%', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" }
								],
								[

									{ text: 'GST 28%', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" }
								],
								[
									{ text: '(ii). Exempted', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" }
								],
								[
									{ text: '(iii). Nill Rated', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" }
								],
								[
									{ text: '(iv). Others', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" }
								],
								[

									{ text: 'INWARD SUPPLIES', style: "Header2" },
									{ text: '0', style: "Header2" },
									{ text: '0', style: "Header2" },
									{ text: '0', style: "Header2" },
									{ text: '0', style: "Header2" },
									{ text: '0', style: "Header2" },
									{ text: '0', style: "Header2" }
								],
								[

									{ text: '(A). Intra state', style: "Header3" },
									{ text: '0', style: "Header3" },
									{ text: '0', style: "Header3" },
									{ text: '0', style: "Header3" },
									{ text: '0', style: "Header3" },
									{ text: '0', style: "Header3" },
									{ text: '0', style: "Header3" }
								],
								[

									{ text: '(i). Taxable', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" }
								],
								[

									{ text: 'GST 3%', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" }
								],
								[

									{ text: 'GST 5%', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" }
								],
								[

									{ text: 'GST 12%', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" }
								],
								[

									{ text: 'GST 18%', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" }
								],
								[

									{ text: 'GST 28%', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" }
								],
								[
									{ text: '(ii). Exempted', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" }
								],
								[
									{ text: '(iii). Nill Rated', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" }
								],
								[
									{ text: '(iv). Others', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" }
								],
								[

									{ text: '(A). Inter state', style: "Header3" },
									{ text: '0', style: "Header3" },
									{ text: '0', style: "Header3" },
									{ text: '0', style: "Header3" },
									{ text: '0', style: "Header3" },
									{ text: '0', style: "Header3" },
									{ text: '0', style: "Header3" }
								],
								[

									{ text: '(i). Taxable', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" }
								],
								[

									{ text: 'GST 3%', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" }
								],
								[

									{ text: 'GST 5%', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" }
								],
								[

									{ text: 'GST 12%', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" }
								],
								[

									{ text: 'GST 18%', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" }
								],
								[

									{ text: 'GST 28%', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" }
								],
								[
									{ text: '(ii). Exempted', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" }
								],
								[
									{ text: '(iii). Nill Rated', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" }
								],
								[
									{ text: '(iv). Others', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" }
								],

							]
						}
						, pageBreak: 'after'
					},
					{
						table: {

							body: [
								[
									{ text: 'GSTR-3', style: "header", colSpan: 9, decoration: 'underline', },
									{ text: '', style: "header" },
									{ text: '', style: "header" },
									{ text: '', style: "header" },
									{ text: '', style: "header" },
									{ text: '', style: "header" },
									{ text: '', style: "header" },
									{ text: '', style: "header" },
									{ text: '', style: "header" },
								],
								[
									{ text: 'S. No', style: "gstHeader", rowSpan: 2 },
									{ text: 'Description', style: "gstHeader", rowSpan: 2 },
									{ text: 'Place of Supply', style: "gstHeader", rowSpan: 2 },
									{ text: 'Taxable Value', style: "gstHeader", rowSpan: 2 },
									{ text: 'TAX Amounts', style: "gstHeader", colSpan: 4, rowSpan: 1 },
									{ text: '', style: "gstHeader", rowSpan: 2 },
									{ text: '', style: "gstHeader", rowSpan: 2 },
									{ text: '', style: "gstHeader", rowSpan: 2 },
									{ text: 'Invoice Amount', style: "gstHeader", rowSpan: 2 }
								],
								[
									{ text: 'Description of Invoices', style: "gstHeader" },
									{ text: 'Voucher Count', style: "gstHeader" },
									{ text: 'Voucher Count', style: "gstHeader" },
									{ text: 'Total Taxable Value', style: "gstHeader" },
									{ text: 'IGST A.', style: "gstHeader" },
									{ text: 'CGST A.', style: "gstHeader" },
									{ text: 'SGST A.', style: "gstHeader" },
									{ text: 'CESS', style: "gstHeader" },
									{ text: 'Total Invoices', style: "gstHeader" }
								],
								[
									{ text: '3.1', style: "Header2" },
									{ text: 'OUTWARD & INWARD SUPPLIES', style: "Header2" },
									{ text: '0', style: "Header2" },
									{ text: '0', style: "Header2" },
									{ text: '0', style: "Header2" },
									{ text: '0', style: "Header2" },
									{ text: '0', style: "Header2" },
									{ text: '0', style: "Header2" },
									{ text: '0', style: "Header2" },

								],
								[
									{ text: '', style: "Header4" },
									{ text: '(A). Outward Taxable Supplies (Taxable)', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header2" },
								],
								[
									{ text: '', style: "Header4" },
									{ text: '(B). Outward Taxable Supplies (Zero Rated)', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" }
								],
								[
									{ text: '', style: "Header4" },
									{ text: '(C). Outward Taxable Supplies (Nill Rated or Exempt)', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" }
								],
								[
									{ text: '', style: "Header4" },
									{ text: '(D). Inward Taxable Supplies (Liable To Reverse Charge)', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" }
								],
								[
									{ text: '', style: "Header4" },
									{ text: '(E). NON-GST Outward Supplies', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" }
								],
								[
									{ text: '3.2', style: "Header2" },
									{ text: 'INTER-STATE Supplies Made To Understand Composition Taxable Persons UIN Holders', style: "Header2" },
									{ text: '0', style: "Header2" },
									{ text: '0', style: "Header2" },
									{ text: '0', style: "Header2" },
									{ text: '0', style: "Header2" },
									{ text: '0', style: "Header2" },
									{ text: '0', style: "Header2" },
									{ text: '0', style: "Header2" },

								],
								[
									{ text: '4', style: "Header2" },
									{ text: 'ELIGIABLE ITC', style: "Header2" },
									{ text: '0', style: "Header2" },
									{ text: '0', style: "Header2" },
									{ text: '0', style: "Header2" },
									{ text: '0', style: "Header2" },
									{ text: '0', style: "Header2" },
									{ text: '0', style: "Header2" },
									{ text: '0', style: "Header2" },

								],
								[
									{ text: '', style: "Header3" },
									{ text: '(A). ITC Available [Full/Part]', style: "Header3" },
									{ text: '0', style: "Header3" },
									{ text: '0', style: "Header3" },
									{ text: '0', style: "Header3" },
									{ text: '0', style: "Header3" },
									{ text: '0', style: "Header3" },
									{ text: '0', style: "Header3" },
									{ text: '0', style: "Header3" }
								],
								[
									{ text: '', style: "Header4" },
									{ text: '(i). Imports of Goods', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" }
								],
								[
									{ text: '', style: "Header4" },
									{ text: '(ii). Imports of Services', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" }
								],
								[
									{ text: '', style: "Header4" },
									{ text: '(iii). Inward Supplies Liable To reverse charges', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" }
								],
								[
									{ text: '', style: "Header4" },
									{ text: '(iv). Inward Supplies From ISD', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" }
								],
								[
									{ text: '', style: "Header4" },
									{ text: '(v). All Other ITC', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" }
								],
								[
									{ text: '', style: "Header3" },
									{ text: '(B). ITC Reserved', style: "Header3" },
									{ text: '0', style: "Header3" },
									{ text: '0', style: "Header3" },
									{ text: '0', style: "Header3" },
									{ text: '0', style: "Header3" },
									{ text: '0', style: "Header3" },
									{ text: '0', style: "Header3" },
									{ text: '0', style: "Header3" }
								],
								[
									{ text: '', style: "Header4" },
									{ text: '(i). As per Rules 42 & 43 of cost', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" }
								],
								[
									{ text: '', style: "Header4" },
									{ text: '(ii). Others', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" }
								],

								[
									{ text: '', style: "Header3" },
									{ text: '(C). Net ITC Available (A) - (B)', style: "Header3" },
									{ text: '0', style: "Header3" },
									{ text: '0', style: "Header3" },
									{ text: '0', style: "Header3" },
									{ text: '0', style: "Header3" },
									{ text: '0', style: "Header3" },
									{ text: '0', style: "Header3" },
									{ text: '0', style: "Header3" }
								],

								[
									{ text: '', style: "Header3" },
									{ text: '(D). InEligible ITC', style: "Header3" },
									{ text: '0', style: "Header3" },
									{ text: '0', style: "Header3" },
									{ text: '0', style: "Header3" },
									{ text: '0', style: "Header3" },
									{ text: '0', style: "Header3" },
									{ text: '0', style: "Header3" },
									{ text: '0', style: "Header3" }
								],
								[
									{ text: '', style: "Header4" },
									{ text: '(i). As per Section 17(s)', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" }
								],
								[
									{ text: '', style: "Header4" },
									{ text: '(ii). Others', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" },
									{ text: '0', style: "Header4" }
								],
								[
									{ text: '5', style: "Header2" },
									{ text: 'Values Of Exempted Nill rated & NON-GST Inward Supplies', style: "Header2" },
									{ text: '0', style: "Header2" },
									{ text: '0', style: "Header2" },
									{ text: '0', style: "Header2" },
									{ text: '0', style: "Header2" },
									{ text: '0', style: "Header2" },
									{ text: '0', style: "Header2" },
									{ text: '0', style: "Header2" },

								],
								[
									{ text: '', style: "Header3" },
									{ text: '(A). From Supplier Under Composition Scheme, Exempt & Nillrated Supplies', style: "Header3" },
									{ text: '0', style: "Header3" },
									{ text: '0', style: "Header3" },
									{ text: '0', style: "Header3" },
									{ text: '0', style: "Header3" },
									{ text: '0', style: "Header3" },
									{ text: '0', style: "Header3" },
									{ text: '0', style: "Header3" }
								],
								[
									{ text: '', style: "Header3" },
									{ text: '(B). Non-GST Supplies', style: "Header3" },
									{ text: '0', style: "Header3" },
									{ text: '0', style: "Header3" },
									{ text: '0', style: "Header3" },
									{ text: '0', style: "Header3" },
									{ text: '0', style: "Header3" },
									{ text: '0', style: "Header3" },
									{ text: '0', style: "Header3" }
								],
							]
						}
					},
				],
				footer: {
					columns: [
						{
							text: 'Powered By ACUIFY',
							alignment: 'right',
							color: '#160091'
						}
					],
					margin: [10, 10]
				},

				styles: {
					header: {
						fontSize: 14,
						bold: true,
						alignment: 'center'
					},
					gstHeader: {
						fontSize: 13,
						bold: true,
						alignment: 'center'
					},
					Header2: {
						fontSize: 12,
						bold: true,
						alignment: 'center'
					},
					Header3: {
						fontSize: 11,
						bold: true,
						alignment: 'center'
					},
					Header4: {
						fontSize: 10,
						alignment: 'center'
					},
					gstData: {
						fontSize: 9,
						alignment: 'center',

					},
					bigger: {
						fontSize: 18,
						bold: true,
						alignment: 'center',
						decoration: 'underline',
						decorationStyle: 'solid',
						decorationColor: 'black'
					}
				}

			}

			//Firm Details 
			pdfDoc.content[1].table.body[1][0].text[1].text = (metaData.firm.name ? metaData.firm.name : '') + "\n";
			pdfDoc.content[1].table.body[1][0].text[3].text = (metaData.firm.address ? metaData.firm.address : '') + "\n";
			pdfDoc.content[1].table.body[1][0].text[5].text = (metaData.firm.mobileNumber ? metaData.firm.mobileNumber : '') + "\n";
			pdfDoc.content[1].table.body[1][0].text[7].text = (metaData.firm.panNumber ? metaData.firm.panNumber : '') + "\n";
			pdfDoc.content[1].table.body[1][0].text[9].text = (metaData.firm.email ? metaData.firm.email : '') + "\n";
			pdfDoc.content[1].table.body[1][0].text[11].text = (metaData.firm.GST_number ? metaData.firm.GST_number : '') + "\n";
			pdfDoc.content[1].table.body[1][0].text[13].text = (metaData.firm.website ? metaData.firm.website : '') + "\n";

			//gst summary


			//outward
			pdfDoc.content[2].table.body[3][1].text = Number.parseFloat(metaData.outwardSupplies.totalBaseAmount).toFixed(2)
			pdfDoc.content[2].table.body[3][2].text = Number.parseFloat(metaData.outwardSupplies.IGST).toFixed(2)
			pdfDoc.content[2].table.body[3][3].text = Number.parseFloat(metaData.outwardSupplies.CGST).toFixed(2)
			pdfDoc.content[2].table.body[3][4].text = Number.parseFloat(metaData.outwardSupplies.SGST).toFixed(2)
			pdfDoc.content[2].table.body[3][5].text = Number.parseFloat(metaData.outwardSupplies.CESS).toFixed(2)
			pdfDoc.content[2].table.body[3][6].text = Number.parseFloat(metaData.outwardSupplies.totalInvoiceAmount).toFixed(2)

			pdfDoc.content[2].table.body[4][1].text = Number.parseFloat(metaData.outwardSupplies.intraState.totalBaseAmount).toFixed(2)
			pdfDoc.content[2].table.body[4][2].text = Number.parseFloat(metaData.outwardSupplies.intraState.IGST).toFixed(2)
			pdfDoc.content[2].table.body[4][3].text = Number.parseFloat(metaData.outwardSupplies.intraState.CGST).toFixed(2)
			pdfDoc.content[2].table.body[4][4].text = Number.parseFloat(metaData.outwardSupplies.intraState.SGST).toFixed(2)
			pdfDoc.content[2].table.body[4][5].text = Number.parseFloat(metaData.outwardSupplies.intraState.CESS).toFixed(2)
			pdfDoc.content[2].table.body[4][6].text = Number.parseFloat(metaData.outwardSupplies.intraState.totalInvoiceAmount).toFixed(2)

			pdfDoc.content[2].table.body[5][1].text = Number.parseFloat(metaData.outwardSupplies.intraState.taxable.totalBaseAmount).toFixed(2)
			pdfDoc.content[2].table.body[5][2].text = Number.parseFloat(metaData.outwardSupplies.intraState.taxable.IGST).toFixed(2)
			pdfDoc.content[2].table.body[5][3].text = Number.parseFloat(metaData.outwardSupplies.intraState.taxable.CGST).toFixed(2)
			pdfDoc.content[2].table.body[5][4].text = Number.parseFloat(metaData.outwardSupplies.intraState.taxable.SGST).toFixed(2)
			pdfDoc.content[2].table.body[5][5].text = Number.parseFloat(metaData.outwardSupplies.intraState.taxable.CESS).toFixed(2)
			pdfDoc.content[2].table.body[5][6].text = Number.parseFloat(metaData.outwardSupplies.intraState.taxable.totalInvoiceAmount).toFixed(2)

			pdfDoc.content[2].table.body[6][1].text = Number.parseFloat(metaData.outwardSupplies.intraState.taxable.GST_3.totalBaseAmount).toFixed(2)
			pdfDoc.content[2].table.body[6][2].text = Number.parseFloat(metaData.outwardSupplies.intraState.taxable.GST_3.IGST).toFixed(2)
			pdfDoc.content[2].table.body[6][3].text = Number.parseFloat(metaData.outwardSupplies.intraState.taxable.GST_3.CGST).toFixed(2)
			pdfDoc.content[2].table.body[6][4].text = Number.parseFloat(metaData.outwardSupplies.intraState.taxable.GST_3.SGST).toFixed(2)
			pdfDoc.content[2].table.body[6][5].text = Number.parseFloat(metaData.outwardSupplies.intraState.taxable.GST_3.CESS).toFixed(2)
			pdfDoc.content[2].table.body[6][6].text = Number.parseFloat(metaData.outwardSupplies.intraState.taxable.GST_3.totalInvoiceAmount).toFixed(2)

			pdfDoc.content[2].table.body[7][1].text = Number.parseFloat(metaData.outwardSupplies.intraState.taxable.GST_5.totalBaseAmount).toFixed(2)
			pdfDoc.content[2].table.body[7][2].text = Number.parseFloat(metaData.outwardSupplies.intraState.taxable.GST_5.IGST).toFixed(2)
			pdfDoc.content[2].table.body[7][3].text = Number.parseFloat(metaData.outwardSupplies.intraState.taxable.GST_5.CGST).toFixed(2)
			pdfDoc.content[2].table.body[7][4].text = Number.parseFloat(metaData.outwardSupplies.intraState.taxable.GST_5.SGST).toFixed(2)
			pdfDoc.content[2].table.body[7][5].text = Number.parseFloat(metaData.outwardSupplies.intraState.taxable.GST_5.CESS).toFixed(2)
			pdfDoc.content[2].table.body[7][6].text = Number.parseFloat(metaData.outwardSupplies.intraState.taxable.GST_5.totalInvoiceAmount).toFixed(2)

			pdfDoc.content[2].table.body[8][1].text = Number.parseFloat(metaData.outwardSupplies.intraState.taxable.GST_12.totalBaseAmount).toFixed(2)
			pdfDoc.content[2].table.body[8][2].text = Number.parseFloat(metaData.outwardSupplies.intraState.taxable.GST_12.IGST).toFixed(2)
			pdfDoc.content[2].table.body[8][3].text = Number.parseFloat(metaData.outwardSupplies.intraState.taxable.GST_12.CGST).toFixed(2)
			pdfDoc.content[2].table.body[8][4].text = Number.parseFloat(metaData.outwardSupplies.intraState.taxable.GST_12.SGST).toFixed(2)
			pdfDoc.content[2].table.body[8][5].text = Number.parseFloat(metaData.outwardSupplies.intraState.taxable.GST_12.CESS).toFixed(2)
			pdfDoc.content[2].table.body[8][6].text = Number.parseFloat(metaData.outwardSupplies.intraState.taxable.GST_12.totalInvoiceAmount).toFixed(2)

			pdfDoc.content[2].table.body[9][1].text = Number.parseFloat(metaData.outwardSupplies.intraState.taxable.GST_18.totalBaseAmount).toFixed(2)
			pdfDoc.content[2].table.body[9][2].text = Number.parseFloat(metaData.outwardSupplies.intraState.taxable.GST_18.IGST).toFixed(2)
			pdfDoc.content[2].table.body[9][3].text = Number.parseFloat(metaData.outwardSupplies.intraState.taxable.GST_18.CGST).toFixed(2)
			pdfDoc.content[2].table.body[9][4].text = Number.parseFloat(metaData.outwardSupplies.intraState.taxable.GST_18.SGST).toFixed(2)
			pdfDoc.content[2].table.body[9][5].text = Number.parseFloat(metaData.outwardSupplies.intraState.taxable.GST_18.CESS).toFixed(2)
			pdfDoc.content[2].table.body[9][6].text = Number.parseFloat(metaData.outwardSupplies.intraState.taxable.GST_18.totalInvoiceAmount).toFixed(2)

			pdfDoc.content[2].table.body[10][1].text = Number.parseFloat(metaData.outwardSupplies.intraState.taxable.GST_28.totalBaseAmount).toFixed(2)
			pdfDoc.content[2].table.body[10][2].text = Number.parseFloat(metaData.outwardSupplies.intraState.taxable.GST_28.IGST).toFixed(2)
			pdfDoc.content[2].table.body[10][3].text = Number.parseFloat(metaData.outwardSupplies.intraState.taxable.GST_28.CGST).toFixed(2)
			pdfDoc.content[2].table.body[10][4].text = Number.parseFloat(metaData.outwardSupplies.intraState.taxable.GST_28.SGST).toFixed(2)
			pdfDoc.content[2].table.body[10][5].text = Number.parseFloat(metaData.outwardSupplies.intraState.taxable.GST_28.CESS).toFixed(2)
			pdfDoc.content[2].table.body[10][6].text = Number.parseFloat(metaData.outwardSupplies.intraState.taxable.GST_28.totalInvoiceAmount).toFixed(2)

			pdfDoc.content[2].table.body[11][1].text = Number.parseFloat(metaData.outwardSupplies.intraState.exempted.totalBaseAmount).toFixed(2)
			pdfDoc.content[2].table.body[11][2].text = Number.parseFloat(metaData.outwardSupplies.intraState.exempted.IGST).toFixed(2)
			pdfDoc.content[2].table.body[11][3].text = Number.parseFloat(metaData.outwardSupplies.intraState.exempted.CGST).toFixed(2)
			pdfDoc.content[2].table.body[11][4].text = Number.parseFloat(metaData.outwardSupplies.intraState.exempted.SGST).toFixed(2)
			pdfDoc.content[2].table.body[11][5].text = Number.parseFloat(metaData.outwardSupplies.intraState.exempted.CESS).toFixed(2)
			pdfDoc.content[2].table.body[11][6].text = Number.parseFloat(metaData.outwardSupplies.intraState.exempted.totalInvoiceAmount).toFixed(2)

			pdfDoc.content[2].table.body[12][1].text = Number.parseFloat(metaData.outwardSupplies.intraState.nillrated.totalBaseAmount).toFixed(2)
			pdfDoc.content[2].table.body[12][2].text = Number.parseFloat(metaData.outwardSupplies.intraState.nillrated.IGST).toFixed(2)
			pdfDoc.content[2].table.body[12][3].text = Number.parseFloat(metaData.outwardSupplies.intraState.nillrated.CGST).toFixed(2)
			pdfDoc.content[2].table.body[12][4].text = Number.parseFloat(metaData.outwardSupplies.intraState.nillrated.SGST).toFixed(2)
			pdfDoc.content[2].table.body[12][5].text = Number.parseFloat(metaData.outwardSupplies.intraState.nillrated.CESS).toFixed(2)
			pdfDoc.content[2].table.body[12][6].text = Number.parseFloat(metaData.outwardSupplies.intraState.nillrated.totalInvoiceAmount).toFixed(2)

			pdfDoc.content[2].table.body[13][1].text = Number.parseFloat(metaData.outwardSupplies.intraState.others.totalBaseAmount).toFixed(2)
			pdfDoc.content[2].table.body[13][2].text = Number.parseFloat(metaData.outwardSupplies.intraState.others.IGST).toFixed(2)
			pdfDoc.content[2].table.body[13][3].text = Number.parseFloat(metaData.outwardSupplies.intraState.others.CGST).toFixed(2)
			pdfDoc.content[2].table.body[13][4].text = Number.parseFloat(metaData.outwardSupplies.intraState.others.SGST).toFixed(2)
			pdfDoc.content[2].table.body[13][5].text = Number.parseFloat(metaData.outwardSupplies.intraState.others.CESS).toFixed(2)
			pdfDoc.content[2].table.body[13][6].text = Number.parseFloat(metaData.outwardSupplies.intraState.others.totalInvoiceAmount).toFixed(2)

			pdfDoc.content[2].table.body[14][1].text = Number.parseFloat(metaData.outwardSupplies.interState.totalBaseAmount).toFixed(2)
			pdfDoc.content[2].table.body[14][2].text = Number.parseFloat(metaData.outwardSupplies.interState.IGST).toFixed(2)
			pdfDoc.content[2].table.body[14][3].text = Number.parseFloat(metaData.outwardSupplies.interState.CGST).toFixed(2)
			pdfDoc.content[2].table.body[14][4].text = Number.parseFloat(metaData.outwardSupplies.interState.SGST).toFixed(2)
			pdfDoc.content[2].table.body[14][5].text = Number.parseFloat(metaData.outwardSupplies.interState.CESS).toFixed(2)
			pdfDoc.content[2].table.body[14][6].text = Number.parseFloat(metaData.outwardSupplies.interState.totalInvoiceAmount).toFixed(2)

			pdfDoc.content[2].table.body[15][1].text = Number.parseFloat(metaData.outwardSupplies.interState.taxable.totalBaseAmount).toFixed(2)
			pdfDoc.content[2].table.body[15][2].text = Number.parseFloat(metaData.outwardSupplies.interState.taxable.IGST).toFixed(2)
			pdfDoc.content[2].table.body[15][3].text = Number.parseFloat(metaData.outwardSupplies.interState.taxable.CGST).toFixed(2)
			pdfDoc.content[2].table.body[15][4].text = Number.parseFloat(metaData.outwardSupplies.interState.taxable.SGST).toFixed(2)
			pdfDoc.content[2].table.body[15][5].text = Number.parseFloat(metaData.outwardSupplies.interState.taxable.CESS).toFixed(2)
			pdfDoc.content[2].table.body[15][6].text = Number.parseFloat(metaData.outwardSupplies.interState.taxable.totalInvoiceAmount).toFixed(2)

			pdfDoc.content[2].table.body[16][1].text = Number.parseFloat(metaData.outwardSupplies.interState.taxable.GST_3.totalBaseAmount).toFixed(2)
			pdfDoc.content[2].table.body[16][2].text = Number.parseFloat(metaData.outwardSupplies.interState.taxable.GST_3.IGST).toFixed(2)
			pdfDoc.content[2].table.body[16][3].text = Number.parseFloat(metaData.outwardSupplies.interState.taxable.GST_3.CGST).toFixed(2)
			pdfDoc.content[2].table.body[16][4].text = Number.parseFloat(metaData.outwardSupplies.interState.taxable.GST_3.SGST).toFixed(2)
			pdfDoc.content[2].table.body[16][5].text = Number.parseFloat(metaData.outwardSupplies.interState.taxable.GST_3.CESS).toFixed(2)
			pdfDoc.content[2].table.body[16][6].text = Number.parseFloat(metaData.outwardSupplies.interState.taxable.GST_3.totalInvoiceAmount).toFixed(2)

			pdfDoc.content[2].table.body[17][1].text = Number.parseFloat(metaData.outwardSupplies.interState.taxable.GST_5.totalBaseAmount).toFixed(2)
			pdfDoc.content[2].table.body[17][2].text = Number.parseFloat(metaData.outwardSupplies.interState.taxable.GST_5.IGST).toFixed(2)
			pdfDoc.content[2].table.body[17][3].text = Number.parseFloat(metaData.outwardSupplies.interState.taxable.GST_5.CGST).toFixed(2)
			pdfDoc.content[2].table.body[17][4].text = Number.parseFloat(metaData.outwardSupplies.interState.taxable.GST_5.SGST).toFixed(2)
			pdfDoc.content[2].table.body[17][5].text = Number.parseFloat(metaData.outwardSupplies.interState.taxable.GST_5.CESS).toFixed(2)
			pdfDoc.content[2].table.body[17][6].text = Number.parseFloat(metaData.outwardSupplies.interState.taxable.GST_5.totalInvoiceAmount).toFixed(2)

			pdfDoc.content[2].table.body[18][1].text = Number.parseFloat(metaData.outwardSupplies.interState.taxable.GST_12.totalBaseAmount).toFixed(2)
			pdfDoc.content[2].table.body[18][2].text = Number.parseFloat(metaData.outwardSupplies.interState.taxable.GST_12.IGST).toFixed(2)
			pdfDoc.content[2].table.body[18][3].text = Number.parseFloat(metaData.outwardSupplies.interState.taxable.GST_12.CGST).toFixed(2)
			pdfDoc.content[2].table.body[18][4].text = Number.parseFloat(metaData.outwardSupplies.interState.taxable.GST_12.SGST).toFixed(2)
			pdfDoc.content[2].table.body[18][5].text = Number.parseFloat(metaData.outwardSupplies.interState.taxable.GST_12.CESS).toFixed(2)
			pdfDoc.content[2].table.body[18][6].text = Number.parseFloat(metaData.outwardSupplies.interState.taxable.GST_12.totalInvoiceAmount).toFixed(2)

			pdfDoc.content[2].table.body[19][1].text = Number.parseFloat(metaData.outwardSupplies.interState.taxable.GST_18.totalBaseAmount).toFixed(2)
			pdfDoc.content[2].table.body[19][2].text = Number.parseFloat(metaData.outwardSupplies.interState.taxable.GST_18.IGST).toFixed(2)
			pdfDoc.content[2].table.body[19][3].text = Number.parseFloat(metaData.outwardSupplies.interState.taxable.GST_18.CGST).toFixed(2)
			pdfDoc.content[2].table.body[19][4].text = Number.parseFloat(metaData.outwardSupplies.interState.taxable.GST_18.SGST).toFixed(2)
			pdfDoc.content[2].table.body[19][5].text = Number.parseFloat(metaData.outwardSupplies.interState.taxable.GST_18.CESS).toFixed(2)
			pdfDoc.content[2].table.body[19][6].text = Number.parseFloat(metaData.outwardSupplies.interState.taxable.GST_18.totalInvoiceAmount).toFixed(2)

			pdfDoc.content[2].table.body[20][1].text = Number.parseFloat(metaData.outwardSupplies.interState.taxable.GST_28.totalBaseAmount).toFixed(2)
			pdfDoc.content[2].table.body[20][2].text = Number.parseFloat(metaData.outwardSupplies.interState.taxable.GST_28.IGST).toFixed(2)
			pdfDoc.content[2].table.body[20][3].text = Number.parseFloat(metaData.outwardSupplies.interState.taxable.GST_28.CGST).toFixed(2)
			pdfDoc.content[2].table.body[20][4].text = Number.parseFloat(metaData.outwardSupplies.interState.taxable.GST_28.SGST).toFixed(2)
			pdfDoc.content[2].table.body[20][5].text = Number.parseFloat(metaData.outwardSupplies.interState.taxable.GST_28.CESS).toFixed(2)
			pdfDoc.content[2].table.body[20][6].text = Number.parseFloat(metaData.outwardSupplies.interState.taxable.GST_28.totalInvoiceAmount).toFixed(2)

			pdfDoc.content[2].table.body[21][1].text = Number.parseFloat(metaData.outwardSupplies.interState.exempted.totalBaseAmount).toFixed(2)
			pdfDoc.content[2].table.body[21][2].text = Number.parseFloat(metaData.outwardSupplies.interState.exempted.IGST).toFixed(2)
			pdfDoc.content[2].table.body[21][3].text = Number.parseFloat(metaData.outwardSupplies.interState.exempted.CGST).toFixed(2)
			pdfDoc.content[2].table.body[21][4].text = Number.parseFloat(metaData.outwardSupplies.interState.exempted.SGST).toFixed(2)
			pdfDoc.content[2].table.body[21][5].text = Number.parseFloat(metaData.outwardSupplies.interState.exempted.CESS).toFixed(2)
			pdfDoc.content[2].table.body[21][6].text = Number.parseFloat(metaData.outwardSupplies.interState.exempted.totalInvoiceAmount).toFixed(2)

			pdfDoc.content[2].table.body[22][1].text = Number.parseFloat(metaData.outwardSupplies.interState.nillrated.totalBaseAmount).toFixed(2)
			pdfDoc.content[2].table.body[22][2].text = Number.parseFloat(metaData.outwardSupplies.interState.nillrated.IGST).toFixed(2)
			pdfDoc.content[2].table.body[22][3].text = Number.parseFloat(metaData.outwardSupplies.interState.nillrated.CGST).toFixed(2)
			pdfDoc.content[2].table.body[22][4].text = Number.parseFloat(metaData.outwardSupplies.interState.nillrated.SGST).toFixed(2)
			pdfDoc.content[2].table.body[22][5].text = Number.parseFloat(metaData.outwardSupplies.interState.nillrated.CESS).toFixed(2)
			pdfDoc.content[2].table.body[22][6].text = Number.parseFloat(metaData.outwardSupplies.interState.nillrated.totalInvoiceAmount).toFixed(2)

			pdfDoc.content[2].table.body[23][1].text = Number.parseFloat(metaData.outwardSupplies.interState.others.totalBaseAmount).toFixed(2)
			pdfDoc.content[2].table.body[23][2].text = Number.parseFloat(metaData.outwardSupplies.interState.others.IGST).toFixed(2)
			pdfDoc.content[2].table.body[23][3].text = Number.parseFloat(metaData.outwardSupplies.interState.others.CGST).toFixed(2)
			pdfDoc.content[2].table.body[23][4].text = Number.parseFloat(metaData.outwardSupplies.interState.others.SGST).toFixed(2)
			pdfDoc.content[2].table.body[23][5].text = Number.parseFloat(metaData.outwardSupplies.interState.others.CESS).toFixed(2)
			pdfDoc.content[2].table.body[23][6].text = Number.parseFloat(metaData.outwardSupplies.interState.others.totalInvoiceAmount).toFixed(2)

			//inward 

			pdfDoc.content[2].table.body[24][1].text = Number.parseFloat(metaData.inwardSupplies.totalBaseAmount).toFixed(2)
			pdfDoc.content[2].table.body[24][2].text = Number.parseFloat(metaData.inwardSupplies.IGST).toFixed(2)
			pdfDoc.content[2].table.body[24][3].text = Number.parseFloat(metaData.inwardSupplies.CGST).toFixed(2)
			pdfDoc.content[2].table.body[24][4].text = Number.parseFloat(metaData.inwardSupplies.SGST).toFixed(2)
			pdfDoc.content[2].table.body[24][5].text = Number.parseFloat(metaData.inwardSupplies.CESS).toFixed(2)
			pdfDoc.content[2].table.body[24][6].text = Number.parseFloat(metaData.inwardSupplies.totalInvoiceAmount).toFixed(2)

			pdfDoc.content[2].table.body[25][1].text = Number.parseFloat(metaData.inwardSupplies.intraState.totalBaseAmount).toFixed(2)
			pdfDoc.content[2].table.body[25][2].text = Number.parseFloat(metaData.inwardSupplies.intraState.IGST).toFixed(2)
			pdfDoc.content[2].table.body[25][3].text = Number.parseFloat(metaData.inwardSupplies.intraState.CGST).toFixed(2)
			pdfDoc.content[2].table.body[25][4].text = Number.parseFloat(metaData.inwardSupplies.intraState.SGST).toFixed(2)
			pdfDoc.content[2].table.body[25][5].text = Number.parseFloat(metaData.inwardSupplies.intraState.CESS).toFixed(2)
			pdfDoc.content[2].table.body[25][6].text = Number.parseFloat(metaData.inwardSupplies.intraState.totalInvoiceAmount).toFixed(2)

			pdfDoc.content[2].table.body[26][1].text = Number.parseFloat(metaData.inwardSupplies.intraState.taxable.totalBaseAmount).toFixed(2)
			pdfDoc.content[2].table.body[26][2].text = Number.parseFloat(metaData.inwardSupplies.intraState.taxable.IGST).toFixed(2)
			pdfDoc.content[2].table.body[26][3].text = Number.parseFloat(metaData.inwardSupplies.intraState.taxable.CGST).toFixed(2)
			pdfDoc.content[2].table.body[26][4].text = Number.parseFloat(metaData.inwardSupplies.intraState.taxable.SGST).toFixed(2)
			pdfDoc.content[2].table.body[26][5].text = Number.parseFloat(metaData.inwardSupplies.intraState.taxable.CESS).toFixed(2)
			pdfDoc.content[2].table.body[26][6].text = Number.parseFloat(metaData.inwardSupplies.intraState.taxable.totalInvoiceAmount).toFixed(2)

			pdfDoc.content[2].table.body[27][1].text = Number.parseFloat(metaData.inwardSupplies.intraState.taxable.GST_3.totalBaseAmount).toFixed(2)
			pdfDoc.content[2].table.body[27][2].text = Number.parseFloat(metaData.inwardSupplies.intraState.taxable.GST_3.IGST).toFixed(2)
			pdfDoc.content[2].table.body[27][3].text = Number.parseFloat(metaData.inwardSupplies.intraState.taxable.GST_3.CGST).toFixed(2)
			pdfDoc.content[2].table.body[27][4].text = Number.parseFloat(metaData.inwardSupplies.intraState.taxable.GST_3.SGST).toFixed(2)
			pdfDoc.content[2].table.body[27][5].text = Number.parseFloat(metaData.inwardSupplies.intraState.taxable.GST_3.CESS).toFixed(2)
			pdfDoc.content[2].table.body[27][6].text = Number.parseFloat(metaData.inwardSupplies.intraState.taxable.GST_3.totalInvoiceAmount).toFixed(2)

			pdfDoc.content[2].table.body[28][1].text = Number.parseFloat(metaData.inwardSupplies.intraState.taxable.GST_5.totalBaseAmount).toFixed(2)
			pdfDoc.content[2].table.body[28][2].text = Number.parseFloat(metaData.inwardSupplies.intraState.taxable.GST_5.IGST).toFixed(2)
			pdfDoc.content[2].table.body[28][3].text = Number.parseFloat(metaData.inwardSupplies.intraState.taxable.GST_5.CGST).toFixed(2)
			pdfDoc.content[2].table.body[28][4].text = Number.parseFloat(metaData.inwardSupplies.intraState.taxable.GST_5.SGST).toFixed(2)
			pdfDoc.content[2].table.body[28][5].text = Number.parseFloat(metaData.inwardSupplies.intraState.taxable.GST_5.CESS).toFixed(2)
			pdfDoc.content[2].table.body[28][6].text = Number.parseFloat(metaData.inwardSupplies.intraState.taxable.GST_5.totalInvoiceAmount).toFixed(2)

			pdfDoc.content[2].table.body[29][1].text = Number.parseFloat(metaData.inwardSupplies.intraState.taxable.GST_12.totalBaseAmount).toFixed(2)
			pdfDoc.content[2].table.body[29][2].text = Number.parseFloat(metaData.inwardSupplies.intraState.taxable.GST_12.IGST).toFixed(2)
			pdfDoc.content[2].table.body[29][3].text = Number.parseFloat(metaData.inwardSupplies.intraState.taxable.GST_12.CGST).toFixed(2)
			pdfDoc.content[2].table.body[29][4].text = Number.parseFloat(metaData.inwardSupplies.intraState.taxable.GST_12.SGST).toFixed(2)
			pdfDoc.content[2].table.body[29][5].text = Number.parseFloat(metaData.inwardSupplies.intraState.taxable.GST_12.CESS).toFixed(2)
			pdfDoc.content[2].table.body[29][6].text = Number.parseFloat(metaData.inwardSupplies.intraState.taxable.GST_12.totalInvoiceAmount).toFixed(2)

			pdfDoc.content[2].table.body[30][1].text = Number.parseFloat(metaData.inwardSupplies.intraState.taxable.GST_18.totalBaseAmount).toFixed(2)
			pdfDoc.content[2].table.body[30][2].text = Number.parseFloat(metaData.inwardSupplies.intraState.taxable.GST_18.IGST).toFixed(2)
			pdfDoc.content[2].table.body[30][3].text = Number.parseFloat(metaData.inwardSupplies.intraState.taxable.GST_18.CGST).toFixed(2)
			pdfDoc.content[2].table.body[30][4].text = Number.parseFloat(metaData.inwardSupplies.intraState.taxable.GST_18.SGST).toFixed(2)
			pdfDoc.content[2].table.body[30][5].text = Number.parseFloat(metaData.inwardSupplies.intraState.taxable.GST_18.CESS).toFixed(2)
			pdfDoc.content[2].table.body[30][6].text = Number.parseFloat(metaData.inwardSupplies.intraState.taxable.GST_18.totalInvoiceAmount).toFixed(2)

			pdfDoc.content[2].table.body[31][1].text = Number.parseFloat(metaData.inwardSupplies.intraState.taxable.GST_28.totalBaseAmount).toFixed(2)
			pdfDoc.content[2].table.body[31][2].text = Number.parseFloat(metaData.inwardSupplies.intraState.taxable.GST_28.IGST).toFixed(2)
			pdfDoc.content[2].table.body[31][3].text = Number.parseFloat(metaData.inwardSupplies.intraState.taxable.GST_28.CGST).toFixed(2)
			pdfDoc.content[2].table.body[31][4].text = Number.parseFloat(metaData.inwardSupplies.intraState.taxable.GST_28.SGST).toFixed(2)
			pdfDoc.content[2].table.body[31][5].text = Number.parseFloat(metaData.inwardSupplies.intraState.taxable.GST_28.CESS).toFixed(2)
			pdfDoc.content[2].table.body[31][6].text = Number.parseFloat(metaData.inwardSupplies.intraState.taxable.GST_28.totalInvoiceAmount).toFixed(2)

			pdfDoc.content[2].table.body[32][1].text = Number.parseFloat(metaData.inwardSupplies.intraState.exempted.totalBaseAmount).toFixed(2)
			pdfDoc.content[2].table.body[32][2].text = Number.parseFloat(metaData.inwardSupplies.intraState.exempted.IGST).toFixed(2)
			pdfDoc.content[2].table.body[32][3].text = Number.parseFloat(metaData.inwardSupplies.intraState.exempted.CGST).toFixed(2)
			pdfDoc.content[2].table.body[32][4].text = Number.parseFloat(metaData.inwardSupplies.intraState.exempted.SGST).toFixed(2)
			pdfDoc.content[2].table.body[32][5].text = Number.parseFloat(metaData.inwardSupplies.intraState.exempted.CESS).toFixed(2)
			pdfDoc.content[2].table.body[32][6].text = Number.parseFloat(metaData.inwardSupplies.intraState.exempted.totalInvoiceAmount).toFixed(2)

			pdfDoc.content[2].table.body[33][1].text = Number.parseFloat(metaData.inwardSupplies.intraState.nillrated.totalBaseAmount).toFixed(2)
			pdfDoc.content[2].table.body[33][2].text = Number.parseFloat(metaData.inwardSupplies.intraState.nillrated.IGST).toFixed(2)
			pdfDoc.content[2].table.body[33][3].text = Number.parseFloat(metaData.inwardSupplies.intraState.nillrated.CGST).toFixed(2)
			pdfDoc.content[2].table.body[33][4].text = Number.parseFloat(metaData.inwardSupplies.intraState.nillrated.SGST).toFixed(2)
			pdfDoc.content[2].table.body[33][5].text = Number.parseFloat(metaData.inwardSupplies.intraState.nillrated.CESS).toFixed(2)
			pdfDoc.content[2].table.body[33][6].text = Number.parseFloat(metaData.inwardSupplies.intraState.nillrated.totalInvoiceAmount).toFixed(2)

			pdfDoc.content[2].table.body[34][1].text = Number.parseFloat(metaData.inwardSupplies.intraState.others.totalBaseAmount).toFixed(2)
			pdfDoc.content[2].table.body[34][2].text = Number.parseFloat(metaData.inwardSupplies.intraState.others.IGST).toFixed(2)
			pdfDoc.content[2].table.body[34][3].text = Number.parseFloat(metaData.inwardSupplies.intraState.others.CGST).toFixed(2)
			pdfDoc.content[2].table.body[34][4].text = Number.parseFloat(metaData.inwardSupplies.intraState.others.SGST).toFixed(2)
			pdfDoc.content[2].table.body[34][5].text = Number.parseFloat(metaData.inwardSupplies.intraState.others.CESS).toFixed(2)
			pdfDoc.content[2].table.body[34][6].text = Number.parseFloat(metaData.inwardSupplies.intraState.others.totalInvoiceAmount).toFixed(2)

			pdfDoc.content[2].table.body[35][1].text = Number.parseFloat(metaData.inwardSupplies.interState.totalBaseAmount).toFixed(2)
			pdfDoc.content[2].table.body[35][2].text = Number.parseFloat(metaData.inwardSupplies.interState.IGST).toFixed(2)
			pdfDoc.content[2].table.body[35][3].text = Number.parseFloat(metaData.inwardSupplies.interState.CGST).toFixed(2)
			pdfDoc.content[2].table.body[35][4].text = Number.parseFloat(metaData.inwardSupplies.interState.SGST).toFixed(2)
			pdfDoc.content[2].table.body[35][5].text = Number.parseFloat(metaData.inwardSupplies.interState.CESS).toFixed(2)
			pdfDoc.content[2].table.body[35][6].text = Number.parseFloat(metaData.inwardSupplies.interState.totalInvoiceAmount).toFixed(2)

			pdfDoc.content[2].table.body[36][1].text = Number.parseFloat(metaData.inwardSupplies.interState.taxable.totalBaseAmount).toFixed(2)
			pdfDoc.content[2].table.body[36][2].text = Number.parseFloat(metaData.inwardSupplies.interState.taxable.IGST).toFixed(2)
			pdfDoc.content[2].table.body[36][3].text = Number.parseFloat(metaData.inwardSupplies.interState.taxable.CGST).toFixed(2)
			pdfDoc.content[2].table.body[36][4].text = Number.parseFloat(metaData.inwardSupplies.interState.taxable.SGST).toFixed(2)
			pdfDoc.content[2].table.body[36][5].text = Number.parseFloat(metaData.inwardSupplies.interState.taxable.CESS).toFixed(2)
			pdfDoc.content[2].table.body[36][6].text = Number.parseFloat(metaData.inwardSupplies.interState.taxable.totalInvoiceAmount).toFixed(2)

			pdfDoc.content[2].table.body[37][1].text = Number.parseFloat(metaData.inwardSupplies.interState.taxable.GST_3.totalBaseAmount).toFixed(2)
			pdfDoc.content[2].table.body[37][2].text = Number.parseFloat(metaData.inwardSupplies.interState.taxable.GST_3.IGST).toFixed(2)
			pdfDoc.content[2].table.body[37][3].text = Number.parseFloat(metaData.inwardSupplies.interState.taxable.GST_3.CGST).toFixed(2)
			pdfDoc.content[2].table.body[37][4].text = Number.parseFloat(metaData.inwardSupplies.interState.taxable.GST_3.SGST).toFixed(2)
			pdfDoc.content[2].table.body[37][5].text = Number.parseFloat(metaData.inwardSupplies.interState.taxable.GST_3.CESS).toFixed(2)
			pdfDoc.content[2].table.body[37][6].text = Number.parseFloat(metaData.inwardSupplies.interState.taxable.GST_3.totalInvoiceAmount).toFixed(2)

			pdfDoc.content[2].table.body[38][1].text = Number.parseFloat(metaData.inwardSupplies.interState.taxable.GST_5.totalBaseAmount).toFixed(2)
			pdfDoc.content[2].table.body[38][2].text = Number.parseFloat(metaData.inwardSupplies.interState.taxable.GST_5.IGST).toFixed(2)
			pdfDoc.content[2].table.body[38][3].text = Number.parseFloat(metaData.inwardSupplies.interState.taxable.GST_5.CGST).toFixed(2)
			pdfDoc.content[2].table.body[38][4].text = Number.parseFloat(metaData.inwardSupplies.interState.taxable.GST_5.SGST).toFixed(2)
			pdfDoc.content[2].table.body[38][5].text = Number.parseFloat(metaData.inwardSupplies.interState.taxable.GST_5.CESS).toFixed(2)
			pdfDoc.content[2].table.body[38][6].text = Number.parseFloat(metaData.inwardSupplies.interState.taxable.GST_5.totalInvoiceAmount).toFixed(2)

			pdfDoc.content[2].table.body[39][1].text = Number.parseFloat(metaData.inwardSupplies.interState.taxable.GST_12.totalBaseAmount).toFixed(2)
			pdfDoc.content[2].table.body[39][2].text = Number.parseFloat(metaData.inwardSupplies.interState.taxable.GST_12.IGST).toFixed(2)
			pdfDoc.content[2].table.body[39][3].text = Number.parseFloat(metaData.inwardSupplies.interState.taxable.GST_12.CGST).toFixed(2)
			pdfDoc.content[2].table.body[39][4].text = Number.parseFloat(metaData.inwardSupplies.interState.taxable.GST_12.SGST).toFixed(2)
			pdfDoc.content[2].table.body[39][5].text = Number.parseFloat(metaData.inwardSupplies.interState.taxable.GST_12.CESS).toFixed(2)
			pdfDoc.content[2].table.body[39][6].text = Number.parseFloat(metaData.inwardSupplies.interState.taxable.GST_12.totalInvoiceAmount).toFixed(2)

			pdfDoc.content[2].table.body[40][1].text = Number.parseFloat(metaData.inwardSupplies.interState.taxable.GST_18.totalBaseAmount).toFixed(2)
			pdfDoc.content[2].table.body[40][2].text = Number.parseFloat(metaData.inwardSupplies.interState.taxable.GST_18.IGST).toFixed(2)
			pdfDoc.content[2].table.body[40][3].text = Number.parseFloat(metaData.inwardSupplies.interState.taxable.GST_18.CGST).toFixed(2)
			pdfDoc.content[2].table.body[40][4].text = Number.parseFloat(metaData.inwardSupplies.interState.taxable.GST_18.SGST).toFixed(2)
			pdfDoc.content[2].table.body[40][5].text = Number.parseFloat(metaData.inwardSupplies.interState.taxable.GST_18.CESS).toFixed(2)
			pdfDoc.content[2].table.body[40][6].text = Number.parseFloat(metaData.inwardSupplies.interState.taxable.GST_18.totalInvoiceAmount).toFixed(2)

			pdfDoc.content[2].table.body[41][1].text = Number.parseFloat(metaData.inwardSupplies.interState.taxable.GST_28.totalBaseAmount).toFixed(2)
			pdfDoc.content[2].table.body[41][2].text = Number.parseFloat(metaData.inwardSupplies.interState.taxable.GST_28.IGST).toFixed(2)
			pdfDoc.content[2].table.body[41][3].text = Number.parseFloat(metaData.inwardSupplies.interState.taxable.GST_28.CGST).toFixed(2)
			pdfDoc.content[2].table.body[41][4].text = Number.parseFloat(metaData.inwardSupplies.interState.taxable.GST_28.SGST).toFixed(2)
			pdfDoc.content[2].table.body[41][5].text = Number.parseFloat(metaData.inwardSupplies.interState.taxable.GST_28.CESS).toFixed(2)
			pdfDoc.content[2].table.body[41][6].text = Number.parseFloat(metaData.inwardSupplies.interState.taxable.GST_28.totalInvoiceAmount).toFixed(2)

			pdfDoc.content[2].table.body[42][1].text = Number.parseFloat(metaData.inwardSupplies.interState.exempted.totalBaseAmount).toFixed(2)
			pdfDoc.content[2].table.body[42][2].text = Number.parseFloat(metaData.inwardSupplies.interState.exempted.IGST).toFixed(2)
			pdfDoc.content[2].table.body[42][3].text = Number.parseFloat(metaData.inwardSupplies.interState.exempted.CGST).toFixed(2)
			pdfDoc.content[2].table.body[42][4].text = Number.parseFloat(metaData.inwardSupplies.interState.exempted.SGST).toFixed(2)
			pdfDoc.content[2].table.body[42][5].text = Number.parseFloat(metaData.inwardSupplies.interState.exempted.CESS).toFixed(2)
			pdfDoc.content[2].table.body[42][6].text = Number.parseFloat(metaData.inwardSupplies.interState.exempted.totalInvoiceAmount).toFixed(2)

			pdfDoc.content[2].table.body[43][1].text = Number.parseFloat(metaData.inwardSupplies.interState.nillrated.totalBaseAmount).toFixed(2)
			pdfDoc.content[2].table.body[43][2].text = Number.parseFloat(metaData.inwardSupplies.interState.nillrated.IGST).toFixed(2)
			pdfDoc.content[2].table.body[43][3].text = Number.parseFloat(metaData.inwardSupplies.interState.nillrated.CGST).toFixed(2)
			pdfDoc.content[2].table.body[43][4].text = Number.parseFloat(metaData.inwardSupplies.interState.nillrated.SGST).toFixed(2)
			pdfDoc.content[2].table.body[43][5].text = Number.parseFloat(metaData.inwardSupplies.interState.nillrated.CESS).toFixed(2)
			pdfDoc.content[2].table.body[43][6].text = Number.parseFloat(metaData.inwardSupplies.interState.nillrated.totalInvoiceAmount).toFixed(2)

			pdfDoc.content[2].table.body[44][1].text = Number.parseFloat(metaData.inwardSupplies.interState.others.totalBaseAmount).toFixed(2)
			pdfDoc.content[2].table.body[44][2].text = Number.parseFloat(metaData.inwardSupplies.interState.others.IGST).toFixed(2)
			pdfDoc.content[2].table.body[44][3].text = Number.parseFloat(metaData.inwardSupplies.interState.others.CGST).toFixed(2)
			pdfDoc.content[2].table.body[44][4].text = Number.parseFloat(metaData.inwardSupplies.interState.others.SGST).toFixed(2)
			pdfDoc.content[2].table.body[44][5].text = Number.parseFloat(metaData.inwardSupplies.interState.others.CESS).toFixed(2)
			pdfDoc.content[2].table.body[44][6].text = Number.parseFloat(metaData.inwardSupplies.interState.others.totalInvoiceAmount).toFixed(2)


			//gst3
			pdfDoc.content[3].table.body[3][2].text = '-'
			pdfDoc.content[3].table.body[3][3].text = Number.parseFloat(metaData.inwardSupplies.totalBaseAmount + metaData.outwardSupplies.totalBaseAmount).toFixed(2)
			pdfDoc.content[3].table.body[3][4].text = Number.parseFloat(metaData.inwardSupplies.IGST + metaData.outwardSupplies.IGST).toFixed(2)
			pdfDoc.content[3].table.body[3][5].text = Number.parseFloat(metaData.inwardSupplies.CGST + metaData.outwardSupplies.CGST).toFixed(2)
			pdfDoc.content[3].table.body[3][6].text = Number.parseFloat(metaData.inwardSupplies.SGST + metaData.outwardSupplies.SGST).toFixed(2)
			pdfDoc.content[3].table.body[3][7].text = Number.parseFloat(metaData.inwardSupplies.CESS + metaData.outwardSupplies.CESS).toFixed(2)
			pdfDoc.content[3].table.body[3][8].text = Number.parseFloat(metaData.inwardSupplies.totalInvoiceAmount + metaData.outwardSupplies.totalInvoiceAmount).toFixed(2)

			pdfDoc.content[3].table.body[4][2].text = '-'
			pdfDoc.content[3].table.body[4][3].text = Number.parseFloat(metaData.outwardSupplies.interState.taxable.totalBaseAmount + metaData.outwardSupplies.intraState.taxable.totalBaseAmount + metaData.inwardSupplies.interState.taxable.totalBaseAmount + metaData.inwardSupplies.intraState.taxable.totalBaseAmount).toFixed(2)
			pdfDoc.content[3].table.body[4][4].text = Number.parseFloat(metaData.outwardSupplies.interState.taxable.IGST + metaData.outwardSupplies.intraState.taxable.IGST + metaData.inwardSupplies.interState.taxable.IGST + metaData.inwardSupplies.intraState.taxable.IGST).toFixed(2)
			pdfDoc.content[3].table.body[4][5].text = Number.parseFloat(metaData.outwardSupplies.interState.taxable.CGST + metaData.outwardSupplies.intraState.taxable.CGST + metaData.inwardSupplies.interState.taxable.CGST + metaData.inwardSupplies.intraState.taxable.CGST).toFixed(2)
			pdfDoc.content[3].table.body[4][6].text = Number.parseFloat(metaData.outwardSupplies.interState.taxable.SGST + metaData.outwardSupplies.intraState.taxable.SGST + metaData.inwardSupplies.interState.taxable.SGST + metaData.inwardSupplies.intraState.taxable.SGST).toFixed(2)
			pdfDoc.content[3].table.body[4][7].text = Number.parseFloat(metaData.outwardSupplies.interState.taxable.CESS + metaData.outwardSupplies.intraState.taxable.CESS + metaData.inwardSupplies.interState.taxable.CESS + metaData.inwardSupplies.intraState.taxable.CESS).toFixed(2)
			pdfDoc.content[3].table.body[4][8].text = Number.parseFloat(metaData.outwardSupplies.interState.taxable.totalInvoiceAmount + metaData.outwardSupplies.intraState.taxable.totalInvoiceAmount + metaData.inwardSupplies.interState.taxable.totalInvoiceAmount + metaData.inwardSupplies.intraState.taxable.totalInvoiceAmount).toFixed(2)

			pdfDoc.content[3].table.body[5][2].text = '-'
			pdfDoc.content[3].table.body[5][3].text = Number.parseFloat(metaData.outwardSupplies.interState.nillrated.totalBaseAmount + metaData.outwardSupplies.intraState.nillrated.totalBaseAmount).toFixed(2)
			pdfDoc.content[3].table.body[5][4].text = Number.parseFloat(metaData.outwardSupplies.interState.nillrated.IGST + metaData.outwardSupplies.intraState.nillrated.IGST).toFixed(2)
			pdfDoc.content[3].table.body[5][5].text = Number.parseFloat(metaData.outwardSupplies.interState.nillrated.CGST + metaData.outwardSupplies.intraState.nillrated.CGST).toFixed(2)
			pdfDoc.content[3].table.body[5][6].text = Number.parseFloat(metaData.outwardSupplies.interState.nillrated.SGST + metaData.outwardSupplies.intraState.nillrated.SGST).toFixed(2)
			pdfDoc.content[3].table.body[5][7].text = Number.parseFloat(metaData.outwardSupplies.interState.nillrated.CESS + metaData.outwardSupplies.intraState.nillrated.CESS).toFixed(2)
			pdfDoc.content[3].table.body[5][8].text = Number.parseFloat(metaData.outwardSupplies.interState.nillrated.totalInvoiceAmount + metaData.outwardSupplies.intraState.nillrated.totalInvoiceAmount).toFixed(2)

			pdfDoc.content[3].table.body[6][2].text = '-'
			pdfDoc.content[3].table.body[6][3].text = Number.parseFloat(metaData.outwardSupplies.interState.exempted.totalBaseAmount + metaData.outwardSupplies.intraState.exempted.totalBaseAmount).toFixed(2)
			pdfDoc.content[3].table.body[6][4].text = Number.parseFloat(metaData.outwardSupplies.interState.exempted.IGST + metaData.outwardSupplies.intraState.exempted.IGST).toFixed(2)
			pdfDoc.content[3].table.body[6][5].text = Number.parseFloat(metaData.outwardSupplies.interState.exempted.CGST + metaData.outwardSupplies.intraState.exempted.CGST).toFixed(2)
			pdfDoc.content[3].table.body[6][6].text = Number.parseFloat(metaData.outwardSupplies.interState.exempted.SGST + metaData.outwardSupplies.intraState.exempted.SGST).toFixed(2)
			pdfDoc.content[3].table.body[6][7].text = Number.parseFloat(metaData.outwardSupplies.interState.exempted.CESS + metaData.outwardSupplies.intraState.exempted.CESS).toFixed(2)
			pdfDoc.content[3].table.body[6][8].text = Number.parseFloat(metaData.outwardSupplies.interState.exempted.totalInvoiceAmount + metaData.outwardSupplies.intraState.exempted.totalInvoiceAmount).toFixed(2)

			pdfDoc.content[3].table.body[8][2].text = '-'
			pdfDoc.content[3].table.body[8][3].text = Number.parseFloat(metaData.outwardSupplies.interState.others.totalBaseAmount + metaData.outwardSupplies.intraState.others.totalBaseAmount).toFixed(2)
			pdfDoc.content[3].table.body[8][4].text = Number.parseFloat(metaData.outwardSupplies.interState.others.IGST + metaData.outwardSupplies.intraState.others.IGST).toFixed(2)
			pdfDoc.content[3].table.body[8][5].text = Number.parseFloat(metaData.outwardSupplies.interState.others.CGST + metaData.outwardSupplies.intraState.others.CGST).toFixed(2)
			pdfDoc.content[3].table.body[8][6].text = Number.parseFloat(metaData.outwardSupplies.interState.others.SGST + metaData.outwardSupplies.intraState.others.SGST).toFixed(2)
			pdfDoc.content[3].table.body[8][7].text = Number.parseFloat(metaData.outwardSupplies.interState.others.CESS + metaData.outwardSupplies.intraState.others.CESS).toFixed(2)
			pdfDoc.content[3].table.body[8][8].text = Number.parseFloat(metaData.outwardSupplies.interState.others.totalInvoiceAmount + metaData.outwardSupplies.intraState.others.totalInvoiceAmount).toFixed(2)

			return pdfDoc;
		}

		export const buyerStatement = (metaData) => {
			let pdfDoc = {
				content: [
					{ text: 'Statement\n\n', style: "bigger" },
					{
						table: {
							widths: ['60%', '40%'],
							body: [
								[
									{ text: 'CUSTOMER DETAILS', style: "topHeader" },
									{ text: 'FIRM DETAILS', style: "topHeader" },
								],
								[
									{
										text:
											[
												{ text: '         ', bold: true },
												{ text: 'Google\n' },
												{ text: '                 ', bold: true },
												{ text: '123456\n' },
												{ text: '                 ', bold: true },
												{ text: '123456\n' },
												{ text: '                   ', bold: true },
												{ text: '1600 Amphitheatre Parkway in Mountain View, California, United States, near San Jose. \n' },
												{ text: ' 		  ', bold: true },
												{ text: '88776655\n' },
												// { text: 'PAN No:-               ', bold: true },
												// { text: '123456\n' },
												// { text: 'Email:-              ', bold: true },
												// { text: 'njnjn@jnn.com\n' },
												// { text: 'Website:-               ', bold: true },
												// { text: 'www.123456.com\n' },
											]
									},
									{
										text:
											[
												{ text: '                ', bold: true },
												{ text: 'Google\n' },
												{ text: '                ', bold: true },
												{ text: 'GSTIN\n' },
												{ text: '                 ', bold: true },
												{ text: '123456\n' },
												{ text: '                ', bold: true },
												{ text: '7788996655\n' },
												{ text: '                ', bold: true },
												{ text: '1679905\n' },
												// { text: 'State Code:-       ', bold: true },
												// { text: '23\n' },
											]
									},
								],
							]
						}
					},
					{
						table: {
							body: [
								[
									{ text: 'TRANSACTION SUMMARY', style: "topHeader", colSpan: 8 },
									{ text: '', style: "topHeader" },
									{ text: '', style: "topHeader" },
									{ text: '', style: "topHeader" },
									{ text: '', style: "topHeader" },
									{ text: '', style: "topHeader" },
									{ text: '', style: "topHeader" },
									{ text: '', style: "topHeader" },
								],
								[
									{ text: 'From Date', style: "header", colSpan: 2 },
									{ text: '', style: "header" },
									{ text: '22/3/20', colSpan: 2, style: "header" },
									{ text: '', style: "header" },
									{ text: 'To Date', colSpan: 2, style: "header" },
									{ text: '', style: "header" },
									{ text: '22/3/20', colSpan: 2, style: "header" },
									{ text: '', style: "header" },
								],
								[
									{ text: 'Date', style: "gstHeader" },
									// { text: 'Invoice Key', style: "gstHeader"},
									{ text: 'Invoice Id', style: "gstHeader" },
									{ text: 'Debit', style: "gstHeader" },
									{ text: 'Credit', style: "gstHeader" },
									{ text: 'Balance', style: "gstHeader" },
									{ text: 'Payment', style: "gstHeader" },
									{ text: 'Voucher', style: "gstHeader" },
									{ text: 'Remark', style: "gstHeader" }
								],
							]
						}
					},
				],
				footer: {
					columns: [
						{
							text: 'Powered By ACUIFY',
							alignment: 'right',
							color: '#160091'
						}
					],
					margin: [10, 10]
				},
				styles: {
					header: {
						fontSize: 14,
						bold: true,
						alignment: 'center'
					},
					topHeader: {
						color: 'white',
						fontSize: 12,
						alignment: 'center',
						bold: true,
						fillColor: '#15155d',
					},
					gstHeader: {
						fontSize: 13,
						bold: true,
						alignment: 'center'
					},
					Header2: {
						fontSize: 12,
						bold: true,
						alignment: 'center'
					},
					Header3: {
						fontSize: 11,
						bold: true,
						alignment: 'center'
					},
					Header4: {
						fontSize: 10,
						alignment: 'center'
					},
					gstData: {
						fontSize: 9,
						alignment: 'center',
					},
					gstData1: {
						fontSize: 9,
						alignment: 'center',
						color: '#15155d',
						bold: true,
					},
					gstData2: {
						fontSize: 9,
						alignment: 'center',
						color: '#B71C1C',
						bold: true,
					},
					gstData3: {
						fontSize: 9,
						alignment: 'center',
						color: '#43A047',
						bold: true,
					},
					bigger: {
						fontSize: 18,
						bold: true,
						alignment: 'center',
						decoration: 'underline',
						decorationStyle: 'solid',
						color: '#15155d'
					}
				}
			}
			//Firm Details 
			pdfDoc.content[1].table.body[1][1].text[1].text = (metaData.firm.name ? metaData.firm.name : '') + "\n";
			pdfDoc.content[1].table.body[1][1].text[3].text = (metaData.firm.GST_number ? metaData.firm.GST_number : '') + "\n";
			pdfDoc.content[1].table.body[1][1].text[5].text = (metaData.customer.address ? metaData.customer.localAddress : '') + "\n";
			pdfDoc.content[1].table.body[1][1].text[7].text = (metaData.firm.address ? metaData.firm.address : '') + "\n";
			pdfDoc.content[1].table.body[1][1].text[9].text = (metaData.firm.mobileNumber ? metaData.firm.mobileNumber : '') + "\n";
			// pdfDoc.content[1].table.body[1][0].text[7].text = (metaData.firm.panNumber ? metaData.firm.panNumber : '') + "\n";
			// pdfDoc.content[1].table.body[1][0].text[11].text = (metaData.firm.email ? metaData.firm.email : '') + "\n";
			// pdfDoc.content[1].table.body[1][0].text[13].text = (metaData.firm.website ? metaData.firm.website : '') + "\n";		

			//Receipient Details
			pdfDoc.content[1].table.body[1][0].text[1].text = (metaData.customer.name ? metaData.customer.name : '') + "\n";
			pdfDoc.content[1].table.body[1][0].text[3].text = (metaData.customer.GST_number ? metaData.customer.GST_number : '') + "\n";
			pdfDoc.content[1].table.body[1][0].text[5].text = (metaData.customer.address ? metaData.customer.localAddress : '') + "\n";
			pdfDoc.content[1].table.body[1][0].text[7].text = (metaData.customer.address ? metaData.customer.address : '') + "\n";
			pdfDoc.content[1].table.body[1][0].text[9].text = (metaData.customer.mobile ? metaData.customer.mobile : '') + "\n";
			// pdfDoc.content[1].table.body[1][1].text[9].text = (metaData.customer.stateCode ? metaData.customer.stateCode : '') + "\n";

			//from Date
			pdfDoc.content[2].table.body[1][2].text = metaData.fromDate ? new Date(metaData.fromDate).toLocaleDateString('en-GB') : '';

			//to Date
			pdfDoc.content[2].table.body[1][6].text = metaData.toDate ? new Date(metaData.toDate).toLocaleDateString('en-GB') : '';

			function getVocherType(invoice) {
				if (invoice.return) {
					if (invoice.isBuyer) {
						return "Credit Note";
					} else {
						return "Debit Note";
					}
				}
				else if (invoice.transactionType != "Debit" && invoice["type"] === "Advance" || invoice["type"] === "Opening Balance" || invoice["type"] === "Loan" || invoice["type"] === "Security") {
					return invoice["type"];
				}
				else if (invoice.isBuyer && invoice.transactionType === "Debit") {
					return "Sale";
				}
				else if (invoice.isBuyer && invoice.transactionType === "Credit" || !invoice.isBuyer && invoice.transactionType === "Credit") {
					return "Receipt";
				}
				else if (!invoice.isBuyer && invoice.transactionType === "Debit") {
					return "Purchase";
				}
				else if (!invoice.isBuyer && invoice.transactionType === "Credit" || !invoice.isBuyer && invoice.transactionType === "Credit") {
					return "Payment";
				}
			}
			//invoices 
			metaData.invoices.map((invoice) => {
				pdfDoc.content[2].table.body.push([
					// { text: new Date(invoice.date).toLocaleDateString('en-GB'), style: "gstData1" },
					// { text: invoice['.key'], style: "gstData" },
					{ text: invoice.date == 'Total' ? "Total" : new Date(invoice.date).toLocaleDateString('en-GB'), style: "gstData1" },
					{ text: invoice['invoiceId'], style: "gstData" },
					{ text: Number.parseFloat(invoice['debit']).toFixed(2), style: "gstData3" },
					{ text: Number.parseFloat(invoice['credit']).toFixed(2), style: "gstData1" },
					{ text: Number.parseFloat(invoice['RunningBal']).toFixed(2), style: "gstData2" },
					{ text: invoice['paymentType'], style: "gstData" },
					{ text: getVocherType(invoice), style: "gstData" },
					{ text: invoice['remark'], style: "gstData" },
				])
			})
			return pdfDoc;
		}
		
		// Start of Detailed Buyer Statement
		export const buyerStatementDetailed = (metaData) => {
			let pdfDoc = {
				content: [
					{ text: 'Statement\n\n', style: "bigger" },
					{
						table: {
							widths: ['60%', '40%'],
							body: [
								[
									{ text: 'CUSTOMER DETAILS', style: "topHeader" },
									{ text: 'FIRM DETAILS', style: "topHeader" },
								],
								[
									{
										text:
											[
												{ text: '         ', bold: true },
												{ text: 'Google\n' },
												{ text: '                 ', bold: true },
												{ text: '123456\n' },
												{ text: '                 ', bold: true },
												{ text: '123456\n' },
												{ text: '                   ', bold: true },
												{ text: '1600 Amphitheatre Parkway in Mountain View, California, United States, near San Jose. \n' },
												{ text: ' 		  ', bold: true },
												{ text: '88776655\n' },
												// { text: 'PAN No:-               ', bold: true },
												// { text: '123456\n' },
												// { text: 'Email:-              ', bold: true },
												// { text: 'njnjn@jnn.com\n' },
												// { text: 'Website:-               ', bold: true },
												// { text: 'www.123456.com\n' },
											]
									},
									{
										text:
											[
												{ text: '                ', bold: true },
												{ text: 'Google\n' },
												{ text: '                ', bold: true },
												{ text: 'GSTIN\n' },
												{ text: '                 ', bold: true },
												{ text: '123456\n' },
												{ text: '                ', bold: true },
												{ text: '7788996655\n' },
												{ text: '                ', bold: true },
												{ text: '1679905\n' },
												// { text: 'State Code:-       ', bold: true },
												// { text: '23\n' },
											]
									},
								],
							]
						}
					},
					{
						table: {
							body: [
								[
									{ text: 'TRANSACTION SUMMARY', style: "topHeader", colSpan: 8 },
									{ text: '', style: "topHeader" },
									{ text: '', style: "topHeader" },
									{ text: '', style: "topHeader" },
									{ text: '', style: "topHeader" },
									{ text: '', style: "topHeader" },
									{ text: '', style: "topHeader" },
									{ text: '', style: "topHeader" },
								],
								[
									{ text: 'From Date', style: "header", colSpan: 2 },
									{ text: '', style: "header" },
									{ text: '22/3/20', colSpan: 2, style: "header" },
									{ text: '', style: "header" },
									{ text: 'To Date', colSpan: 2, style: "header" },
									{ text: '', style: "header" },
									{ text: '22/3/20', colSpan: 2, style: "header" },
									{ text: '', style: "header" },
								],
								[
									{ text: 'Date', style: "gstHeader" },
									// { text: 'Invoice Key', style: "gstHeader"},
									{ text: 'Invoice Id', style: "gstHeader" },
									{ text: 'Debit', style: "gstHeader" },
									{ text: 'Credit', style: "gstHeader" },
									{ text: 'Balance', style: "gstHeader" },
									{ text: 'Payment', style: "gstHeader" },
									{ text: 'Voucher', style: "gstHeader" },
									{ text: 'Remark', style: "gstHeader" }
								],
							]
						}
					},
				],
				footer: {
					columns: [
						{
							text: 'Powered By ACUIFY',
							alignment: 'right',
							color: '#160091'
						}
					],
					margin: [10, 10]
				},
				styles: {
					header: {
						fontSize: 14,
						bold: true,
						alignment: 'center'
					},
					topHeader: {
						color: 'white',
						fontSize: 12,
						alignment: 'center',
						bold: true,
						fillColor: '#15155d',
					},
					topHeaderSmall: {
						fontSize: 7,
						alignment: 'center',
						bold: true,
					},
					gstHeader: {
						fontSize: 13,
						bold: true,
						alignment: 'center'
					},
					Header2: {
						fontSize: 12,
						bold: true,
						alignment: 'center'
					},
					Header3: {
						fontSize: 11,
						bold: true,
						alignment: 'center'
					},
					Header4: {
						fontSize: 10,
						alignment: 'center'
					},
					gstData: {
						fontSize: 9,
						alignment: 'center',
						fillColor: '#808080',
					},
					gstDataSmall: {
						fontSize: 7,
						alignment: 'center',
					},
					gstData1: {
						fontSize: 9,
						alignment: 'center',
						color: '#15155d',
						bold: true,
						fillColor: '#808080',
					},
					gstData2: {
						fontSize: 9,
						alignment: 'center',
						color: '#B71C1C',
						bold: true,
						fillColor: '#808080',
					},
					gstData3: {
						fontSize: 9,
						alignment: 'center',
						color: '#00FF00',
						bold: true,
						fillColor: '#808080',
					},
					bigger: {
						fontSize: 18,
						bold: true,
						alignment: 'center',
						decoration: 'underline',
						decorationStyle: 'solid',
						color: '#15155d'
					}
				}
			}
			//Firm Details 
			pdfDoc.content[1].table.body[1][1].text[1].text = (metaData.firm.name ? metaData.firm.name : '') + "\n";
			pdfDoc.content[1].table.body[1][1].text[3].text = (metaData.firm.GST_number ? metaData.firm.GST_number : '') + "\n";
			pdfDoc.content[1].table.body[1][1].text[5].text = (metaData.customer.address ? metaData.customer.localAddress : '') + "\n";
			pdfDoc.content[1].table.body[1][1].text[7].text = (metaData.firm.address ? metaData.firm.address : '') + "\n";
			pdfDoc.content[1].table.body[1][1].text[9].text = (metaData.firm.mobileNumber ? metaData.firm.mobileNumber : '') + "\n";
			// pdfDoc.content[1].table.body[1][0].text[7].text = (metaData.firm.panNumber ? metaData.firm.panNumber : '') + "\n";
			// pdfDoc.content[1].table.body[1][0].text[11].text = (metaData.firm.email ? metaData.firm.email : '') + "\n";
			// pdfDoc.content[1].table.body[1][0].text[13].text = (metaData.firm.website ? metaData.firm.website : '') + "\n";		

			//Receipient Details
			pdfDoc.content[1].table.body[1][0].text[1].text = (metaData.customer.name ? metaData.customer.name : '') + "\n";
			pdfDoc.content[1].table.body[1][0].text[3].text = (metaData.customer.GST_number ? metaData.customer.GST_number : '') + "\n";
			pdfDoc.content[1].table.body[1][0].text[5].text = (metaData.customer.address ? metaData.customer.localAddress : '') + "\n";
			pdfDoc.content[1].table.body[1][0].text[7].text = (metaData.customer.address ? metaData.customer.address : '') + "\n";
			pdfDoc.content[1].table.body[1][0].text[9].text = (metaData.customer.mobile ? metaData.customer.mobile : '') + "\n";
			// pdfDoc.content[1].table.body[1][1].text[9].text = (metaData.customer.stateCode ? metaData.customer.stateCode : '') + "\n";

			//from Date
			pdfDoc.content[2].table.body[1][2].text = metaData.fromDate ? new Date(metaData.fromDate).toLocaleDateString('en-GB') : '';

			//to Date
			pdfDoc.content[2].table.body[1][6].text = metaData.toDate ? new Date(metaData.toDate).toLocaleDateString('en-GB') : '';

			function getVocherType(invoice) {
				if (invoice.return) {
					if (invoice.isBuyer) {
						return "Credit Note";
					} else {
						return "Debit Note";
					}
				}
				else if (invoice.transactionType != "Debit" && invoice["type"] === "Advance" || invoice["type"] === "Opening Balance" || invoice["type"] === "Loan" || invoice["type"] === "Security") {
					return invoice["type"];
				}
				else if (invoice.isBuyer && invoice.transactionType === "Debit") {
					return "Sale";
				}
				else if (invoice.isBuyer && invoice.transactionType === "Credit" || !invoice.isBuyer && invoice.transactionType === "Credit") {
					return "Receipt";
				}
				else if (!invoice.isBuyer && invoice.transactionType === "Debit") {
					return "Purchase";
				}
				else if (!invoice.isBuyer && invoice.transactionType === "Credit" || !invoice.isBuyer && invoice.transactionType === "Credit") {
					return "Payment";
				}
			}
			//invoices 
			metaData.invoices.map((invoice) => {
				pdfDoc.content[2].table.body.push([
					// { text: new Date(invoice.date).toLocaleDateString('en-GB'), style: "gstData1" },
					// { text: invoice['.key'], style: "gstData" },
					{ text: invoice.date == 'Total' ? "Total" : new Date(invoice.date).toLocaleDateString('en-GB'), style: "gstData1" },
					{ text: invoice['invoiceId'], style: "gstData" },
					{ text: Number.parseFloat(invoice['debit']).toFixed(2), style: "gstData3" },
					{ text: Number.parseFloat(invoice['credit']).toFixed(2), style: "gstData1" },
					{ text: Number.parseFloat(invoice['RunningBal']).toFixed(2), style: "gstData2" },
					{ text: invoice['paymentType'], style: "gstData" },
					{ text: getVocherType(invoice), style: "gstData" },
					{ text: invoice['remark'], style: "gstData" },
				])
				if(invoice.items && invoice.items.length) {
									pdfDoc.content[2].table.body.push([
										{ text: "Product Name", style: "topHeaderSmall" ,colSpan: 2},
										{ text: "", style: "gstDataSmall" },
										// { text: invoice['.key'], style: "gstData" },
										{ text: "HSN", style: "topHeaderSmall",colSpan: 2 },
										{ text: "Taxable Rate", style: "topHeaderSmall" },
										{ text: "Unit", style: "topHeaderSmall" },
										{ text: "Quantity", style: "topHeaderSmall" },
										{ text: "Fat", style: "gstDataSmall" },
										{ text: "Rate", style: "topHeaderSmall" },
				
									])
									invoice.items.map((item)=>{
										pdfDoc.content[2].table.body.push([
											{ text: item.productName, style: "gstDataSmall" ,colSpan: 2},
											{ text: item['taxableGST_rate'], style: "gstDataSmall" },
											// { text: invoice['.key'], style: "gstDataSmall" },
											{ text: item['HSN_code'], style: "gstDataSmall",colSpan: 2 },
											{ text: item['taxableGST_rate'], style: "gstDataSmall" },
											{ text: item['productUnit'], style: "gstDataSmall" },
											{ text: item['quantity'], style: "gstDataSmall" },
											{ text: item['fat'], style: "gstDataSmall" },
											{ text: item['rate'], style: "gstDataSmall" },
					
										])
									})
								}
			})
			return pdfDoc;
		}
		// End of Detailed Buyer Statement

		const getBase64ImageFromURL = async (url) => {
			return new Promise((resolve, reject) => {
				var img = new Image();
				img.setAttribute("crossOrigin", "anonymous");

				img.onload = () => {
					var canvas = document.createElement("canvas");
					canvas.width = img.width;
					canvas.height = img.height;

					var ctx = canvas.getContext("2d");
					ctx.drawImage(img, 0, 0);

					var dataURL = canvas.toDataURL("image/png");

					resolve(dataURL);
				};

				img.onerror = error => {
					reject(error);
				};

				img.src = url;
			});
		}
		// End of Buyer Statment


		export const convertToEwayBillType2 = async (metaData) => {
			let pdfDoc = {
				content: [
					{
						table: {
							widths: ['50%', '50%'],
							body: [
								[
									{
										image: '',
										width: 120,
										height: 80,
									},

									{
										text:
											[
												{ text: 'Firm Name\n', style: 'topFirmAuthority1', },
												{ text: 'Live Address\n', style: 'topFirmHeader', },
												{ text: 'Address\n', style: 'topFirmHeader', },
												{ text: 'GSTIN\n', style: 'topFirmHeader', },
												{ text: 'MOBILE\n', style: 'topFirmHeader', },
												{ text: 'EMAIL\n', style: 'topFirmHeader', },
											]
									}
								],
							],

						},
						layout: {
							hLineWidth: function (i, node) {
								return (i === 0 || i === node.table.body.length) ? 2 : 0;
							},
							vLineWidth: function (i, node) {
								return (i === 0 || i === node.table.widths.length) ? 2 : 0;
							},
							hLineColor: function (i, node) {
								return (i === 0 || i === node.table.body.length) ? 'black' : 'white';
							},
							vLineColor: function (i, node) {
								return (i === 0 || i === node.table.widths.length) ? 'black' : 'white';
							},
						}
					},

					{
						table: {
							widths: ['32%', '32%', '*'],
							body: [
								[
									{ text: 'BILL TO', style: "topHeader" },
									{ text: 'SHIP TO', style: "topHeader" },
									{ text: 'INVOICE DETAILS', style: "topHeader" },
								],
								[
									{
										text:
											[
												{ text: ' ', bold: true, style: 'invoiceDetails' },
												{ text: 'Google\n', style: 'invoiceDetails' },
												{ text: ' ', bold: true, style: 'invoiceDetails' },
												{ text: '1600 Amphitheatre Parkway in Mountain View, California, United States, near San Jose. \n', style: 'invoiceDetails' },
												{ text: ' ', bold: true, style: 'invoiceDetails' },
												{ text: '1600 Amphitheatre Parkway in Mountain View, California, United States, near San Jose. \n', style: 'invoiceDetails' },
												{ text: ' ', bold: true, style: 'invoiceDetails' },
												{ text: '7788996655\n', style: 'invoiceDetails' },
												{ text: ' ', bold: true, style: 'invoiceDetails' },
												{ text: '1679905\n', style: 'invoiceDetails' },
												{ text: ' ', bold: true, style: 'invoiceDetails' },
												{ text: '23\n', style: 'invoiceDetails' },
											]
									},

									{
										text:
											[
												{ text: ' ', bold: true, style: 'invoiceDetails' },
												{ text: 'Google\n', style: 'invoiceDetails' },
												{ text: ' ', bold: true, style: 'invoiceDetails' },
												{ text: '1600 Amphitheatre Parkway in Mountain View, California, United States, near San Jose. \n', style: 'invoiceDetails' },
												{ text: ' ', bold: true, style: 'invoiceDetails' },
												{ text: '1600 Amphitheatre Parkway in Mountain View, California, United States, near San Jose. \n', style: 'invoiceDetails' },
												{ text: ' ', bold: true, style: 'invoiceDetails' },
												{ text: '7788996655\n', style: 'invoiceDetails' },
												{ text: ' ', bold: true, style: 'invoiceDetails' },
												{ text: '1679905\n', style: 'invoiceDetails' },
												{ text: ' ', bold: true, style: 'invoiceDetails' },
												{ text: '23\n', style: 'invoiceDetails' },
											]
									},
									{
										text:
											[
												{ text: 'Invoice No:          ', bold: true, style: 'invoiceDetails' },
												{ text: '787878\n', style: 'invoiceDetails' },
												{ text: 'Invoice Date:       ', bold: true, style: 'invoiceDetails' },
												{ text: '12/12/90 \n', style: 'invoiceDetails' },
												{ text: 'Invoice Status:    ', bold: true, style: 'invoiceDetails' },
												{ text: '12/12/90 \n', style: 'invoiceStatusDetails' },
												{ text: 'Payment Date:    ', bold: true, style: 'invoiceDetails' },
												{ text: '13/12/90\n', style: 'invoiceDetails' },
												{ text: 'Order No:             ', bold: true, style: 'invoiceDetails' },
												{ text: '787878\n', style: 'invoiceDetails' },
												{ text: 'Order Date:          ', bold: true, style: 'invoiceDetails' },
												{ text: '12/12/90 \n', style: 'invoiceDetails' },
												{ text: 'E-Way Bill No:     ', bold: true, style: 'invoiceDetails' },
												{ text: '787878\n', style: 'invoiceDetails' },

												// { text: 'TRANSPORT DETAILS' ,style:'transpotationDel'},
												// { text: '\n',style:'invoiceDetails' },
												{ text: 'Vehicle No:          ', bold: true, style: 'invoiceDetails' },
												{ text: '12121212 \n', style: 'invoiceDetails' },
												{ text: 'Driver Name:       ', bold: true, style: 'invoiceDetails' },
												{ text: '12121212 \n', style: 'invoiceDetails' },
												{ text: 'Driver No:            ', bold: true, style: 'invoiceDetails' },
												{ text: '12121212 \n', style: 'invoiceDetails' },
											]
									},

								],
							]
						}
					},

					{
						table: {
							widths: ['7%', '33%', '9%', '11%', '10%', '10%', '20%'],
							body: [
								[
									{ text: 'S.NO', style: "productHeader", rowSpan: 2 },
									{ text: 'PRODUCT DESCRIPTION', style: "productHeader", rowSpan: 2 },
									{ text: 'HSN', style: "productHeader", rowSpan: 2 },
									{ text: 'QUANTITY', style: "productHeader", rowSpan: 2 },
									{ text: 'UNIT', style: "productHeader", rowSpan: 2 },
									{ text: 'RATE', style: "productHeader", rowSpan: 2 },
									{ text: 'TAXABLE AMOUNT', style: "productHeader", rowSpan: 2 },
								],
								[
									{ text: 'S.NO', style: "productHeader" },
									{ text: 'PRODUCT DESCRIPTION', style: "productHeader" },
									{ text: 'HSN', style: "productHeader" },
									{ text: 'QUANTITY', style: "productHeader" },
									{ text: 'UNIT', style: "productHeader" },
									{ text: 'RATE', style: "productHeader" },
									{ text: 'TAXABLE AMOUNT', style: "productHeader" },
								],
							]
						}
					},
					{
						table: {
							widths: ['70%', '*'],
							body: [

								[
									[
										{
											table: {

												body: [
													[{ text: 'HSN SUMMARY', style: "gstHeader1", colSpan: 10 },
													{ text: 'Qty', style: "gstHeader" },
													{ text: 'TAXABLE AMOUNT', style: "gstHeader" },
													{ text: '%', style: "gstHeader" },
													{ text: 'AMOUNT', style: "gstHeader" },
													{ text: '%', style: "gstHeader" },
													{ text: 'AMOUNT', style: "gstHeader" },
													{ text: '%', style: "gstHeader" },
													{ text: 'AMOUNT', style: "gstHeader" },
													{ text: 'TOTAL AMOUNT', style: "gstHeader" }],
													[

														{ text: 'HSN/SAC', style: "gstHeader", rowSpan: 2 },
														{ text: 'QTY', style: "gstHeader", rowSpan: 2 },
														{ text: 'TAXABLE AMOUNT', style: "gstHeader", rowSpan: 2 },
														{ text: 'CGST', style: "gstHeader", colSpan: 2, rowSpan: 1 },
														{ text: '', style: "gstHeader", rowSpan: 2 },
														{ text: 'SGST', style: "gstHeader", colSpan: 2, rowSpan: 1 },
														{ text: '', style: "gstHeader", rowSpan: 2 },
														{ text: 'IGST', style: "gstHeader", colSpan: 2, rowSpan: 1 },
														{ text: '', style: "gstHeader", rowSpan: 2 },
														{ text: 'TOTAL AMOUNT', style: "gstHeader", rowSpan: 2 },

													],
													[

														{ text: 'HSN/SAC', style: "gstHeader" },
														{ text: 'Qty', style: "gstHeader" },
														{ text: 'Taxable Amount', style: "gstHeader" },
														{ text: '%', style: "gstHeader" },
														{ text: 'Amount', style: "gstHeader" },
														{ text: '%', style: "gstHeader" },
														{ text: 'Amount', style: "gstHeader" },
														{ text: '%', style: "gstHeader" },
														{ text: 'Amount', style: "gstHeader" },
														{ text: 'Total Amount', style: "gstHeader" },

													],
												]
											}
										},


									],
									{
										text:
											[
												{ text: 'Taxable Amount     ', bold: true, style: 'invoiceDetails' },
												{ text: '12122\n', style: 'invoiceDetails' },
												{ text: 'CGST Amount         ', bold: true, style: 'invoiceDetails' },
												{ text: '12122\n', style: 'invoiceDetails' },
												{ text: 'SGST Amount         ', bold: true, style: 'invoiceDetails' },
												{ text: '12122\n', style: 'invoiceDetails' },
												{ text: 'IGST Amount          ', bold: true, style: 'invoiceDetails' },
												{ text: '12122\n', style: 'invoiceDetails' },
												// { text: 'Labour Charge:-                ', bold: true },
												// { text: '12122\n' },
												{ text: 'Discount                  ', bold: true, style: 'invoiceDetails' },
												{ text: '12122\n', style: 'invoiceDetails' },
												{ text: 'RoundOff                 ', bold: true, style: 'invoiceDetails' },
												{ text: '12122\n', style: 'invoiceDetails' },
												{ text: 'Total Amount          ', bold: true, style: 'totalAmountHeader' },
												{ text: '12122\n', style: 'totalAmountHeader' },
												{ text: 'Paid Amount           ', bold: true, style: 'invoiceDetails' },
												{ text: '12122\n', style: 'invoiceDetails' },
												{ text: 'Due Amount            ', bold: true, style: 'invoiceStatusDetails' },
												{ text: '12122\n', style: 'invoiceStatusDetails' },
											]

									},

								],
							],


						},
						style: 'tab2',



					},

					{
						table: {
							widths: ['30%', '40%', '30%'],
							body: [
								[
									{
										text:
											[
												{ text: 'PAYMENT DETAILS\n', style: 'transpotationDel' },
												{ text: '', style: 'invoiceDetails1' },
											]
									},
									{
										text:
											[
												{ text: 'TERMS AND CONDITIONS\n', style: 'transpotationDel' },
												{ text: '', style: 'invoiceDetails1' },

											]
									},

									// {
									// 	text:
											[{ text: '' },
											{ text: 'Firm Name  ', bold: true, alignment: 'center', style: 'topFirmAuthority' },
											{ text: '\n\n\n' },

											{ text: 'AUTHORITY SIGNATURE  ', bold: true, alignment: 'center', style: 'topFirmAuthority' },
											{ text: '\n' },
											]
									// },
								],
							],

						},
						layout: {
							hLineWidth: function (i, node) {
								return (i === 0 || i === node.table.body.length) ? 2 : 0;
							},
							vLineWidth: function (i, node) {
								return (i === 0 || i === node.table.widths.length) ? 2 : 0;
							},
							hLineColor: function (i, node) {
								return (i === 0 || i === node.table.body.length) ? 'black' : 'white';
							},
							vLineColor: function (i, node) {
								return (i === 0 || i === node.table.widths.length) ? 'black' : 'white';
							},
						}
					}

				],
				footer: {
					columns: [
						{
							text: 'Powered By ACUIFY',
							alignment: 'right',
							color: '#160091'
						}
					],
					margin: [10, 10]
				},
				styles: {
					header: {
						fontSize: 10,
						bold: true,
						alignment: 'center'
					},
					productHeader: {
						fontSize: 10,
						bold: true,
						alignment: 'center',
						color: '#160091',
					},
					transpotationDel: {
						fontSize: 9,
						bold: true,
						alignment: 'center',
						color: '#160091',
					},
					gstHeader: {
						fontSize: 8,
						color: '#160091',
						alignment: 'center'
					},
					gstHeader1: {
						fontSize: 10,
						color: '#160091',
						bold: true,
						alignment: 'center'
					},
					product: {
						fontSize: 9,
						alignment: 'center',
					},
					product1: {
						fontSize: 7,
						alignment: 'center',
					},
					productRight: {
						fontSize: 10,
						alignment: 'right',
						// bold: true
					},
					totalRight: {
						fontSize: 10,
						alignment: 'right',
						bold: true
					},
					total: {
						fontSize: 10,
						alignment: 'center',
						bold: true
					},
					total1: {
						fontSize: 7,
						alignment: 'center',
					},
					topHeader: {
						color: '#160091',
						fontSize: 10,
						alignment: 'center',
						bold: true,
					},
					topFirmAuthority: {
						color: '#160091',
						fontSize: 9,
						bold: true,
					},
					topFirmAuthority1: {
						color: '#160091',
						fontSize: 12,
						bold: true,
					},
					topFirmHeader: {
						fontSize: 10,
						bold: true,
					},
					invoiceDetails: {
						fontSize: 10,
						bold: true,
					},
					invoiceDetails1: {
						fontSize: 9,
						bold: true,
					},
					totalAmountHeader: {
						color: '#160091',
						fontSize: 10,
						bold: true,
					},
					invoiceStatusDetails: {
						color: '#FF0000',
						fontSize: 10,
						bold: true,
					}
				}
			}
			//Firm Details 
			pdfDoc.content[0].table.body[0][1].text[0].text = (metaData.firm.name ? (metaData.firm.name).toUpperCase() : '') + "\n";
			pdfDoc.content[0].table.body[0][1].text[1].text = (metaData.firm.liveAddress ? metaData.firm.liveAddress : '') + "\n";
			pdfDoc.content[0].table.body[0][1].text[2].text = (metaData.firm.address ? metaData.firm.address : '') + "\n";
			pdfDoc.content[0].table.body[0][1].text[3].text = (metaData.firm.mobileNumber ? metaData.firm.mobileNumber : '') + "\n";
			// pdfDoc.content[0].table.body[0][1].text[7].text = (metaData.firm.panNumber ? metaData.firm.panNumber : '') + "\n";
			pdfDoc.content[0].table.body[0][1].text[4].text = (metaData.firm.email ? metaData.firm.email : '') + "\n";
			pdfDoc.content[0].table.body[0][1].text[5].text = (metaData.firm.GST_number ? metaData.firm.GST_number : '') + "\n";
			// pdfDoc.content[0].table.body[0][1].text[13].text = (metaData.firm.website ? metaData.firm.website : '') + "\n";

			//Invoice Details
			// let date = new Date(metaData.invoiceData.date)
			// let paymentDueDate = date.setDate(date.getDate() + metaData.invoiceData.alertDuration ? metaData.invoiceData.alertDuration : 0);
			let date = new Date(metaData.invoiceData.date)
			let paymentDueDate = date.setDate(date.getDate() + (metaData.invoiceData.duration ? parseInt(metaData.invoiceData.duration) : 0));
			pdfDoc.content[1].table.body[1][2].text[1].text = metaData.invoiceData.invoiceId + "\n";
			pdfDoc.content[1].table.body[1][2].text[3].text = new Date(metaData.invoiceData.date).toLocaleDateString('en-GB').toString() + "\n";
			pdfDoc.content[1].table.body[1][2].text[5].text = (metaData.invoiceData.status ? metaData.invoiceData.status.toUpperCase() : '') + "\n";
			pdfDoc.content[1].table.body[1][2].text[7].text = new Date(paymentDueDate).toLocaleDateString('en-GB').toString() + "\n";
			pdfDoc.content[1].table.body[1][2].text[9].text = (metaData.invoiceData.orderNumber ? metaData.invoiceData.orderNumber : '-') + "\n";
			pdfDoc.content[1].table.body[1][2].text[11].text = (metaData.invoiceData.orderDate ? new Date(metaData.invoiceData.orderDate).toLocaleDateString('en-GB').toString() : '-') + "\n";
			pdfDoc.content[1].table.body[1][2].text[13].text = (metaData.ebillDetails.billNo ? metaData.ebillDetails.billNo : '') + "\n";   //eway bill nu
			pdfDoc.content[1].table.body[1][2].text[15].text = (metaData.transportationDetails.vehicleNo ? metaData.transportationDetails.vehicleNo : '') + "\n";
			pdfDoc.content[1].table.body[1][2].text[17].text = (metaData.transportationDetails.driverName ? metaData.transportationDetails.driverName : '') + "\n";
			pdfDoc.content[1].table.body[1][2].text[19].text = (metaData.transportationDetails.driverNumber ? metaData.transportationDetails.driverNumber : '') + "\n";


			//Receipient Details

			// pdfDoc.content[1].table.body[1][0].text[1].text = (metaData.customer.name ? metaData.customer.name : '') + "\n";
			pdfDoc.content[1].table.body[1][0].text[1].text = (getCustomerDetails(metaData, 'name').toUpperCase()) + "\n";
			pdfDoc.content[1].table.body[1][0].text[3].text = (metaData.customer.GST_number ? metaData.customer.GST_number : '') + "\n";
			pdfDoc.content[1].table.body[1][0].text[5].text = (metaData.customer.address ? metaData.customer.localAddress : '') + "\n";
			//pdfDoc.content[1].table.body[1][0].text[7].text = (metaData.customer.address ? metaData.customer.address : '') + "\n";
			//pdfDoc.content[1].table.body[1][0].text[9].text = (metaData.customer.mobile ? metaData.customer.mobile : '') + "\n";
			pdfDoc.content[1].table.body[1][0].text[7].text = (getCustomerDetails(metaData, 'address')) + "\n";
			pdfDoc.content[1].table.body[1][0].text[9].text = (getCustomerDetails(metaData, 'mobile').toUpperCase()) + "\n";
			pdfDoc.content[1].table.body[1][0].text[11].text = (metaData.customer.stateCode ? metaData.customer.stateCode : '') + "\n";

			//Consignee Details

			pdfDoc.content[1].table.body[1][1].text[1].text = (metaData.consignee.name ? metaData.consignee.name : '') + "\n";
			pdfDoc.content[1].table.body[1][1].text[3].text = (metaData.consignee.address ? metaData.consignee.localAddress : '') + "\n";
			pdfDoc.content[1].table.body[1][1].text[5].text = (metaData.consignee.address ? metaData.consignee.address : '') + "\n";
			pdfDoc.content[1].table.body[1][1].text[7].text = (metaData.consignee.mobile ? metaData.consignee.mobile : '') + "\n";
			pdfDoc.content[1].table.body[1][1].text[9].text = (metaData.consignee.GST_number ? metaData.consignee.GST_number : '') + "\n";
			pdfDoc.content[1].table.body[1][1].text[11].text = (metaData.consignee.stateCode ? metaData.consignee.stateCode : '') + "\n";


			//Products
			// let productList = convertToPDFProducts(metaData.invoiceData.items,false);
			let productList = convertToPDFProducts(metaData.invoiceData.items, false, metaData.invoiceData, metaData);
			productList.map((item) => {
				pdfDoc.content[2].table.body.push(item);
			});
			let gstObj = convertToGST(metaData.invoiceData.items);
			Object.keys(gstObj).forEach((key) => {
				if (key != "totalObj") {
					pdfDoc.content[3].table.body[0][0][0].table.body.push([
						{ text: key, style: "product1" },
						{ text: gstObj[key].quantity, style: "product1" },
						{ text: Number.parseFloat(gstObj[key].basicPrice).toFixed(2), style: "product1" },
						{ text: gstObj[key].CGST + '%', style: "product1" },
						{ text: gstObj[key].CGST_val, style: "product1" },
						{ text: gstObj[key].SGST + '%', style: "product1" },
						{ text: gstObj[key].SGST_val, style: "product1" },
						{ text: gstObj[key].IGST + '%', style: "product1" },
						{ text: gstObj[key].IGST_val, style: "product1" },
						{ text: Number.parseFloat(Number.parseFloat(gstObj[key].basicPrice) + Number.parseFloat(gstObj[key].GSTValue)).toFixed(2), style: "product1" }])
				}
			});

			pdfDoc.content[3].table.body[0][0][0].table.body.push([
				{ text: 'Total', style: "total1" },
				{ text: gstObj.totalObj.quantity, style: "total1" },
				{ text: Number.parseFloat(gstObj.totalObj.basicPrice).toFixed(2), style: "total1" },
				{ text: '', style: "total1" },
				{ text: Number.parseFloat(gstObj.totalObj.CGST_val).toFixed(2), style: "total1" },
				{ text: '', style: "total1" },
				{ text: Number.parseFloat(gstObj.totalObj.SGST_val).toFixed(2), style: "total1" },
				{ text: '', style: "total1" },
				{ text: Number.parseFloat(gstObj.totalObj.IGST_val).toFixed(2), style: "total1" },
				{ text: Number.parseFloat(Number.parseFloat(gstObj.totalObj.basicPrice) + Number.parseFloat(gstObj.totalObj.GSTValue)).toFixed(2), style: "total1" }]);

			//Bank Account Details
			if (metaData.terms.banks.length) {
				metaData.terms.banks.map((bankDetails) => {
					pdfDoc.content[4].table.body[0][0].text.push({ text: bankDetails.bankName + "\n", style: 'invoiceDetails1' })
					pdfDoc.content[4].table.body[0][0].text.push({ text: "NAME: " + bankDetails.accountHolderName + "\n", style: 'invoiceDetails1' })
					pdfDoc.content[4].table.body[0][0].text.push({ text: "A/C NO:  " + bankDetails.accountnumber + "\n", style: 'invoiceDetails1' })
					pdfDoc.content[4].table.body[0][0].text.push({ text: "IFSC: " + bankDetails.ifsccode + "\n", style: 'invoiceDetails1' })
					pdfDoc.content[4].table.body[0][0].text.push({ text: bankDetails.address + "\n", style: 'invoiceDetails1' })
				})
			}


			//Terms and cond
			pdfDoc.content[4].table.body[0][1].text[1].text = metaData.terms.termsAndConditions;

			//gst details
			// pdfDoc.content[5].table.body[0][1].text[1].text = (metaData.invoiceData.totalAmount ? Number.parseFloat(metaData.invoiceData.totalAmount).toFixed(2) - Number.parseFloat(metaData.gstTotal.CGST_val + metaData.gstTotal.SGST_val + metaData.gstTotal.IGST_val).toFixed(2) : '0') + "\n";
			// pdfDoc.content[3].table.body[0][1].text[1].text = (metaData.invoiceData.totalAmount - metaData.invoiceData.roundOffAmount ? Number.parseFloat(metaData.invoiceData.totalAmount - metaData.invoiceData.roundOffAmount).toFixed(2) - Number.parseFloat(metaData.gstTotal.CGST_val + metaData.gstTotal.SGST_val + metaData.gstTotal.IGST_val).toFixed(2) : '0').toFixed(2) + "\n";
			pdfDoc.content[3].table.body[0][1].text[1].text = (
				Number.parseFloat(metaData.invoiceData.totalAmount) +
				Number.parseFloat(metaData.invoiceData.discountAmount || 0) +
				Number.parseFloat(metaData.invoiceData.gstOnExtraChanrges ? 0 : (-Number.parseFloat(metaData.invoiceData.totalExtraCharges))) -
				Number.parseFloat(metaData.invoiceData.gstOnExtraChanrges ? Number.parseFloat(metaData.invoiceData.totalExtraChargesGST) : 0) -
				Number.parseFloat(metaData.invoiceData.roundOffAmount || 0) -
				(Number.parseFloat(
					metaData.gstTotal.SGST_val
				) +
					Number.parseFloat(
						metaData.gstTotal.CGST_val
					) +
					Number.parseFloat(
						metaData.gstTotal.IGST_val
					))
			).toFixed(2) + "\n";
			pdfDoc.content[3].table.body[0][1].text[3].text = (metaData.gstTotal.CGST_val ? (Number.parseFloat(metaData.gstTotal.CGST_val) + Number.parseFloat(metaData.invoiceData.gstOnExtraChanrges ? Number.parseFloat(metaData.invoiceData.totalExtraChargesGST) / 2 : 0)).toFixed(2) : '0.00') + "\n";
			pdfDoc.content[3].table.body[0][1].text[5].text = (metaData.gstTotal.SGST_val ? (Number.parseFloat(metaData.gstTotal.SGST_val) + Number.parseFloat(metaData.invoiceData.gstOnExtraChanrges ? Number.parseFloat(metaData.invoiceData.totalExtraChargesGST) / 2 : 0)).toFixed(2) : '0.00') + "\n";
			pdfDoc.content[3].table.body[0][1].text[7].text = (metaData.gstTotal.IGST_val ? (Number.parseFloat(metaData.gstTotal.IGST_val) + Number.parseFloat(metaData.invoiceData.gstOnExtraChanrges ? Number.parseFloat(metaData.invoiceData.totalExtraChargesGST) : 0)).toFixed(2) : '0.00') + "\n";
			let offset = 0;
			// if(metaData.invoiceData.extraCharges && metaData.invoiceData.extraCharges.length) {
			if (!metaData.invoiceData.gstOnExtraChanrges && metaData.invoiceData.extraCharges && metaData.invoiceData.extraCharges.length) {
				metaData.invoiceData.extraCharges.map((charge) => {
					pdfDoc.content[3].table.body[0][1].text.splice(8 + offset, 0, { text: '' + charge.name + ':        ', bold: true, style: 'invoiceDetails' })
					offset++;
					pdfDoc.content[3].table.body[0][1].text.splice(8 + offset, 0, { text: Number.parseFloat(charge.amount).toFixed(2) + '\n', style: 'invoiceDetails' })
					offset++;
				})
			}
			// pdfDoc.content[3].table.body[0][1].text[9].text = (metaData.invoiceData.labourAmount ? Number.parseFloat(metaData.invoiceData.labourAmount).toFixed(2) : '0') + "\n";
			pdfDoc.content[3].table.body[0][1].text[9 + offset].text = (metaData.invoiceData.discountAmount ? Number.parseFloat(metaData.invoiceData.discountAmount).toFixed(2) : '0') + "\n";
			pdfDoc.content[3].table.body[0][1].text[11 + offset].text = (metaData.invoiceData.roundOffAmount ? Number.parseFloat(metaData.invoiceData.roundOffAmount).toFixed(2) : '0') + "\n";
			pdfDoc.content[3].table.body[0][1].text[13 + offset].text = (metaData.invoiceData.totalAmount ? Number.parseFloat(metaData.invoiceData.totalAmount).toFixed(2) : '0') + "\n";
			pdfDoc.content[3].table.body[0][1].text[15 + offset].text = (metaData.invoiceData.paidAmount ? Number.parseFloat(metaData.invoiceData.paidAmount).toFixed(2) : '0') + "\n";
			pdfDoc.content[3].table.body[0][1].text[17 + offset].text = (metaData.invoiceData.remainingAmount ? Number.parseFloat(metaData.invoiceData.remainingAmount).toFixed(2) : '') + "\n";


			// pdfDoc.content[6].table.body[0][1].text[17].text = (metaData.invoiceData.paymentType ? metaData.invoiceData.paymentType : '') + "\n";

			//authority
			pdfDoc.content[4].table.body[0][2][1].text = metaData.firm.name ? (metaData.firm.name).toUpperCase() : '';

			if (metaData.terms.printLogo) {
				try {
					let logoData = await getBase64ImageFromURL(metaData.terms.printLogo)
					pdfDoc.content[0].table.body[0][0].image = logoData;
					let invoiceImages = document.getElementById('invoiceImages');
					if (invoiceImages && invoiceImages.files && invoiceImages.files.length) {
						let temp = {columns: []};
						if(invoiceImages.files[0]) {
							temp.columns.push({
								image: await toBase64(invoiceImages.files[0]).catch(e => Error(e)),
								width: 150
							})
						}
						if(invoiceImages.files[1]) {
							temp.columns.push({
								image: await toBase64(invoiceImages.files[1]).catch(e => Error(e)),
								width: 150
							})
						}
						if(invoiceImages.files[2]) {
							temp.columns.push({
								image: await toBase64(invoiceImages.files[2]).catch(e => Error(e)),
								width: 150
							})
						}
						pdfDoc.content.push(temp)
					}
					if(metaData.terms.signature) {
						let temp = {columns: []};
						temp.columns.push({
							image: await getBase64ImageFromURL(metaData.terms.signature),
							width: 150,
							alignment: 'right'
						})
						//pdfDoc.content.push(temp)
						pdfDoc.content[4].table.body[0][2][2] = temp.columns[0]
					}
					return pdfDoc;
				} catch (error) {
					console.log(error)
				}
			} else {
				var imgToExport = document.getElementById('pdfimgToExport');
				var canvas = document.createElement('canvas');
				canvas.width = imgToExport.width;
				canvas.height = imgToExport.height;
				canvas.getContext('2d').drawImage(imgToExport, 0, 0);
				let base64 = canvas.toDataURL('image/png')
				pdfDoc.content[0].table.body[0][0].image = base64;


				let invoiceImages = document.getElementById('invoiceImages');
					if (invoiceImages && invoiceImages.files && invoiceImages.files.length) {
						let temp = {columns: []};
						if(invoiceImages.files[0]) {
							temp.columns.push({
								image: await toBase64(invoiceImages.files[0]).catch(e => Error(e)),
								width: 150
							})
						}
						if(invoiceImages.files[1]) {
							temp.columns.push({
								image: await toBase64(invoiceImages.files[1]).catch(e => Error(e)),
								width: 150
							})
						}
						if(invoiceImages.files[2]) {
							temp.columns.push({
								image: await toBase64(invoiceImages.files[2]).catch(e => Error(e)),
								width: 150
							})
						}
						pdfDoc.content.push(temp)
					}
			}

			if(metaData.terms.signature) {
				let temp = {columns: []};
				temp.columns.push({
					image: await getBase64ImageFromURL(metaData.terms.signature),
					width: 150,
					alignment: 'right'
				})
				//pdfDoc.content.push(temp)
				pdfDoc.content[4].table.body[0][2][2] = temp.columns[0]
			}	
			return pdfDoc;
		}

		// New Developent - part 3 //
		export const convertToEwayBillType3 = async (metaData) => {
			let pdfDoc = {
				content: [
					{ text: 'TAX INVOICE \n', style: 'header' },
					{
						table: {
							widths: ['20%', '43%', '37%'],
							body: [
								[
									{
										image: 'sampleImage.jpg',
										width: 100,
										height: 80,
									},

									{
										text:
											[
												{ text: 'Firm Name\n', style: 'topFirmAuthority1', },
												{ text: 'Live Address\n', style: 'topFirmHeader', },
												{ text: 'Address\n', style: 'topFirmHeader', },
												{ text: 'GSTIN\n', style: 'topFirmHeader', },
												{ text: 'MOBILE\n', style: 'topFirmHeader', },
												{ text: 'EMAIL\n', style: 'topFirmHeader', },
											]
									},
									{
										text:
											[
												{ text: 'Invoice No        :  ', bold: true, style: "invoiceDetails" },
												{ text: '787878\n', style: "invoiceDetailsBlue" },
												{ text: 'Invoice Date     :  ', bold: true, style: "invoiceDetails" },
												{ text: '12/12/90 \n', style: "invoiceDetails" },
												{ text: 'Invoice Status  :  ', bold: true, style: 'invoiceDetails' },
												{ text: '12/12/90 \n', style: 'invoiceStatusDetails' },
												{ text: 'Due Date           :  ', bold: true, style: "invoiceDetails" },
												{ text: '13/12/90\n', style: "invoiceDetails" },
												{ text: 'E-Way Bill No   :  ', bold: true, style: 'invoiceDetails' },
												{ text: '787878\n', style: 'invoiceDetails' },
												{ text: 'Order Number  :  ', bold: true, style: 'invoiceDetails' },
												{ text: '787878\n', style: 'invoiceDetails' },
												{ text: 'Order Date        :  ', bold: true, style: 'invoiceDetails' },
												{ text: '12/12/90 \n', style: 'invoiceDetails' },
											]
									},
								],
							],

						},
						layout: {
							hLineWidth: function (i, node) {
								return (i === 0 || i === node.table.body.length) ? 2 : 0;
							},
							vLineWidth: function (i, node) {
								return (i === 0 || i === node.table.widths.length) ? 2 : 0;
							},
							hLineColor: function (i, node) {
								return (i === 0 || i === node.table.body.length) ? 'black' : 'white';
							},
							vLineColor: function (i, node) {
								return (i === 0 || i === node.table.widths.length) ? 'black' : 'white';
							},
						}
					},
					{
						table: {
							widths: ['*'],
							body: [
								[
									{ text: "Invoice Summary", style: 'invoiceColorDetails' },
								],
							],
						},
					},
					// {text:'\n'},
					{
						table: {
							widths: ['32%', '32%', '*'],
							body: [
								[
									{ text: 'BILL TO', style: "topHeader" },
									{ text: 'SHIP TO', style: "topHeader" },
									{ text: 'TRANSPORTATION DETAILS', style: "topHeader" },
								],
								[
									{
										text:
											[
												{ text: ' ', bold: true, style: 'invoiceDetails' },
												{ text: 'Google\n', style: 'invoiceDetailsBlueConsignee' },
												{ text: ' ', bold: true, style: 'invoiceDetails' },
												{ text: '1600 Amphitheatre Parkway in Mountain View, California, United States, near San Jose. \n', style: 'invoiceDetails' },
												{ text: ' ', bold: true, style: 'invoiceDetails' },
												{ text: '1600 Amphitheatre Parkway in Mountain View, California, United States, near San Jose. \n', style: 'invoiceDetails' },
												{ text: ' ', bold: true, style: 'invoiceDetails' },
												{ text: '7788996655\n', style: 'invoiceDetails' },
												{ text: 'Mobile Number  : ', bold: true, style: "invoiceDetails" },
												{ text: '1679905\n', style: "invoiceDetails" },
												{ text: 'Place of Supply  : ', bold: true, style: "invoiceDetails" },
												{ text: '23\n', style: "invoiceDetails" },
												{ text: 'State Code          : ', bold: true, style: "invoiceDetails" },
												{ text: '23\n', style: "invoiceDetails" },
											]
									},

									{
										text:
											[
												{ text: ' ', bold: true, style: 'invoiceDetails' },
												{ text: 'Google\n', style: 'invoiceDetailsBlueConsignee' },
												{ text: ' ', bold: true, style: 'invoiceDetails' },
												{ text: '1600 Amphitheatre Parkway in Mountain View, California, United States, near San Jose. \n', style: 'invoiceDetails' },
												{ text: ' ', bold: true, style: 'invoiceDetails' },
												{ text: '1600 Amphitheatre Parkway in Mountain View, California, United States, near San Jose. \n', style: 'invoiceDetails' },
												{ text: ' ', bold: true, style: 'invoiceDetails' },
												{ text: '7788996655\n', style: 'invoiceDetails' },
												{ text: 'Mobile Number  : ', bold: true, style: "invoiceDetails" },
												{ text: '1679905\n', style: "invoiceDetails" },
												{ text: 'Place of Supply  : ', bold: true, style: "invoiceDetails" },
												{ text: '23\n', style: "invoiceDetails" },
												{ text: 'State Code          : ', bold: true, style: "invoiceDetails" },
												{ text: '23\n', style: "invoiceDetails" },
											]
									},
									{
										table: {
											widths: ['40%', '60%'],
											body: [
											]
										},
										layout: {
											hLineWidth: function (i, node) {
												return 0;
											},
											vLineWidth: function (i, node) {
												return 0;
											},
											hLineColor: function (i, node) {
												return (i === 0 || i === node.table.body.length) ? 'black' : 'white';
											},
											vLineColor: function (i, node) {
												return (i === 0 || i === node.table.widths.length) ? 'black' : 'white';
											},
										}
									},

								],
							]
						}
					},
					{
						table: {
							widths: ['*'],
							body: [
								[
									{ text: "Product Summary", style: 'invoiceColorDetails' },
								],
							],
						},
					},
					//{text:'\n'},    
					{
						table: {
							widths: ['6%', '33%', '10%', '11%', '10%', '10%', '20%'],
							body: [
								[
									{ text: 'S.NO', style: "productHeader", rowSpan: 2 },
									{ text: 'PRODUCT DESCRIPTION', style: "productHeader", rowSpan: 2 },
									{ text: 'HSN/SAC', style: "productHeader", rowSpan: 2 },
									{ text: 'QUANTITY', style: "productHeader", rowSpan: 2 },
									{ text: 'UNIT', style: "productHeader", rowSpan: 2 },
									{ text: 'RATE', style: "productHeader", rowSpan: 2 },
									{ text: 'TAXABLE AMOUNT', style: "productHeader", rowSpan: 2 },
								],
								[
									{ text: 'S.NO', style: "productHeader" },
									{ text: 'PRODUCT DESCRIPTION', style: "productHeader" },
									{ text: 'HSN', style: "productHeader" },
									{ text: 'QUANTITY', style: "productHeader" },
									{ text: 'UNIT', style: "productHeader" },
									{ text: 'RATE', style: "productHeader" },
									{ text: 'TAXABLE AMOUNT', style: "productHeader" },
								],
							]
						}
					},
					{
						table: {
							widths: ['*'],
							body: [
								[
									{ text: "Other Summary", style: 'invoiceColorDetails' },
								],
							],
						},
					},
					//{text:'\n'},
					{
						table: {
							widths: ['70%', '*'],
							body: [

								[
									[
										{
											table: {

												body: [
													[{ text: 'HSN SUMMARY', style: "gstHeader1", colSpan: 10 },
													{ text: 'Qty', style: "gstHeader" },
													{ text: 'TAXABLE AMOUNT', style: "gstHeader" },
													{ text: '%', style: "gstHeader" },
													{ text: 'AMOUNT', style: "gstHeader" },
													{ text: '%', style: "gstHeader" },
													{ text: 'AMOUNT', style: "gstHeader" },
													{ text: '%', style: "gstHeader" },
													{ text: 'AMOUNT', style: "gstHeader" },
													{ text: 'TOTAL TAX AMOUNT', style: "gstHeader" }],
													[

														{ text: 'HSN/SAC', style: "gstHeader", rowSpan: 2 },
														{ text: 'QTY', style: "gstHeader", rowSpan: 2 },
														{ text: 'TAXABLE AMOUNT', style: "gstHeader", rowSpan: 2 },
														{ text: 'CGST', style: "gstHeader", colSpan: 2, rowSpan: 1 },
														{ text: '', style: "gstHeader", rowSpan: 2 },
														{ text: 'SGST', style: "gstHeader", colSpan: 2, rowSpan: 1 },
														{ text: '', style: "gstHeader", rowSpan: 2 },
														{ text: 'IGST', style: "gstHeader", colSpan: 2, rowSpan: 1 },
														{ text: '', style: "gstHeader", rowSpan: 2 },
														{ text: 'TOTAL TAX AMOUNT', style: "gstHeader", rowSpan: 2 },

													],
													[

														{ text: 'HSN/SAC', style: "gstHeader" },
														{ text: 'Qty', style: "gstHeader" },
														{ text: 'Taxable Amount', style: "gstHeader" },
														{ text: '%', style: "gstHeader" },
														{ text: 'Amount', style: "gstHeader" },
														{ text: '%', style: "gstHeader" },
														{ text: 'Amount', style: "gstHeader" },
														{ text: '%', style: "gstHeader" },
														{ text: 'Amount', style: "gstHeader" },
														{ text: 'Total Tax Amount', style: "gstHeader" },

													],
												]
											}
										},


									],
									{
										text:
											[
												{ text: 'Taxable Amount  :   ', bold: true, style: 'invoiceDetails' },
												{ text: '12122\n', style: 'invoiceDetailsRight' },
												{ text: 'CGST Amount      :   ', bold: true, style: 'invoiceDetails' },
												{ text: '12122\n', style: 'invoiceDetailsRight' },
												{ text: 'SGST Amount      :   ', bold: true, style: 'invoiceDetails' },
												{ text: '12122\n', style: 'invoiceDetailsRight' },
												{ text: 'IGST Amount       :   ', bold: true, style: 'invoiceDetails' },
												{ text: '12122\n', style: 'invoiceDetailsRight' },
												// { text: 'Labour Charge:-                ', bold: true },
												// { text: '12122\n' },
												{ text: 'Discount               :   ', bold: true, style: 'invoiceDetails' },
												{ text: '12122\n', style: 'invoiceDetailsRight' },
												{ text: 'RoundOff              :   ', bold: true, style: 'invoiceDetails' },
												{ text: '12122\n', style: 'invoiceDetailsRight' },
												{ text: 'Total Amount       :   ', bold: true, style: 'totalAmountHeader' },
												{ text: '12122\n', style: 'totalAmountHeader' },
												{ text: 'Paid Amount        :   ', bold: true, style: 'invoiceDetails' },
												{ text: '12122\n', style: 'invoiceDetailsRight' },
												{ text: 'Due Amount         :   ', bold: true, style: 'invoiceStatusDetails' },
												{ text: '12122\n', style: 'invoiceStatusDetails' },
											]

									},

								],
							],


						},
						style: 'tab2',



					},
					{
						table: {
							widths: ['*'],
							body: [
								[
									{ text: "In Words: ", style: 'invoiceDetails' },
								],
							],
						},
					},
					{
						table: {
							widths: ['30%', '40%', '30%'],
							body: [
								[
									{
										text:
											[
												{ text: 'PAYMENT DETAILS\n', style: 'transpotationDelLeft' },
												{ text: '', style: 'invoiceDetails1' },
											]
									},
									{
										text:
											[
												{ text: 'TERMS AND CONDITIONS\n', style: 'transpotationDelLeft' },
												{ text: '', style: 'invoiceDetails1' },

											]
									},

									// {
									// 	text:
											[
												{ text: '' },
												{ text: 'Firm Name  ', bold: true, alignment: 'center', style: 'topFirmAuthority' },
												{ text: '\n\n\n\n' },

												{ text: 'AUTHORITY SIGNATURE  ', bold: true, alignment: 'center', style: 'topFirmAuthority' },
												{ text: '\n' },
											]

									// },
								],
							],

						},
						layout: {
							hLineWidth: function (i, node) {
								return (i === 0 || i === node.table.body.length) ? 2 : 0;
							},
							vLineWidth: function (i, node) {
								return (i === 0 || i === node.table.widths.length) ? 2 : 0;
							},
							hLineColor: function (i, node) {
								return (i === 0 || i === node.table.body.length) ? 'black' : 'white';
							},
							vLineColor: function (i, node) {
								return (i === 0 || i === node.table.widths.length) ? 'black' : 'white';
							},
						}
					},
					{
						table: {
							widths: ['*'],
							body: [
								[
									{ text: 'Thank you', style: 'thankyouMsg' },
								],
							],
						},
					},

				],
				footer: {
					columns: [
						{
							text: 'Powered By ACUIFY',
							alignment: 'right',
							color: '#160091'
						}
					],
					margin: [10, 10]
				},
				styles: {
					header: {
						fontSize: 15,
						bold: true,
						alignment: 'center',
						color: '#160091'
					},
					productHeader: {
						fontSize: 9,
						bold: true,
						alignment: 'center',
						color: '#160091',
					},
					transpotationDel: {
						fontSize: 9,
						bold: true,
						alignment: 'center',
						color: '#160091',
					},
					transpotationDelLeft: {
						fontSize: 9,
						bold: true,
						alignment: 'left',
						color: '#160091',
					},
					gstHeader: {
						fontSize: 8,
						color: '#160091',
						alignment: 'center'
					},
					gstHeader1: {
						fontSize: 10,
						color: '#160091',
						bold: true,
						alignment: 'center'
					},
					product: {
						fontSize: 9,
						alignment: 'center',
						bold: true
					},
					productRight: {
						fontSize: 10,
						alignment: 'right',
						// bold: true
					},
					totalRight: {
						fontSize: 10,
						alignment: 'right',
						bold: true
					},
					subproduct: {
						fontSize: 9,
						alignment: 'center',
					},
					product1: {
						fontSize: 7,
						alignment: 'center',
					},
					total: {
						fontSize: 10,
						alignment: 'center',
						bold: true
					},
					total1: {
						fontSize: 7,
						alignment: 'center',
					},
					topHeader: {
						color: '#160091',
						fontSize: 11,
						alignment: 'center',
						bold: true,
					},
					topFirmAuthority: {
						color: '#160091',
						fontSize: 9,
						bold: true,
					},
					topFirmAuthority1: {
						color: '#160091',
						fontSize: 14,
						bold: true,
					},
					topFirmHeader: {
						fontSize: 10,
						bold: true,
					},
					invoiceDetails: {
						fontSize: 10,
						bold: true,
					},
					invoiceDetailsRight: {
						fontSize: 10,
						bold: true,
						alignment: 'right'
					},
					invoiceColorDetails: {
						fontSize: 12,
						color: 'white',
						bold: true,
						alignment: 'center'
					},
					invoiceDetailsBlue: {
						fontSize: 10,
						bold: true,
						color: '#160091'
					},
					invoiceDetailsBlueConsignee: {
						fontSize: 11,
						bold: true,
						color: '#160091'
					},
					invoiceDetails1: {
						fontSize: 9,
						bold: true,
					},
					totalAmountHeader: {
						color: '#160091',
						fontSize: 10,
						bold: true,
					},
					invoiceStatusDetails: {
						color: '#FF0000',
						fontSize: 10,
						bold: true,
					},
					thankyouMsg: {
						color: '#160091',
						fontSize: 12,
						bold: true,
						alignment: 'center',
					}
				}
			}

			//Firm Details 
			pdfDoc.content[1].table.body[0][1].text[0].text = (metaData.firm.name ? (metaData.firm.name).toUpperCase() : '') + "\n";
			pdfDoc.content[1].table.body[0][1].text[1].text = (metaData.firm.GST_number ? metaData.firm.GST_number : '') + "\n";
			pdfDoc.content[1].table.body[0][1].text[2].text = (metaData.firm.liveAddress ? metaData.firm.liveAddress : '') + "\n";
			pdfDoc.content[1].table.body[0][1].text[3].text = (metaData.firm.address ? metaData.firm.address : '') + "\n";
			pdfDoc.content[1].table.body[0][1].text[4].text = (metaData.firm.mobileNumber ? metaData.firm.mobileNumber : '') + "\n";
			// pdfDoc.content[0].table.body[0][1].text[7].text = (metaData.firm.panNumber ? metaData.firm.panNumber : '') + "\n";
			pdfDoc.content[1].table.body[0][1].text[5].text = (metaData.firm.email ? metaData.firm.email : '') + "\n";
			// pdfDoc.content[0].table.body[0][1].text[13].text = (metaData.firm.website ? metaData.firm.website : '') + "\n";

			//Firm Details 
			// pdfDoc.content[0].table.body[0][2].text[0].text = (metaData.firm.name ? (metaData.firm.name).toUpperCase() : '') + "\n";
			// pdfDoc.content[0].table.body[0][2].text[1].text = (metaData.firm.liveAddress ? metaData.firm.liveAddress : '') + "\n";
			// pdfDoc.content[0].table.body[0][2].text[2].text = (metaData.firm.address ? metaData.firm.address : '') + "\n";
			// pdfDoc.content[0].table.body[0][2].text[3].text = (metaData.firm.mobileNumber ? metaData.firm.mobileNumber : '') + "\n";
			// pdfDoc.content[0].table.body[0][1].text[7].text = (metaData.firm.panNumber ? metaData.firm.panNumber : '') + "\n";
			// pdfDoc.content[0].table.body[0][2].text[4].text = (metaData.firm.email ? metaData.firm.email : '') + "\n";
			// pdfDoc.content[0].table.body[0][2].text[5].text = (metaData.firm.GST_number ? metaData.firm.GST_number : '') + "\n";
			// pdfDoc.content[0].table.body[0][1].text[13].text = (metaData.firm.website ? metaData.firm.website : '') + "\n";

			//Invoice Details
			// let date = new Date(metaData.invoiceData.date)
			// let paymentDueDate = date.setDate(date.getDate() + metaData.invoiceData.duration ? metaData.invoiceData.duration : 0);
			let date = new Date(metaData.invoiceData.date)
			let paymentDueDate = date.setDate(date.getDate() + (metaData.invoiceData.duration ? parseInt(metaData.invoiceData.duration) : 0));
			pdfDoc.content[1].table.body[0][2].text[1].text = metaData.invoiceData.invoiceId + "\n";
			pdfDoc.content[1].table.body[0][2].text[3].text = new Date(metaData.invoiceData.date).toLocaleDateString('en-GB').toString() + "\n";
			pdfDoc.content[1].table.body[0][2].text[5].text = (metaData.invoiceData.status ? metaData.invoiceData.status.toUpperCase() : '') + "\n";
			pdfDoc.content[1].table.body[0][2].text[7].text = new Date(paymentDueDate).toLocaleDateString('en-GB').toString() + "\n";
			pdfDoc.content[1].table.body[0][2].text[9].text = (metaData.ebillDetails.billNo ? metaData.ebillDetails.billNo : '') + "\n";   //eway bill nu
			pdfDoc.content[1].table.body[0][2].text[11].text = (metaData.invoiceData.orderNumber ? metaData.invoiceData.orderNumber : '-') + "\n";
			pdfDoc.content[1].table.body[0][2].text[13].text = (metaData.invoiceData.orderDate ? new Date(metaData.invoiceData.orderDate).toLocaleDateString('en-GB').toString() : '-') + "\n";
			// pdfDoc.content[1].table.body[1][2].text[15].text = (metaData.transportationDetails.vehicleNo ? metaData.transportationDetails.vehicleNo : '') + "\n";
			// pdfDoc.content[1].table.body[1][2].text[17].text = (metaData.transportationDetails.driverName ? metaData.transportationDetails.driverName : '') + "\n";
			// pdfDoc.content[1].table.body[1][2].text[19].text = (metaData.transportationDetails.driverNumber ? metaData.transportationDetails.driverNumber : '') + "\n";


			if (metaData.transportationDetails.transporterName) {
				pdfDoc.content[3].table.body[1][2].table.body.push(
					[
						{ text: 'Transporter  :', style: "invoiceDetails" },
						{ text: (metaData.transportationDetails.transporterName), style: "invoiceDetails" }
					]
				)
			}

			if (metaData.transportationDetails.goodsReceiptNumber) {
				pdfDoc.content[3].table.body[1][2].table.body.push(
					[
						{ text: 'GR/LR No     :', style: "invoiceDetails" },
						{ text: (metaData.transportationDetails.goodsReceiptNumber), style: "invoiceDetails" }
					]
				)
			}

			if (metaData.transportationDetails.vehicleNo) {
				pdfDoc.content[3].table.body[1][2].table.body.push(
					[
						{ text: 'Vehicle No    :', style: "invoiceDetails" },
						{ text: (metaData.transportationDetails.vehicleNo.toUpperCase()), style: "invoiceDetails" }
					]
				)
			}

			if (metaData.transportationDetails.driverName) {
				pdfDoc.content[3].table.body[1][2].table.body.push(
					[
						{ text: 'Driver Name :', style: "invoiceDetails" },
						{ text: (metaData.transportationDetails.driverName), style: "invoiceDetails" }
					]
				)
			}

			if (metaData.transportationDetails.driverNumber) {
				pdfDoc.content[3].table.body[1][2].table.body.push(
					[
						{ text: 'Driver M.No  :', style: "invoiceDetails" },
						{ text: (metaData.transportationDetails.driverNumber), style: "invoiceDetails" }
					]
				)
			}

			if (metaData.transportationDetails.remark) {
				pdfDoc.content[3].table.body[1][2].table.body.push(
					[
						{ text: 'Delivery Terms :', style: "invoiceDetails" },
						{ text: (metaData.transportationDetails.remark), style: "invoiceDetails" }
					]
				)
			}

			if (metaData.transportationDetails.supplyDate) {
				pdfDoc.content[3].table.body[1][2].table.body.push(
					[
						{ text: 'Delivery Terms :', style: "invoiceDetails" },
						{ text: new Date(metaData.transportationDetails.supplyDate).toLocaleDateString('en-GB').toString(), style: "invoiceDetails" }
					]
				)
			}


			// pdfDoc.content[3].table.body[1][2].text[1].text = (metaData.transportationDetails.transporterName ? metaData.transportationDetails.transporterName : '') + "\n";
			// pdfDoc.content[3].table.body[1][2].text[3].text = (metaData.transportationDetails.goodsReceiptNumber ? metaData.transportationDetails.goodsReceiptNumber : '') + "\n";
			// pdfDoc.content[3].table.body[1][2].text[5].text = (metaData.transportationDetails.vehicleNo ? metaData.transportationDetails.vehicleNo : '').toUpperCase() + "\n";
			// pdfDoc.content[3].table.body[1][2].text[7].text = (metaData.transportationDetails.driverName ? metaData.transportationDetails.driverName : '') + "\n";
			// pdfDoc.content[3].table.body[1][2].text[9].text = (metaData.transportationDetails.driverNumber ? metaData.transportationDetails.driverNumber : '') + "\n";
			// pdfDoc.content[3].table.body[1][2].text[11].text = (metaData.invoiceData.remark ? metaData.invoiceData.remark : '') + "\n";
			// pdfDoc.content[3].table.body[1][2].text[13].text = (metaData.transportationDetails.supplyDate ? new Date(metaData.transportationDetails.supplyDate).toLocaleDateString('en-GB').toString() : '') + "\n";

			//Receipient Details

			// pdfDoc.content[3].table.body[1][0].text[1].text = (metaData.customer.name ? (metaData.customer.name).toUpperCase() : '') + "\n";
			pdfDoc.content[3].table.body[1][0].text[1].text = (getCustomerDetails(metaData, 'name').toUpperCase()) + "\n";
			pdfDoc.content[3].table.body[1][0].text[3].text = (metaData.customer.GST_number ? metaData.customer.GST_number : '') + "\n";
			pdfDoc.content[3].table.body[1][0].text[5].text = (metaData.customer.localAddress ? metaData.customer.localAddress : '') + "\n";
			// pdfDoc.content[3].table.body[1][0].text[7].text = (metaData.customer.address ? metaData.customer.address : '') + "\n";
			// pdfDoc.content[3].table.body[1][0].text[9].text = (metaData.customer.mobile ? metaData.customer.mobile : '') + "\n";
			pdfDoc.content[3].table.body[1][0].text[7].text = (getCustomerDetails(metaData, 'address')) + "\n";
			pdfDoc.content[3].table.body[1][0].text[9].text = (getCustomerDetails(metaData, 'mobile').toUpperCase()) + "\n";
			pdfDoc.content[3].table.body[1][0].text[11].text = (metaData.invoiceData.placeOfSupply ? metaData.invoiceData.placeOfSupply : '') + "\n";
			pdfDoc.content[3].table.body[1][0].text[13].text = (metaData.consignee.stateCode ? metaData.consignee.stateCode : '') + "\n";

			//Consignee Details
			pdfDoc.content[3].table.body[1][1].text[1].text = (metaData.consignee.name ? (metaData.consignee.name).toUpperCase() : '') + "\n";
			pdfDoc.content[3].table.body[1][1].text[3].text = (metaData.consignee.GST_number ? metaData.consignee.GST_number : '') + "\n";
			pdfDoc.content[3].table.body[1][1].text[5].text = (metaData.consignee.localAddress ? metaData.consignee.localAddress : metaData.customer.localAddress) + "\n";
			pdfDoc.content[3].table.body[1][1].text[7].text = (metaData.consignee.address ? metaData.consignee.address : '') + "\n";
			pdfDoc.content[3].table.body[1][1].text[9].text = (metaData.consignee.mobile ? metaData.consignee.mobile : '') + "\n";
			pdfDoc.content[3].table.body[1][1].text[11].text = (metaData.invoiceData.placeOfSupply ? metaData.invoiceData.placeOfSupply : '') + "\n";
			pdfDoc.content[3].table.body[1][1].text[13].text = (metaData.consignee.stateCode ? metaData.consignee.stateCode : '') + "\n";

			//Products
			let productList = convertToPDFProductForSimplePrint(metaData.invoiceData.items, false, false, false, false, false, false, metaData.invoiceData);
			productList.map((item) => {
				pdfDoc.content[5].table.body.push(item);
			});
			let gstObj = convertToGST(metaData.invoiceData.items);
			Object.keys(gstObj).forEach((key) => {
				if (key != "totalObj") {
					pdfDoc.content[7].table.body[0][0][0].table.body.push([
						{ text: key, style: "product1" },
						{ text: gstObj[key].quantity, style: "product1" },
						{ text: Number.parseFloat(gstObj[key].basicPrice).toFixed(2), style: "product1" },
						{ text: gstObj[key].CGST + '%', style: "product1" },
						{ text: gstObj[key].CGST_val.toFixed(2), style: "product1" },
						{ text: gstObj[key].SGST + '%', style: "product1" },
						{ text: gstObj[key].SGST_val.toFixed(2), style: "product1" },
						{ text: gstObj[key].IGST + '%', style: "product1" },
						{ text: gstObj[key].IGST_val.toFixed(2), style: "product1" },
						{ text: Number.parseFloat(gstObj[key].GSTValue).toFixed(2), style: "product1" }])
				}
			});

			pdfDoc.content[7].table.body[0][0][0].table.body.push([
				{ text: 'Total', style: "total1" },
				{ text: gstObj.totalObj.quantity, style: "total1" },
				{ text: Number.parseFloat(gstObj.totalObj.basicPrice).toFixed(2), style: "total1" },
				{ text: '', style: "total1" },
				{ text: Number.parseFloat(gstObj.totalObj.CGST_val).toFixed(2), style: "total1" },
				{ text: '', style: "total1" },
				{ text: Number.parseFloat(gstObj.totalObj.SGST_val).toFixed(2), style: "total1" },
				{ text: '', style: "total1" },
				{ text: Number.parseFloat(gstObj.totalObj.IGST_val).toFixed(2), style: "total1" },
				{ text: Number.parseFloat(gstObj.totalObj.GSTValue).toFixed(2), style: "total1" }]);

			//Bank Account Details
			if (metaData.terms.banks.length) {
				metaData.terms.banks.map((bankDetails) => {
					pdfDoc.content[9].table.body[0][0].text.push({ text: bankDetails.bankName + "\n", style: 'invoiceDetails1' })
					pdfDoc.content[9].table.body[0][0].text.push({ text: "NAME: " + bankDetails.accountHolderName + "\n", style: 'invoiceDetails1' })
					pdfDoc.content[9].table.body[0][0].text.push({ text: "A/C NO:  " + bankDetails.accountnumber + "\n", style: 'invoiceDetails1' })
					pdfDoc.content[9].table.body[0][0].text.push({ text: "IFSC: " + bankDetails.ifsccode + "\n", style: 'invoiceDetails1' })
					pdfDoc.content[9].table.body[0][0].text.push({ text: bankDetails.accountLocation + "\n", style: 'invoiceDetails1' })
				})
			}

			pdfDoc.content[8].table.body[0][0].text = ("In Words: " + _.startCase(digitsToWords(metaData.invoiceData.totalAmount)))

			//Terms and cond
			pdfDoc.content[9].table.body[0][1].text[1].text = metaData.terms.termsAndConditions;

			//gst details
			// pdfDoc.content[5].table.body[0][1].text[1].text = (metaData.invoiceData.totalAmount ? Number.parseFloat(metaData.invoiceData.totalAmount).toFixed(2) - Number.parseFloat(metaData.gstTotal.CGST_val + metaData.gstTotal.SGST_val + metaData.gstTotal.IGST_val).toFixed(2) : '0') + "\n";
			// pdfDoc.content[3].table.body[0][1].text[1].text = (metaData.invoiceData.totalAmount - metaData.invoiceData.roundOffAmount ? Number.parseFloat(metaData.invoiceData.totalAmount - metaData.invoiceData.roundOffAmount).toFixed(2) - Number.parseFloat(metaData.gstTotal.CGST_val + metaData.gstTotal.SGST_val + metaData.gstTotal.IGST_val).toFixed(2) : '0').toFixed(2) + "\n";
			pdfDoc.content[7].table.body[0][1].text[1].text = (
				Number.parseFloat(metaData.invoiceData.totalAmount) +
				Number.parseFloat(metaData.invoiceData.discountAmount || 0) -
				Number.parseFloat(metaData.invoiceData.totalExtraCharges || 0) -
				Number.parseFloat(metaData.invoiceData.roundOffAmount || 0) -
				(Number.parseFloat(
					metaData.gstTotal.SGST_val
				) +
					Number.parseFloat(
						metaData.gstTotal.CGST_val
					) +
					Number.parseFloat(
						metaData.gstTotal.IGST_val
					))
			).toFixed(2) + "\n";
			pdfDoc.content[7].table.body[0][1].text[3].text = (metaData.gstTotal.CGST_val ? (Number.parseFloat(metaData.gstTotal.CGST_val) + Number.parseFloat(metaData.invoiceData.gstOnExtraChanrges ? Number.parseFloat(metaData.invoiceData.totalExtraChargesGST) / 2 : 0)).toFixed(2) : '0.00') + "\n";
			pdfDoc.content[7].table.body[0][1].text[5].text = (metaData.gstTotal.SGST_val ? (Number.parseFloat(metaData.gstTotal.SGST_val) + Number.parseFloat(metaData.invoiceData.gstOnExtraChanrges ? Number.parseFloat(metaData.invoiceData.totalExtraChargesGST) / 2 : 0)).toFixed(2) : '0.00') + "\n";
			pdfDoc.content[7].table.body[0][1].text[7].text = (metaData.gstTotal.IGST_val ? (Number.parseFloat(metaData.gstTotal.IGST_val) + Number.parseFloat(metaData.invoiceData.gstOnExtraChanrges ? Number.parseFloat(metaData.invoiceData.totalExtraChargesGST) : 0)).toFixed(2) : '0.00') + "\n";
			let offset = 0;
			if (!metaData.invoiceData.gstOnExtraChanrges && metaData.invoiceData.extraCharges && metaData.invoiceData.extraCharges.length) {
				metaData.invoiceData.extraCharges.map((charge) => {
					pdfDoc.content[7].table.body[0][1].text.splice(8 + offset, 0, { text: '' + charge.name + ':        ', bold: true, style: 'invoiceDetails' })
					offset++;
					pdfDoc.content[7].table.body[0][1].text.splice(8 + offset, 0, { text: Number.parseFloat(charge.amount).toFixed(2) + '\n', style: 'invoiceDetails' })
					offset++;
				})
			}
			// pdfDoc.content[3].table.body[0][1].text[9].text = (metaData.invoiceData.labourAmount ? Number.parseFloat(metaData.invoiceData.labourAmount).toFixed(2) : '0') + "\n";
			pdfDoc.content[7].table.body[0][1].text[9 + offset].text = (metaData.invoiceData.discountAmount ? Number.parseFloat(metaData.invoiceData.discountAmount).toFixed(2) : '0') + "\n";
			pdfDoc.content[7].table.body[0][1].text[11 + offset].text = (metaData.invoiceData.roundOffAmount ? Number.parseFloat(metaData.invoiceData.roundOffAmount).toFixed(2) : '0') + "\n";
			pdfDoc.content[7].table.body[0][1].text[13 + offset].text = (metaData.invoiceData.totalAmount ? Number.parseFloat(metaData.invoiceData.totalAmount).toFixed(2) : '0') + "\n";
			pdfDoc.content[7].table.body[0][1].text[15 + offset].text = (metaData.invoiceData.paidAmount ? Number.parseFloat(metaData.invoiceData.paidAmount).toFixed(2) : '0') + "\n";
			pdfDoc.content[7].table.body[0][1].text[17 + offset].text = (metaData.invoiceData.remainingAmount ? Number.parseFloat(metaData.invoiceData.remainingAmount).toFixed(2) : '') + "\n";


			//thank you
			// pdfDoc.content[7].table.body[0][0].text =  "Thank You " + (metaData.customer.name.toUpperCase() ? metaData.customer.name.toUpperCase() : '') +" For Choosing us!" ;
			// pdfDoc.content[10].table.body[0][0].text =  metaData.terms.termsAndConditions.greetingMessage || ("Thank You " + ((metaData.customer && metaData.customer.name )? metaData.customer.name.toUpperCase() : '') +" For doing business with us!" );
			// pdfDoc.content[6].table.body[0][1].text[17].text = (metaData.invoiceData.paymentType ? metaData.invoiceData.paymentType : '') + "\n";
			pdfDoc.content[10].table.body[0][0].text = metaData.terms.termsAndConditions.greetingMessage || ("Thank You " + (getCustomerDetails(metaData, 'name').toUpperCase()) + " For your business with us!");

			//authority
			pdfDoc.content[9].table.body[0][2][1].text = metaData.firm.name ? (metaData.firm.name).toUpperCase() : '';

			if (metaData.terms.printLogo) {
				try {
					let logoData = await getBase64ImageFromURL(metaData.terms.printLogo)
					pdfDoc.content[1].table.body[0][0].image = logoData;
					let invoiceImages = document.getElementById('invoiceImages');
					if (invoiceImages && invoiceImages.files && invoiceImages.files.length) {
						let temp = {columns: []};
						if(invoiceImages.files[0]) {
							temp.columns.push({
								image: await toBase64(invoiceImages.files[0]).catch(e => Error(e)),
								width: 150
							})
						}
						if(invoiceImages.files[1]) {
							temp.columns.push({
								image: await toBase64(invoiceImages.files[1]).catch(e => Error(e)),
								width: 150
							})
						}
						if(invoiceImages.files[2]) {
							temp.columns.push({
								image: await toBase64(invoiceImages.files[2]).catch(e => Error(e)),
								width: 150
							})
						}
						pdfDoc.content.push(temp)
					}
					if(metaData.terms.signature) {
						let temp = {columns: []};
						temp.columns.push({
							image: await getBase64ImageFromURL(metaData.terms.signature),
							width: 150,
							alignment: 'right'
						})
						//pdfDoc.content.push(temp)
						pdfDoc.content[4].table.body[0][2][2] = temp.columns[0]
					}
					return pdfDoc;
				} catch (error) {
					console.log(error)
				}
			} else {
				var imgToExport = document.getElementById('pdfimgToExport');
				var canvas = document.createElement('canvas');
				canvas.width = imgToExport.width;
				canvas.height = imgToExport.height;
				canvas.getContext('2d').drawImage(imgToExport, 0, 0);
				let base64 = canvas.toDataURL('image/png')
				pdfDoc.content[1].table.body[0][0].image = base64;
				let invoiceImages = document.getElementById('invoiceImages');
					if (invoiceImages && invoiceImages.files && invoiceImages.files.length) {
						let temp = {columns: []};
						if(invoiceImages.files[0]) {
							temp.columns.push({
								image: await toBase64(invoiceImages.files[0]).catch(e => Error(e)),
								width: 150
							})
						}
						if(invoiceImages.files[1]) {
							temp.columns.push({
								image: await toBase64(invoiceImages.files[1]).catch(e => Error(e)),
								width: 150
							})
						}
						if(invoiceImages.files[2]) {
							temp.columns.push({
								image: await toBase64(invoiceImages.files[2]).catch(e => Error(e)),
								width: 150
							})
						}
						pdfDoc.content.push(temp)
					}
			}
			


			if(metaData.terms.signature) {
				let temp = {columns: []};
				temp.columns.push({
					image: await getBase64ImageFromURL(metaData.terms.signature),
					width: 150,
					alignment: 'right',
				})
				//pdfDoc.content.push(temp)
				pdfDoc.content[4].table.body[0][2][2] = temp.columns[0]
			}
			return pdfDoc;
		}
		// end of New Development Part -3 

		export const convertToPDFProductForSimplePrint = (items, isTradeDiscount, isSpecialCharge, isGrossWeight, isNetWeight, isLessStone, isPurity, purityRemark, isGSTGroupingDisabled, isTotalAmount, invoiceData) => {

			let productList = [];
			let totalObj = {
				quantity: 0,
				basicPrice: 0,
				totlePrice: 0,
				CGST_val: 0,
				SGST_val: 0,
				IGST_val: 0,
				tradeDiscount: 0,
				specialCharge: 0,
				netWeight: 0,
				purity: 100,
				grossWeight: 0,
				lessStone: 0,
				taxableGST_rate: 0,
				totalAmount: 0,
			}
			let lastIndex = 0;
			items.map((item, index) => {
				let product = [];
				lastIndex = index;
				let totalAmount = Number.parseFloat(item.basicPrice) + Number.parseFloat(item.GSTValue)
				product.push({ text: index + 1, style: "product" });
				product.push({ text: item.productName + (item.subDescription ? "\n" + item.subDescription + "\n" : ""), alignment: 'left', fontSize: '10' });
				product.push({ text: item.HSN_code, style: "product" });
				if (isGSTGroupingDisabled) {
					product.push({ text: item.taxableGST_rate + " %", style: "product" });
				}
				product.push({ text: item.quantity, style: "productRight" });
				product.push({ text: item.unit, style: "product" });
				if (isPurity) {
					product.push({ text: Number.parseFloat(item.purity).toFixed(2), style: "productRight" });
				}
				if (purityRemark) {
					product.push({ text: item.purityRemark, style: "productRight" });
				}
				if (isGrossWeight) {
					product.push({ text: Number.parseFloat(item.grossWeight).toFixed(3), style: "productRight" });
				}
				if (isNetWeight) {
					let netWeight = Number.parseFloat(Number.parseFloat((item.grossWeight - item.lessStone) * (item.purity/100))).toFixed(3)
					product.push({ text: Number.parseFloat(netWeight).toFixed(3), style: "productRight" });
				}
				if (isLessStone) {
					product.push({ text: Number.parseFloat(item.lessStone).toFixed(3), style: "productRight" });
				}
				product.push({ text: item.rate, style: "productRight" });
				if (isSpecialCharge) {
					let percentage = Math.abs((100 * item.specialCharge) / (item.basicPrice - item.specialCharge)).toFixed(2)
					product.push({ text: percentage, style: "productRight" });
				}
				if (isTradeDiscount) {
					product.push({ text: Number.parseFloat(item.tradeDiscount).toFixed(2), style: "productRight" });
				}
				product.push({ text: Number.parseFloat(item.basicPrice).toFixed(2), style: "productRight" });
				if (isTotalAmount) {
					product.push({ text: Number.parseFloat(totalAmount).toFixed(2), style: "productRight" });
				}

				totalObj.quantity += item.quantity;
				totalObj.basicPrice += Number.parseFloat(item.basicPrice);
				totalObj.CGST_val += Number.parseFloat(item.CGST_val);
				totalObj.SGST_val += Number.parseFloat(item.SGST_val);
				totalObj.IGST_val += Number.parseFloat(item.IGST_val);
				totalObj.tradeDiscount += Number.parseFloat(item.tradeDiscount);
				totalObj.specialCharge += Number.parseFloat(item.specialCharge);
				totalObj.grossWeight += Number.parseFloat(item.grossWeight);
				totalObj.netWeight += Number.parseFloat(item.netWeight);
				totalObj.totalAmount += Number.parseFloat(totalAmount);
				productList.push(product);
			})
			if (invoiceData.gstOnExtraChanrges) {
				let isIGST = invoiceData.gstType == 'IGST' ? true : false;
				invoiceData.extraCharges.map((item, index) => {
					let product = [];
					let totalAmount = Number.parseFloat(item.amount) + Number.parseFloat(item.GSTValue)
					product.push({ text: lastIndex + 1, style: "product" });
					product.push({ text: item.name + (item.subDescription ? "\n" + item.subDescription + "\n" : ""), alignment: 'left', fontSize: '10' });
					product.push({ text: "", style: "product" });
					if (isGSTGroupingDisabled) {
						product.push({ text: item.gst + " %", style: "product" });
					}
					product.push({ text: "", style: "productRight" });
					product.push({ text: "", style: "product" });
					if (isPurity) {
						product.push({ text: "", style: "productRight" });
					}
					if (purityRemark) {
						product.push({ text: "", style: "productRight" });
					}
					if (isGrossWeight) {
						product.push({ text: "", style: "productRight" });
					}
					if (isNetWeight) {
						product.push({ text: "", style: "productRight" });
					}
					if (isLessStone) {
						product.push({ text: "", style: "productRight" });
					}
					product.push({ text: "", style: "productRight" });
					if (isSpecialCharge) {
						product.push({ text: "", style: "productRight" });
					}
					if (isTradeDiscount) {
						product.push({ text: "", style: "productRight" });
					}
					product.push({ text: Number.parseFloat(item.amount).toFixed(2), style: "productRight" });
					if (isTotalAmount) {
						product.push({ text: Number.parseFloat(totalAmount).toFixed(2), style: "productRight" });
					}
					totalObj.quantity += 0;
					totalObj.basicPrice += Number.parseFloat(item.amount);
					if (isIGST) {
						totalObj.IGST_val += Number.parseFloat(item.gstAmount);
					} else {
						totalObj.CGST_val += Number.parseFloat(item.gstAmount / 2);
						totalObj.SGST_val += Number.parseFloat(item.gstAmount / 2);
					}
					totalObj.tradeDiscount += 0;
					totalObj.specialCharge += 0;
					totalObj.netWeight += 0;
					totalObj.grossWeight += 0;
					totalObj.totalAmount += Number.parseFloat(totalAmount);
					productList.push(product);
				});
			}
			let temp = [
				{ text: '', style: "product" },
				{ text: 'Total', style: "total" },
				{ text: '', style: "product" },
			]

			if (isGSTGroupingDisabled) {
				temp.push({ text: '', style: "product" },);
			}
			temp.push({ text: (totalObj.quantity).toFixed(2), style: "productRight" })
			temp.push({ text: '', style: "product" })
			if (isPurity) {
				temp.push({ text: '', style: "totalRight" });
			}
			if (purityRemark) {
				temp.push({ text: '', style: "totalRight" });
			}
			if (isGrossWeight) {
				temp.push({ text: totalObj.grossWeight.toFixed(3), style: "totalRight" });
			}
			if (isNetWeight) {
				temp.push({ text: totalObj.netWeight.toFixed(3), style: "totalRight" });
			}
			if (isLessStone) {
				temp.push({ text: '', style: "totalRight" });
			}
			temp.push({ text: '', style: "product" })
			if (isSpecialCharge) {
				temp.push({ text: '', style: "totalRight" });
			}
			if (isTradeDiscount) {
				temp.push({ text: totalObj.tradeDiscount.toFixed(2), style: "totalRight" });
			}
			temp.push({ text: totalObj.basicPrice.toFixed(2), style: "totalRight" })
			if (isTotalAmount) {
				temp.push({ text: totalObj.totalAmount.toFixed(2), style: "totalRight" });
			}
			productList.push(temp);
			return productList;
		}

		// Start - Simple Print
		export const convertToSimpleInvoicePrint = async (metaData) => {
			let pdfDoc = {
				content: [
					{ text: 'TAX INVOICE', style: 'header' },
					{
						table: {
							widths: ['50%', '50%'],
							body: [
								[
									{
										image: 'sampleImage.jpg',
										width: 100,
										height: 80,
									},

									{
										text:
											[
												{ text: 'Firm Name\n', style: 'topFirmAuthority1Right' },
												{ text: 'Live Address\n', style: 'topFirmHeaderRight' },
												{ text: 'Address\n', style: 'topFirmHeaderRight' },
												{ text: 'GSTIN\n', style: 'topFirmHeaderRight' },
												{ text: 'MOBILE\n', style: 'topFirmHeaderRight' },
												{ text: 'EMAIL\n', style: 'topFirmHeaderRight' },
											]
									},
								],
							],

						},
						layout: {
							hLineWidth: function (i, node) {
								return (i === 0 || i === node.table.body.length) ? 2 : 0;
							},
							vLineWidth: function (i, node) {
								return (i === 0 || i === node.table.widths.length) ? 2 : 0;
							},
							hLineColor: function (i, node) {
								return (i === 0 || i === node.table.body.length) ? 'black' : 'white';
							},
							vLineColor: function (i, node) {
								return (i === 0 || i === node.table.widths.length) ? 'black' : 'white';
							},
						}
					},
					// {text:'\n'},
					{
						table: {
							widths: ['60%', '40%'],
							body: [
								[
									{ text: 'BILL TO', style: "topCustomerHeader" },
									{ text: 'INVOICE DETAILS', style: "topHeader" },
								],
								[
									{
										text:
											[
												{ text: ' ', bold: true, style: 'invoiceDetails' },
												{ text: 'Google\n', style: 'invoiceDetailsBlueConsignee' },
												{ text: ' ', bold: true, style: 'invoiceDetails' },
												{ text: '1600 Amphitheatre Parkway in Mountain View, California, United States, near San Jose. \n', style: 'invoiceDetails' },
												{ text: ' ', bold: true, style: 'invoiceDetails' },
												{ text: '1600 Amphitheatre Parkway in Mountain View, California, United States, near San Jose. \n', style: 'invoiceDetails' },
												{ text: ' ', bold: true, style: 'invoiceDetails' },
												{ text: '7788996655\n', style: 'invoiceDetails' },
												{ text: 'Mobile Number  : ', bold: true, style: "invoiceDetails" },
												{ text: '1679905\n', style: "invoiceDetails" },
												{ text: 'Place of Supply  : ', bold: true, style: "invoiceDetails" },
												{ text: '23\n', style: "invoiceDetails" },
												{ text: 'State Code          : ', bold: true, style: "invoiceDetails" },
												{ text: '23\n', style: "invoiceDetails" },
											]
									},
									{
										text:
											[
												{ text: 'Invoice No        :  ', bold: true, style: "invoiceDetails" },
												{ text: '787878\n', style: "invoiceDetailsBlue" },
												{ text: 'Invoice Date     :  ', bold: true, style: "invoiceDetails" },
												{ text: '12/12/90 \n', style: "invoiceDetails" },
												{ text: 'Invoice Status  :  ', bold: true, style: 'invoiceDetails' },
												{ text: '12/12/90 \n', style: 'invoiceStatusDetails' },
												{ text: 'Payment Date  :  ', bold: true, style: "invoiceDetails" },
												{ text: '13/12/90\n', style: "invoiceDetails" },
												{ text: 'Delivery Terms :  ', bold: true, style: "invoiceDetails" },
												{ text: '13/12/90\n', style: "invoiceDetails" },
												// { text: 'Payment Type  :  ', bold: true, style: "invoiceDetails" },
												// { text: '\n', style: "invoiceDetails" },
												// { text: 'From Cash 		:  ', bold: true, style: "invoiceDetails" },
												// { text: '\n', style: "invoiceDetails" },
												// { text: 'From Bank 		:  ', bold: true, style: "invoiceDetails" },
												// { text: '\n', style: "invoiceDetails" },
											]
									},

								],
							]
						}
					},
					//{text:'\n'},    
					{
						table: {
							//widths: ['6%','28%','10%','5%','8%','8%','*'],
							widths: ['3%', '22%', '6%'],
							body: [
								[
									{ text: 'NO.', style: "productHeader" },
									{ text: 'PRODUCT DESCRIPTION', style: "productHeader" },
									{ text: 'HSN/SAC', style: "productHeader" },
								],
							]
						}
					},
					//{text:'\n'},
					{
						table: {
							widths: ['70%', '*'],
							body: [

								[
									[
										{
											table: {

												body: [
													[{ text: 'HSN SUMMARY', style: "gstHeader1", colSpan: 10 },
													{ text: 'Qty', style: "gstHeader" },
													{ text: 'TAXABLE AMOUNT', style: "gstHeader" },
													{ text: '%', style: "gstHeader" },
													{ text: 'AMOUNT', style: "gstHeader" },
													{ text: '%', style: "gstHeader" },
													{ text: 'AMOUNT', style: "gstHeader" },
													{ text: '%', style: "gstHeader" },
													{ text: 'AMOUNT', style: "gstHeader" },
													{ text: 'TOTAL TAX AMOUNT', style: "gstHeader" }],
													[

														{ text: 'HSN/SAC', style: "gstHeader", rowSpan: 2 },
														{ text: 'QTY', style: "gstHeader", rowSpan: 2 },
														{ text: 'TAXABLE AMOUNT', style: "gstHeader", rowSpan: 2 },
														{ text: 'CGST', style: "gstHeader", colSpan: 2, rowSpan: 1 },
														{ text: '', style: "gstHeader", rowSpan: 2 },
														{ text: 'SGST', style: "gstHeader", colSpan: 2, rowSpan: 1 },
														{ text: '', style: "gstHeader", rowSpan: 2 },
														{ text: 'IGST', style: "gstHeader", colSpan: 2, rowSpan: 1 },
														{ text: '', style: "gstHeader", rowSpan: 2 },
														{ text: 'TOTAL TAX AMOUNT', style: "gstHeader", rowSpan: 2 },

													],
													[

														{ text: 'HSN/SAC', style: "gstHeader" },
														{ text: 'Qty', style: "gstHeader" },
														{ text: 'Taxable Amount', style: "gstHeader" },
														{ text: '%', style: "gstHeader" },
														{ text: 'Amount', style: "gstHeader" },
														{ text: '%', style: "gstHeader" },
														{ text: 'Amount', style: "gstHeader" },
														{ text: '%', style: "gstHeader" },
														{ text: 'Amount', style: "gstHeader" },
														{ text: 'Total Tax Amount', style: "gstHeader" },

													],
												]
											}
										},


									],
									{
										text:
											[
												{ text: 'Taxable Amount  :   ', bold: true, style: 'invoiceDetails' },
												{ text: '12122\n', style: 'invoiceDetails' },
												{ text: 'CGST Amount      :   ', bold: true, style: 'invoiceDetails' },
												{ text: '12122\n', style: 'invoiceDetails' },
												{ text: 'SGST Amount      :   ', bold: true, style: 'invoiceDetails' },
												{ text: '12122\n', style: 'invoiceDetails' },
												{ text: 'IGST Amount       :   ', bold: true, style: 'invoiceDetails' },
												{ text: '12122\n', style: 'invoiceDetails' },
												// { text: 'Labour Charge:-                ', bold: true },
												// { text: '12122\n' },
												{ text: 'Discount               :   ', bold: true, style: 'invoiceDetails' },
												{ text: '12122\n', style: 'invoiceDetails' },
												{ text: 'RoundOff              :   ', bold: true, style: 'invoiceDetails' },
												{ text: '12122\n', style: 'invoiceDetails' },
												{ text: 'Total Amount       :   ', bold: true, style: 'totalAmountHeader' },
												{ text: '12122\n', style: 'totalAmountHeader' },
												{ text: 'Paid Amount        :   ', bold: true, style: 'invoiceDetails' },
												{ text: '12122\n', style: 'invoiceDetails' },
												{ text: 'Due Amount         :   ', bold: true, style: 'invoiceStatusDetails' },
												{ text: '12122\n', style: 'invoiceStatusDetails' },
											]

									},

								],
							],


						},
						style: 'tab2',



					},
					{
						table: {
							widths: ['*'],
							body: [
								[
									{ text: "In Words: ", style: 'invoiceDetails' },
								],
							],
						},
					},
					// Start of Previous + current = Total Column
					{
						table: {
							widths: ['34%', '39%', '27%'],
							body: [
								[
									{ text: '', style: "topBlankHeader" },
									{ text: '', style: "topMainHeader" },
									{ text: '', style: "topBlankHeader" },
								],
								[
									{
										text:
											[
												{ text: 'PREVIOUS BALANCE :  ', bold: true, style: 'topHeader11' },
												{ text: '\n', style: 'topHeader11' },
											]
									},
									{
										text:
											[
												{ text: 'CURRENT BALANCE :  ', bold: true, style: 'topHeader11' },
												{ text: '\n', style: 'topHeader11' },
											]
									},

									{
										text:
											[
												{ text: 'TOTAL BALANCE :  ', bold: true, style: 'topRemainingHeader1' },
												{ text: '\n', style: 'topRemainingHeader1' },
											]
									},

								],
							]
						},
						layout: {
							hLineWidth: function (i, node) {
								return (i === 0 || i === node.table.body.length) ? 1 : 0;
							},
							vLineWidth: function (i, node) {
								return (i === 0 || i === node.table.widths.length) ? 1 : 0;
							},
							hLineColor: function (i, node) {
								return (i === 0 || i === node.table.body.length) ? 'black' : 'black';
							},
							vLineColor: function (i, node) {
								return (i === 0 || i === node.table.widths.length) ? 'black' : 'black';
							},
						}
					},
					// End of Previous + current = Total Column
					{
						table: {
							widths: ['30%', '40%', '30%'],
							body: [
								[
									{
										text:
											[
												{ text: 'PAYMENT DETAILS\n', style: 'transpotationDel' },
												{ text: '', style: 'invoiceDetails1' },
											]
									},
									{
										text:
											[
												{ text: 'TERMS AND CONDITIONS\n', style: 'transpotationDel' },
												{ text: '', style: 'invoiceDetails1' },

											]
									},

									// {
									// 	text:
											[{ text: '' },
											{ text: 'Firm Name  ', bold: true, alignment: 'center', style: 'topFirmAuthority' },
											{ text: '\n\n\n\n' },

											{ text: 'AUTHORITY SIGNATURE  ', bold: true, alignment: 'center', style: 'topFirmAuthority' },
											{ text: '\n' },
											]

									// },
								],
							],

						},
						layout: {
							hLineWidth: function (i, node) {
								return (i === 0 || i === node.table.body.length) ? 2 : 0;
							},
							vLineWidth: function (i, node) {
								return (i === 0 || i === node.table.widths.length) ? 2 : 0;
							},
							hLineColor: function (i, node) {
								return (i === 0 || i === node.table.body.length) ? 'black' : 'white';
							},
							vLineColor: function (i, node) {
								return (i === 0 || i === node.table.widths.length) ? 'black' : 'white';
							},
						}
					},
					{
						table: {
							widths: ['*'],
							body: [
								[
									{ text: 'Thank you', style: 'thankyouMsg' },
								],
							],
						},
					},
					// {
					// 	table: {
					// 		widths: ['8%', '10%', '20%', '15%', '15%', '15%', '10%', '7%'],
					// 		body: [
					// 			[{ text: 'Previous Due Invoices', style: "productHeader", colSpan: 8 },
					// 			{ text: 'Date', style: "productHeader" },
					// 			{ text: 'Invoice No.', style: "productHeader" },
					// 			{ text: 'Total Amount', style: "productHeader" },
					// 			{ text: 'Paid Amount', style: "productHeader" },
					// 			{ text: 'Due Amount', style: "productHeader" },
					// 			{ text: 'Duration', style: "gstHeader" },
					// 			{ text: 'Status', style: "productHeader" },],
					// 			[

					// 				{ text: 'S No.', style: "productHeader" },
					// 				{ text: 'Date', style: "productHeader" },
					// 				{ text: 'Invoice No.', style: "productHeader" },
					// 				{ text: 'Total Amount', style: "productHeader" },
					// 				{ text: 'Paid Amount', style: "productHeader" },
					// 				{ text: 'Due Amount', style: "productHeader" },
					// 				{ text: 'Duration', style: "productHeader" },
					// 				{ text: 'Status', style: "productHeader" },
					// 			],
					// 		]
					// 	}
					// },
					// {
					// 	table: {
					//         widths: ['10%','20%','*','20%'],
					// 		body: [
					// 			[{ text: 'Estimates', style: "productHeader", colSpan: 4 },
					// 		    { text: 'Date', style: "productHeader" },
					// 		    { text: 'Items', style: "productHeader" },
					// 			{ text: 'Total Amount', style: "productHeader" },
					//             ],
					// 		[

					// 			{ text: 'S No.', style: "productHeader" },
					// 			{ text: 'Date', style: "productHeader" },
					// 		    { text: 'Items', style: "productHeader" },
					// 			{ text: 'Total Amount', style: "productHeader" },
					// 		],
					// 		]
					// 	}
					// },

				],
				footer: {
					columns: [
						{ text: 'Powered By ACUIFY', alignment: 'right', color: '#160091' }
					],
					margin: [10, 10]
				},
				styles: {
					header: {
						fontSize: 15,
						bold: true,
						alignment: 'center',
						color: '#160091'
					},
					productHeader: {
						fontSize: 9,
						bold: true,
						alignment: 'center',
						color: '#160091',
					},
					transpotationDel: {
						fontSize: 9,
						bold: true,
						alignment: 'center',
						color: '#160091',
					},
					gstHeader: {
						fontSize: 8,
						color: '#160091',
						alignment: 'center'
					},
					gstHeader1: {
						fontSize: 10,
						color: '#160091',
						bold: true,
						alignment: 'center'
					},
					product: {
						fontSize: 9,
						alignment: 'center',
						bold: true
					},
					productRight: {
						fontSize: 10,
						alignment: 'right',
						// bold: true
					},
					totalRight: {
						fontSize: 10,
						alignment: 'right',
						bold: true
					},
					subproduct: {
						fontSize: 9,
						alignment: 'center',
					},
					product1: {
						fontSize: 7,
						alignment: 'center',
					},
					total: {
						fontSize: 10,
						alignment: 'center',
						bold: true
					},
					total1: {
						fontSize: 7,
						alignment: 'center',
					},
					topHeader: {
						color: '#160091',
						fontSize: 11,
						alignment: 'center',
						bold: true,
					},
					topCustomerHeader: {
						color: '#160091',
						fontSize: 11,
						alignment: 'left',
						bold: true,
					},

					topFirmAuthority: {
						color: '#160091',
						fontSize: 9,
						bold: true,
					},
					topFirmAuthority1: {
						color: '#160091',
						fontSize: 12,
						bold: true,
					},
					topFirmAuthority1Right: {
						color: '#160091',
						fontSize: 12,
						bold: true,
						alignment: 'right',
					},
					topFirmHeaderRight: {
						fontSize: 10,
						bold: true,
						alignment: 'right',
					},
					topFirmHeader: {
						fontSize: 10,
						bold: true,
					},
					invoiceDetails: {
						fontSize: 10,
						bold: true,
					},
					invoiceDetailsBlue: {
						fontSize: 10,
						bold: true,
						color: '#160091'
					},
					invoiceDetailsBlueConsignee: {
						fontSize: 11,
						bold: true,
						color: '#160091'
					},
					invoiceDetails1: {
						fontSize: 9,
						bold: true,
					},
					totalAmountHeader: {
						color: '#160091',
						fontSize: 10,
						bold: true,
					},
					invoiceStatusDetails: {
						color: '#FF0000',
						fontSize: 10,
						bold: true,
					},
					thankyouMsg: {
						color: '#160091',
						fontSize: 12,
						bold: true,
						alignment: 'center',
					},
					topHeader11: {
						color: '#160091',
						fontSize: 10,
						bold: true,
					},
					topRemainingHeader1: {
						color: '#FF0000',
						fontSize: 10,
						bold: true,
					},
					hiddenTab: {
						fillColor: '#ffffff',
						color: '#ffffff',
					},
				}
			}

			//Firm Details 
			pdfDoc.content[1].table.body[0][1].text[0].text = (metaData.firm.name ? (metaData.firm.name).toUpperCase() : '') + "\n";
			pdfDoc.content[1].table.body[0][1].text[1].text = (metaData.firm.GST_number ? metaData.firm.GST_number : '') + "\n";
			pdfDoc.content[1].table.body[0][1].text[2].text = (metaData.firm.liveAddress ? metaData.firm.liveAddress : '') + "\n";
			pdfDoc.content[1].table.body[0][1].text[3].text = (metaData.firm.address ? metaData.firm.address : '') + "\n";
			pdfDoc.content[1].table.body[0][1].text[4].text = (metaData.firm.mobileNumber ? metaData.firm.mobileNumber : '') + "\n";
			pdfDoc.content[1].table.body[0][1].text[5].text = (metaData.firm.email ? metaData.firm.email : '') + "\n";

			//Invoice Details
			let date = new Date(metaData.invoiceData.date)
			let paymentDueDate = date.setDate(date.getDate() + (metaData.invoiceData.duration ? parseInt(metaData.invoiceData.duration) : 0));
			pdfDoc.content[2].table.body[1][1].text[1].text = metaData.invoiceData.invoiceId + "\n";
			pdfDoc.content[2].table.body[1][1].text[3].text = new Date(metaData.invoiceData.date).toLocaleDateString('en-GB').toString() + "\n";
			pdfDoc.content[2].table.body[1][1].text[5].text = (metaData.invoiceData.status ? metaData.invoiceData.status.toUpperCase() : '') + "\n";
			pdfDoc.content[2].table.body[1][1].text[7].text = new Date(paymentDueDate).toLocaleDateString('en-GB').toString() + "\n";
			pdfDoc.content[2].table.body[1][1].text[9].text = (metaData.invoiceData.remark ? metaData.invoiceData.remark : '') + "\n";
			if (metaData.terms.isPaymentType) {
				pdfDoc.content[2].table.body[1][1].text.push({ text: 'Payment Type  :  ', bold: true, style:'invoiceDetails' })
				pdfDoc.content[2].table.body[1][1].text.push({ text: metaData.invoiceData.paymentType+'\n', style:'invoiceDetails' })
			}	// pdfDoc.content[2].table.body[1][1].text[11].text = (metaData.invoiceData.paymentType ? metaData.invoiceData.paymentType : '') + "\n";
			if (metaData.terms.isPaymentType && (metaData.invoiceData.paymentType ==='cash'||'CashAndBank Account')){
				pdfDoc.content[2].table.body[1][1].text.push({ text: 'From Cash 	   :  ', bold: true, style:'invoiceDetails' })
				pdfDoc.content[2].table.body[1][1].text.push({ text: metaData.invoiceData.amountFromCash+'\n', style:'invoiceDetails' })
			}	
			// 	pdfDoc.content[2].table.body[1][1].text[13].text = (metaData.invoiceData.amountFromCash ? metaData.invoiceData.amountFromCash : '') + "\n";
			if (metaData.terms.isPaymentType && (metaData.invoiceData.paymentType ==='bank' || 'CashAndBank Account') ){
				pdfDoc.content[2].table.body[1][1].text.push({ text: 'From Bank   	 :  ', bold: true, style:'invoiceDetails' })
				pdfDoc.content[2].table.body[1][1].text.push({ text: metaData.invoiceData.amountFromBank+'\n', style:'invoiceDetails' })
			}
			// 	pdfDoc.content[2].table.body[1][1].text[15].text = (metaData.invoiceData.amountFromBank ? metaData.invoiceData.amountFromBank : '') + "\n";
			//Receipient Details

			//pdfDoc.content[2].table.body[1][0].text[1].text = (metaData.customer.name ? (metaData.customer.name).toUpperCase() : '') + "\n";
			pdfDoc.content[2].table.body[1][0].text[1].text = (getCustomerDetails(metaData, 'name').toUpperCase()) + "\n";
			pdfDoc.content[2].table.body[1][0].text[3].text = (metaData.customer.GST_number ? metaData.customer.GST_number : '') + "\n";
			pdfDoc.content[2].table.body[1][0].text[5].text = (metaData.customer.localAddress ? metaData.customer.localAddress : '') + "\n";
			pdfDoc.content[2].table.body[1][0].text[7].text = (metaData.customer.address ? metaData.customer.address : '') + "\n";
			pdfDoc.content[2].table.body[1][0].text[9].text = (metaData.customer.mobile ? metaData.customer.mobile : '') + "\n";
			pdfDoc.content[2].table.body[1][0].text[7].text = (getCustomerDetails(metaData, 'address')) + "\n";
			pdfDoc.content[2].table.body[1][0].text[9].text = (getCustomerDetails(metaData, 'mobile').toUpperCase()) + "\n";
			pdfDoc.content[2].table.body[1][0].text[11].text = (metaData.invoiceData.placeOfSupply ? metaData.invoiceData.placeOfSupply : '') + "\n";
			pdfDoc.content[2].table.body[1][0].text[13].text = (metaData.customer.stateCode ? metaData.customer.stateCode : '') + "\n";

			let isTradeDiscount = metaData.terms.isTradeDiscount;
			let isSpecialCharge = metaData.terms.isSpecialCharge;
			let isGrossWeight = metaData.terms.isGrossWeight;
			let isNetWeight = metaData.terms.isNetWeight;
			let isLessStone = metaData.terms.isLessStone;
			let isPurity = metaData.terms.isPurity;
			let purityRemark = metaData.terms.purityRemark;
			let isGSTGroupingDisabled = metaData.terms.isGSTGroupingDisabled;
			let isTotalAmount = metaData.terms.isTotalAmount;

			//Products
			let productList = convertToPDFProductForSimplePrint(metaData.invoiceData.items, isTradeDiscount, isSpecialCharge, isGrossWeight, isLessStone, isNetWeight, isPurity, purityRemark, isGSTGroupingDisabled, isTotalAmount, metaData.invoiceData);
			if (isGSTGroupingDisabled) {
				pdfDoc.content[3].table.widths.push("5%")
				pdfDoc.content[3].table.body[0].push({ text: 'GST', style: "productHeader" })
			}
			pdfDoc.content[3].table.widths.push("5%")
			pdfDoc.content[3].table.body[0].push({ text: 'QTY', style: "productHeader" })
			pdfDoc.content[3].table.widths.push("6%*")
			pdfDoc.content[3].table.body[0].push({ text: 'UNIT', style: "productHeader" })
			if (isPurity) {
				pdfDoc.content[3].table.widths.push("9%")
				pdfDoc.content[3].table.body[0].push({ text: 'PURITY', style: "productHeader" })
			}
			if (purityRemark) {
				pdfDoc.content[3].table.widths.push("9%")
				pdfDoc.content[3].table.body[0].push({ text: 'PURITY', style: "productHeader" })
			}
			if (isGrossWeight) {
				pdfDoc.content[3].table.widths.push("8%")
				pdfDoc.content[3].table.body[0].push({ text: 'G.WT', style: "productHeader" })
			}
			if (isNetWeight) {
				pdfDoc.content[3].table.widths.push("8%")
				pdfDoc.content[3].table.body[0].push({ text: 'N.WT', style: "productHeader" })
			}
			if (isLessStone) {
				pdfDoc.content[3].table.widths.push("8%")
				pdfDoc.content[3].table.body[0].push({ text: 'LESS', style: "productHeader" })
			}
			pdfDoc.content[3].table.widths.push("7%")
			pdfDoc.content[3].table.body[0].push({ text: 'RATE', style: "productHeader" })
			if (isSpecialCharge) {
				pdfDoc.content[3].table.widths.push("7%")
				pdfDoc.content[3].table.body[0].push({ text: 'LC(%)', style: "productHeader" })
			}
			if (isTradeDiscount) {
				pdfDoc.content[3].table.widths.push("6%")
				pdfDoc.content[3].table.body[0].push({ text: 'DIS', style: "productHeader" })
			}
			pdfDoc.content[3].table.widths.push("*")
			pdfDoc.content[3].table.body[0].push({ text: 'TAXABLE AMOUNT', style: "productHeader" })
			if (isTotalAmount) {
				pdfDoc.content[3].table.widths.push("*")
				pdfDoc.content[3].table.body[0].push({ text: 'TOTAL AMOUNT', style: "productHeader" })
			}
			productList.map((item) => {
				pdfDoc.content[3].table.body.push(item);
			});
			let gstObj = convertToGST(metaData.invoiceData.items);
			Object.keys(gstObj).forEach((key) => {
				if (key != "totalObj") {
					pdfDoc.content[4].table.body[0][0][0].table.body.push([
						{ text: key, style: "product1" },
						{ text: gstObj[key].quantity, style: "product1" },
						{ text: Number.parseFloat(gstObj[key].basicPrice).toFixed(2), style: "product1" },
						{ text: gstObj[key].CGST + '%', style: "product1" },
						{ text: gstObj[key].CGST_val.toFixed(2), style: "product1" },
						{ text: gstObj[key].SGST + '%', style: "product1" },
						{ text: gstObj[key].SGST_val.toFixed(2), style: "product1" },
						{ text: gstObj[key].IGST + '%', style: "product1" },
						{ text: gstObj[key].IGST_val.toFixed(2), style: "product1" },
						{ text: Number.parseFloat(gstObj[key].GSTValue).toFixed(2), style: "product1" }])
				}
			});

			pdfDoc.content[4].table.body[0][0][0].table.body.push([
				{ text: 'Total', style: "total1" },
				{ text: gstObj.totalObj.quantity, style: "total1" },
				{ text: Number.parseFloat(gstObj.totalObj.basicPrice).toFixed(2), style: "total1" },
				{ text: '', style: "total1" },
				{ text: Number.parseFloat(gstObj.totalObj.CGST_val).toFixed(2), style: "total1" },
				{ text: '', style: "total1" },
				{ text: Number.parseFloat(gstObj.totalObj.SGST_val).toFixed(2), style: "total1" },
				{ text: '', style: "total1" },
				{ text: Number.parseFloat(gstObj.totalObj.IGST_val).toFixed(2), style: "total1" },
				{ text: Number.parseFloat(gstObj.totalObj.GSTValue).toFixed(2), style: "total1" }]);


			//gst details
			pdfDoc.content[4].table.body[0][1].text[1].text = (
				Number.parseFloat(metaData.invoiceData.totalAmount) +
				Number.parseFloat(metaData.invoiceData.discountAmount || 0) +
				Number.parseFloat(metaData.invoiceData.gstOnExtraChanrges ? 0 : (-Number.parseFloat(metaData.invoiceData.totalExtraCharges))) -
				Number.parseFloat(metaData.invoiceData.gstOnExtraChanrges ? Number.parseFloat(metaData.invoiceData.totalExtraChargesGST) : 0) -
				Number.parseFloat(metaData.invoiceData.roundOffAmount || 0) -
				(Number.parseFloat(
					metaData.gstTotal.SGST_val
				) +
					Number.parseFloat(
						metaData.gstTotal.CGST_val
					) +
					Number.parseFloat(
						metaData.gstTotal.IGST_val
					))
			).toFixed(2) + "\n";
			pdfDoc.content[4].table.body[0][1].text[3].text = (metaData.gstTotal.CGST_val ? (Number.parseFloat(metaData.gstTotal.CGST_val) + Number.parseFloat(metaData.invoiceData.gstOnExtraChanrges ? Number.parseFloat(metaData.invoiceData.totalExtraChargesGST) / 2 : 0)).toFixed(2) : '0.00') + "\n";
			pdfDoc.content[4].table.body[0][1].text[5].text = (metaData.gstTotal.SGST_val ? (Number.parseFloat(metaData.gstTotal.SGST_val) + Number.parseFloat(metaData.invoiceData.gstOnExtraChanrges ? Number.parseFloat(metaData.invoiceData.totalExtraChargesGST) / 2 : 0)).toFixed(2) : '0.00') + "\n";
			pdfDoc.content[4].table.body[0][1].text[7].text = (metaData.gstTotal.IGST_val ? (Number.parseFloat(metaData.gstTotal.IGST_val) + Number.parseFloat(metaData.invoiceData.gstOnExtraChanrges ? Number.parseFloat(metaData.invoiceData.totalExtraChargesGST) : 0)).toFixed(2) : '0.00') + "\n";
			let offset = 0;
			// if(metaData.invoiceData.extraCharges && metaData.invoiceData.extraCharges.length) {
			if (!metaData.invoiceData.gstOnExtraChanrges && metaData.invoiceData.extraCharges && metaData.invoiceData.extraCharges.length) {
				metaData.invoiceData.extraCharges.map((charge) => {
					pdfDoc.content[4].table.body[0][1].text.splice(8 + offset, 0, { text: '' + charge.name + '    :   ', bold: true, style: 'invoiceDetails' })
					offset++;
					pdfDoc.content[4].table.body[0][1].text.splice(8 + offset, 0, { text: Number.parseFloat(charge.amount).toFixed(2) + '\n', style: 'invoiceDetails' })
					offset++;
				})
			}
			pdfDoc.content[4].table.body[0][1].text[9 + offset].text = (metaData.invoiceData.discountAmount ? Number.parseFloat(metaData.invoiceData.discountAmount).toFixed(2) : '0.00') + "\n";
			pdfDoc.content[4].table.body[0][1].text[11 + offset].text = (metaData.invoiceData.roundOffAmount ? Number.parseFloat(metaData.invoiceData.roundOffAmount).toFixed(2) : '0.00') + "\n";
			pdfDoc.content[4].table.body[0][1].text[13 + offset].text = (metaData.invoiceData.totalAmount ? Number.parseFloat(metaData.invoiceData.totalAmount).toFixed(2) : '0') + "\n";
			pdfDoc.content[4].table.body[0][1].text[15 + offset].text = (metaData.invoiceData.paidAmount ? Number.parseFloat(metaData.invoiceData.paidAmount).toFixed(2) : '0') + "\n";
			pdfDoc.content[4].table.body[0][1].text[17 + offset].text = (metaData.invoiceData.remainingAmount ? Number.parseFloat(metaData.invoiceData.remainingAmount).toFixed(2) : '') + "\n";

			// In Words
			pdfDoc.content[5].table.body[0][0].text = ("In Words: " + _.startCase(digitsToWords(metaData.invoiceData.totalAmount)))

			// Overall Balance
			if (metaData.balance && metaData.terms.isPreviousCurrentTotalBalance) {
				pdfDoc.content[6].table.body[1][0].text[1].text = Number.parseFloat(Number.parseFloat(metaData.balance) - Number.parseFloat(metaData.invoiceData.remainingAmount).toFixed(2)).toFixed(2) + "\n";
				pdfDoc.content[6].table.body[1][1].text[1].text = (metaData.invoiceData.remainingAmount ? Number.parseFloat(metaData.invoiceData.remainingAmount).toFixed(2) : '0.00') + "\n";
				pdfDoc.content[6].table.body[1][2].text[1].text = (metaData.balance ? Number.parseFloat(metaData.balance).toFixed(2) : '0.00') + "\n";
			} else {
				pdfDoc.content[6] = {};
				//pdfDoc.content[5] = {};
			}

			//Bank Account Details
			if (metaData.terms.banks.length) {
				metaData.terms.banks.map((bankDetails) => {
					pdfDoc.content[7].table.body[0][0].text.push({ text: bankDetails.bankName + "\n", style: 'invoiceDetails1' })
					pdfDoc.content[7].table.body[0][0].text.push({ text: "NAME: " + bankDetails.accountHolderName + "\n", style: 'invoiceDetails1' })
					pdfDoc.content[7].table.body[0][0].text.push({ text: "A/C NO:  " + bankDetails.accountnumber + "\n", style: 'invoiceDetails1' })
					pdfDoc.content[7].table.body[0][0].text.push({ text: "IFSC: " + bankDetails.ifsccode + "\n", style: 'invoiceDetails1' })
					pdfDoc.content[7].table.body[0][0].text.push({ text: bankDetails.address + "\n", style: 'invoiceDetails1' })
				})
			}

			//Terms and cond
			pdfDoc.content[7].table.body[0][1].text[1].text = metaData.terms.termsAndConditions;

			//Authority Signature
			pdfDoc.content[7].table.body[0][2][1].text = metaData.firm.name ? (metaData.firm.name).toUpperCase() : '';

			//thank you
			// pdfDoc.content[10].table.body[0][0].text =  metaData.terms.termsAndConditions.greetingMessage || ("Thank You " + ((metaData.customer && metaData.customer.name )? metaData.customer.name.toUpperCase() : '') +" For doing business with us!" );
			pdfDoc.content[8].table.body[0][0].text = metaData.terms.greetingMessage || ("Thank You " + (getCustomerDetails(metaData, 'name').toUpperCase()) + " For your business with us!");

			// if (metaData.previousDue.length) {
			// 	metaData.previousDue.map((invoice, index) => {
			// 		pdfDoc.content[9].table.body.push([
			// 			{ text: index + 1, style: "product1" },
			// 			{ text: new Date(invoice.date).toLocaleDateString('en-GB').toString(), style: "product1" },
			// 			{ text: invoice.invoiceId, style: "product1" },
			// 			{ text: (invoice.totalAmount ? Number.parseFloat(invoice.totalAmount).toFixed(2) : '0'), style: "product1" },
			// 			{ text: (invoice.paidAmount ? Number.parseFloat(invoice.paidAmount).toFixed(2) : '0'), style: "product1" },
			// 			{ text: (invoice.remainingAmount ? Number.parseFloat(invoice.remainingAmount).toFixed(2) : '0'), style: "product1" },
			// 			{ text: (invoice.duration ? invoice.duration.toUpperCase() : 0), style: "product1" },
			// 			{ text: (invoice.status ? invoice.status.toUpperCase() : ''), style: "product1" }
			// 		])
			// 	})
			// } else {
			// 	pdfDoc.content.splice(9, 1);
			// }

			// if(metaData.estimates.length) {
			// 	let getTotal = (invoice)=>{
			// 		let total = 0;
			// 		invoice.items.map((i)=>{
			// 		  total += Number.parseFloat((Number.parseFloat(i.rate)) * (Number.parseFloat(i.quantity)))
			// 		})
			// 		return total;
			// 	  }
			// 	metaData.estimates.map((invoice,index) => {
			// 		pdfDoc.content[9].table.body.push([
			// 			{ text: index+1, style: "product1" },
			// 			{ text: new Date(invoice.date).toLocaleDateString('en-GB').toString(), style: "product1" },
			// 			{ text: (invoice.items.map((item,index)=> item.productName + (index != invoice.items.length-1 ? ' ,' :''))), style: "product1" },
			// 			{ text: (getTotal(invoice)), style: "product1" }
			// 		])
			// 	})
			// } else {
			// 	pdfDoc.content.splice(9, 1);
			// }

			if (metaData.terms.isBlankHeader) {
				pdfDoc.content[1].table.body[0][0] = { text: '' };
				pdfDoc.content[1].style = 'hiddenTab';
				pdfDoc.content[1].table.body[0][1].text[0].style = 'hiddenTab'
			} else {

				if (metaData.terms.printLogo) {
					try {
						let logoData = await getBase64ImageFromURL(metaData.terms.printLogo)
						pdfDoc.content[1].table.body[0][0].image = logoData;
						let invoiceImages = document.getElementById('invoiceImages');
					if (invoiceImages && invoiceImages.files && invoiceImages.files.length) {
						let temp = {columns: []};
						if(invoiceImages.files[0]) {
							temp.columns.push({
								image: await toBase64(invoiceImages.files[0]).catch(e => Error(e)),
								width: 150
							})
						}
						if(invoiceImages.files[1]) {
							temp.columns.push({
								image: await toBase64(invoiceImages.files[1]).catch(e => Error(e)),
								width: 150
							})
						}
						if(invoiceImages.files[2]) {
							temp.columns.push({
								image: await toBase64(invoiceImages.files[2]).catch(e => Error(e)),
								width: 150
							})
						}
						pdfDoc.content.push(temp)
					}
					if(metaData.terms.signature) {
						let temp = {columns: []};
						temp.columns.push({
							image: await getBase64ImageFromURL(metaData.terms.signature),
							width: 150,
							alignment: 'right'
						})
						//pdfDoc.content.push(temp)
						pdfDoc.content[7].table.body[0][2][2] = temp.columns[0]
					}
						return pdfDoc;
					} catch (error) {
						console.log(error)
					}
				} else {
					var imgToExport = document.getElementById('pdfimgToExport');
					var canvas = document.createElement('canvas');
					canvas.width = imgToExport.width;
					canvas.height = imgToExport.height;
					canvas.getContext('2d').drawImage(imgToExport, 0, 0);
					let base64 = canvas.toDataURL('image/png')
					pdfDoc.content[1].table.body[0][0].image = base64;
					let invoiceImages = document.getElementById('invoiceImages');
					if (invoiceImages && invoiceImages.files && invoiceImages.files.length) {
						let temp = {columns: []};
						if(invoiceImages.files[0]) {
							temp.columns.push({
								image: await toBase64(invoiceImages.files[0]).catch(e => Error(e)),
								width: 150
							})
						}
						if(invoiceImages.files[1]) {
							temp.columns.push({
								image: await toBase64(invoiceImages.files[1]).catch(e => Error(e)),
								width: 150
							})
						}
						if(invoiceImages.files[2]) {
							temp.columns.push({
								image: await toBase64(invoiceImages.files[2]).catch(e => Error(e)),
								width: 150
							})
						}
						pdfDoc.content.push(temp)
					}
				}

			}

			if(metaData.terms.signature) {
				let temp = {columns: []};
				temp.columns.push({
					image: await getBase64ImageFromURL(metaData.terms.signature),
					width: 150,
					alignment: 'right'
				})
				pdfDoc.content[7].table.body[0][2][2] = temp.columns[0]
				//pdfDoc.content.push(temp)
			}
			return pdfDoc;
		}


// WEBPACK FOOTER //
// ./src/utils/pdfmake.js